// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type Client, type TDataShape, formDataBodySerializer } from './client';
import type { AppStatusGetAppStatusData, AppStatusGetAppStatusResponses, AppStatusGetAppStatusErrors, AuthCancelDeletionData, AuthCancelDeletionResponses, AuthCancelDeletionErrors, AuthLoginData, AuthLoginResponses, AuthLoginErrors, AuthRefreshAccessTokenData, AuthRefreshAccessTokenResponses, AuthRefreshAccessTokenErrors, AuthLogoutData, AuthLogoutResponses, AuthTestTokenData, AuthTestTokenResponses, AuthPasswordRecoveryData, AuthPasswordRecoveryResponses, AuthPasswordRecoveryErrors, AuthResetPasswordData, AuthResetPasswordResponses, AuthResetPasswordErrors, AuthRequestMagicLinkData, AuthRequestMagicLinkResponses, AuthRequestMagicLinkErrors, AuthRequestLinkEmailData, AuthRequestLinkEmailResponses, AuthRequestLinkEmailErrors, AuthConfirmLinkEmailData, AuthConfirmLinkEmailResponses, AuthConfirmLinkEmailErrors, AuthVerifyMagicLinkData, AuthVerifyMagicLinkResponses, AuthVerifyMagicLinkErrors, AuthCloudflareAccessLoginData, AuthCloudflareAccessLoginResponses, AuthCloudflareAccessLoginErrors, AuthRedeemLoginCodeData, AuthRedeemLoginCodeResponses, AuthRedeemLoginCodeErrors, AuthSetupTotpData, AuthSetupTotpResponses, AuthGetTotpQrcodeData, AuthGetTotpQrcodeResponses, AuthVerifyTotpSetupData, AuthVerifyTotpSetupResponses, AuthVerifyTotpSetupErrors, AuthVerifyTotpData, AuthVerifyTotpResponses, AuthVerifyTotpErrors, AuthRegisterUserData, AuthRegisterUserResponses, AuthRegisterUserErrors, AuthDisableTotpData, AuthDisableTotpResponses, AuthDisableTotpErrors, AuthRegisterBiometricTokenData, AuthRegisterBiometricTokenResponses, AuthRegisterBiometricTokenErrors, AuthRevokeBiometricTokenData, AuthRevokeBiometricTokenResponses, AuthLoginWithBiometricData, AuthLoginWithBiometricResponses, AuthLoginWithBiometricErrors, AuthPingAuthData, AuthPingAuthResponses, AuthDeviceAuthData, AuthDeviceAuthResponses, AuthDeviceAuthErrors, AuthDeviceBindData, AuthDeviceBindResponses, AuthDeviceBindErrors, AuthDeviceConvertData, AuthDeviceConvertResponses, AuthDeviceConvertErrors, OauthGoogleLoginData, OauthGoogleLoginResponses, OauthGoogleLoginErrors, OauthGoogleCallbackData, OauthGoogleCallbackResponses, OauthGoogleCallbackErrors, OauthGoogleMobileCallbackData, OauthGoogleMobileCallbackResponses, OauthGoogleMobileCallbackErrors, OauthAppleCallbackData, OauthAppleCallbackResponses, OauthAppleCallbackErrors, OauthGetOauthConfigData, OauthGetOauthConfigResponses, OauthGetOauthConfigErrors, OauthTestOauthConfigData, OauthTestOauthConfigResponses, UsersDeleteUserMeData, UsersDeleteUserMeResponses, UsersReadUserMeData, UsersReadUserMeResponses, UsersUpdateUserMeData, UsersUpdateUserMeResponses, UsersUpdateUserMeErrors, UsersGetMyBillingIdData, UsersGetMyBillingIdResponses, UsersGetUserAccessData, UsersGetUserAccessResponses, UsersUpdatePasswordMeData, UsersUpdatePasswordMeResponses, UsersUpdatePasswordMeErrors, UsersUpdateDeviceMetadataData, UsersUpdateDeviceMetadataResponses, UsersUpdateDeviceMetadataErrors, UsersRecordInstallAttributionData, UsersRecordInstallAttributionResponses, UsersRecordInstallAttributionErrors, UsersReportPermissionChangeData, UsersReportPermissionChangeResponses, UsersReportPermissionChangeErrors, UsersMarkWidgetUsedData, UsersMarkWidgetUsedResponses, UsersUpdateAbTestVariantData, UsersUpdateAbTestVariantResponses, UsersUpdateAbTestVariantErrors, UsersUpdateJourneyPaceData, UsersUpdateJourneyPaceResponses, UsersUpdateJourneyPaceErrors, UsersReadMyEmailPreferencesData, UsersReadMyEmailPreferencesResponses, UsersUpdateMyEmailPreferenceData, UsersUpdateMyEmailPreferenceResponses, UsersUpdateMyEmailPreferenceErrors, UsersReadMyHealthDataConsentData, UsersReadMyHealthDataConsentResponses, UsersRecordMyHealthDataConsentData, UsersRecordMyHealthDataConsentResponses, UsersRecordMyHealthDataConsentErrors, UsersReadMyResearchConsentData, UsersReadMyResearchConsentResponses, UsersRecordMyResearchConsentData, UsersRecordMyResearchConsentResponses, UsersRecordMyResearchConsentErrors, UsersReadUserAuthProfileData, UsersReadUserAuthProfileResponses, UsersDeleteAllPushTokensData, UsersDeleteAllPushTokensResponses, UsersGetUserPushTokensData, UsersGetUserPushTokensResponses, UsersRegisterPushTokenData, UsersRegisterPushTokenResponses, UsersRegisterPushTokenErrors, UsersDeletePushTokenData, UsersDeletePushTokenResponses, UsersDeletePushTokenErrors, UsersGetOctopusTokenData, UsersGetOctopusTokenResponses, UsersReadUserByIdData, UsersReadUserByIdResponses, UsersReadUserByIdErrors, UsersReadUsersData, UsersReadUsersResponses, UsersReadUsersErrors, UsersCreateUserData, UsersCreateUserResponses, UsersCreateUserErrors, UsersExportUsersCsvData, UsersExportUsersCsvResponses, UsersExportUsersCsvErrors, UsersDeleteUserData, UsersDeleteUserResponses, UsersDeleteUserErrors, UsersUpdateUserData, UsersUpdateUserResponses, UsersUpdateUserErrors, UsersCreateUserFeedbackData, UsersCreateUserFeedbackResponses, UsersCreateUserFeedbackErrors, UsersUpdateUserStaffFlagData, UsersUpdateUserStaffFlagResponses, UsersUpdateUserStaffFlagErrors, UsersUpdateUserRolesData, UsersUpdateUserRolesResponses, UsersUpdateUserRolesErrors, UsersCheckRevenuecatCustomerStatusData, UsersCheckRevenuecatCustomerStatusResponses, UsersCheckRevenuecatCustomerStatusErrors, UsersGetRevenuecatRawCustomerInfoData, UsersGetRevenuecatRawCustomerInfoResponses, UsersGetRevenuecatRawCustomerInfoErrors, UsersDeleteRevenuecatCustomerData, UsersDeleteRevenuecatCustomerResponses, UsersDeleteRevenuecatCustomerErrors, UsersGetMyEntitlementData, UsersGetMyEntitlementResponses, UsersGrantMyPurchasePendingData, UsersGrantMyPurchasePendingResponses, UsersGrantMyPurchasePendingErrors, TouchEventsRecordAppTouchesData, TouchEventsRecordAppTouchesResponses, TouchEventsRecordAppTouchesErrors, AppInstallsRecordAppInstallData, AppInstallsRecordAppInstallResponses, AppInstallsRecordAppInstallErrors, AppInstallsLinkAppInstallData, AppInstallsLinkAppInstallResponses, AppInstallsLinkAppInstallErrors, UsersGetMyHardshipRequestData, UsersGetMyHardshipRequestResponses, UsersCreateMyHardshipRequestData, UsersCreateMyHardshipRequestResponses, UsersCreateMyHardshipRequestErrors, UsersScheduleMyBillingReminderData, UsersScheduleMyBillingReminderResponses, UsersScheduleMyBillingReminderErrors, AdminBillingIdentityResolveBillingIdData, AdminBillingIdentityResolveBillingIdResponses, AdminBillingIdentityResolveBillingIdErrors, AdminRevenuecatImportImportRevenuecatCsvData, AdminRevenuecatImportImportRevenuecatCsvResponses, AdminRevenuecatImportImportRevenuecatCsvErrors, AdminInsightsEventCountsData, AdminInsightsEventCountsResponses, AdminInsightsEventCountsErrors, AdminInsightsActiveUsersData, AdminInsightsActiveUsersResponses, AdminInsightsActiveUsersErrors, AdminInsightsNewUsersData, AdminInsightsNewUsersResponses, AdminInsightsNewUsersErrors, AdminInsightsChurnScreensData, AdminInsightsChurnScreensResponses, AdminInsightsVersionBreakdownData, AdminInsightsVersionBreakdownResponses, AdminInsightsVersionBreakdownErrors, AdminInsightsUsageBreakdownData, AdminInsightsUsageBreakdownResponses, AdminInsightsUsageBreakdownErrors, AdminInsightsWebFunnelData, AdminInsightsWebFunnelResponses, AdminInsightsWebFunnelErrors, AdminInsightsEmailCoverageData, AdminInsightsEmailCoverageResponses, AdminInsightsEmailCoverageErrors, AdminCheckpointsReachByVersionData, AdminCheckpointsReachByVersionResponses, AdminCheckpointsReachByVersionErrors, AdminCheckpointsTimeToMomentData, AdminCheckpointsTimeToMomentResponses, AdminCheckpointsTimeToMomentErrors, AdminCheckpointsHealthEntryVolumeData, AdminCheckpointsHealthEntryVolumeResponses, AdminCheckpointsHealthEntryVolumeErrors, AdminCheckpointsBackendReachData, AdminCheckpointsBackendReachResponses, AdminCheckpointsBackendReachErrors, AdminActivationActivationOverviewData, AdminActivationActivationOverviewResponses, AdminActivationActivationOverviewErrors, AdminJourneyHealthJourneySummaryData, AdminJourneyHealthJourneySummaryResponses, AdminJourneyHealthJourneySummaryErrors, AdminJourneyHealthJourneyLadderData, AdminJourneyHealthJourneyLadderResponses, AdminJourneyHealthJourneyLadderErrors, AdminJourneyHealthJourneyFunnelData, AdminJourneyHealthJourneyFunnelResponses, AdminJourneyHealthJourneyFunnelErrors, AdminJourneyHealthJourneyCohortsData, AdminJourneyHealthJourneyCohortsResponses, AdminJourneyHealthJourneyCohortsErrors, AdminJourneyHealthJourneyRetentionData, AdminJourneyHealthJourneyRetentionResponses, AdminJourneyHealthJourneyRetentionErrors, AdminPricingGetPricingGridData, AdminPricingGetPricingGridResponses, AdminPricingGetPricingGridErrors, AdminPricingGetStorePricesData, AdminPricingGetStorePricesResponses, AdminPricingGetStorePricesErrors, AdminPricingListStripePricesData, AdminPricingListStripePricesResponses, AdminPricingAdoptEnvPricesData, AdminPricingAdoptEnvPricesResponses, AdminPricingRotatePriceData, AdminPricingRotatePriceResponses, AdminPricingRotatePriceErrors, AdminPricingGetPriceHistoryData, AdminPricingGetPriceHistoryResponses, AdminPricingGetPriceHistoryErrors, AdminPricingListExperimentsData, AdminPricingListExperimentsResponses, AdminPricingUpsertExperimentData, AdminPricingUpsertExperimentResponses, AdminPricingUpsertExperimentErrors, AdminPricingSetExperimentActiveData, AdminPricingSetExperimentActiveResponses, AdminPricingSetExperimentActiveErrors, AdminPricingListPublicOffersData, AdminPricingListPublicOffersResponses, AdminPricingGetPlanDisplayData, AdminPricingGetPlanDisplayResponses, AdminPricingSetPlanDisplayData, AdminPricingSetPlanDisplayResponses, AdminPricingSetPlanDisplayErrors, AdminPaymentsPaymentsOverviewData, AdminPaymentsPaymentsOverviewResponses, AdminPaymentsPaymentsOverviewErrors, AdminPaymentsPaymentsGrowthData, AdminPaymentsPaymentsGrowthResponses, AdminPaymentsPaymentsRetentionData, AdminPaymentsPaymentsRetentionResponses, AdminPaymentsPaymentsRetentionErrors, AdminPaymentsPaymentDimensionsData, AdminPaymentsPaymentDimensionsResponses, AdminPaymentsPaymentsChartData, AdminPaymentsPaymentsChartResponses, AdminPaymentsPaymentsChartErrors, AdminPaymentsPaymentsChartsBatchData, AdminPaymentsPaymentsChartsBatchResponses, AdminPaymentsPaymentsChartsBatchErrors, AdminPaymentsPaymentsReleaseMarkersData, AdminPaymentsPaymentsReleaseMarkersResponses, AdminPaymentsPaymentsReleaseMarkersErrors, AdminPaymentsListSubscriptionsData, AdminPaymentsListSubscriptionsResponses, AdminPaymentsListSubscriptionsErrors, AdminPaymentsSubscriptionEventsData, AdminPaymentsSubscriptionEventsResponses, AdminPaymentsSubscriptionEventsErrors, AdminPaymentsHealthDetailData, AdminPaymentsHealthDetailResponses, AdminPaymentsHealthDetailErrors, AdminPaymentsPipelineHealthData, AdminPaymentsPipelineHealthResponses, AdminPaymentsListAnomaliesData, AdminPaymentsListAnomaliesResponses, AdminPaymentsListAnomaliesErrors, AdminPaymentsTriageAnomaliesData, AdminPaymentsTriageAnomaliesResponses, AdminPaymentsTriageAnomaliesErrors, AdminPaymentsAttributeAnomalyData, AdminPaymentsAttributeAnomalyResponses, AdminPaymentsAttributeAnomalyErrors, AdminPaymentsLookupProviderProfileData, AdminPaymentsLookupProviderProfileResponses, AdminPaymentsLookupProviderProfileErrors, AdminPaymentsRecentTransactionsData, AdminPaymentsRecentTransactionsResponses, AdminPaymentsRecentTransactionsErrors, AdminPaymentsGroupCoachingCampaignsData, AdminPaymentsGroupCoachingCampaignsResponses, AdminPaymentsGroupCoachingCampaignsErrors, AdminPaymentsCoachingBuyersData, AdminPaymentsCoachingBuyersResponses, AdminPaymentsCoachingBuyersErrors, AdminVitalSignsVitalSignsData, AdminVitalSignsVitalSignsResponses, AdminVitalSignsVitalSignsErrors, AdminCustomersLookupCustomerData, AdminCustomersLookupCustomerResponses, AdminCustomersLookupCustomerErrors, AdminCustomersCustomerLandingData, AdminCustomersCustomerLandingResponses, AdminCustomersGetCustomerData, AdminCustomersGetCustomerResponses, AdminCustomersGetCustomerErrors, AdminCustomersGetCustomerActivityData, AdminCustomersGetCustomerActivityResponses, AdminCustomersGetCustomerActivityErrors, AdminCustomersGetCustomerEmailsData, AdminCustomersGetCustomerEmailsResponses, AdminCustomersGetCustomerEmailsErrors, AdminCustomersGetCustomerEmailDataData, AdminCustomersGetCustomerEmailDataResponses, AdminCustomersGetCustomerEmailDataErrors, AdminCustomersGetCustomerDevicesData, AdminCustomersGetCustomerDevicesResponses, AdminCustomersGetCustomerDevicesErrors, AdminCustomersGetCustomerReleaseStateData, AdminCustomersGetCustomerReleaseStateResponses, AdminCustomersGetCustomerReleaseStateErrors, AdminCustomersCreateGrantData, AdminCustomersCreateGrantResponses, AdminCustomersCreateGrantErrors, AdminCustomersRevokeGrantData, AdminCustomersRevokeGrantResponses, AdminCustomersRevokeGrantErrors, AdminCustomersSetCustomerPaymentsV2Data, AdminCustomersSetCustomerPaymentsV2Responses, AdminCustomersSetCustomerPaymentsV2Errors, AdminCustomersGetCustomerSegmentsData, AdminCustomersGetCustomerSegmentsResponses, AdminCustomersGetCustomerSegmentsErrors, AdminCustomersRemoveCustomerFromSegmentData, AdminCustomersRemoveCustomerFromSegmentResponses, AdminCustomersRemoveCustomerFromSegmentErrors, AdminCustomersAddCustomerToSegmentData, AdminCustomersAddCustomerToSegmentResponses, AdminCustomersAddCustomerToSegmentErrors, AdminCustomersRevokeStaticLoginCodeData, AdminCustomersRevokeStaticLoginCodeResponses, AdminCustomersRevokeStaticLoginCodeErrors, AdminCustomersGetStaticLoginCodeData, AdminCustomersGetStaticLoginCodeResponses, AdminCustomersGetStaticLoginCodeErrors, AdminCustomersCreateStaticLoginCodeData, AdminCustomersCreateStaticLoginCodeResponses, AdminCustomersCreateStaticLoginCodeErrors, AdminFunnelLeadsListFunnelLeadsData, AdminFunnelLeadsListFunnelLeadsResponses, AdminFunnelLeadsListFunnelLeadsErrors, AdminFunnelLeadsExportFunnelLeadsCsvData, AdminFunnelLeadsExportFunnelLeadsCsvResponses, AdminFunnelLeadsExportFunnelLeadsCsvErrors, AdminHardshipOfferGetHardshipOfferData, AdminHardshipOfferGetHardshipOfferResponses, AdminHardshipOfferRemoveHardshipEmailData, AdminHardshipOfferRemoveHardshipEmailResponses, AdminHardshipOfferRemoveHardshipEmailErrors, AdminHardshipOfferAddHardshipEmailsData, AdminHardshipOfferAddHardshipEmailsResponses, AdminHardshipOfferAddHardshipEmailsErrors, AdminHardshipOfferSendHardshipOfferEmailData, AdminHardshipOfferSendHardshipOfferEmailResponses, AdminHardshipOfferSendHardshipOfferEmailErrors, AdminHardshipOfferTestSendHardshipOfferEmailData, AdminHardshipOfferTestSendHardshipOfferEmailResponses, AdminConsentConsentDashboardData, AdminConsentConsentDashboardResponses, AdminCustomersGetPushReadinessData, AdminCustomersGetPushReadinessResponses, AdminCustomersGetPushReadinessErrors, AdminCustomersCheckPushReceiptsData, AdminCustomersCheckPushReceiptsResponses, AdminCustomersCheckPushReceiptsErrors, AdminCustomersSendTestPushData, AdminCustomersSendTestPushResponses, AdminCustomersSendTestPushErrors, AdminPushListsPreviewPushListData, AdminPushListsPreviewPushListResponses, AdminPushListsPreviewPushListErrors, AdminPushListsSendPushListData, AdminPushListsSendPushListResponses, AdminPushListsSendPushListErrors, AdminPushListsPreviewScheduleData, AdminPushListsPreviewScheduleResponses, AdminPushListsPreviewScheduleErrors, AdminPushListsCreateScheduleData, AdminPushListsCreateScheduleResponses, AdminPushListsCreateScheduleErrors, AdminPushListsListScheduledData, AdminPushListsListScheduledResponses, AdminPushListsCancelScheduledData, AdminPushListsCancelScheduledResponses, AdminPushListsCancelScheduledErrors, AdminStoreReviewGetStoreReviewOverviewData, AdminStoreReviewGetStoreReviewOverviewResponses, AdminStoreReviewLookupStoreReviewEmailData, AdminStoreReviewLookupStoreReviewEmailResponses, AdminStoreReviewLookupStoreReviewEmailErrors, AdminStoreReviewProvisionStoreReviewAccountData, AdminStoreReviewProvisionStoreReviewAccountResponses, AdminStoreReviewProvisionStoreReviewAccountErrors, AdminCommunityListCommunityPostsData, AdminCommunityListCommunityPostsResponses, AdminCommunityListCommunityPostsErrors, AdminCommunityCreateCommunityPostData, AdminCommunityCreateCommunityPostResponses, AdminCommunityCreateCommunityPostErrors, AdminCommunityCancelScheduledCommunityPostData, AdminCommunityCancelScheduledCommunityPostResponses, AdminCommunityCancelScheduledCommunityPostErrors, AdminCommunityGetCommunityPostData, AdminCommunityGetCommunityPostResponses, AdminCommunityGetCommunityPostErrors, AdminCommunityUpdateScheduledCommunityPostData, AdminCommunityUpdateScheduledCommunityPostResponses, AdminCommunityUpdateScheduledCommunityPostErrors, AdminCommunityArchiveCommunityPostData, AdminCommunityArchiveCommunityPostResponses, AdminCommunityArchiveCommunityPostErrors, AdminCommunityRestoreCommunityPostData, AdminCommunityRestoreCommunityPostResponses, AdminCommunityRestoreCommunityPostErrors, AdminCommunitySetCommunityPostTopicData, AdminCommunitySetCommunityPostTopicResponses, AdminCommunitySetCommunityPostTopicErrors, AdminCommunityBoostCommunityPostData, AdminCommunityBoostCommunityPostResponses, AdminCommunityBoostCommunityPostErrors, AdminCommunityUnboostCommunityPostData, AdminCommunityUnboostCommunityPostResponses, AdminCommunityUnboostCommunityPostErrors, AdminCommunityHighlightCommunityPostData, AdminCommunityHighlightCommunityPostResponses, AdminCommunityHighlightCommunityPostErrors, AdminCommunityHeroCommunityPostData, AdminCommunityHeroCommunityPostResponses, AdminCommunityHeroCommunityPostErrors, AdminCommunityGetCommunityIdentityData, AdminCommunityGetCommunityIdentityResponses, AdminCommunitySetCommunityNameData, AdminCommunitySetCommunityNameResponses, AdminCommunitySetCommunityNameErrors, AdminCommunityListCommunityPostCommentsData, AdminCommunityListCommunityPostCommentsResponses, AdminCommunityListCommunityPostCommentsErrors, AdminCommunityCreateCommunityPostCommentData, AdminCommunityCreateCommunityPostCommentResponses, AdminCommunityCreateCommunityPostCommentErrors, AdminCommunityArchiveCommunityCommentData, AdminCommunityArchiveCommunityCommentResponses, AdminCommunityArchiveCommunityCommentErrors, AdminCommunityRestoreCommunityCommentData, AdminCommunityRestoreCommunityCommentResponses, AdminCommunityRestoreCommunityCommentErrors, AdminCommunitySetCommunityCommentReactionData, AdminCommunitySetCommunityCommentReactionResponses, AdminCommunitySetCommunityCommentReactionErrors, AdminCommunitySetCommunityPostReactionData, AdminCommunitySetCommunityPostReactionResponses, AdminCommunitySetCommunityPostReactionErrors, AdminCommunityPublishScheduledCommunityPostData, AdminCommunityPublishScheduledCommunityPostResponses, AdminCommunityPublishScheduledCommunityPostErrors, AdminCommunityCommunityStatsData, AdminCommunityCommunityStatsResponses, AdminCommunityCommunityStatsErrors, AdminBeehiivGetSubscriptionByEmailData, AdminBeehiivGetSubscriptionByEmailResponses, AdminBeehiivGetSubscriptionByEmailErrors, AdminBeehiivListCustomFieldsData, AdminBeehiivListCustomFieldsResponses, AdminBeehiivGetPublicationData, AdminBeehiivGetPublicationResponses, AdminBeehiivGetPublicationErrors, AdminBeehiivListPostsData, AdminBeehiivListPostsResponses, AdminBeehiivListPostsErrors, AdminBeehiivGetPostsAggregateStatsData, AdminBeehiivGetPostsAggregateStatsResponses, AdminBeehiivGetPostsAggregateStatsErrors, AdminBeehiivListSubscriptionsData, AdminBeehiivListSubscriptionsResponses, AdminBeehiivListSubscriptionsErrors, AdminBeehiivListSegmentsData, AdminBeehiivListSegmentsResponses, AdminBeehiivListSegmentsErrors, AdminBeehiivRecalculateSegmentData, AdminBeehiivRecalculateSegmentResponses, AdminBeehiivRecalculateSegmentErrors, UsersV2ListUsersV2Data, UsersV2ListUsersV2Responses, UsersV2ListUsersV2Errors, UsersV2GetUserV2Data, UsersV2GetUserV2Responses, UsersV2GetUserV2Errors, UsersV2GetUserEventsV2Data, UsersV2GetUserEventsV2Responses, UsersV2GetUserEventsV2Errors, UsersV2GetUserStatsV2Data, UsersV2GetUserStatsV2Responses, UsersV2GetUserStatsV2Errors, MetricsGetUserCountsData, MetricsGetUserCountsResponses, MetricsGetUserCountsErrors, MetricsGetNewUsersChartData, MetricsGetNewUsersChartResponses, MetricsGetNewUsersChartErrors, MetricsGetUserCountOverTimeData, MetricsGetUserCountOverTimeResponses, MetricsGetUserCountOverTimeErrors, MetricsListUserGrowthEventsData, MetricsListUserGrowthEventsResponses, MetricsListUserGrowthEventsErrors, MetricsCreateUserGrowthEventData, MetricsCreateUserGrowthEventResponses, MetricsCreateUserGrowthEventErrors, MetricsDeleteUserGrowthEventData, MetricsDeleteUserGrowthEventResponses, MetricsDeleteUserGrowthEventErrors, MetricsGetDistinctProductIdentifiersData, MetricsGetDistinctProductIdentifiersResponses, MetricsGetUserRetentionData, MetricsGetUserRetentionResponses, MetricsGetUserRetentionErrors, MetricsGetCohortRetentionData, MetricsGetCohortRetentionResponses, MetricsGetCohortRetentionErrors, UtilsHealthCheckData, UtilsHealthCheckResponses, UtilsHealthCheckErrors, NotificationsDeleteAllNotificationPreferencesData, NotificationsDeleteAllNotificationPreferencesResponses, NotificationsGetNotificationPreferencesData, NotificationsGetNotificationPreferencesResponses, NotificationsCreateNotificationPreferenceData, NotificationsCreateNotificationPreferenceResponses, NotificationsCreateNotificationPreferenceErrors, NotificationsDeleteNotificationPreferenceData, NotificationsDeleteNotificationPreferenceResponses, NotificationsDeleteNotificationPreferenceErrors, NotificationsUpdateNotificationPreferenceData, NotificationsUpdateNotificationPreferenceResponses, NotificationsUpdateNotificationPreferenceErrors, NotificationsReadAllNotificationPreferencesData, NotificationsReadAllNotificationPreferencesResponses, NotificationsReadAllNotificationPreferencesErrors, NotificationsReadNotificationHistoryData, NotificationsReadNotificationHistoryResponses, NotificationsReadNotificationHistoryErrors, NotificationsReadUserNotificationHistoryData, NotificationsReadUserNotificationHistoryResponses, NotificationsReadUserNotificationHistoryErrors, NotificationsReadNotificationHistoryByIdData, NotificationsReadNotificationHistoryByIdResponses, NotificationsReadNotificationHistoryByIdErrors, NotificationsRecordNotificationOpenedData, NotificationsRecordNotificationOpenedResponses, NotificationsRecordNotificationOpenedErrors, PublicGetCommunityStatsData, PublicGetCommunityStatsResponses, PublicGetCommunityStatsErrors, PublicGetCohortMoodProgressionData, PublicGetCohortMoodProgressionResponses, PublicGetCohortMoodProgressionErrors, PublicGetEmailPreferencesData, PublicGetEmailPreferencesResponses, PublicGetEmailPreferencesErrors, PublicUpdateEmailPreferenceData, PublicUpdateEmailPreferenceResponses, PublicUpdateEmailPreferenceErrors, PublicOneClickUnsubscribeData, PublicOneClickUnsubscribeResponses, PublicOneClickUnsubscribeErrors, PublicUnsubscribeFromEmailsData, PublicUnsubscribeFromEmailsResponses, PublicUnsubscribeFromEmailsErrors, StripeRefundEligibilityData, StripeRefundEligibilityResponses, StripeRefundData, StripeRefundResponses, StripeGetStripePricesData, StripeGetStripePricesResponses, StripeGetStripePricesErrors, StripeCreateBillingPortalSessionData, StripeCreateBillingPortalSessionResponses, WebOnboardingIngestWebOnboardingData, WebOnboardingIngestWebOnboardingResponses, WebOnboardingIngestWebOnboardingErrors, WebOnboardingFunnelTouchData, WebOnboardingFunnelTouchResponses, WebOnboardingFunnelTouchErrors, WebOnboardingFunnelOfferData, WebOnboardingFunnelOfferResponses, WebOnboardingFunnelOfferErrors, WebOnboardingWebOnboardingConfigData, WebOnboardingWebOnboardingConfigResponses, WebOnboardingWebOnboardingConfigErrors, WebOnboardingWebOnboardingCheckoutData, WebOnboardingWebOnboardingCheckoutResponses, WebOnboardingWebOnboardingCheckoutErrors, WebOnboardingWebOnboardingCompleteData, WebOnboardingWebOnboardingCompleteResponses, WebOnboardingWebOnboardingCompleteErrors, WebOnboardingWebOnboardingResendData, WebOnboardingWebOnboardingResendResponses, WebOnboardingWebOnboardingResendErrors, PaymentsPaymentWebhookData, PaymentsPaymentWebhookResponses, PaymentsPaymentWebhookErrors, StripeWebhookStripeWebhookData, StripeWebhookStripeWebhookResponses, RevenuecatSyncRevenuecatSubscriptionData, RevenuecatSyncRevenuecatSubscriptionResponses, RevenuecatSyncRevenuecatSubscriptionErrors, RevenuecatWebhookRevenuecatWebhookData, RevenuecatWebhookRevenuecatWebhookResponses, PromoCodesValidatePromoCodeData, PromoCodesValidatePromoCodeResponses, PromoCodesValidatePromoCodeErrors, FeedbackReadFeedbackListData, FeedbackReadFeedbackListResponses, FeedbackReadFeedbackListErrors, FeedbackCreateFeedbackData, FeedbackCreateFeedbackResponses, FeedbackCreateFeedbackErrors, FeedbackDeleteFeedbackData, FeedbackDeleteFeedbackResponses, FeedbackDeleteFeedbackErrors, FeedbackReadFeedbackData, FeedbackReadFeedbackResponses, FeedbackReadFeedbackErrors, FeedbackUpdateFeedbackData, FeedbackUpdateFeedbackResponses, FeedbackUpdateFeedbackErrors, AgentConfigsGetAgentConfigBySlugData, AgentConfigsGetAgentConfigBySlugResponses, AgentConfigsGetAgentConfigBySlugErrors, AgentConfigsCreateElevenlabsSignedUrlData, AgentConfigsCreateElevenlabsSignedUrlResponses, AgentConfigsCreateElevenlabsSignedUrlErrors, AgentConfigsListAgentConfigsData, AgentConfigsListAgentConfigsResponses, AgentConfigsListAgentConfigsErrors, AgentConfigsCreateAgentConfigData, AgentConfigsCreateAgentConfigResponses, AgentConfigsCreateAgentConfigErrors, AgentConfigsDeleteAgentConfigData, AgentConfigsDeleteAgentConfigResponses, AgentConfigsDeleteAgentConfigErrors, AgentConfigsGetAgentConfigByIdData, AgentConfigsGetAgentConfigByIdResponses, AgentConfigsGetAgentConfigByIdErrors, AgentConfigsUpdateAgentConfigData, AgentConfigsUpdateAgentConfigResponses, AgentConfigsUpdateAgentConfigErrors, AgentConfigsInvalidateAgentCacheData, AgentConfigsInvalidateAgentCacheResponses, AgentConfigsInvalidateAgentCacheErrors, ExercisesGetDailyFlowBehaviorsData, ExercisesGetDailyFlowBehaviorsResponses, ExercisesGetDailyFlowRecommendationData, ExercisesGetDailyFlowRecommendationResponses, ExercisesGetDailyFlowRecommendationErrors, ExercisesListExercisesData, ExercisesListExercisesResponses, ExercisesListExercisesErrors, ExercisesCreateExerciseData, ExercisesCreateExerciseResponses, ExercisesCreateExerciseErrors, ExercisesDeleteExerciseData, ExercisesDeleteExerciseResponses, ExercisesDeleteExerciseErrors, ExercisesGetExerciseByIdAdminData, ExercisesGetExerciseByIdAdminResponses, ExercisesGetExerciseByIdAdminErrors, ExercisesUpdateExerciseData, ExercisesUpdateExerciseResponses, ExercisesUpdateExerciseErrors, ExercisesPromoteExerciseFromStagingData, ExercisesPromoteExerciseFromStagingResponses, ExercisesPromoteExerciseFromStagingErrors, ExercisesPublishExerciseData, ExercisesPublishExerciseResponses, ExercisesPublishExerciseErrors, ExercisesUnpublishExerciseData, ExercisesUnpublishExerciseResponses, ExercisesUnpublishExerciseErrors, ExercisesSyncExercisesFromProductionData, ExercisesSyncExercisesFromProductionResponses, ExercisesListExerciseCategoriesData, ExercisesListExerciseCategoriesResponses, ExercisesGetExercisesByCategoryData, ExercisesGetExercisesByCategoryResponses, ExercisesGetExercisesByCategoryErrors, ExercisesGetExerciseBySlugData, ExercisesGetExerciseBySlugResponses, ExercisesGetExerciseBySlugErrors, ExercisesGetExerciseBySlugAndVersionData, ExercisesGetExerciseBySlugAndVersionResponses, ExercisesGetExerciseBySlugAndVersionErrors, AmisExercisesListAmisExercisesData, AmisExercisesListAmisExercisesResponses, AmisExercisesListAmisExercisesErrors, AmisExercisesCreateAmisExerciseData, AmisExercisesCreateAmisExerciseResponses, AmisExercisesCreateAmisExerciseErrors, AmisExercisesGetDailyFlowRecommendationData, AmisExercisesGetDailyFlowRecommendationResponses, AmisExercisesGetDailyFlowRecommendationErrors, AmisExercisesDeleteAmisExerciseData, AmisExercisesDeleteAmisExerciseResponses, AmisExercisesDeleteAmisExerciseErrors, AmisExercisesGetAmisExerciseByIdData, AmisExercisesGetAmisExerciseByIdResponses, AmisExercisesGetAmisExerciseByIdErrors, AmisExercisesUpdateAmisExerciseData, AmisExercisesUpdateAmisExerciseResponses, AmisExercisesUpdateAmisExerciseErrors, AmisExercisesPublishAmisExerciseData, AmisExercisesPublishAmisExerciseResponses, AmisExercisesPublishAmisExerciseErrors, AmisExercisesGetAmisExerciseHistoryData, AmisExercisesGetAmisExerciseHistoryResponses, AmisExercisesGetAmisExerciseHistoryErrors, AmisExercisesDeleteAmisExerciseVersionData, AmisExercisesDeleteAmisExerciseVersionResponses, AmisExercisesDeleteAmisExerciseVersionErrors, AmisExercisesGetAmisExerciseVersionByIdData, AmisExercisesGetAmisExerciseVersionByIdResponses, AmisExercisesGetAmisExerciseVersionByIdErrors, AmisExercisesDeleteOldDraftVersionsData, AmisExercisesDeleteOldDraftVersionsResponses, AmisExercisesDeleteOldDraftVersionsErrors, DailyLessonsGetAvailableLessonsData, DailyLessonsGetAvailableLessonsResponses, DailyLessonsGetAvailableLessonsErrors, DailyLessonsGetSavedLessonsData, DailyLessonsGetSavedLessonsResponses, DailyLessonsGetDailyLessonData, DailyLessonsGetDailyLessonResponses, DailyLessonsGetDailyLessonErrors, DailyLessonsDismissLessonData, DailyLessonsDismissLessonResponses, DailyLessonsDismissLessonErrors, DailyLessonsLikeLessonData, DailyLessonsLikeLessonResponses, DailyLessonsLikeLessonErrors, DailyLessonsListDailyLessonsAdminData, DailyLessonsListDailyLessonsAdminResponses, DailyLessonsListDailyLessonsAdminErrors, DailyLessonsCreateDailyLessonAdminData, DailyLessonsCreateDailyLessonAdminResponses, DailyLessonsCreateDailyLessonAdminErrors, DailyLessonsBulkUpsertDailyLessonsAdminData, DailyLessonsBulkUpsertDailyLessonsAdminResponses, DailyLessonsBulkUpsertDailyLessonsAdminErrors, DailyLessonsDeleteDailyLessonAdminData, DailyLessonsDeleteDailyLessonAdminResponses, DailyLessonsDeleteDailyLessonAdminErrors, DailyLessonsGetDailyLessonAdminData, DailyLessonsGetDailyLessonAdminResponses, DailyLessonsGetDailyLessonAdminErrors, DailyLessonsUpdateDailyLessonAdminData, DailyLessonsUpdateDailyLessonAdminResponses, DailyLessonsUpdateDailyLessonAdminErrors, DailyLessonsPromoteDailyLessonFromStagingData, DailyLessonsPromoteDailyLessonFromStagingResponses, DailyLessonsPromoteDailyLessonFromStagingErrors, DailyLessonsPublishDailyLessonData, DailyLessonsPublishDailyLessonResponses, DailyLessonsPublishDailyLessonErrors, DailyLessonsUnpublishDailyLessonData, DailyLessonsUnpublishDailyLessonResponses, DailyLessonsUnpublishDailyLessonErrors, DailyLessonsSyncDailyLessonsFromProductionData, DailyLessonsSyncDailyLessonsFromProductionResponses, BannersGetEligibleBannersData, BannersGetEligibleBannersResponses, BannersGetEligibleBannersErrors, BannersGetBannerHistoryData, BannersGetBannerHistoryResponses, BannersGetBannerHistoryErrors, BannersRecordBannerShownData, BannersRecordBannerShownResponses, BannersRecordBannerShownErrors, BannersRecordBannerClickData, BannersRecordBannerClickResponses, BannersRecordBannerClickErrors, BannersRecordBannerCompleteData, BannersRecordBannerCompleteResponses, BannersRecordBannerCompleteErrors, BannersRecordBannerDeliveredData, BannersRecordBannerDeliveredResponses, BannersRecordBannerDeliveredErrors, BannersDismissBannerData, BannersDismissBannerResponses, BannersDismissBannerErrors, BannersListBannersAdminData, BannersListBannersAdminResponses, BannersListBannersAdminErrors, BannersGetBannerStatsAdminData, BannersGetBannerStatsAdminResponses, BannersGetBannerStatsAdminErrors, BannersCreateBannerAdminData, BannersCreateBannerAdminResponses, BannersCreateBannerAdminErrors, BannersCreateDraftBannerAdminData, BannersCreateDraftBannerAdminResponses, BannersCreateDraftBannerAdminErrors, BannersDeleteBannerAdminData, BannersDeleteBannerAdminResponses, BannersDeleteBannerAdminErrors, BannersGetBannerAdminData, BannersGetBannerAdminResponses, BannersGetBannerAdminErrors, BannersUpdateBannerAdminData, BannersUpdateBannerAdminResponses, BannersUpdateBannerAdminErrors, BannersGetBannerDistributionAdminData, BannersGetBannerDistributionAdminResponses, BannersGetBannerDistributionAdminErrors, BannersArchiveBannerAdminData, BannersArchiveBannerAdminResponses, BannersArchiveBannerAdminErrors, BannersUnarchiveBannerAdminData, BannersUnarchiveBannerAdminResponses, BannersUnarchiveBannerAdminErrors, BannersDuplicateBannerAdminData, BannersDuplicateBannerAdminResponses, BannersDuplicateBannerAdminErrors, BannersPublishBannerAdminData, BannersPublishBannerAdminResponses, BannersPublishBannerAdminErrors, BannersForceDeliverBannerAdminData, BannersForceDeliverBannerAdminResponses, BannersForceDeliverBannerAdminErrors, BannersGetBannerContentAdminData, BannersGetBannerContentAdminResponses, BannersGetBannerContentAdminErrors, BannersUpsertBannerContentAdminData, BannersUpsertBannerContentAdminResponses, BannersUpsertBannerContentAdminErrors, BannersUpsertDraftContentAdminData, BannersUpsertDraftContentAdminResponses, BannersUpsertDraftContentAdminErrors, BannersPinContextualBannerData, BannersPinContextualBannerResponses, BannersPinContextualBannerErrors, BannersResetPersonalClockData, BannersResetPersonalClockResponses, BannersResetPersonalClockErrors, BannersGetPersonalClockData, BannersGetPersonalClockResponses, BannersAdvancePersonalClockData, BannersAdvancePersonalClockResponses, BannersAdvancePersonalClockErrors, WalkStartWalkData, WalkStartWalkResponses, WalkStartWalkErrors, LiveActivityGetLiveActivityData, LiveActivityGetLiveActivityResponses, SimSimResetData, SimSimResetResponses, SimSimResetErrors, SimSimTickData, SimSimTickResponses, SimSimTickErrors, SimSimStepData, SimSimStepResponses, SimSimStepErrors, SimSimPublishData, SimSimPublishResponses, SimSimPublishErrors, SimSimStateData, SimSimStateResponses, SimSimUserDetailData, SimSimUserDetailResponses, SimSimUserDetailErrors, JourneyDevResetOwnJourneyData, JourneyDevResetOwnJourneyResponses, JourneyDevResetOwnJourneyErrors, JourneyDevSeedOwnJourneyData, JourneyDevSeedOwnJourneyResponses, JourneyDevSeedOwnJourneyErrors, BookInterestCaptureBookInterestData, BookInterestCaptureBookInterestResponses, BookInterestCaptureBookInterestErrors, QuizResultCaptureQuizResultData, QuizResultCaptureQuizResultResponses, QuizResultCaptureQuizResultErrors, CoachingWaitlistCaptureCoachingWaitlistData, CoachingWaitlistCaptureCoachingWaitlistResponses, CoachingWaitlistCaptureCoachingWaitlistErrors, ContactCaptureCaptureContactData, ContactCaptureCaptureContactResponses, ContactCaptureCaptureContactErrors, QuizResultDownloadQuizResultData, QuizResultDownloadQuizResultResponses, QuizResultDownloadQuizResultErrors, FeatureFlagsGetFeatureFlagsData, FeatureFlagsGetFeatureFlagsResponses, FeatureFlagsListFeatureFlagsAdminData, FeatureFlagsListFeatureFlagsAdminResponses, FeatureFlagsListFeatureFlagsAdminErrors, FeatureFlagsCreateFeatureFlagData, FeatureFlagsCreateFeatureFlagResponses, FeatureFlagsCreateFeatureFlagErrors, FeatureFlagsGetStoreVersionsData, FeatureFlagsGetStoreVersionsResponses, FeatureFlagsDeleteFeatureFlagData, FeatureFlagsDeleteFeatureFlagResponses, FeatureFlagsDeleteFeatureFlagErrors, FeatureFlagsGetFeatureFlagAdminData, FeatureFlagsGetFeatureFlagAdminResponses, FeatureFlagsGetFeatureFlagAdminErrors, FeatureFlagsUpdateFeatureFlagData, FeatureFlagsUpdateFeatureFlagResponses, FeatureFlagsUpdateFeatureFlagErrors, FeatureFlagsEstimateFeatureFlagReachData, FeatureFlagsEstimateFeatureFlagReachResponses, FeatureFlagsEstimateFeatureFlagReachErrors, FeatureFlagsExplainFeatureFlagData, FeatureFlagsExplainFeatureFlagResponses, FeatureFlagsExplainFeatureFlagErrors, FeatureFlagsListFeatureFlagRevisionsData, FeatureFlagsListFeatureFlagRevisionsResponses, FeatureFlagsListFeatureFlagRevisionsErrors, FeatureFlagsListFeatureFlagRevisionsByKeyData, FeatureFlagsListFeatureFlagRevisionsByKeyResponses, FeatureFlagsListFeatureFlagRevisionsByKeyErrors, FeatureFlagsListUserFeatureFlagOverridesData, FeatureFlagsListUserFeatureFlagOverridesResponses, FeatureFlagsListUserFeatureFlagOverridesErrors, FeatureFlagsCreateUserFeatureFlagOverrideData, FeatureFlagsCreateUserFeatureFlagOverrideResponses, FeatureFlagsCreateUserFeatureFlagOverrideErrors, FeatureFlagsDeleteUserFeatureFlagOverrideData, FeatureFlagsDeleteUserFeatureFlagOverrideResponses, FeatureFlagsDeleteUserFeatureFlagOverrideErrors, FeatureFlagsListSegmentFeatureFlagOverridesData, FeatureFlagsListSegmentFeatureFlagOverridesResponses, FeatureFlagsListSegmentFeatureFlagOverridesErrors, FeatureFlagsSetSegmentFeatureFlagOverrideData, FeatureFlagsSetSegmentFeatureFlagOverrideResponses, FeatureFlagsSetSegmentFeatureFlagOverrideErrors, FeatureFlagsClearSegmentFeatureFlagOverrideData, FeatureFlagsClearSegmentFeatureFlagOverrideResponses, FeatureFlagsClearSegmentFeatureFlagOverrideErrors, FeatureFlagsProposeFeatureFlagChangeData, FeatureFlagsProposeFeatureFlagChangeResponses, FeatureFlagsProposeFeatureFlagChangeErrors, FeatureFlagsListFeatureFlagChangesData, FeatureFlagsListFeatureFlagChangesResponses, FeatureFlagsListFeatureFlagChangesErrors, FeatureFlagsGetFeatureFlagChangeData, FeatureFlagsGetFeatureFlagChangeResponses, FeatureFlagsGetFeatureFlagChangeErrors, FeatureFlagsApplyFeatureFlagChangeData, FeatureFlagsApplyFeatureFlagChangeResponses, FeatureFlagsApplyFeatureFlagChangeErrors, FeatureFlagsApproveFeatureFlagChangeData, FeatureFlagsApproveFeatureFlagChangeResponses, FeatureFlagsApproveFeatureFlagChangeErrors, FeatureFlagsRejectFeatureFlagChangeData, FeatureFlagsRejectFeatureFlagChangeResponses, FeatureFlagsRejectFeatureFlagChangeErrors, InsightsGetPeerInsightsData, InsightsGetPeerInsightsResponses, InsightsGetPeerInsightsErrors, InsightsGetBehaviorInsightsData, InsightsGetBehaviorInsightsResponses, InsightsGetBehaviorInsightsErrors, SecretsListSecretsData, SecretsListSecretsResponses, SecretsListSecretsErrors, SecretsCreateSecretData, SecretsCreateSecretResponses, SecretsCreateSecretErrors, SecretsGetLatestSecretData, SecretsGetLatestSecretResponses, SecretsGetLatestSecretErrors, SecretsGetSecretVersionsData, SecretsGetSecretVersionsResponses, SecretsGetSecretVersionsErrors, SecretsDeleteSecretData, SecretsDeleteSecretResponses, SecretsDeleteSecretErrors, SecretsUpdateSecretData, SecretsUpdateSecretResponses, SecretsUpdateSecretErrors, SecretsGetSecretAgentConfigsData, SecretsGetSecretAgentConfigsResponses, SecretsGetSecretAgentConfigsErrors, MediaListMediaData, MediaListMediaResponses, MediaListMediaErrors, MediaUploadMediaData, MediaUploadMediaResponses, MediaUploadMediaErrors, MediaCheckFilenameConflictData, MediaCheckFilenameConflictResponses, MediaCheckFilenameConflictErrors, MediaDeleteMediaData, MediaDeleteMediaResponses, MediaDeleteMediaErrors, MediaGetMediaData, MediaGetMediaResponses, MediaGetMediaErrors, MediaUpdateMediaData, MediaUpdateMediaResponses, MediaUpdateMediaErrors, MediaUploadMediaBatchData, MediaUploadMediaBatchResponses, MediaUploadMediaBatchErrors, ReviewsListReviewsData, ReviewsListReviewsResponses, ReviewsListReviewsErrors, ReviewsCreateReviewData, ReviewsCreateReviewResponses, ReviewsCreateReviewErrors, ReviewsListReviewsAdminData, ReviewsListReviewsAdminResponses, ReviewsListReviewsAdminErrors, ReviewsDeleteReviewAdminData, ReviewsDeleteReviewAdminResponses, ReviewsDeleteReviewAdminErrors, ReviewsGetReviewAdminData, ReviewsGetReviewAdminResponses, ReviewsGetReviewAdminErrors, ReviewsUpdateReviewAdminData, ReviewsUpdateReviewAdminResponses, ReviewsUpdateReviewAdminErrors, ReviewsGetReviewData, ReviewsGetReviewResponses, ReviewsGetReviewErrors, PromoCodesAdminListPromoCodesData, PromoCodesAdminListPromoCodesResponses, PromoCodesAdminListPromoCodesErrors, PromoCodesAdminCreatePromoCodeData, PromoCodesAdminCreatePromoCodeResponses, PromoCodesAdminCreatePromoCodeErrors, PromoCodesAdminDeletePromoCodeData, PromoCodesAdminDeletePromoCodeResponses, PromoCodesAdminDeletePromoCodeErrors, PromoCodesAdminGetPromoCodeByIdData, PromoCodesAdminGetPromoCodeByIdResponses, PromoCodesAdminGetPromoCodeByIdErrors, PromoCodesAdminUpdatePromoCodeData, PromoCodesAdminUpdatePromoCodeResponses, PromoCodesAdminUpdatePromoCodeErrors, PromoCodesAdminGetRevenuecatProductsData, PromoCodesAdminGetRevenuecatProductsResponses, PromoCodesAdminGetRevenuecatOfferingsData, PromoCodesAdminGetRevenuecatOfferingsResponses, PromoCodesAdminGetRevenuecatOfferingsErrors, PromoCodesAdminGetRevenuecatAppData, PromoCodesAdminGetRevenuecatAppResponses, PromoCodesAdminGetRevenuecatAppErrors, PromoCodesAdminClearRevenuecatCacheData, PromoCodesAdminClearRevenuecatCacheResponses, PromoCodesAdminClearRevenuecatCacheErrors, EmailTemplatesListEmailTemplatesData, EmailTemplatesListEmailTemplatesResponses, EmailTemplatesListEmailTemplatesErrors, EmailTemplatesCreateEmailTemplateData, EmailTemplatesCreateEmailTemplateResponses, EmailTemplatesCreateEmailTemplateErrors, EmailTemplatesListSystemEmailsData, EmailTemplatesListSystemEmailsResponses, EmailTemplatesSystemEmailBuiltInData, EmailTemplatesSystemEmailBuiltInResponses, EmailTemplatesSystemEmailBuiltInErrors, EmailTemplatesCustomizeSystemEmailData, EmailTemplatesCustomizeSystemEmailResponses, EmailTemplatesCustomizeSystemEmailErrors, EmailTemplatesUseBuiltInSystemEmailData, EmailTemplatesUseBuiltInSystemEmailResponses, EmailTemplatesUseBuiltInSystemEmailErrors, EmailTemplatesDeleteEmailTemplateData, EmailTemplatesDeleteEmailTemplateResponses, EmailTemplatesDeleteEmailTemplateErrors, EmailTemplatesGetEmailTemplateData, EmailTemplatesGetEmailTemplateResponses, EmailTemplatesGetEmailTemplateErrors, EmailTemplatesUpdateEmailTemplateData, EmailTemplatesUpdateEmailTemplateResponses, EmailTemplatesUpdateEmailTemplateErrors, EmailTemplatesPreviewEmailTemplateData, EmailTemplatesPreviewEmailTemplateResponses, EmailTemplatesPreviewEmailTemplateErrors, EmailTemplatesTestSendEmailTemplateData, EmailTemplatesTestSendEmailTemplateResponses, EmailTemplatesTestSendEmailTemplateErrors, EmailTemplatesListTemplateVersionsData, EmailTemplatesListTemplateVersionsResponses, EmailTemplatesListTemplateVersionsErrors, EmailTemplatesDiscardTemplateDraftData, EmailTemplatesDiscardTemplateDraftResponses, EmailTemplatesDiscardTemplateDraftErrors, EmailTemplatesSaveTemplateDraftData, EmailTemplatesSaveTemplateDraftResponses, EmailTemplatesSaveTemplateDraftErrors, EmailTemplatesReviewTemplateVersionData, EmailTemplatesReviewTemplateVersionResponses, EmailTemplatesReviewTemplateVersionErrors, EmailTemplatesPublishTemplateVersionData, EmailTemplatesPublishTemplateVersionResponses, EmailTemplatesPublishTemplateVersionErrors, EmailTemplatesTemplateStatsData, EmailTemplatesTemplateStatsResponses, EmailTemplatesTemplateStatsErrors, EmailLayoutsListLayoutsData, EmailLayoutsListLayoutsResponses, EmailLayoutsGetSenderIdentityData, EmailLayoutsGetSenderIdentityResponses, EmailLayoutsUpdateSenderIdentityData, EmailLayoutsUpdateSenderIdentityResponses, EmailLayoutsUpdateSenderIdentityErrors, EmailLayoutsLayoutUsageData, EmailLayoutsLayoutUsageResponses, EmailLayoutsLayoutUsageErrors, EmailLayoutsDuplicateLayoutData, EmailLayoutsDuplicateLayoutResponses, EmailLayoutsDuplicateLayoutErrors, EmailLayoutsDeleteLayoutData, EmailLayoutsDeleteLayoutResponses, EmailLayoutsDeleteLayoutErrors, EmailLayoutsUpdateLayoutData, EmailLayoutsUpdateLayoutResponses, EmailLayoutsUpdateLayoutErrors, EmailLayoutsPreviewLayoutData, EmailLayoutsPreviewLayoutResponses, EmailLayoutsPreviewLayoutErrors, EmailLayoutsCompileBodyData, EmailLayoutsCompileBodyResponses, EmailLayoutsCompileBodyErrors, EmailDeliverabilityDeliverabilityData, EmailDeliverabilityDeliverabilityResponses, EmailDeliverabilityDeliverabilityErrors, EmailDeliverabilityRatesData, EmailDeliverabilityRatesResponses, EmailDeliverabilityListHealthData, EmailDeliverabilityListHealthResponses, EmailDeliverabilityDeliveryMethodsComparedData, EmailDeliverabilityDeliveryMethodsComparedResponses, EmailDeliverabilityPipelineData, EmailDeliverabilityPipelineResponses, EmailSuppressionsListSuppressionsData, EmailSuppressionsListSuppressionsResponses, EmailSuppressionsListSuppressionsErrors, EmailSuppressionsAddSuppressionData, EmailSuppressionsAddSuppressionResponses, EmailSuppressionsAddSuppressionErrors, EmailSuppressionsLiftSuppressionData, EmailSuppressionsLiftSuppressionResponses, EmailSuppressionsLiftSuppressionErrors, EmailSuppressionsRequestPostmarkLiftData, EmailSuppressionsRequestPostmarkLiftResponses, EmailSuppressionsRequestPostmarkLiftErrors, EmailCampaignsGetTriggerEventsData, EmailCampaignsGetTriggerEventsResponses, EmailCampaignsGetFlowConditionsData, EmailCampaignsGetFlowConditionsResponses, EmailCampaignsGetEnrollmentCountsData, EmailCampaignsGetEnrollmentCountsResponses, EmailCampaignsListEmailCampaignsData, EmailCampaignsListEmailCampaignsResponses, EmailCampaignsListEmailCampaignsErrors, EmailCampaignsCreateEmailCampaignData, EmailCampaignsCreateEmailCampaignResponses, EmailCampaignsCreateEmailCampaignErrors, EmailCampaignsDeleteEmailCampaignData, EmailCampaignsDeleteEmailCampaignResponses, EmailCampaignsDeleteEmailCampaignErrors, EmailCampaignsGetEmailCampaignData, EmailCampaignsGetEmailCampaignResponses, EmailCampaignsGetEmailCampaignErrors, EmailCampaignsUpdateEmailCampaignData, EmailCampaignsUpdateEmailCampaignResponses, EmailCampaignsUpdateEmailCampaignErrors, EmailCampaignsMoveCampaignData, EmailCampaignsMoveCampaignResponses, EmailCampaignsMoveCampaignErrors, EmailCampaignsCancelRestData, EmailCampaignsCancelRestResponses, EmailCampaignsCancelRestErrors, EmailCampaignsEnrollSegmentInCampaignData, EmailCampaignsEnrollSegmentInCampaignResponses, EmailCampaignsEnrollSegmentInCampaignErrors, EmailCampaignsGetCampaignEngagementData, EmailCampaignsGetCampaignEngagementResponses, EmailCampaignsGetCampaignEngagementErrors, EmailCampaignsCampaignOverviewData, EmailCampaignsCampaignOverviewResponses, EmailCampaignsCampaignOverviewErrors, EmailFlowsDiscardFlowDraftData, EmailFlowsDiscardFlowDraftResponses, EmailFlowsDiscardFlowDraftErrors, EmailFlowsGetFlowDraftData, EmailFlowsGetFlowDraftResponses, EmailFlowsGetFlowDraftErrors, EmailFlowsSaveFlowDraftData, EmailFlowsSaveFlowDraftResponses, EmailFlowsSaveFlowDraftErrors, EmailFlowsReviewFlowDraftData, EmailFlowsReviewFlowDraftResponses, EmailFlowsReviewFlowDraftErrors, EmailFlowsPublishFlowDraftData, EmailFlowsPublishFlowDraftResponses, EmailFlowsPublishFlowDraftErrors, EmailFlowsPreviewFlowDraftData, EmailFlowsPreviewFlowDraftResponses, EmailFlowsPreviewFlowDraftErrors, EmailFlowsTestFlowDraftData, EmailFlowsTestFlowDraftResponses, EmailFlowsTestFlowDraftErrors, EmailFlowsArchiveFlowData, EmailFlowsArchiveFlowResponses, EmailFlowsArchiveFlowErrors, EmailFlowsFlowPreviewPeopleData, EmailFlowsFlowPreviewPeopleResponses, EmailFlowsFlowPreviewPeopleErrors, EmailFlowsDuplicateFlowData, EmailFlowsDuplicateFlowResponses, EmailFlowsDuplicateFlowErrors, EmailCampaignStepsListCampaignStepsData, EmailCampaignStepsListCampaignStepsResponses, EmailCampaignStepsListCampaignStepsErrors, EmailCampaignStepsCreateCampaignStepData, EmailCampaignStepsCreateCampaignStepResponses, EmailCampaignStepsCreateCampaignStepErrors, EmailCampaignStepsDeleteCampaignStepData, EmailCampaignStepsDeleteCampaignStepResponses, EmailCampaignStepsDeleteCampaignStepErrors, EmailCampaignStepsGetCampaignStepData, EmailCampaignStepsGetCampaignStepResponses, EmailCampaignStepsGetCampaignStepErrors, EmailCampaignStepsUpdateCampaignStepData, EmailCampaignStepsUpdateCampaignStepResponses, EmailCampaignStepsUpdateCampaignStepErrors, EmailCampaignStepsReorderCampaignStepsData, EmailCampaignStepsReorderCampaignStepsResponses, EmailCampaignStepsReorderCampaignStepsErrors, EmailCampaignStepsPlanStepBackfillData, EmailCampaignStepsPlanStepBackfillResponses, EmailCampaignStepsPlanStepBackfillErrors, EmailCampaignStepsApplyStepBackfillData, EmailCampaignStepsApplyStepBackfillResponses, EmailCampaignStepsApplyStepBackfillErrors, EmailSendsPreviewEmailData, EmailSendsPreviewEmailResponses, EmailSendsPreviewEmailErrors, EmailSendsEnqueueEmailSendData, EmailSendsEnqueueEmailSendResponses, EmailSendsEnqueueEmailSendErrors, EmailSendsEnqueueEmailSendFromCsvData, EmailSendsEnqueueEmailSendFromCsvResponses, EmailSendsEnqueueEmailSendFromCsvErrors, EmailControlsGetMailControlsData, EmailControlsGetMailControlsResponses, EmailControlsPauseMarketingData, EmailControlsPauseMarketingResponses, EmailControlsPauseMarketingErrors, EmailControlsResumeMarketingData, EmailControlsResumeMarketingResponses, EmailExecutionsListEmailExecutionsData, EmailExecutionsListEmailExecutionsResponses, EmailExecutionsListEmailExecutionsErrors, EmailExecutionsGetEmailExecutionData, EmailExecutionsGetEmailExecutionResponses, EmailExecutionsGetEmailExecutionErrors, EmailExecutionsGetExecutionStatsData, EmailExecutionsGetExecutionStatsResponses, EmailExecutionsGetExecutionStatsErrors, EmailExecutionsRetryEmailExecutionData, EmailExecutionsRetryEmailExecutionResponses, EmailExecutionsRetryEmailExecutionErrors, EmailExecutionsCancelEmailExecutionData, EmailExecutionsCancelEmailExecutionResponses, EmailExecutionsCancelEmailExecutionErrors, EmailExecutionsBulkRetryEmailExecutionsData, EmailExecutionsBulkRetryEmailExecutionsResponses, EmailExecutionsBulkRetryEmailExecutionsErrors, EmailExecutionsBulkCancelEmailExecutionsData, EmailExecutionsBulkCancelEmailExecutionsResponses, EmailExecutionsBulkCancelEmailExecutionsErrors, EmailExecutionsGetSendRunEngagementData, EmailExecutionsGetSendRunEngagementResponses, EmailExecutionsGetSendRunEngagementErrors, EmailComebackCampaignsCameBackData, EmailComebackCampaignsCameBackResponses, EmailComebackCampaignsCameBackErrors, EmailComebackCampaignCameBackData, EmailComebackCampaignCameBackResponses, EmailComebackCampaignCameBackErrors, EmailComebackSendRunCameBackData, EmailComebackSendRunCameBackResponses, EmailComebackSendRunCameBackErrors, EmailComebackTemplateCameBackData, EmailComebackTemplateCameBackResponses, EmailComebackTemplateCameBackErrors, NewsletterListIssuesData, NewsletterListIssuesResponses, NewsletterCreateIssueData, NewsletterCreateIssueResponses, NewsletterCreateIssueErrors, NewsletterDeleteDraftsData, NewsletterDeleteDraftsResponses, NewsletterDeleteDraftsErrors, NewsletterListHealthData, NewsletterListHealthResponses, EmailPeopleListPeopleData, EmailPeopleListPeopleResponses, EmailPeopleListPeopleErrors, EmailPeopleFindPersonData, EmailPeopleFindPersonResponses, EmailPeopleFindPersonErrors, EmailPeopleGetPersonData, EmailPeopleGetPersonResponses, EmailPeopleGetPersonErrors, EmailPeopleWithdrawPersonData, EmailPeopleWithdrawPersonResponses, EmailPeopleWithdrawPersonErrors, EmailPeopleErasePersonData, EmailPeopleErasePersonResponses, EmailPeopleErasePersonErrors, EmailEnrollmentsListEmailEnrollmentsData, EmailEnrollmentsListEmailEnrollmentsResponses, EmailEnrollmentsListEmailEnrollmentsErrors, EmailEnrollmentsGetEmailEnrollmentData, EmailEnrollmentsGetEmailEnrollmentResponses, EmailEnrollmentsGetEmailEnrollmentErrors, EmailEnrollmentsPauseEmailEnrollmentData, EmailEnrollmentsPauseEmailEnrollmentResponses, EmailEnrollmentsPauseEmailEnrollmentErrors, EmailEnrollmentsResumeEmailEnrollmentData, EmailEnrollmentsResumeEmailEnrollmentResponses, EmailEnrollmentsResumeEmailEnrollmentErrors, EmailEnrollmentsCancelEmailEnrollmentData, EmailEnrollmentsCancelEmailEnrollmentResponses, EmailEnrollmentsCancelEmailEnrollmentErrors, MailMediaListMailImagesData, MailMediaListMailImagesResponses, MailMediaUploadMailImageData, MailMediaUploadMailImageResponses, MailMediaUploadMailImageErrors, MailMediaUpdateMailImageData, MailMediaUpdateMailImageResponses, MailMediaUpdateMailImageErrors, CampaignsEnrollInCampaignData, CampaignsEnrollInCampaignResponses, CampaignsEnrollInCampaignErrors, PostmarkWebhookHandlePostmarkWebhookData, PostmarkWebhookHandlePostmarkWebhookResponses, PostmarkWebhookHandlePostmarkWebhook2Data, PostmarkWebhookHandlePostmarkWebhook2Responses, PostmarkWebhookHandlePostmarkInboundData, PostmarkWebhookHandlePostmarkInboundResponses, UserSegmentsListUserSegmentsData, UserSegmentsListUserSegmentsResponses, UserSegmentsListUserSegmentsErrors, UserSegmentsCreateUserSegmentData, UserSegmentsCreateUserSegmentResponses, UserSegmentsCreateUserSegmentErrors, UserSegmentsDeleteUserSegmentData, UserSegmentsDeleteUserSegmentResponses, UserSegmentsDeleteUserSegmentErrors, UserSegmentsGetUserSegmentData, UserSegmentsGetUserSegmentResponses, UserSegmentsGetUserSegmentErrors, UserSegmentsUpdateUserSegmentData, UserSegmentsUpdateUserSegmentResponses, UserSegmentsUpdateUserSegmentErrors, UserSegmentsGetSegmentCountData, UserSegmentsGetSegmentCountResponses, UserSegmentsGetSegmentCountErrors, UserSegmentsGetSegmentSampleData, UserSegmentsGetSegmentSampleResponses, UserSegmentsGetSegmentSampleErrors, UserSegmentsUploadCsvToSegmentData, UserSegmentsUploadCsvToSegmentResponses, UserSegmentsUploadCsvToSegmentErrors, UserSegmentsClearSegmentMembersData, UserSegmentsClearSegmentMembersResponses, UserSegmentsClearSegmentMembersErrors, OtaOtaBundleAdoptionData, OtaOtaBundleAdoptionResponses, OtaOtaBundleAdoptionErrors, DbSchemaGetDatabaseSchemaData, DbSchemaGetDatabaseSchemaResponses, OpsGetOpsStatusData, OpsGetOpsStatusResponses, OpsGetOpsStatusErrors, OpsGetOpsPeerStatusData, OpsGetOpsPeerStatusResponses, OpsGetPeerStatusData, OpsGetPeerStatusResponses, OpsGetPeerStatusErrors, OpsMarkBackfillRunManuallyData, OpsMarkBackfillRunManuallyResponses, OpsMarkBackfillRunManuallyErrors, OpsRetireBackfillData, OpsRetireBackfillResponses, OpsRetireBackfillErrors, OpsPreviewMigrationData, OpsPreviewMigrationResponses, OpsPreviewMigrationErrors, OpsLocateMigrationData, OpsLocateMigrationResponses, OpsLocateMigrationErrors, OpsMigrationRefsData, OpsMigrationRefsResponses, OpsListOpsJobsData, OpsListOpsJobsResponses, OpsListOpsJobsErrors, OpsRequestOpsJobData, OpsRequestOpsJobResponses, OpsRequestOpsJobErrors, OpsGetOpsRunnerData, OpsGetOpsRunnerResponses, OpsGetOpsJobData, OpsGetOpsJobResponses, OpsGetOpsJobErrors, OpsGetOpsJobLogData, OpsGetOpsJobLogResponses, OpsGetOpsJobLogErrors, OpsCancelOpsJobData, OpsCancelOpsJobResponses, OpsCancelOpsJobErrors, OpsApproveOpsJobData, OpsApproveOpsJobResponses, OpsApproveOpsJobErrors, OpsRejectOpsJobData, OpsRejectOpsJobResponses, OpsRejectOpsJobErrors, OpsResumeOpsJobData, OpsResumeOpsJobResponses, OpsResumeOpsJobErrors, OpsPauseOpsRunnerData, OpsPauseOpsRunnerResponses, OpsPauseOpsRunnerErrors, OpsUnpauseOpsRunnerData, OpsUnpauseOpsRunnerResponses, DbMigrationsGetCurrentRevisionData, DbMigrationsGetCurrentRevisionResponses, DbMigrationsGetCurrentRevisionErrors, DbMigrationsCreateApprovalRequestData, DbMigrationsCreateApprovalRequestResponses, DbMigrationsCreateApprovalRequestErrors, DbMigrationsGetApprovalStatusData, DbMigrationsGetApprovalStatusResponses, DbMigrationsGetApprovalStatusErrors, DbMigrationsGetApprovalRequestData, DbMigrationsGetApprovalRequestResponses, DbMigrationsGetApprovalRequestErrors, DbMigrationsApproveApprovalRequestData, DbMigrationsApproveApprovalRequestResponses, DbMigrationsApproveApprovalRequestErrors, DbMigrationsRejectApprovalRequestData, DbMigrationsRejectApprovalRequestResponses, DbMigrationsRejectApprovalRequestErrors, TherapistWaitlistGetRatesData, TherapistWaitlistGetRatesResponses, TherapistWaitlistGetRatesErrors, TherapistWaitlistRecordGroupCoachingConsentsData, TherapistWaitlistRecordGroupCoachingConsentsResponses, TherapistWaitlistRecordGroupCoachingConsentsErrors, TherapistWaitlistListRatesAdminData, TherapistWaitlistListRatesAdminResponses, TherapistWaitlistListRatesAdminErrors, TherapistWaitlistCreateRateData, TherapistWaitlistCreateRateResponses, TherapistWaitlistCreateRateErrors, TherapistWaitlistDeleteRateData, TherapistWaitlistDeleteRateResponses, TherapistWaitlistDeleteRateErrors, TherapistWaitlistUpdateRateData, TherapistWaitlistUpdateRateResponses, TherapistWaitlistUpdateRateErrors, TherapistWaitlistBulkUpsertRatesData, TherapistWaitlistBulkUpsertRatesResponses, TherapistWaitlistBulkUpsertRatesErrors, TherapistWaitlistListWaitlistUsersData, TherapistWaitlistListWaitlistUsersResponses, TherapistWaitlistListWaitlistUsersErrors, TherapistWaitlistExportWaitlistUsersCsvData, TherapistWaitlistExportWaitlistUsersCsvResponses, TherapistWaitlistExportWaitlistUsersCsvErrors, TherapistWaitlistGetWaitlistStatsData, TherapistWaitlistGetWaitlistStatsResponses, TherapistWaitlistGetWaitlistStatsErrors, ConversationsListConversationSessionsData, ConversationsListConversationSessionsResponses, ConversationsListConversationSessionsErrors, ConversationsCreateConversationSessionData, ConversationsCreateConversationSessionResponses, ConversationsCreateConversationSessionErrors, ConversationsCreateOrResumeConversationSessionData, ConversationsCreateOrResumeConversationSessionResponses, ConversationsCreateOrResumeConversationSessionErrors, ConversationsGetConversationSessionData, ConversationsGetConversationSessionResponses, ConversationsGetConversationSessionErrors, ConversationsUpdateConversationSessionData, ConversationsUpdateConversationSessionResponses, ConversationsUpdateConversationSessionErrors, ConversationsGetSessionMessagesData, ConversationsGetSessionMessagesResponses, ConversationsGetSessionMessagesErrors, ConversationsAddMessageData, ConversationsAddMessageResponses, ConversationsAddMessageErrors, HealthEntriesListHealthEntriesData, HealthEntriesListHealthEntriesResponses, HealthEntriesListHealthEntriesErrors, HealthEntriesCreateHealthEntryData, HealthEntriesCreateHealthEntryResponses, HealthEntriesCreateHealthEntryErrors, HealthEntriesUpsertHealthEntryData, HealthEntriesUpsertHealthEntryResponses, HealthEntriesUpsertHealthEntryErrors, HealthEntriesDeleteHealthEntryData, HealthEntriesDeleteHealthEntryResponses, HealthEntriesDeleteHealthEntryErrors, HealthEntriesGetHealthEntryData, HealthEntriesGetHealthEntryResponses, HealthEntriesGetHealthEntryErrors, HealthEntriesUpdateHealthEntryData, HealthEntriesUpdateHealthEntryResponses, HealthEntriesUpdateHealthEntryErrors, HealthEntriesBulkDeleteHealthEntriesData, HealthEntriesBulkDeleteHealthEntriesResponses, HealthEntriesBulkDeleteHealthEntriesErrors, PrepareListMomentsData, PrepareListMomentsResponses, PrepareCreateMomentData, PrepareCreateMomentResponses, PrepareCreateMomentErrors, PrepareDeleteMomentData, PrepareDeleteMomentResponses, PrepareDeleteMomentErrors, PrepareGetMomentData, PrepareGetMomentResponses, PrepareGetMomentErrors, PrepareUpdateMomentData, PrepareUpdateMomentResponses, PrepareUpdateMomentErrors, SupportRelationshipsGetSupportRelationshipsData, SupportRelationshipsGetSupportRelationshipsResponses, SupportRelationshipsCreateSupportRelationshipData, SupportRelationshipsCreateSupportRelationshipResponses, SupportRelationshipsCreateSupportRelationshipErrors, SupportRelationshipsAcceptSupporterInvitationPageData, SupportRelationshipsAcceptSupporterInvitationPageResponses, SupportRelationshipsAcceptSupporterInvitationPageErrors, SupportRelationshipsAcceptSupporterInvitationData, SupportRelationshipsAcceptSupporterInvitationResponses, SupportRelationshipsAcceptSupporterInvitationErrors, SupportRelationshipsDeclineSupporterInvitationPageData, SupportRelationshipsDeclineSupporterInvitationPageResponses, SupportRelationshipsDeclineSupporterInvitationPageErrors, SupportRelationshipsDeclineSupporterInvitationData, SupportRelationshipsDeclineSupporterInvitationResponses, SupportRelationshipsDeclineSupporterInvitationErrors, SupportRelationshipsUnsubscribeSupporterNotificationsData, SupportRelationshipsUnsubscribeSupporterNotificationsResponses, SupportRelationshipsUnsubscribeSupporterNotificationsErrors, SupportRelationshipsUnsubscribeSupporterNotificationsPostData, SupportRelationshipsUnsubscribeSupporterNotificationsPostResponses, SupportRelationshipsUnsubscribeSupporterNotificationsPostErrors, SupportRelationshipsGetSupportingRelationshipsData, SupportRelationshipsGetSupportingRelationshipsResponses, SupportRelationshipsConfirmSupportRelationshipData, SupportRelationshipsConfirmSupportRelationshipResponses, SupportRelationshipsConfirmSupportRelationshipErrors, SupportRelationshipsDeleteSupportRelationshipData, SupportRelationshipsDeleteSupportRelationshipResponses, SupportRelationshipsDeleteSupportRelationshipErrors, SupportRelationshipsUpdateSupportRelationshipData, SupportRelationshipsUpdateSupportRelationshipResponses, SupportRelationshipsUpdateSupportRelationshipErrors, SupporterGetSupporterDashboardData, SupporterGetSupporterDashboardResponses, SupporterGetUserInsightsData, SupporterGetUserInsightsResponses, SupporterGetUserInsightsErrors, SupporterDeleteSupporterAccountData, SupporterDeleteSupporterAccountResponses, SupporterGetSupporterAccountData, SupporterGetSupporterAccountResponses, SupporterUpdateSupporterPreferencesData, SupporterUpdateSupporterPreferencesResponses, SupporterUpdateSupporterPreferencesErrors, CommunityGetFeedData, CommunityGetFeedResponses, CommunityGetFeedErrors, CommunityDeletePostData, CommunityDeletePostResponses, CommunityDeletePostErrors, CommunityGetPostData, CommunityGetPostResponses, CommunityGetPostErrors, CommunityUpdatePostData, CommunityUpdatePostResponses, CommunityUpdatePostErrors, CommunityGetPostCommentsData, CommunityGetPostCommentsResponses, CommunityGetPostCommentsErrors, CommunityCreatePostData, CommunityCreatePostResponses, CommunityCreatePostErrors, CommunityUploadMediaData, CommunityUploadMediaResponses, CommunityUploadMediaErrors, CommunityAttachYoutubeMediaData, CommunityAttachYoutubeMediaResponses, CommunityAttachYoutubeMediaErrors, CommunityCreateVideoUploadData, CommunityCreateVideoUploadResponses, CommunityCreateVideoUploadErrors, CommunityFinalizeVideoMediaData, CommunityFinalizeVideoMediaResponses, CommunityFinalizeVideoMediaErrors, CommunityCreateCommentData, CommunityCreateCommentResponses, CommunityCreateCommentErrors, CommunityBoostPostData, CommunityBoostPostResponses, CommunityBoostPostErrors, CommunityUnboostPostData, CommunityUnboostPostResponses, CommunityUnboostPostErrors, CommunityArchivePostData, CommunityArchivePostResponses, CommunityArchivePostErrors, CommunityRestorePostData, CommunityRestorePostResponses, CommunityRestorePostErrors, CommunitySetPostTopicData, CommunitySetPostTopicResponses, CommunitySetPostTopicErrors, CommunityArchiveCommentData, CommunityArchiveCommentResponses, CommunityArchiveCommentErrors, CommunityUpdateCommentData, CommunityUpdateCommentResponses, CommunityUpdateCommentErrors, CommunitySetPostReactionData, CommunitySetPostReactionResponses, CommunitySetPostReactionErrors, CommunitySetCommentReactionData, CommunitySetCommentReactionResponses, CommunitySetCommentReactionErrors, CommunitySetPostSavedData, CommunitySetPostSavedResponses, CommunitySetPostSavedErrors, CommunityGetSavedData, CommunityGetSavedResponses, CommunityGetSavedErrors, CommunityReportContentData, CommunityReportContentResponses, CommunityReportContentErrors, CommunityGetUserProfileData, CommunityGetUserProfileResponses, CommunityGetUserProfileErrors, CommunityGetUserPostsData, CommunityGetUserPostsResponses, CommunityGetUserPostsErrors, CommunityUpdateMyProfileData, CommunityUpdateMyProfileResponses, CommunityUpdateMyProfileErrors, CommunityGetPledgeRoomData, CommunityGetPledgeRoomResponses, CommunityListTopicsData, CommunityListTopicsResponses, CommunityListTopicsErrors, CommunityCreateTopicData, CommunityCreateTopicResponses, CommunityCreateTopicErrors, CommunityDeleteTopicData, CommunityDeleteTopicResponses, CommunityDeleteTopicErrors, CommunityUpdateTopicData, CommunityUpdateTopicResponses, CommunityUpdateTopicErrors, CommunityReorderTopicsData, CommunityReorderTopicsResponses, CommunityReorderTopicsErrors, CommunityListChannelVideosData, CommunityListChannelVideosResponses, CommunitySetChannelVideosData, CommunitySetChannelVideosResponses, CommunitySetChannelVideosErrors, CommunityGetActivityData, CommunityGetActivityResponses, CommunityDismissActivityRowData, CommunityDismissActivityRowResponses, CommunityDismissActivityRowErrors, CommunityDismissAllActivityData, CommunityDismissAllActivityResponses, CommunityGetPushPreferenceData, CommunityGetPushPreferenceResponses, CommunitySetPushPreferenceData, CommunitySetPushPreferenceResponses, CommunitySetPushPreferenceErrors, CommunityGetMyFlairsData, CommunityGetMyFlairsResponses, CommunitySetMyShownFlairsData, CommunitySetMyShownFlairsResponses, CommunitySetMyShownFlairsErrors, CommunityMarkMyFlairsSeenData, CommunityMarkMyFlairsSeenResponses, CommunityMarkMyFlairsSeenErrors, UserStateReadMyStateData, UserStateReadMyStateResponses, UserStateWriteMyStateData, UserStateWriteMyStateResponses, UserStateWriteMyStateErrors, PaywallEventsRecordMyPaywallEventsData, PaywallEventsRecordMyPaywallEventsResponses, PaywallEventsRecordMyPaywallEventsErrors, ActiveDaysRecordMyActiveDaysData, ActiveDaysRecordMyActiveDaysResponses, ActiveDaysRecordMyActiveDaysErrors, PrivateSendCustomNotificationData, PrivateSendCustomNotificationResponses, PrivateSendCustomNotificationErrors } from './types.gen';
import { client } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export class AppStatus {
    /**
     * Get App Status
     * Checked on every app cold start and every foreground.
     *
     * Returns whether the app is operational, under maintenance, or requires an
     * update. Auth is OPTIONAL and the endpoint must keep working without it — a
     * user who cannot sign in is exactly who a maintenance notice is for. A token,
     * when present, is what makes segment targeting possible: a kill-switch rule
     * naming a segment matches only its current members, so a prompt can be
     * rehearsed on your own account before it goes to everyone.
     *
     * Every uncertainty resolves to doing nothing: no token, an archived or
     * empty segment, an unknown platform or version — the rule does not match.
     * Blocking or nagging the wrong people is the harmful failure here; showing
     * nothing is not.
     *
     * ``platform`` and ``app_version`` are OPTIONAL for the same reason. They
     * only decide the two version-gated sections; maintenance does not depend on a
     * build at all. A caller who omits them — an
     * uptime check, a curl, a client we have not written yet — gets the answer to
     * the question they can be answered, and is never told to update, because
     * there is no version to compare against. Refusing the whole request with a
     * 422 was the one behaviour this endpoint must not have: it is the endpoint
     * you reach for when everything else is broken.
     *
     * ``response_model_exclude_none=True`` keeps the common case small. When
     * everything is off this is ~130 bytes instead of 311 of nulls, on every
     * foreground of every install. The section objects are still present, so the
     * client's optional chaining is unaffected.
     */
    public static appStatusGetAppStatus<ThrowOnError extends boolean = false>(options?: Options<AppStatusGetAppStatusData, ThrowOnError>) {
        return (options?.client ?? client).get<AppStatusGetAppStatusResponses, AppStatusGetAppStatusErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/app/status',
            ...options
        });
    }
}

export class Auth {
    /**
     * Cancel Deletion
     * Confirm cancellation of a pending account deletion (resurrection).
     *
     * Ownership is proven by the ``recovery_token`` — minted only after a
     * successful auth for THIS account while it had a pending deletion. We
     * re-validate the grace window server-side and clear the markers atomically.
     * Replay-safe: once cleared, the account no longer has a pending deletion, so
     * a reused token is rejected. On success the user is logged back in.
     */
    public static authCancelDeletion<ThrowOnError extends boolean = false>(options: Options<AuthCancelDeletionData, ThrowOnError>) {
        return (options.client ?? client).post<AuthCancelDeletionResponses, AuthCancelDeletionErrors, ThrowOnError>({
            url: '/api/v1/auth/cancel-deletion',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Login
     * OAuth2 compatible token login, get an access token for future requests.
     * If 2FA is enabled, returns a two-factor token instead.
     * If email not verified, sends verification email and returns message.
     * If the account has a pending deletion within grace, returns a
     * PendingDeletionToken so the app can offer to cancel the deletion.
     */
    public static authLogin<ThrowOnError extends boolean = false>(options: Options<AuthLoginData, ThrowOnError>) {
        return (options.client ?? client).post<AuthLoginResponses, AuthLoginErrors, ThrowOnError>({
            url: '/api/v1/auth/login',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Refresh Access Token
     * Refresh access token using HTTP-only cookie (web) or request body (mobile)
     */
    public static authRefreshAccessToken<ThrowOnError extends boolean = false>(options?: Options<AuthRefreshAccessTokenData, ThrowOnError>) {
        return (options?.client ?? client).post<AuthRefreshAccessTokenResponses, AuthRefreshAccessTokenErrors, ThrowOnError>({
            url: '/api/v1/auth/refresh-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Logout
     * Revoke all refresh tokens for the current user (logout from all devices)
     */
    public static authLogout<ThrowOnError extends boolean = false>(options?: Options<AuthLogoutData, ThrowOnError>) {
        return (options?.client ?? client).post<AuthLogoutResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/logout',
            ...options
        });
    }
    
    /**
     * Test Token
     * Test access token
     */
    public static authTestToken<ThrowOnError extends boolean = false>(options?: Options<AuthTestTokenData, ThrowOnError>) {
        return (options?.client ?? client).post<AuthTestTokenResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/test-token',
            ...options
        });
    }
    
    /**
     * Password Recovery
     * Send password recovery email.
     * Always returns success message, even if user doesn't exist (prevents user enumeration).
     */
    public static authPasswordRecovery<ThrowOnError extends boolean = false>(options: Options<AuthPasswordRecoveryData, ThrowOnError>) {
        return (options.client ?? client).post<AuthPasswordRecoveryResponses, AuthPasswordRecoveryErrors, ThrowOnError>({
            url: '/api/v1/auth/password-recovery',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reset Password
     * Reset password
     */
    public static authResetPassword<ThrowOnError extends boolean = false>(options: Options<AuthResetPasswordData, ThrowOnError>) {
        return (options.client ?? client).post<AuthResetPasswordResponses, AuthResetPasswordErrors, ThrowOnError>({
            url: '/api/v1/auth/reset-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Request Magic Link
     * Unified passwordless magic link. There is no separate "login" vs "sign up" —
     * the caller always sends just an email, and the intent is decided here from
     * (a) whether the email already belongs to an account and (b) whether the
     * caller is an authenticated guest (anonymous) sending their bearer token:
     *
     * - email belongs to an existing account  → LOGIN to it
     * - caller is a guest, email is free       → CONVERT the guest (keep progress)
     * - no account, no guest                   → SIGNUP (create on verify)
     *
     * The actual mutation happens in /magic-link/verify when the link is tapped.
     * The response is identical in every case (no account-existence leak), with
     * one deliberate exception: a throttled request answers 429 with Retry-After.
     * That says something about the caller's own recent requests, never about
     * whether the address has an account.
     *
     * An address holding a static login code is answered without sending anything
     * at all, and says so with `code_only` -- see the comment at that branch.
     *
     * `intent="login"` is the exception to all of the above: it needs a session,
     * and an address with no account answers 404 `no_account` and sends nothing.
     */
    public static authRequestMagicLink<ThrowOnError extends boolean = false>(options: Options<AuthRequestMagicLinkData, ThrowOnError>) {
        return (options.client ?? client).post<AuthRequestMagicLinkResponses, AuthRequestMagicLinkErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/magic-link',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Request Link Email
     * Associate `email` with the signed-in caller's account. Used by the in-app
     * email asks (onboarding, post-purchase, the existing-user screen) and by the
     * recovery flow (condri://auth/link-email).
     *
     * Verification-by-construction: an email is NEVER attached here. Every
     * outcome is an email to the typed address, and the attach happens only when
     * a link (or the code) in that email is redeemed: proof the inbox is theirs.
     *
     * - email is free (or unverified on caller)  → send a magic link carrying a
     * convert intent for the
     * caller; redeeming it
     * attaches the address and
     * stamps dt_email_verified.
     * - email already verified on caller         → no-op success.
     * - email belongs to another live account    → email that address a
     * confirmation link; tapping
     * it merges the older
     * account's data into the
     * caller's account.
     *
     * We always return a generic 200 to avoid leaking which emails exist: every
     * branch that sends anything answers with the same words.
     *
     * `consents` (the marketing box, the welcome notice) are recorded against the
     * typed address with the caller's id and only take effect once that same
     * account redeems the email (`contact.confirm_app_grants`).
     */
    public static authRequestLinkEmail<ThrowOnError extends boolean = false>(options: Options<AuthRequestLinkEmailData, ThrowOnError>) {
        return (options.client ?? client).post<AuthRequestLinkEmailResponses, AuthRequestLinkEmailErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/link-email',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Confirm Link Email
     * Confirm a link-email merge.
     *
     * SECURITY (account-merge takeover fix): a merge moves the SOURCE account's
     * entire dataset into the TARGET account and then soft-deletes the source.
     * Previously this endpoint was public and any recipient tap completed the
     * merge — so an attacker (target) could name a victim's email and, on the
     * victim's single click, receive the victim's data. The click alone is not
     * consent to *donate* your data into someone else's account.
     *
     * Now the confirming party must be **authenticated as the source account**
     * (the owner of the emailed address). That is the account whose data moves,
     * so it — and only it — can authorize the move. An attacker cannot satisfy
     * this because they don't control the victim's session. The token still binds
     * (source, target) so ids can't be swapped, and it is single-use.
     */
    public static authConfirmLinkEmail<ThrowOnError extends boolean = false>(options: Options<AuthConfirmLinkEmailData, ThrowOnError>) {
        return (options.client ?? client).post<AuthConfirmLinkEmailResponses, AuthConfirmLinkEmailErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/link-email/confirm',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Verify Magic Link
     * Verify a magic link token and return an access token.
     * If 2FA is enabled, returns a two-factor token instead.
     */
    public static authVerifyMagicLink<ThrowOnError extends boolean = false>(options: Options<AuthVerifyMagicLinkData, ThrowOnError>) {
        return (options.client ?? client).post<AuthVerifyMagicLinkResponses, AuthVerifyMagicLinkErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/magic-link/verify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Cloudflare Access Login
     * Admin panel sign-in on the Cloudflare Access token for the panel host.
     *
     * Stands in for the magic link only: the account must already exist and hold
     * panel scopes, and the session (TOTP step included) is the one a magic link
     * for the same account would grant. 404 until CF_ACCESS_* is configured.
     */
    public static authCloudflareAccessLogin<ThrowOnError extends boolean = false>(options: Options<AuthCloudflareAccessLoginData, ThrowOnError>) {
        return (options.client ?? client).post<AuthCloudflareAccessLoginResponses, AuthCloudflareAccessLoginErrors, ThrowOnError>({
            url: '/api/v1/auth/cloudflare-access',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Redeem Login Code
     * Redeem the 6-digit code from a magic-link email.
     *
     * Same grant as tapping the link — login, passwordless signup, or guest
     * conversion, whichever the email carried — for people reading the email on
     * a different device than the one signing in, and for inboxes whose
     * security scanners prefetch and burn one-time links.
     *
     * Guardrails: the stored hash is compared in constant time; a code dies
     * after 5 wrong attempts, on expiry, when its paired link is used, or when
     * a newer code is issued for the same email; failures are rate limited per
     * email and per IP off auth_events, like magic-link verification. Every
     * failure is the same generic 400 so nothing leaks about which codes exist;
     * exceeding the rate limit answers 429 with Retry-After, the one distinction
     * the client needs to stop asking someone to retype.
     *
     * One address in a thousand also carries a static code -- the permanent
     * credential we hand to App Store and Play reviewers, who cannot open the
     * inbox this email would land in. It is checked first, below the rate limits
     * and above everything else. See models.database.a.StaticLoginCode.
     */
    public static authRedeemLoginCode<ThrowOnError extends boolean = false>(options: Options<AuthRedeemLoginCodeData, ThrowOnError>) {
        return (options.client ?? client).post<AuthRedeemLoginCodeResponses, AuthRedeemLoginCodeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/magic-link/redeem-code',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Setup Totp
     * Setup TOTP for the current user
     */
    public static authSetupTotp<ThrowOnError extends boolean = false>(options?: Options<AuthSetupTotpData, ThrowOnError>) {
        return (options?.client ?? client).post<AuthSetupTotpResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/totp/setup',
            ...options
        });
    }
    
    /**
     * Get Totp Qrcode
     * Get a QR code for TOTP setup
     */
    public static authGetTotpQrcode<ThrowOnError extends boolean = false>(options?: Options<AuthGetTotpQrcodeData, ThrowOnError>) {
        return (options?.client ?? client).get<AuthGetTotpQrcodeResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/totp/qrcode',
            ...options
        });
    }
    
    /**
     * Verify Totp Setup
     * Verify TOTP setup and enable it for the user
     */
    public static authVerifyTotpSetup<ThrowOnError extends boolean = false>(options: Options<AuthVerifyTotpSetupData, ThrowOnError>) {
        return (options.client ?? client).post<AuthVerifyTotpSetupResponses, AuthVerifyTotpSetupErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/totp/verify-setup',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Verify Totp
     * Verify TOTP code and complete the login process
     */
    public static authVerifyTotp<ThrowOnError extends boolean = false>(options: Options<AuthVerifyTotpData, ThrowOnError>) {
        return (options.client ?? client).post<AuthVerifyTotpResponses, AuthVerifyTotpErrors, ThrowOnError>({
            url: '/api/v1/auth/totp/verify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Register User
     * Create new user without the need to be logged in.
     * Only allowed if ALLOW_USER_REGISTRATION is enabled.
     *
     * Flow:
     * 1. Check if user already exists -> handle duplicate signup
     * 2. Create new user
     * 3. Check email verification requirement -> return tokens or message accordingly
     * 4. Send magic link email if ENABLE_MAGIC_LINK_ON_SIGNUP is True
     * 5. Emit signup event (campaign enrollment handled by ENABLE_CAMPAIGN_EVENT_HANDLERS)
     *
     * Settings:
     * - ENABLE_MAGIC_LINK_ON_SIGNUP: Controls whether magic link email is sent.
     * - REQUIRE_EMAIL_VERIFICATION: Controls whether email verification is required before login.
     * - ENABLE_CAMPAIGN_EVENT_HANDLERS: Controls whether campaign enrollment happens via events.
     */
    public static authRegisterUser<ThrowOnError extends boolean = false>(options: Options<AuthRegisterUserData, ThrowOnError>) {
        return (options.client ?? client).post<AuthRegisterUserResponses, AuthRegisterUserErrors, ThrowOnError>({
            url: '/api/v1/auth/signup',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Disable Totp
     * Disable TOTP for the current user
     */
    public static authDisableTotp<ThrowOnError extends boolean = false>(options: Options<AuthDisableTotpData, ThrowOnError>) {
        return (options.client ?? client).post<AuthDisableTotpResponses, AuthDisableTotpErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/totp/disable',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Register Biometric Token
     * Register a biometric token for the current user.
     */
    public static authRegisterBiometricToken<ThrowOnError extends boolean = false>(options: Options<AuthRegisterBiometricTokenData, ThrowOnError>) {
        return (options.client ?? client).post<AuthRegisterBiometricTokenResponses, AuthRegisterBiometricTokenErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/biometric/register',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Revoke Biometric Token
     * Revoke the current user's biometric token (disable biometric re-login).
     */
    public static authRevokeBiometricToken<ThrowOnError extends boolean = false>(options?: Options<AuthRevokeBiometricTokenData, ThrowOnError>) {
        return (options?.client ?? client).post<AuthRevokeBiometricTokenResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/biometric/revoke',
            ...options
        });
    }
    
    /**
     * Login With Biometric
     * Login using a biometric token.
     *
     * A within-grace pending-deletion account is allowed through to token
     * verification; on success it gets a PendingDeletionToken (offer to cancel)
     * rather than a session.
     */
    public static authLoginWithBiometric<ThrowOnError extends boolean = false>(options: Options<AuthLoginWithBiometricData, ThrowOnError>) {
        return (options.client ?? client).post<AuthLoginWithBiometricResponses, AuthLoginWithBiometricErrors, ThrowOnError>({
            url: '/api/v1/auth/biometric/login',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Ping Auth
     * Ping endpoint to verify authentication token is valid.
     * Returns basic user info if token is valid, 401 if invalid.
     */
    public static authPingAuth<ThrowOnError extends boolean = false>(options?: Options<AuthPingAuthData, ThrowOnError>) {
        return (options?.client ?? client).get<AuthPingAuthResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/ping',
            ...options
        });
    }
    
    /**
     * Device Auth
     * Authenticate or create an anonymous user via device credentials.
     *
     * - If device_id is not found, creates a new anonymous user and returns tokens.
     * - If device_id exists, verifies the device_secret and returns tokens.
     * - With `expected_user_id`, never creates: an unbound device, or one bound to
     * anyone else, gets 409 `device_not_bound_to_user` and nothing is written.
     */
    public static authDeviceAuth<ThrowOnError extends boolean = false>(options: Options<AuthDeviceAuthData, ThrowOnError>) {
        return (options.client ?? client).post<AuthDeviceAuthResponses, AuthDeviceAuthErrors, ThrowOnError>({
            url: '/api/v1/auth/device',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Device Bind
     * Bind this device to the signed-in member, so that pinned device recovery
     * (`/auth/device` with `expected_user_id`) can sign them back in after the
     * app loses their session. Guests are bound when they are created.
     *
     * The same proof as `/biometric/register`: the member's own session. The
     * device can only ever sign in the account that bound it. One device per
     * member, so a newer phone's bind replaces the last. A device another
     * account holds is never moved (409): that account's way back is this
     * device, and only guest merge releases it.
     */
    public static authDeviceBind<ThrowOnError extends boolean = false>(options: Options<AuthDeviceBindData, ThrowOnError>) {
        return (options.client ?? client).post<AuthDeviceBindResponses, AuthDeviceBindErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/device/bind',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Device Convert
     * Convert an anonymous (device-auth) user to a regular account.
     *
     * Sets email + password on the existing user row. All data stays linked
     * to the same user_id.
     *
     * The address is typed, not proven, so this does not register a member: that
     * happens when the address is first verified (``user_crud.register_member``).
     */
    public static authDeviceConvert<ThrowOnError extends boolean = false>(options: Options<AuthDeviceConvertData, ThrowOnError>) {
        return (options.client ?? client).post<AuthDeviceConvertResponses, AuthDeviceConvertErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/auth/device/convert',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Oauth {
    /**
     * Google Login
     */
    public static oauthGoogleLogin<ThrowOnError extends boolean = false>(options: Options<OauthGoogleLoginData, ThrowOnError>) {
        return (options.client ?? client).get<OauthGoogleLoginResponses, OauthGoogleLoginErrors, ThrowOnError>({
            url: '/api/v1/a/oauth/google/login',
            ...options
        });
    }
    
    /**
     * Google Callback
     */
    public static oauthGoogleCallback<ThrowOnError extends boolean = false>(options: Options<OauthGoogleCallbackData, ThrowOnError>) {
        return (options.client ?? client).get<OauthGoogleCallbackResponses, OauthGoogleCallbackErrors, ThrowOnError>({
            url: '/api/v1/a/oauth/google/callback',
            ...options
        });
    }
    
    /**
     * Google Mobile Callback
     * Verify Google authorization code and create/login user for mobile apps.
     *
     * Google Sign In flow for mobile:
     * 1. Client gets authorization code from Google via expo-auth-session
     * 2. Client sends code to this endpoint
     * 3. Backend exchanges code for Google tokens
     * 4. Backend verifies Google ID token
     * 5. Extract user ID (sub) from verified token
     * 6. Check if user exists by google_oauth_id
     * 7. If not found and email provided, try to link to existing email account
     * 8. Create new user if needed
     * 9. Return our JWT access token
     */
    public static oauthGoogleMobileCallback<ThrowOnError extends boolean = false>(options: Options<OauthGoogleMobileCallbackData, ThrowOnError>) {
        return (options.client ?? client).post<OauthGoogleMobileCallbackResponses, OauthGoogleMobileCallbackErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/a/oauth/google/mobile-callback',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Apple Callback
     * Verify Apple identity token and create/login user.
     *
     * Apple Sign In flow:
     * 1. Client gets identity_token from Apple SDK
     * 2. Client sends identity_token to this endpoint
     * 3. Backend verifies token with Apple's public keys
     * 4. Extract user ID (sub) from verified token
     * 5. Check if user exists by apple_oauth_id
     * 6. If not found and email provided, try to link to existing email account
     * 7. Create new user if needed
     * 8. Return our JWT access token
     *
     * Note: Apple only provides email/name on FIRST sign-in. Subsequent sign-ins
     * will only have the identity_token with the stable user ID (sub).
     */
    public static oauthAppleCallback<ThrowOnError extends boolean = false>(options: Options<OauthAppleCallbackData, ThrowOnError>) {
        return (options.client ?? client).post<OauthAppleCallbackResponses, OauthAppleCallbackErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/a/oauth/apple/callback',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Oauth Config
     * Get OAuth configuration for mobile clients.
     *
     * Returns public OAuth client IDs (safe to expose).
     * Used by mobile apps to initiate OAuth flows.
     *
     * If platform is provided ("ios" or "android"), returns the platform-specific client ID.
     */
    public static oauthGetOauthConfig<ThrowOnError extends boolean = false>(options?: Options<OauthGetOauthConfigData, ThrowOnError>) {
        return (options?.client ?? client).get<OauthGetOauthConfigResponses, OauthGetOauthConfigErrors, ThrowOnError>({
            url: '/api/v1/a/oauth/config',
            ...options
        });
    }
    
    /**
     * Test Oauth Config
     * Test endpoint to verify OAuth configuration for localhost testing.
     */
    public static oauthTestOauthConfig<ThrowOnError extends boolean = false>(options?: Options<OauthTestOauthConfigData, ThrowOnError>) {
        return (options?.client ?? client).get<OauthTestOauthConfigResponses, unknown, ThrowOnError>({
            url: '/api/v1/a/oauth/test',
            ...options
        });
    }
}

export class Users {
    /**
     * Delete User Me
     * Request deletion of your own account.
     *
     * This is a SOFT delete plus offboarding, not an immediate erasure. It marks
     * the account for deletion (recoverable during a grace window by logging back
     * in), writes a PII-free audit tombstone, kills all sessions, cancels any live
     * Stripe subscription at period end, and emails a confirmation with the right
     * place to cancel a store-managed subscription. The daily grace cron performs
     * the irreversible erasure after the grace window, once nothing still bills
     * the account.
     */
    public static usersDeleteUserMe<ThrowOnError extends boolean = false>(options?: Options<UsersDeleteUserMeData, ThrowOnError>) {
        return (options?.client ?? client).delete<UsersDeleteUserMeResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me',
            ...options
        });
    }
    
    /**
     * Read User Me
     * Get current user.
     *
     * ``is_onboarded`` is derived server-side from the onboarding marker entry —
     * the single source of truth the app and web funnel share — so a fresh device
     * (whose local copy hasn't synced) gets the authoritative answer here rather
     * than inferring it from an empty local database.
     */
    public static usersReadUserMe<ThrowOnError extends boolean = false>(options?: Options<UsersReadUserMeData, ThrowOnError>) {
        return (options?.client ?? client).get<UsersReadUserMeResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me',
            ...options
        });
    }
    
    /**
     * Update User Me
     * Update own user.
     *
     * Changing the email is a security-sensitive step-up action: it re-points the
     * login identity and feeds the (previously verified) address into downstream
     * SSO tokens (Octopus/beehiiv). So when the email changes we (a) require the
     * current password to prove it's really the account owner, (b) reset the
     * verified flag and (c) send a fresh verification email. Name/metadata-only
     * updates are unaffected.
     */
    public static usersUpdateUserMe<ThrowOnError extends boolean = false>(options: Options<UsersUpdateUserMeData, ThrowOnError>) {
        return (options.client ?? client).patch<UsersUpdateUserMeResponses, UsersUpdateUserMeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get My Billing Id
     * The pseudonym to hand a payment provider for this account.
     *
     * The app calls Purchases.logIn() with THIS, never a.users.id — so the real
     * account id is not what RevenueCat/Adapty stores.
     *
     * It is NOT safe to assume this equals a.users.id. Accounts that existed when
     * the 20260722_090000 migration ran carry billing_id == user_id as a legacy
     * alias, but every account created since gets an opaque uuid4, so the client
     * must use whatever this returns and must not substitute the account id when
     * the call fails — RevenueCat would mint a second customer for the same person
     * and never merge the two. See RevenueCatService.fetchBillingId.
     *
     * get_or_create_current self-heals if the account somehow has no identity yet.
     */
    public static usersGetMyBillingId<ThrowOnError extends boolean = false>(options?: Options<UsersGetMyBillingIdData, ThrowOnError>) {
        return (options?.client ?? client).get<UsersGetMyBillingIdResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/billing-id',
            ...options
        });
    }
    
    /**
     * Get User Access
     * Get user access level and permissions.
     */
    public static usersGetUserAccess<ThrowOnError extends boolean = false>(options?: Options<UsersGetUserAccessData, ThrowOnError>) {
        return (options?.client ?? client).get<UsersGetUserAccessResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/access',
            ...options
        });
    }
    
    /**
     * Update Password Me
     * Update own password.
     */
    public static usersUpdatePasswordMe<ThrowOnError extends boolean = false>(options: Options<UsersUpdatePasswordMeData, ThrowOnError>) {
        return (options.client ?? client).patch<UsersUpdatePasswordMeResponses, UsersUpdatePasswordMeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update Device Metadata
     * Update device metadata (device_type, is_test, app_version, and device details) in app_metadata.
     *
     * This is a dedicated endpoint for device-specific metadata updates that should
     * only happen once per user per device. All fields are optional - only provided
     * fields will be updated.
     *
     * This endpoint is idempotent and designed to be called during app initialization
     * to sync device type, test flight status, app version, and detailed device information.
     */
    public static usersUpdateDeviceMetadata<ThrowOnError extends boolean = false>(options: Options<UsersUpdateDeviceMetadataData, ThrowOnError>) {
        return (options.client ?? client).patch<UsersUpdateDeviceMetadataResponses, UsersUpdateDeviceMetadataErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/device-metadata',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Record Install Attribution
     * Record the measurement partner's verdict on this install (guests too).
     *
     * Idempotent: first report per (user, provider) wins, a repeat is a 200 and a
     * no-op, so the app can retry until it sees one. A failure to store is a 503
     * so the app keeps its copy and tries again next launch.
     */
    public static usersRecordInstallAttribution<ThrowOnError extends boolean = false>(options: Options<UsersRecordInstallAttributionData, ThrowOnError>) {
        return (options.client ?? client).post<UsersRecordInstallAttributionResponses, UsersRecordInstallAttributionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/install-attribution',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Report Permission Change
     * Record that an OS permission (push, or iOS ATT) changed on this device.
     *
     * The app reports only when what the OS says differs from what it last
     * reported, and retries until it gets a 2xx, so this is idempotent: a report
     * that repeats the latest state for this device and kind writes nothing.
     */
    public static usersReportPermissionChange<ThrowOnError extends boolean = false>(options: Options<UsersReportPermissionChangeData, ThrowOnError>) {
        return (options.client ?? client).post<UsersReportPermissionChangeResponses, UsersReportPermissionChangeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/permission-changes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Mark Widget Used
     * Record that the user has used the panic-button widget — launched from it,
     * or confirmed 'I've already added it'. Idempotent. Sets a flag in
     * user_metadata that server-gates the 'add the widget' portal card so we stop
     * nagging them (the client also gates locally as an offline fallback).
     */
    public static usersMarkWidgetUsed<ThrowOnError extends boolean = false>(options?: Options<UsersMarkWidgetUsedData, ThrowOnError>) {
        return (options?.client ?? client).post<UsersMarkWidgetUsedResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/widget-used',
            ...options
        });
    }
    
    /**
     * Update Ab Test Variant
     * Update A/B test variant selection in app_metadata.
     *
     * Stores the selected variant for a feature flag in the user's app_metadata
     * under the 'ab_test_variants' key. This allows the app to remember which
     * variant was assigned to the user for consistent experience.
     */
    public static usersUpdateAbTestVariant<ThrowOnError extends boolean = false>(options: Options<UsersUpdateAbTestVariantData, ThrowOnError>) {
        return (options.client ?? client).patch<UsersUpdateAbTestVariantResponses, UsersUpdateAbTestVariantErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/ab-test-variant',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update Journey Pace
     * Choose the Journey's pacing: one day per day, or as fast as you work.
     *
     * Scoped to the caller alone — there is deliberately no ``user_id``, so no
     * token confusion can re-pace somebody else's programme.
     *
     * Changing pace is not retroactive and moves nobody: it changes which day the
     * client will OFFER next, and the member still has to tap. Going back to
     * ``daily`` re-applies the calendar to wherever they now stand, which can mean
     * today's day is already finished and tomorrow is a real wait again. That is
     * the honest behaviour, and the reason this is a preference rather than a
     * one-way door.
     *
     * See ``app/services/journey_pace.py`` for why this is not time travel.
     */
    public static usersUpdateJourneyPace<ThrowOnError extends boolean = false>(options: Options<UsersUpdateJourneyPaceData, ThrowOnError>) {
        return (options.client ?? client).patch<UsersUpdateJourneyPaceResponses, UsersUpdateJourneyPaceErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/journey-pace',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Read My Email Preferences
     * Which email purposes this account currently receives (Settings).
     */
    public static usersReadMyEmailPreferences<ThrowOnError extends boolean = false>(options?: Options<UsersReadMyEmailPreferencesData, ThrowOnError>) {
        return (options?.client ?? client).get<UsersReadMyEmailPreferencesResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/email-preferences',
            ...options
        });
    }
    
    /**
     * Update My Email Preference
     * Turn one email purpose on or off from Settings.
     *
     * Needs a verified address: consent belongs to an inbox, and an address
     * nobody proved is not one yet. The toggle's label is sent as the statement,
     * so the log keeps the words that were on screen.
     */
    public static usersUpdateMyEmailPreference<ThrowOnError extends boolean = false>(options: Options<UsersUpdateMyEmailPreferenceData, ThrowOnError>) {
        return (options.client ?? client).post<UsersUpdateMyEmailPreferenceResponses, UsersUpdateMyEmailPreferenceErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/email-preferences',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Read My Health Data Consent
     * Whether this account has agreed to us processing its health information.
     */
    public static usersReadMyHealthDataConsent<ThrowOnError extends boolean = false>(options?: Options<UsersReadMyHealthDataConsentData, ThrowOnError>) {
        return (options?.client ?? client).get<UsersReadMyHealthDataConsentResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/health-data-consent',
            ...options
        });
    }
    
    /**
     * Record My Health Data Consent
     * Record the in-app Art. 9 decision, keyed to the account.
     *
     * Guests included: they have no address, and the data this covers is held
     * under the account rather than an inbox. The screen's words are sent as the
     * statement, so the log keeps exactly what was on screen.
     */
    public static usersRecordMyHealthDataConsent<ThrowOnError extends boolean = false>(options: Options<UsersRecordMyHealthDataConsentData, ThrowOnError>) {
        return (options.client ?? client).post<UsersRecordMyHealthDataConsentResponses, UsersRecordMyHealthDataConsentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/health-data-consent',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Read My Research Consent
     * Whether this account has agreed to its data being used for research.
     */
    public static usersReadMyResearchConsent<ThrowOnError extends boolean = false>(options?: Options<UsersReadMyResearchConsentData, ThrowOnError>) {
        return (options?.client ?? client).get<UsersReadMyResearchConsentResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/research-consent',
            ...options
        });
    }
    
    /**
     * Record My Research Consent
     * Record the optional research decision, keyed to the account.
     *
     * Given as an unticked box on the health information screen, and taken back
     * from Settings. A "no" after a yes is a withdrawal.
     */
    public static usersRecordMyResearchConsent<ThrowOnError extends boolean = false>(options: Options<UsersRecordMyResearchConsentData, ThrowOnError>) {
        return (options.client ?? client).post<UsersRecordMyResearchConsentResponses, UsersRecordMyResearchConsentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/research-consent',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Read User Auth Profile
     * Get current user's authentication profile.
     */
    public static usersReadUserAuthProfile<ThrowOnError extends boolean = false>(options?: Options<UsersReadUserAuthProfileData, ThrowOnError>) {
        return (options?.client ?? client).get<UsersReadUserAuthProfileResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/auth',
            ...options
        });
    }
    
    /**
     * Delete All Push Tokens
     * Delete all push tokens for the current user.
     */
    public static usersDeleteAllPushTokens<ThrowOnError extends boolean = false>(options?: Options<UsersDeleteAllPushTokensData, ThrowOnError>) {
        return (options?.client ?? client).delete<UsersDeleteAllPushTokensResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/push-tokens',
            ...options
        });
    }
    
    /**
     * Get User Push Tokens
     * Get all push tokens for the current user.
     */
    public static usersGetUserPushTokens<ThrowOnError extends boolean = false>(options?: Options<UsersGetUserPushTokensData, ThrowOnError>) {
        return (options?.client ?? client).get<UsersGetUserPushTokensResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/push-tokens',
            ...options
        });
    }
    
    /**
     * Register Push Token
     * Register a push token for the current user.
     *
     * If this user already has the token (even if disabled) it is re-enabled.
     * If ANOTHER user has it, they lose it: one Expo token is one phone, and it
     * belongs to whoever is signed in on it now. See `upsert_push_token`.
     *
     * Except a walk account (walk mode): the phone belongs to the walker, who is
     * only borrowing the walk's session. Registering would MOVE the walker's
     * token to the test account, and their own notifications would stop until
     * they came back. 409, never stored.
     */
    public static usersRegisterPushToken<ThrowOnError extends boolean = false>(options: Options<UsersRegisterPushTokenData, ThrowOnError>) {
        return (options.client ?? client).post<UsersRegisterPushTokenResponses, UsersRegisterPushTokenErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/push-tokens',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Push Token
     * Delete a push token for the current user.
     */
    public static usersDeletePushToken<ThrowOnError extends boolean = false>(options: Options<UsersDeletePushTokenData, ThrowOnError>) {
        return (options.client ?? client).delete<UsersDeletePushTokenResponses, UsersDeletePushTokenErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/push-tokens/{token}',
            ...options
        });
    }
    
    /**
     * Get Octopus Token
     * Generate a JWT token for Octopus Community SSO.
     *
     * This endpoint is called on-demand by the Octopus SDK when it needs
     * a fresh authentication token. The token includes user profile data
     * and expires in 1 hour.
     *
     * The token is signed with OCTOPUS_SSO_SECRET (different from the
     * standard SECRET_KEY used for app authentication).
     *
     * The frontend should extract the 'token' field from the response
     * and provide it to the Octopus SDK via the userTokenProvider callback.
     */
    public static usersGetOctopusToken<ThrowOnError extends boolean = false>(options?: Options<UsersGetOctopusTokenData, ThrowOnError>) {
        return (options?.client ?? client).post<UsersGetOctopusTokenResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/octopus-token',
            ...options
        });
    }
    
    /**
     * Read User By Id
     * Get a specific user by id.
     */
    public static usersReadUserById<ThrowOnError extends boolean = false>(options: Options<UsersReadUserByIdData, ThrowOnError>) {
        return (options.client ?? client).get<UsersReadUserByIdResponses, UsersReadUserByIdErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/{user_id}',
            ...options
        });
    }
    
    /**
     * Read Users
     * Retrieve users with pagination and filtering. Only accessible to admins.
     */
    public static usersReadUsers<ThrowOnError extends boolean = false>(options?: Options<UsersReadUsersData, ThrowOnError>) {
        return (options?.client ?? client).get<UsersReadUsersResponses, UsersReadUsersErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/users/',
            ...options
        });
    }
    
    /**
     * Create User
     * Create new user (admin only).
     */
    public static usersCreateUser<ThrowOnError extends boolean = false>(options: Options<UsersCreateUserData, ThrowOnError>) {
        return (options.client ?? client).post<UsersCreateUserResponses, UsersCreateUserErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/users/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Export Users Csv
     * Export users to CSV with all filters applied. Only accessible to admins.
     *
     * Without PII scope the Email and Full Name columns are written empty: the
     * header stays put so a spreadsheet built on this file keeps working.
     */
    public static usersExportUsersCsv<ThrowOnError extends boolean = false>(options?: Options<UsersExportUsersCsvData, ThrowOnError>) {
        return (options?.client ?? client).get<UsersExportUsersCsvResponses, UsersExportUsersCsvErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/users/export',
            ...options
        });
    }
    
    /**
     * Delete User
     * Delete a user (admin only).
     *
     * If the user has a sandbox RevenueCat subscription, also deletes the customer
     * from RevenueCat. If RevenueCat deletion fails, logs the error but continues
     * with user deletion.
     */
    public static usersDeleteUser<ThrowOnError extends boolean = false>(options: Options<UsersDeleteUserData, ThrowOnError>) {
        return (options.client ?? client).delete<UsersDeleteUserResponses, UsersDeleteUserErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/users/{user_id}',
            ...options
        });
    }
    
    /**
     * Update User
     * Update a user (admin only).
     */
    public static usersUpdateUser<ThrowOnError extends boolean = false>(options: Options<UsersUpdateUserData, ThrowOnError>) {
        return (options.client ?? client).patch<UsersUpdateUserResponses, UsersUpdateUserErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/users/{user_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create User Feedback
     * Submit feedback from the current user.
     *
     * Use the category field to specify feedback type:
     * - "subscription_cancellation" for subscription cancellation feedback
     * - "account_deletion" for account deletion feedback
     * - "bug", "feature", "improvement", "other" for general feedback
     */
    public static usersCreateUserFeedback<ThrowOnError extends boolean = false>(options: Options<UsersCreateUserFeedbackData, ThrowOnError>) {
        return (options.client ?? client).post<UsersCreateUserFeedbackResponses, UsersCreateUserFeedbackErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/feedback',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update User Staff Flag
     * Set or clear `is_staff` — who counts as Condri.
     *
     * Behind `panel:users:roles:write`, NOT `panel:users:write`, because this is a
     * permission grant and not an edit: `is_staff` carries community moderation
     * (staff are automatic community admins) and every internal affordance in the
     * app. Nobody who could not already hand out a role can hand out this.
     *
     * **No no-escalation guard, deliberately.** The one on `update_user_roles`
     * compares the scopes a grant would confer against the scopes the caller
     * holds; `is_staff` is a column, not a scope bundle, so there is nothing to
     * compare. What bounds it instead is who can reach the route at all: only
     * `admin` holds `panel:users:roles:write`, and an admin already holds every
     * capability `is_staff` carries. A guard here would compare admin to admin.
     *
     * **No self-guard, deliberately.** Clearing your own flag is recoverable
     * without help: panel access is decided by `panel:` scopes
     * (`has_panel_access`), which `is_staff` does not touch, so an admin who
     * switches their own off is still looking at the switch and can put it back.
     * The lockout that IS possible — removing your own admin role — is already
     * refused in `update_user_roles` below. Adding a second guard here would be
     * ceremony against a door that does not lock.
     */
    public static usersUpdateUserStaffFlag<ThrowOnError extends boolean = false>(options: Options<UsersUpdateUserStaffFlagData, ThrowOnError>) {
        return (options.client ?? client).patch<UsersUpdateUserStaffFlagResponses, UsersUpdateUserStaffFlagErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/users/{user_id}/staff',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update User Roles
     * Replace a user's roles.
     *
     * Behind `panel:users:roles:write`, which only `admin` holds: a role carries
     * its whole scope bundle, so handing one out hands out everything in it.
     *
     * Three refusals, in order. An incoherent grant (a machine role on a person,
     * or the reverse). An escalation -- granting a role whose scopes the caller
     * does not hold, which is what stops the scope that gates this route from
     * being a route to every other scope. And the two lockouts: you cannot remove
     * your own admin role, and you cannot remove the last admin's.
     */
    public static usersUpdateUserRoles<ThrowOnError extends boolean = false>(options: Options<UsersUpdateUserRolesData, ThrowOnError>) {
        return (options.client ?? client).patch<UsersUpdateUserRolesResponses, UsersUpdateUserRolesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/users/{user_id}/roles',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Check Revenuecat Customer Status
     * Check if RevenueCat customers exist for a user (admin only).
     *
     * Returns status for all RevenueCat subscriptions found for the user.
     * Each subscription may have a different app_user_id, so we check all of them.
     */
    public static usersCheckRevenuecatCustomerStatus<ThrowOnError extends boolean = false>(options: Options<UsersCheckRevenuecatCustomerStatusData, ThrowOnError>) {
        return (options.client ?? client).get<UsersCheckRevenuecatCustomerStatusResponses, UsersCheckRevenuecatCustomerStatusErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/users/{user_id}/revenuecat/status',
            ...options
        });
    }
    
    /**
     * Get Revenuecat Raw Customer Info
     * Get raw RevenueCat customer info for debugging (admin only).
     *
     * Fetches the latest customer info from RevenueCat API and returns it as-is.
     */
    public static usersGetRevenuecatRawCustomerInfo<ThrowOnError extends boolean = false>(options: Options<UsersGetRevenuecatRawCustomerInfoData, ThrowOnError>) {
        return (options.client ?? client).get<UsersGetRevenuecatRawCustomerInfoResponses, UsersGetRevenuecatRawCustomerInfoErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/users/{user_id}/revenuecat/raw-info',
            ...options
        });
    }
    
    /**
     * Delete Revenuecat Customer
     * Delete RevenueCat customer for a user (admin only).
     *
     * Deletes the customer from RevenueCat but keeps the user in the database.
     * Uses the latest subscription with a valid app_user_id.
     */
    public static usersDeleteRevenuecatCustomer<ThrowOnError extends boolean = false>(options: Options<UsersDeleteRevenuecatCustomerData, ThrowOnError>) {
        return (options.client ?? client).delete<UsersDeleteRevenuecatCustomerResponses, UsersDeleteRevenuecatCustomerErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/users/{user_id}/revenuecat/customer',
            ...options
        });
    }
    
    /**
     * Get My Entitlement
     * What the BACKEND thinks this user is entitled to.
     *
     * Today nothing on this server decides app access. The client does, from the
     * RevenueCat SDK's ``CustomerInfo`` (see expo ``atoms/subscription.ts``), and
     * ``a.rc_subscription_state`` gates nothing — it feeds admin views and the
     * unshipped banner context. So this endpoint is not replacing a server-side
     * source of truth; it is offering one for the first time.
     *
     * That shapes the contract:
     *
     * * ``entitled`` is the backend's answer, derived at read time from status +
     * expiry in ``a.entitlement``. Always computed, always returned.
     * * ``authoritative`` says whether this client should OBEY it. False means the
     * device keeps using the RevenueCat SDK exactly as it does today, and this
     * response is informational — fetch it and compare, but do not act on it.
     *
     * Calling this endpoint therefore changes nobody's access until their
     * ``payments_v2`` flag is on. The intended trial is: the client fetches both,
     * keeps obeying the SDK, and reports disagreement — which is how we learn
     * whether the backend projection is right in production before trusting it.
     *
     * The comparison that matters is against the RevenueCat SDK on the device, not
     * against ``rc_subscription_state`` — that projection decides nothing, so a
     * server-side diff with it would measure the wrong thing. The client holds the
     * only answer worth checking against, so the client reports the mismatch.
     */
    public static usersGetMyEntitlement<ThrowOnError extends boolean = false>(options?: Options<UsersGetMyEntitlementData, ThrowOnError>) {
        return (options?.client ?? client).get<UsersGetMyEntitlementResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/entitlement',
            ...options
        });
    }
    
    /**
     * Grant My Purchase Pending
     * Provisionally grant OWNED entitlement right after a store purchase.
     *
     * The store confirms the transaction on the device immediately; the provider
     * webhook that makes it true on our side lands seconds, minutes, or (during an
     * outage) never later. In that gap a user who just paid asks the backend
     * whether they are entitled and is told no — a paywall for the thing they
     * bought thirty seconds ago. The app calls this the moment a purchase
     * completes so OWNED entitlement grants on the client's word while the real
     * webhook confirms.
     *
     * Bounded and idempotent by the primitive, not by this route:
     *
     * * The grant is capped at 24h and never renewed — it lapses unless a real
     * entitlement supersedes it.
     * * The grant id is derived from the user id, so one live pending grant per
     * user; calling again while one is live is a no-op returning the same id.
     * * If a real provider entitlement already covers this user there is no gap to
     * bridge and nothing is written.
     * * A small rolling budget stops the call being replayed into free access a
     * day at a time. Exhausting it is a support case, surfaced as 409 so the
     * client shows the "we're still confirming your purchase" path rather than
     * retrying or treating it as a silent denial.
     *
     * The body is optional, and so is every field in it. Builds already shipped
     * send no body at all and must keep working, and a value we do not recognise
     * is recorded as a fallback rather than rejected: a 4xx here would deny a
     * provisional grant to someone who just paid, which is precisely the harm this
     * endpoint exists to prevent. Rejecting is the more expensive mistake, so the
     * diagnostic fields yield. That is why the body carries no rejecting
     * validation even where `/app/status` validates the same field names with
     * one — that endpoint can afford to turn a client away, and this one cannot.
     *
     * What the body is FOR: a lapsed pending grant is someone who paid and got
     * nothing, and it is the only payment record with no store attached, because
     * it is written precisely when no provider event has arrived. `store` and
     * `app_version` are what let support answer "which store, which build" without
     * a second investigation.
     */
    public static usersGrantMyPurchasePending<ThrowOnError extends boolean = false>(options?: Options<UsersGrantMyPurchasePendingData, ThrowOnError>) {
        return (options?.client ?? client).post<UsersGrantMyPurchasePendingResponses, UsersGrantMyPurchasePendingErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/purchase-pending',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Get My Hardship Request
     * Whether this person may ask, their request if they have, and whether
     * they are covered by anything else.
     *
     * The flag gates new requests only. A request made before it went off is
     * still returned, and its offer still claimable: the email has promised it.
     */
    public static usersGetMyHardshipRequest<ThrowOnError extends boolean = false>(options?: Options<UsersGetMyHardshipRequestData, ThrowOnError>) {
        return (options?.client ?? client).get<UsersGetMyHardshipRequestResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/hardship-request',
            ...options
        });
    }
    
    /**
     * Create My Hardship Request
     * Ask for the hardship price.
     *
     * Approved by rule. Records the request and the reason they typed (private:
     * stored on the request only, never returned, logged or passed on), gives a
     * day of access unless this phone has had one this month, records the
     * newsletter choice, and enrols the account in the offer email.
     *
     * * 404 when the `hardship_plan` flag is off for this person, or they have
     * subscribed before.
     * * 409 `email_unverified` when the account has no verified address: the
     * offer is emailed, and only to an address the person has proven, so that
     * nobody can have us mail a stranger about money trouble.
     * * 409 `hardship_request_exists` on a second request.
     * * 400 for a consent purpose this form does not ask.
     * * 422 for a reason shorter than 10 or longer than 1000 characters.
     */
    public static usersCreateMyHardshipRequest<ThrowOnError extends boolean = false>(options: Options<UsersCreateMyHardshipRequestData, ThrowOnError>) {
        return (options.client ?? client).post<UsersCreateMyHardshipRequestResponses, UsersCreateMyHardshipRequestErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/hardship-request',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Schedule My Billing Reminder
     * Email me two days before my next charge.
     *
     * * 409 `email_unverified` when the account has no proven address. The app
     * verifies first (which is also what turns a guest into an account), so
     * nobody can have us email a stranger about their billing.
     * * 422 `charge_date_unknown` when neither the store nor the app can say
     * when the charge is.
     * * `scheduled: false` when reminders are switched off. Asking twice is
     * fine: the first reminder stands.
     */
    public static usersScheduleMyBillingReminder<ThrowOnError extends boolean = false>(options: Options<UsersScheduleMyBillingReminderData, ThrowOnError>) {
        return (options.client ?? client).post<UsersScheduleMyBillingReminderResponses, UsersScheduleMyBillingReminderErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/users/me/billing-reminder',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TouchEvents {
    /**
     * Record App Touches
     * Record a batch of queued app touches for the signed-in account.
     *
     * Any 2xx tells the app to drop the batch, so a touch that fails to write
     * is logged and dropped here rather than failing the whole batch into an
     * endless retry.
     */
    public static touchEventsRecordAppTouches<ThrowOnError extends boolean = false>(options: Options<TouchEventsRecordAppTouchesData, ThrowOnError>) {
        return (options.client ?? client).post<TouchEventsRecordAppTouchesResponses, TouchEventsRecordAppTouchesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/a/touch-events',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AppInstalls {
    /**
     * Record App Install
     * Record this install's first open. No account needed; idempotent.
     */
    public static appInstallsRecordAppInstall<ThrowOnError extends boolean = false>(options: Options<AppInstallsRecordAppInstallData, ThrowOnError>) {
        return (options.client ?? client).post<AppInstallsRecordAppInstallResponses, AppInstallsRecordAppInstallErrors, ThrowOnError>({
            url: '/api/v1/a/app-installs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Link App Install
     * Tie this install to the signed-in account (guest or member).
     *
     * 404 when the install has not been recorded yet: the app records it first
     * and retries the link after.
     */
    public static appInstallsLinkAppInstall<ThrowOnError extends boolean = false>(options: Options<AppInstallsLinkAppInstallData, ThrowOnError>) {
        return (options.client ?? client).post<AppInstallsLinkAppInstallResponses, AppInstallsLinkAppInstallErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/a/app-installs/link',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AdminBillingIdentity {
    /**
     * Resolve Billing Id
     * billing_id -> user_id. Every call is logged with the caller.
     */
    public static adminBillingIdentityResolveBillingId<ThrowOnError extends boolean = false>(options: Options<AdminBillingIdentityResolveBillingIdData, ThrowOnError>) {
        return (options.client ?? client).get<AdminBillingIdentityResolveBillingIdResponses, AdminBillingIdentityResolveBillingIdErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/billing-identity/resolve/{billing_id}',
            ...options
        });
    }
}

export class AdminRevenuecatImport {
    /**
     * Import Revenuecat Csv
     * Import RevenueCat webhook events from CSV file (admin only).
     *
     * CSV file should have a BODY column containing JSON strings with webhook event payloads.
     * Events are processed sequentially and stored in the database. Storing them
     * is the whole job: no projection is built from here.
     */
    public static adminRevenuecatImportImportRevenuecatCsv<ThrowOnError extends boolean = false>(options: Options<AdminRevenuecatImportImportRevenuecatCsvData, ThrowOnError>) {
        return (options.client ?? client).post<AdminRevenuecatImportImportRevenuecatCsvResponses, AdminRevenuecatImportImportRevenuecatCsvErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/revenuecat/import-csv',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
}

export class AdminInsights {
    /**
     * Event Counts
     * Per custom event: counts and unique users for the last `days` (7 or 28)
     * against the period before it. From PostHog, production builds only, cached a few minutes.
     */
    public static adminInsightsEventCounts<ThrowOnError extends boolean = false>(options?: Options<AdminInsightsEventCountsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminInsightsEventCountsResponses, AdminInsightsEventCountsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/insights/events',
            ...options
        });
    }
    
    /**
     * Active Users
     * Daily unique app users (any event) for the last `days` (7 or 28), by
     * UTC day. From PostHog, production builds only, cached a few minutes.
     */
    public static adminInsightsActiveUsers<ThrowOnError extends boolean = false>(options?: Options<AdminInsightsActiveUsersData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminInsightsActiveUsersResponses, AdminInsightsActiveUsersErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/insights/active-users',
            ...options
        });
    }
    
    /**
     * New Users
     * New app users per UTC day for the last `days` (7 or 28): guest accounts
     * created, the real top of the app funnel. From PostHog, production builds only, cached a few minutes.
     */
    public static adminInsightsNewUsers<ThrowOnError extends boolean = false>(options?: Options<AdminInsightsNewUsersData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminInsightsNewUsersResponses, AdminInsightsNewUsersErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/insights/new-users',
            ...options
        });
    }
    
    /**
     * Churn Screens
     * Where people stop: the last screen of users seen in the last 90 days who
     * then went quiet for 14+ days, top 20, beside each screen's total visitors.
     * From PostHog, production builds only, cached a few minutes.
     */
    public static adminInsightsChurnScreens<ThrowOnError extends boolean = false>(options?: Options<AdminInsightsChurnScreensData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminInsightsChurnScreensResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/insights/churn-screens',
            ...options
        });
    }
    
    /**
     * Version Breakdown
     * Per app version (1.5.x and newer): unique users at each funnel stage and
     * engagement, over the last `days` (7 or 28). From PostHog, production builds only, cached a few minutes.
     */
    public static adminInsightsVersionBreakdown<ThrowOnError extends boolean = false>(options?: Options<AdminInsightsVersionBreakdownData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminInsightsVersionBreakdownResponses, AdminInsightsVersionBreakdownErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/insights/versions',
            ...options
        });
    }
    
    /**
     * Usage Breakdown
     * Screen views, onboarding steps, and login methods over the last `days`
     * (7 or 28), as unique-user counts. From PostHog, production builds only, cached a few minutes.
     */
    public static adminInsightsUsageBreakdown<ThrowOnError extends boolean = false>(options?: Options<AdminInsightsUsageBreakdownData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminInsightsUsageBreakdownResponses, AdminInsightsUsageBreakdownErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/insights/usage',
            ...options
        });
    }
    
    /**
     * Web Funnel
     * Website onboarding funnels (condri.app/start, /coaching-quiz → Stripe).
     */
    public static adminInsightsWebFunnel<ThrowOnError extends boolean = false>(options?: Options<AdminInsightsWebFunnelData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminInsightsWebFunnelResponses, AdminInsightsWebFunnelErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/insights/web-funnel',
            ...options
        });
    }
    
    /**
     * Email Coverage
     * What share of real users we hold an email address for, by signup week.
     *
     * Weekly cohorts rather than a single number, because a single number moves
     * slowly: the install base dilutes it for months. Cohort-by-cohort is where a
     * change to onboarding actually shows up, within a week of shipping.
     */
    public static adminInsightsEmailCoverage<ThrowOnError extends boolean = false>(options?: Options<AdminInsightsEmailCoverageData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminInsightsEmailCoverageResponses, AdminInsightsEmailCoverageErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/insights/email-coverage',
            ...options
        });
    }
}

export class AdminCheckpoints {
    /**
     * Reach By Version
     * Share of each app version's active users who hit each moment at all.
     *
     * Rates AND counts, from one query so every number shares a denominator. The
     * count answers "how many people"; the rate answers "is this version broken"
     * (a version's size otherwise drowns out its behaviour, and a moment that
     * steps between two versions names the release that changed it).
     *
     * Two semantics to read with:
     *
     * * Version rows OVERLAP: a person active on two versions in the window is
     * in both denominators. Rates are per-version honest; the rows do not sum.
     * * A once-per-lifetime moment (onboarding completed, first post) reads low
     * on every version by construction — few of a version's actives are new
     * signups. That is cohort composition, not breakage; the registry marks
     * such moments `once` and the page annotates them.
     */
    public static adminCheckpointsReachByVersion<ThrowOnError extends boolean = false>(options: Options<AdminCheckpointsReachByVersionData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCheckpointsReachByVersionResponses, AdminCheckpointsReachByVersionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/checkpoints/reach',
            ...options
        });
    }
    
    /**
     * Time To Moment
     * Distribution of how long the signup cohort takes to reach each moment.
     *
     * Anchor: `person.created_at`, when PostHog first created the person profile.
     * That approximates signup and does not move with the query window. The
     * population is restricted to profiles CREATED in the window — without that,
     * a 300-day-old user firing the event today enters the distribution at ~300
     * days and the number measures tenure, not time-to-moment. Quantiles are over
     * reachers only: people in the cohort who never fired the event contribute
     * nothing (reach measures them). Negative gaps (an event stamped before
     * profile creation, which merges can produce) clamp to zero.
     *
     * ClickHouse `quantile()` is approximate (a sampling reservoir), unlike the
     * exact `percentile_cont` behind /backend-reach; at small n the high
     * percentiles are essentially the max. The UI suppresses P90/P99 below n=20.
     */
    public static adminCheckpointsTimeToMoment<ThrowOnError extends boolean = false>(options: Options<AdminCheckpointsTimeToMomentData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCheckpointsTimeToMomentResponses, AdminCheckpointsTimeToMomentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/checkpoints/time-to',
            ...options
        });
    }
    
    /**
     * Health Entry Volume
     * Server-side volume for moments that write a health entry.
     *
     * Durable where PostHog is not: survives reinstall and device change, and no
     * ad-blocker touches it. It cannot be broken down by app version — see the
     * version-attribution note in brain/notes/checkpoints-plan.md.
     */
    public static adminCheckpointsHealthEntryVolume<ThrowOnError extends boolean = false>(options: Options<AdminCheckpointsHealthEntryVolumeData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCheckpointsHealthEntryVolumeResponses, AdminCheckpointsHealthEntryVolumeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/checkpoints/entries',
            ...options
        });
    }
    
    /**
     * Backend Reach
     * Owned reach and time-to: the signup cohort, measured from OUR tables.
     *
     * Not PostHog: no ad-blocker, no sampling, and the numbers exist even when
     * the PostHog query API is down. The cohort is real users (not staff,
     * superusers or soft-deleted) created in the window, so every measure reads
     * as "of the people who signed up recently, how many, and how fast".
     *
     * Cohort immaturity is a real bias: yesterday's signup sits in the
     * denominator with no time to have reached anything, so a signup surge
     * mechanically drags every percentage down and a drought "improves" them.
     * Read the pct together with the window, or against a stable baseline; the
     * UI carries the same caveat.
     *
     * The time-to quantiles use percentile_cont over a TRUE anchor,
     * users.dt_created, which is deliberately better than the PostHog time-to
     * endpoint's person.created_at approximation: signup here is a fact, not a
     * profile artefact. (shai_retake is the exception by design: its gap runs
     * first-score-to-second-score.) `timed` is the quantiles' real n.
     *
     * Known asymmetry: no version slicing. The database holds no per-user app
     * version history (deferred with #521), so backend measures cannot split by
     * release the way reach does. Revive that work when a consumer actually
     * wants version-sliced backend measures.
     *
     * The measure catalog is fixed in this module; the query accepts names only.
     */
    public static adminCheckpointsBackendReach<ThrowOnError extends boolean = false>(options: Options<AdminCheckpointsBackendReachData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCheckpointsBackendReachResponses, AdminCheckpointsBackendReachErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/checkpoints/backend-reach',
            ...options
        });
    }
}

export class AdminActivation {
    /**
     * Activation Overview
     * Activation and its week-1 signals for signups from `start` to `end`
     * (both included; the last 90 days when not given). Definitions travel in
     * `metrics`.
     */
    public static adminActivationActivationOverview<ThrowOnError extends boolean = false>(options?: Options<AdminActivationActivationOverviewData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminActivationActivationOverviewResponses, AdminActivationActivationOverviewErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/activation/overview',
            ...options
        });
    }
}

export class AdminJourneyHealth {
    /**
     * Journey Summary
     * The Journey's headline numbers now and seven days earlier.
     *
     * New signups who reached day 2, day 2 done on its unlock day, existing
     * members who started, and weekly actives. Rates carry n (who could have)
     * and k (who did) and are None below `min_readable_n`. Real users only
     * unless `include_staff`.
     */
    public static adminJourneyHealthJourneySummary<ThrowOnError extends boolean = false>(options?: Options<AdminJourneyHealthJourneySummaryData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminJourneyHealthJourneySummaryResponses, AdminJourneyHealthJourneySummaryErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/journey-health/summary',
            ...options
        });
    }
    
    /**
     * Journey Ladder
     * Each Journey day: how many members were eligible for it, how many did it
     * on the day it unlocked, how many did it later, how many have not, and how
     * many were active on its unlock day. `too_few` marks a day whose eligible
     * count is below `min_readable_n`.
     */
    public static adminJourneyHealthJourneyLadder<ThrowOnError extends boolean = false>(options?: Options<AdminJourneyHealthJourneyLadderData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminJourneyHealthJourneyLadderResponses, AdminJourneyHealthJourneyLadderErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/journey-health/ladder',
            ...options
        });
    }
    
    /**
     * Journey Funnel
     * New signups between `start` and `end` (whole UTC days, inclusive),
     * step by step through the Journey's first days. New means signed up after
     * the Journey flip, so the window never starts before it. Rates carry n and
     * k and are None below `min_readable_n`.
     */
    public static adminJourneyHealthJourneyFunnel<ThrowOnError extends boolean = false>(options?: Options<AdminJourneyHealthJourneyFunnelData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminJourneyHealthJourneyFunnelResponses, AdminJourneyHealthJourneyFunnelErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/journey-health/funnel',
            ...options
        });
    }
    
    /**
     * Journey Cohorts
     * Cohort grid. Rows are the week a member finished day 0; columns are the
     * furthest Journey day reached. A member counts in a cell only once they
     * could have reached that day by going every day, so recent weeks are not
     * understated.
     */
    public static adminJourneyHealthJourneyCohorts<ThrowOnError extends boolean = false>(options?: Options<AdminJourneyHealthJourneyCohortsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminJourneyHealthJourneyCohortsResponses, AdminJourneyHealthJourneyCohortsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/journey-health/cohorts',
            ...options
        });
    }
    
    /**
     * Journey Retention
     * Retention by signup week: who came back on day 1, 7 and 14 (any health
     * entry in that UTC day after signup), plus weekly actives. A signup counts
     * for day d only once its window has closed.
     */
    public static adminJourneyHealthJourneyRetention<ThrowOnError extends boolean = false>(options?: Options<AdminJourneyHealthJourneyRetentionData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminJourneyHealthJourneyRetentionResponses, AdminJourneyHealthJourneyRetentionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/journey-health/retention',
            ...options
        });
    }
}

export class AdminPricing {
    /**
     * Get Pricing Grid
     * The full plan x band grid with live Stripe amounts.
     *
     * Amounts come from Stripe rather than our database on purpose: the panel
     * should show what customers will actually be charged, not what we recorded.
     * Read uncached and concurrently — uncached because `active` is the mutable
     * field that reveals a broken slot, concurrently so eight prices cost one
     * round trip and no blocked event loop.
     *
     * `variant` asks for an experiment ARM's grid rather than the default one. An
     * arm with no price of its own reads as `inherited`, which is exactly what it
     * does on the funnel: it shows the control price. Without this the panel had
     * no way to see or set arm prices at all, so a started test assigned people to
     * an arm priced identically to control and measured nothing.
     */
    public static adminPricingGetPricingGrid<ThrowOnError extends boolean = false>(options?: Options<AdminPricingGetPricingGridData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPricingGetPricingGridResponses, AdminPricingGetPricingGridErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/pricing',
            ...options
        });
    }
    
    /**
     * Get Store Prices
     * Live App Store and Play prices for every RevenueCat offering's products.
     *
     * Read-only, cached for a few minutes; `refresh` skips the cache. A store
     * that cannot be read comes back as that source's error, not a failed page.
     */
    public static adminPricingGetStorePrices<ThrowOnError extends boolean = false>(options?: Options<AdminPricingGetStorePricesData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPricingGetStorePricesResponses, AdminPricingGetStorePricesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/pricing/store-prices',
            ...options
        });
    }
    
    /**
     * List Stripe Prices
     * Every price in the Stripe account, with what we know about each.
     *
     * Stripe can say what a price is. Only we can say whether anything sells it
     * and whether anyone is still owed it, and those two columns are what make the
     * list usable: an active price nothing points at reads as litter until you can
     * see a live stamp still promises it to somebody.
     *
     * Archived prices are included deliberately. They are what a slot can be
     * pointed back at, and seeing "we already sold at $12.99" is what stops a
     * second $12.99 being created next to the first.
     */
    public static adminPricingListStripePrices<ThrowOnError extends boolean = false>(options?: Options<AdminPricingListStripePricesData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPricingListStripePricesResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/pricing/stripe-prices',
            ...options
        });
    }
    
    /**
     * Adopt Env Prices
     * Write a pointer row for every slot still resolving through an env var.
     *
     * Not required for anything to work — rotation reads through the env fallback,
     * so an un-adopted slot behaves identically. This exists so the env vars can be
     * *deleted*, which is only safe once every slot has a row of its own.
     *
     * Only adopts a band's own env var, never the standard-band fallback. Adopting
     * the fallback would pin the youth band to today's standard price, so a later
     * change to the standard price would silently stop applying to youth — turning
     * an intentional inheritance into a stale copy.
     *
     * Idempotent: slots that already have a pointer are skipped, so running it
     * twice does nothing and it can be re-run after a new plan is configured.
     */
    public static adminPricingAdoptEnvPrices<ThrowOnError extends boolean = false>(options?: Options<AdminPricingAdoptEnvPricesData, ThrowOnError>) {
        return (options?.client ?? client).post<AdminPricingAdoptEnvPricesResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/pricing/adopt-env',
            ...options
        });
    }
    
    /**
     * Rotate Price
     * Point a (plan, band) at a new Stripe price at the given amount.
     *
     * Order of operations matters. The lock is taken before any Stripe write, so a
     * concurrent caller blocks before spending anything. The new price is created
     * and the pointer committed BEFORE the old price is archived, so the worst case
     * of a mid-way failure is an unused price in Stripe — never a funnel pointing
     * at an archived price, which would fail every checkout.
     */
    public static adminPricingRotatePrice<ThrowOnError extends boolean = false>(options: Options<AdminPricingRotatePriceData, ThrowOnError>) {
        return (options.client ?? client).post<AdminPricingRotatePriceResponses, AdminPricingRotatePriceErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/pricing/rotate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Price History
     * Recent prices this (plan, band) has pointed at, newest first.
     *
     * Only covers changes made through this API — prices set via env before the
     * pointer table existed have no history to show. Bounded by the CRUD layer,
     * since each entry costs a Stripe lookup.
     *
     * Omit `variant` for every arm; pass one to see just that arm's changes. A
     * control history with an arm's rotations spliced into it reads as a price
     * that moved twice as often as it did.
     */
    public static adminPricingGetPriceHistory<ThrowOnError extends boolean = false>(options: Options<AdminPricingGetPriceHistoryData, ThrowOnError>) {
        return (options.client ?? client).get<AdminPricingGetPriceHistoryResponses, AdminPricingGetPriceHistoryErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/pricing/history',
            ...options
        });
    }
    
    /**
     * List Experiments
     * Every experiment, newest first, with its assignment counts.
     */
    public static adminPricingListExperiments<ThrowOnError extends boolean = false>(options?: Options<AdminPricingListExperimentsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPricingListExperimentsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/pricing/experiments',
            ...options
        });
    }
    
    /**
     * Upsert Experiment
     * Create or update an experiment. Never activates it — that is its own call,
     * so writing weights cannot start a test by accident.
     */
    public static adminPricingUpsertExperiment<ThrowOnError extends boolean = false>(options: Options<AdminPricingUpsertExperimentData, ThrowOnError>) {
        return (options.client ?? client).post<AdminPricingUpsertExperimentResponses, AdminPricingUpsertExperimentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/pricing/experiments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Set Experiment Active
     * Start or stop an experiment.
     *
     * Deactivates whatever else was running first: the partial unique index allows
     * exactly one active experiment, so activating without standing the other down
     * would be a 500 rather than a decision. Doing it here makes "start this one"
     * mean "and stop the other", which is the only sane reading.
     *
     * Stopping does NOT move anyone already assigned. Their offer is stamped, and
     * the stamp is a promise — a finished experiment still owes its arms the price
     * they were shown until those stamps expire.
     */
    public static adminPricingSetExperimentActive<ThrowOnError extends boolean = false>(options: Options<AdminPricingSetExperimentActiveData, ThrowOnError>) {
        return (options.client ?? client).post<AdminPricingSetExperimentActiveResponses, AdminPricingSetExperimentActiveErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/pricing/experiments/{name}/activate',
            ...options
        });
    }
    
    /**
     * List Public Offers
     * The named offers dedicated checkout pages can request (PUBLIC_OFFERS).
     *
     * Defined in code — an offer is a page plus a policy, and both ship together.
     * Listed here so the panel can render an editable price grid per offer
     * variant; the prices themselves live on the same pointer axis as experiment
     * arms and rotate without a deploy.
     */
    public static adminPricingListPublicOffers<ThrowOnError extends boolean = false>(options?: Options<AdminPricingListPublicOffersData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPricingListPublicOffersResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/pricing/offers',
            ...options
        });
    }
    
    /**
     * Get Plan Display
     * Which plans the funnel shows, in order.
     *
     * The ONE source. Env booleans, the web-paywall-show-* feature flags and the
     * PostHog plan-pair variant are all gone.
     */
    public static adminPricingGetPlanDisplay<ThrowOnError extends boolean = false>(options?: Options<AdminPricingGetPlanDisplayData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPricingGetPlanDisplayResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/pricing/plans',
            ...options
        });
    }
    
    /**
     * Set Plan Display
     * Set which plans the funnel shows.
     *
     * Refuses to hide everything: a paywall with no plans sells nothing, and the
     * mistake is one keystroke away when the control is a row of switches. Turning
     * the last one off is far more likely to be a slip than an intention, so it
     * fails loudly rather than taking the funnel down quietly.
     */
    public static adminPricingSetPlanDisplay<ThrowOnError extends boolean = false>(options: Options<AdminPricingSetPlanDisplayData, ThrowOnError>) {
        return (options.client ?? client).put<AdminPricingSetPlanDisplayResponses, AdminPricingSetPlanDisplayErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/pricing/plans',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AdminPayments {
    /**
     * Payments Overview
     * Subscription stock now, flows in a window, and MRR now.
     *
     * `stock` and `mrr` are as of this moment; `flow` counts events between
     * `start` and `end` (ISO, UTC; the last 30 days when not given). Web money is
     * in GBP with the per-currency split beside it (the web sells in several
     * currencies); store money is in USD, as the stores report it. Group
     * Coaching sales are kept out of revenue and MRR and reported on their own
     * lines. Each MRR formula travels in the payload.
     */
    public static adminPaymentsPaymentsOverview<ThrowOnError extends boolean = false>(options?: Options<AdminPaymentsPaymentsOverviewData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPaymentsPaymentsOverviewResponses, AdminPaymentsPaymentsOverviewErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/overview',
            ...options
        });
    }
    
    /**
     * Payments Growth
     * The Growth tile group: DAU, MAU, DAU/MAU, signups (30d + today).
     *
     * Owned sources only (d.user_health_entries, a.users) — the sound half of the
     * old dashboard-summary, minus every RC-webhook-derived number.
     */
    public static adminPaymentsPaymentsGrowth<ThrowOnError extends boolean = false>(options?: Options<AdminPaymentsPaymentsGrowthData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPaymentsPaymentsGrowthResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/growth',
            ...options
        });
    }
    
    /**
     * Payments Retention
     * Week-joined signup cohorts with health-entry retention, plus a D1/D7/D30
     * summary. ``paid_users_only`` sources the paid filter from a.entitlement, not
     * the RC webhook table. One grouped query, no per-day MAU loop.
     *
     * The cohort lookback was fixed before; ``weeks`` makes it configurable. It
     * drives both the row count and the day window (a request for 52 weeks needs
     * ~52 weeks of days to have those cohorts to return), leaving max_cohorts/days
     * as the unchanged default path for callers that do not pass it.
     */
    public static adminPaymentsPaymentsRetention<ThrowOnError extends boolean = false>(options?: Options<AdminPaymentsPaymentsRetentionData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPaymentsPaymentsRetentionResponses, AdminPaymentsPaymentsRetentionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/retention',
            ...options
        });
    }
    
    /**
     * Payment Dimensions
     * Distinct values per filter/segment dimension, from subscription_dim.
     *
     * Feeds the panel's filter dropdowns so nobody has to guess a value's
     * spelling. Cheap (one small table), cacheable client-side.
     */
    public static adminPaymentsPaymentDimensions<ThrowOnError extends boolean = false>(options?: Options<AdminPaymentsPaymentDimensionsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPaymentsPaymentDimensionsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/dimensions',
            ...options
        });
    }
    
    /**
     * Payments Chart
     * One grammar for every chart, RC Charts style.
     *
     * `chart` names the chart (its parameter lists them). The window is `start` to
     * `end` (ISO, UTC; the last 30 days when not given), bucketed by
     * `resolution` (day, week, month, quarter, year; weeks start Monday).
     * `segment` splits the series by a dimension (see the dimensions route).
     * Each chart's definition and units come back in its summary.
     *
     * `filter` narrows and `selector` sets a per-chart option; see their
     * parameters. The panel's ``filter.<dimension>=v1,v2`` /
     * ``selector.<name>=<value>`` form still works.
     */
    public static adminPaymentsPaymentsChart<ThrowOnError extends boolean = false>(options: Options<AdminPaymentsPaymentsChartData, ThrowOnError>) {
        return (options.client ?? client).get<AdminPaymentsPaymentsChartResponses, AdminPaymentsPaymentsChartErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/charts/{chart}',
            ...options
        });
    }
    
    /**
     * Payments Charts Batch
     * Several charts over ONE window/resolution, in request order.
     *
     * Backs the overlay view (a primary series plus overlays on a shared axis)
     * and the Ship Health grid, which needs many launch-sensitive signals aligned
     * on the same time axis. ``filter.<dim>`` / ``selector.<name>`` apply to every
     * chart in the batch, matching the single-chart grammar.
     */
    public static adminPaymentsPaymentsChartsBatch<ThrowOnError extends boolean = false>(options: Options<AdminPaymentsPaymentsChartsBatchData, ThrowOnError>) {
        return (options.client ?? client).get<AdminPaymentsPaymentsChartsBatchResponses, AdminPaymentsPaymentsChartsBatchErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/charts-batch',
            ...options
        });
    }
    
    /**
     * Payments Release Markers
     * Ship/release annotation lines for the Ship Health charts.
     *
     * Derived from the first appearance of each app version (thresholded by
     * device count) plus any manual, non-version launches. See
     * ``crud.a.release_markers`` for the source of truth.
     */
    public static adminPaymentsPaymentsReleaseMarkers<ThrowOnError extends boolean = false>(options?: Options<AdminPaymentsPaymentsReleaseMarkersData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPaymentsPaymentsReleaseMarkersResponses, AdminPaymentsPaymentsReleaseMarkersErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/release-markers',
            ...options
        });
    }
    
    /**
     * List Subscriptions
     * The canonical subscription list — one row per subscription per user.
     *
     * Composes ``canonical_entitlements()`` (never restates the dedup), so a
     * bridged Stripe+RevenueCat pair appears exactly once, under the
     * higher-precedence provider. Read-only; paginated for the ~2k+ real rows.
     */
    public static adminPaymentsListSubscriptions<ThrowOnError extends boolean = false>(options?: Options<AdminPaymentsListSubscriptionsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPaymentsListSubscriptionsResponses, AdminPaymentsListSubscriptionsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/subscriptions',
            ...options
        });
    }
    
    /**
     * Subscription Events
     * Full event history for one subscription, across ALL providers.
     *
     * The log is keyed by ``subscription_key`` (the adapter's coalesce), so a
     * bridged web subscription's Stripe rows and RevenueCat echoes both match on
     * the shared identifier — the debugging view no vendor dashboard gives.
     */
    public static adminPaymentsSubscriptionEvents<ThrowOnError extends boolean = false>(options: Options<AdminPaymentsSubscriptionEventsData, ThrowOnError>) {
        return (options.client ?? client).get<AdminPaymentsSubscriptionEventsResponses, AdminPaymentsSubscriptionEventsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/subscriptions/{provider}/{subscription_id}/events',
            ...options
        });
    }
    
    /**
     * Health Detail
     * The rows behind one health tile — the drill-down for the cockpit.
     */
    public static adminPaymentsHealthDetail<ThrowOnError extends boolean = false>(options: Options<AdminPaymentsHealthDetailData, ThrowOnError>) {
        return (options.client ?? client).get<AdminPaymentsHealthDetailResponses, AdminPaymentsHealthDetailErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/health/detail/{invariant}',
            ...options
        });
    }
    
    /**
     * Pipeline Health
     * Health of the payments pipeline: are provider events arriving and does
     * the ledger add up.
     *
     * Each check is a count of rows breaking one invariant from the latest
     * nightly run; red ones mean money or access is wrong for someone. Counts
     * only, no rows: the rows behind a check are a separate, per-person route.
     * Unprocessed events are counted live.
     */
    public static adminPaymentsPipelineHealth<ThrowOnError extends boolean = false>(options?: Options<AdminPaymentsPipelineHealthData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPaymentsPipelineHealthResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/health',
            ...options
        });
    }
    
    /**
     * List Anomalies
     * The flagged items of one invariant bucket, with triage state and the user.
     *
     * Each row carries its disposition (or none == new), whether it is currently
     * "loud" (new, resurfaced deferred, or stale needs_action), and — for
     * unattributed rows — whether it can be attributed to a user in-app.
     */
    public static adminPaymentsListAnomalies<ThrowOnError extends boolean = false>(options: Options<AdminPaymentsListAnomaliesData, ThrowOnError>) {
        return (options.client ?? client).get<AdminPaymentsListAnomaliesResponses, AdminPaymentsListAnomaliesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/anomalies/{check_name}',
            ...options
        });
    }
    
    /**
     * Triage Anomalies
     * Set the triage disposition on one or more flagged items (bulk).
     */
    public static adminPaymentsTriageAnomalies<ThrowOnError extends boolean = false>(options: Options<AdminPaymentsTriageAnomaliesData, ThrowOnError>) {
        return (options.client ?? client).put<AdminPaymentsTriageAnomaliesResponses, AdminPaymentsTriageAnomaliesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/anomalies/{check_name}/triage',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Attribute Anomaly
     * Attribute an unresolved payment identity to an account and re-project it.
     *
     * A targeted fix for `unattributed_entitled`: aliases the provider's
     * `app_user_id` to the target user and runs a scoped re-projection so the
     * entitlement resolves — no full replay. Gated on `payments:grant` and audited.
     */
    public static adminPaymentsAttributeAnomaly<ThrowOnError extends boolean = false>(options: Options<AdminPaymentsAttributeAnomalyData, ThrowOnError>) {
        return (options.client ?? client).post<AdminPaymentsAttributeAnomalyResponses, AdminPaymentsAttributeAnomalyErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/anomalies/attribute',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Lookup Provider Profile
     * Paste the id out of a provider dashboard URL, get the customer.
     *
     * Adapty's dashboard links look like
     * `app.adapty.io/profiles/users/<profile_id>`, and that id is theirs, not
     * ours — until privacy.provider_profile existed there was no way back from it
     * to an account.
     *
     * 404 means we have never received a webhook naming this profile, which is
     * NOT the same as "no such customer": Adapty webhooks on lifecycle
     * transitions, so a subscriber mid-period is legitimately absent until their
     * next renewal.
     */
    public static adminPaymentsLookupProviderProfile<ThrowOnError extends boolean = false>(options: Options<AdminPaymentsLookupProviderProfileData, ThrowOnError>) {
        return (options.client ?? client).get<AdminPaymentsLookupProviderProfileResponses, AdminPaymentsLookupProviderProfileErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/provider-profile/{provider}/{provider_profile_id}',
            ...options
        });
    }
    
    /**
     * Recent Transactions
     * The latest money-shaped events, newest first.
     *
     * Every list filter takes `!value` to exclude it: `kinds=!renewal`.
     *
     * Money events only — trial starts, purchases, renewals, refunds,
     * chargebacks, coaching places and conversions. Auto-renew toggles,
     * billing-issue notices and the opening and closing of a dispute are real
     * events but they are not transactions, and mixing them in turns the feed
     * into the webhook log we already have at /subscriptions.
     */
    public static adminPaymentsRecentTransactions<ThrowOnError extends boolean = false>(options?: Options<AdminPaymentsRecentTransactionsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPaymentsRecentTransactionsResponses, AdminPaymentsRecentTransactionsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/transactions/recent',
            ...options
        });
    }
    
    /**
     * Group Coaching Campaigns
     * Banner reach, coaching page visits and coaching sales, by utm source.
     */
    public static adminPaymentsGroupCoachingCampaigns<ThrowOnError extends boolean = false>(options?: Options<AdminPaymentsGroupCoachingCampaignsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPaymentsGroupCoachingCampaignsResponses, AdminPaymentsGroupCoachingCampaignsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/campaigns/group-coaching',
            ...options
        });
    }
    
    /**
     * Coaching Buyers
     * Every place on the Condri Group Coaching Programme sold in the window,
     * newest first: who bought it, whether they already had an account, whether
     * the money came back, and whether the app access that came with the place
     * is still live.
     *
     * Per-person rows, so it carries the subscriptions scope like the
     * transactions feed rather than the aggregate payments scope.
     */
    public static adminPaymentsCoachingBuyers<ThrowOnError extends boolean = false>(options?: Options<AdminPaymentsCoachingBuyersData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPaymentsCoachingBuyersResponses, AdminPaymentsCoachingBuyersErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/payments/coaching/buyers',
            ...options
        });
    }
}

export class AdminVitalSigns {
    /**
     * Vital Signs
     * Each of the last `days` days, ending yesterday (UTC), judged the way the
     * morning alert judges it: against the BASELINE_DAYS before it.
     */
    public static adminVitalSignsVitalSigns<ThrowOnError extends boolean = false>(options?: Options<AdminVitalSignsVitalSignsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminVitalSignsVitalSignsResponses, AdminVitalSignsVitalSignsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/vital-signs',
            ...options
        });
    }
}

export class AdminCustomers {
    /**
     * Lookup Customer
     * Type-ahead search: partial email/name match (or exact user id),
     * returning compact cells. The exact email hit always ranks first;
     * ``user_id`` is the top hit so Enter can open it directly.
     */
    public static adminCustomersLookupCustomer<ThrowOnError extends boolean = false>(options: Options<AdminCustomersLookupCustomerData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCustomersLookupCustomerResponses, AdminCustomersLookupCustomerErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/lookup',
            ...options
        });
    }
    
    /**
     * Customer Landing
     * The /customers index lists. Per-list access rules:
     *
     * Gated by `users:read`, not `payments:read`: every list here names people
     * (email, name, id), and `payments:read` is the AGGREGATE payments scope
     * that `viewer-insights` holds for charts. Under it, an aggregate-only
     * viewer could read the newest signups' emails.
     *
     * * recently_viewed — the caller's OWN scv_access_audit trail, so no extra
     * scope beyond admin. Every kind of row counts: from now on each person
     * page open writes a `page_view`, and the rows written before that column
     * existed are `activity_read`s, which were page opens too (the page read
     * activity on every open). Filtering to `page_view` would empty the strip
     * on deploy day for no gain.
     * * recent_subscribers — per-user payment data: included only when the
     * caller's roles grant payments:subscriptions:read, empty otherwise.
     * * newest_signups — plain admin.
     */
    public static adminCustomersCustomerLanding<ThrowOnError extends boolean = false>(options?: Options<AdminCustomersCustomerLandingData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminCustomersCustomerLandingResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/landing',
            ...options
        });
    }
    
    /**
     * Get Customer
     */
    public static adminCustomersGetCustomer<ThrowOnError extends boolean = false>(options: Options<AdminCustomersGetCustomerData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCustomersGetCustomerResponses, AdminCustomersGetCustomerErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}',
            ...options
        });
    }
    
    /**
     * Get Customer Activity
     * Engagement counts. How often, never what — no entry text, no messages.
     *
     * Every call writes an access-audit row (viewer, subject, when) before the
     * counts are read: activity frequency per identified person is health data.
     */
    public static adminCustomersGetCustomerActivity<ThrowOnError extends boolean = false>(options: Options<AdminCustomersGetCustomerActivityData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCustomersGetCustomerActivityResponses, AdminCustomersGetCustomerActivityErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/activity',
            ...options
        });
    }
    
    /**
     * Get Customer Emails
     * Sends + engagement state, enrolled campaigns and email consent. Never
     * message bodies.
     */
    public static adminCustomersGetCustomerEmails<ThrowOnError extends boolean = false>(options: Options<AdminCustomersGetCustomerEmailsData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCustomersGetCustomerEmailsResponses, AdminCustomersGetCustomerEmailsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/emails',
            ...options
        });
    }
    
    /**
     * Get Customer Email Data
     * The email part of a subject access request (DATA-03), as one JSON
     * file: every consent decision with the words shown and where, what was
     * sent and what happened to it, "Did this help?" answers, sign-in and
     * account emails, campaigns, and the do-not-email list. PII scope only.
     */
    public static adminCustomersGetCustomerEmailData<ThrowOnError extends boolean = false>(options: Options<AdminCustomersGetCustomerEmailDataData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCustomersGetCustomerEmailDataResponses, AdminCustomersGetCustomerEmailDataErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/email-data',
            ...options
        });
    }
    
    /**
     * Get Customer Devices
     * Devices this account has been seen on (a.user_device_sightings).
     *
     * Scope decision, documented: this is device metadata (platform, versions,
     * when) — hardware facts, not health data — so it sits behind the page's
     * base payments:subscriptions:read like the entitlement and email blocks,
     * NOT behind users:activity:read. The raw identifiers (device_key, idfv)
     * stay server-side: support needs "same device y/n", never the key itself.
     */
    public static adminCustomersGetCustomerDevices<ThrowOnError extends boolean = false>(options: Options<AdminCustomersGetCustomerDevicesData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCustomersGetCustomerDevicesResponses, AdminCustomersGetCustomerDevicesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/devices',
            ...options
        });
    }
    
    /**
     * Get Customer Release State
     * What software this account is running, from every system that decides it.
     *
     * "Why has this person not got the fix" has four possible answers living in
     * four places — their OTA cohort, the bundle actually on the device, a
     * backend flag row, a PostHog gate — and nothing joined them, so answering it
     * meant four lookups and remembering all four existed. This is the join.
     *
     * WHAT IT DELIBERATELY DOES NOT CARRY. No email, no name, no `device_key`,
     * no `idfv`. The devices block takes that decision straight from
     * `get_customer_devices` above and adds only the OTA fields. That absence is
     * what the narrow `panel:users:release:read` is: the agent principal holds it
     * and holds nothing that turns an id into a person.
     *
     * Either scope opens it. A person on the customer page already holds
     * `panel:users:read`, and giving them a second scope to see a block on a page
     * they can already read would be a permission that only ever surprises
     * somebody.
     *
     * PostHog is evaluated for the same distinct id the app identifies with — the
     * user id as a string (`AuthService.identify`) — so this reports what that
     * phone is actually told, not what a rollout percentage suggests. It is
     * allowed to be unanswerable: a gate row with `enabled: null` and a note
     * beats a 500, because the other three sources are usually where the answer
     * is.
     */
    public static adminCustomersGetCustomerReleaseState<ThrowOnError extends boolean = false>(options: Options<AdminCustomersGetCustomerReleaseStateData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCustomersGetCustomerReleaseStateResponses, AdminCustomersGetCustomerReleaseStateErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/release-state',
            ...options
        });
    }
    
    /**
     * Create Grant
     * Issue a manual entitlement grant (spec-scv.md finding 1, all of it).
     *
     * * Kind whitelist: comp / support / staff / refund_goodwill / lifetime_comp.
     * `migration` and `purchase_pending` are unreachable from this surface —
     * the request model rejects them before this function runs.
     * * `expires_at` is REQUIRED unless the kind is `lifetime_comp`, which is a
     * deliberate choice of kind, never a forgotten date. `lifetime_comp` with
     * an expiry is also rejected: one of the two must be meant.
     * * The acting admin is recorded in the event (`granted_by`).
     * * Hourly caps, per admin and global, counted from the event log. The
     * global cap logs at ERROR — that is the mass-grant alarm.
     */
    public static adminCustomersCreateGrant<ThrowOnError extends boolean = false>(options: Options<AdminCustomersCreateGrantData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCustomersCreateGrantResponses, AdminCustomersCreateGrantErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/grants',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Revoke Grant
     * Revoke a manual grant — after validating it (spec-scv.md finding 3).
     *
     * The CRUD will happily write a revocation for any id, which would mint a
     * phantom `expired` entitlement row via apply_delta's insert path. So this
     * endpoint loads the grant first and refuses unless it exists, belongs to
     * this user, is a manual admin grant, and is currently live.
     */
    public static adminCustomersRevokeGrant<ThrowOnError extends boolean = false>(options: Options<AdminCustomersRevokeGrantData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCustomersRevokeGrantResponses, AdminCustomersRevokeGrantErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/grants/{grant_id}/revoke',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Set Customer Payments V2
     * Flip the per-user ``payments_v2`` override for ONE user — the Phase-2
     * rollout control that makes our owned entitlement authoritative for that
     * account.
     *
     * * ``authoritative=true`` sets an explicit user override to ON.
     * * ``authoritative=false`` DELETES the override so the user falls back to
     * the global setting — the rollback path. We never write an explicit
     * False row: "stop overriding" is a clear, single semantic, and it means a
     * later global rollout still reaches this user.
     *
     * Scope is ``PAYMENTS_GRANT`` — the same authority as a manual entitlement
     * grant, because this changes whose answer the user's app obeys. The change
     * is bound to this exact ``user_id`` and fully reversible.
     *
     * If the flag row is not seeded, ``calculate_flag_value`` would report false
     * for everyone and a toggle here would silently no-op — so we 409 loudly
     * rather than pretend it worked.
     */
    public static adminCustomersSetCustomerPaymentsV2<ThrowOnError extends boolean = false>(options: Options<AdminCustomersSetCustomerPaymentsV2Data, ThrowOnError>) {
        return (options.client ?? client).post<AdminCustomersSetCustomerPaymentsV2Responses, AdminCustomersSetCustomerPaymentsV2Errors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/payments-v2',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Customer Segments
     */
    public static adminCustomersGetCustomerSegments<ThrowOnError extends boolean = false>(options: Options<AdminCustomersGetCustomerSegmentsData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCustomersGetCustomerSegmentsResponses, AdminCustomersGetCustomerSegmentsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/segments',
            ...options
        });
    }
    
    /**
     * Remove Customer From Segment
     */
    public static adminCustomersRemoveCustomerFromSegment<ThrowOnError extends boolean = false>(options: Options<AdminCustomersRemoveCustomerFromSegmentData, ThrowOnError>) {
        return (options.client ?? client).delete<AdminCustomersRemoveCustomerFromSegmentResponses, AdminCustomersRemoveCustomerFromSegmentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/segments/{segment_id}',
            ...options
        });
    }
    
    /**
     * Add Customer To Segment
     * Add this user to a static segment, stamped with who did it.
     */
    public static adminCustomersAddCustomerToSegment<ThrowOnError extends boolean = false>(options: Options<AdminCustomersAddCustomerToSegmentData, ThrowOnError>) {
        return (options.client ?? client).put<AdminCustomersAddCustomerToSegmentResponses, AdminCustomersAddCustomerToSegmentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/segments/{segment_id}',
            ...options
        });
    }
    
    /**
     * Revoke Static Login Code
     * Kill this account's live code. The revoked row stays, as the record.
     */
    public static adminCustomersRevokeStaticLoginCode<ThrowOnError extends boolean = false>(options: Options<AdminCustomersRevokeStaticLoginCodeData, ThrowOnError>) {
        return (options.client ?? client).delete<AdminCustomersRevokeStaticLoginCodeResponses, AdminCustomersRevokeStaticLoginCodeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/static-login-code',
            ...options
        });
    }
    
    /**
     * Get Static Login Code
     * Its own admin-only read scope, not the customer-page one.
     *
     * The response body is a live credential. Handing it to everyone who can view
     * a customer record would make "who can sign in as this account" much wider
     * than "who can create the code", which is the wrong way round -- so this sits
     * with `secrets:read`, not with the rest of this file.
     */
    public static adminCustomersGetStaticLoginCode<ThrowOnError extends boolean = false>(options: Options<AdminCustomersGetStaticLoginCodeData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCustomersGetStaticLoginCodeResponses, AdminCustomersGetStaticLoginCodeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/static-login-code',
            ...options
        });
    }
    
    /**
     * Create Static Login Code
     * Mint this account's permanent code, replacing any it already had.
     *
     * Create and regenerate are one operation — the caller never has to know which
     * it is, and no path can leave two live codes behind.
     *
     * Refused for anonymous accounts and for accounts with no email: the code is
     * typed on a screen the app only reaches after an address is submitted, so on
     * an account without one it would be a credential with no door to open.
     */
    public static adminCustomersCreateStaticLoginCode<ThrowOnError extends boolean = false>(options: Options<AdminCustomersCreateStaticLoginCodeData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCustomersCreateStaticLoginCodeResponses, AdminCustomersCreateStaticLoginCodeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/static-login-code',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Push Readiness
     * Device and quiet-hours state for one user, before anything is sent.
     *
     * Behind NOTIFICATIONS_READ, not the send scope. The first draft of this
     * guarded it with `:send` on the reasoning that a person's local hour says
     * where they are, and `test_read_routes_are_not_guarded_by_write_scopes`
     * rejected it: a GET behind a mutating scope locks viewers out of a page
     * they are meant to see. The invariant is right. This is device health and
     * a clock reading, the same shape of fact as the device list already behind
     * a viewer scope, and the panel hides the whole card behind `:send` anyway,
     * so nothing is advertised to someone who cannot act on it. The token
     * strings, which are the only part worth guarding harder, never leave the
     * server at all.
     */
    public static adminCustomersGetPushReadiness<ThrowOnError extends boolean = false>(options: Options<AdminCustomersGetPushReadinessData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCustomersGetPushReadinessResponses, AdminCustomersGetPushReadinessErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/push-readiness',
            ...options
        });
    }
    
    /**
     * Check Push Receipts
     * Ask Expo what became of each of this person's last push messages.
     *
     * `send()` reports success when Expo ACCEPTS a message, so the panel said
     * "sent" for a phone dead for an hour. Only the receipt knows.
     *
     * Behind the send scope, not the read scope: a DeviceNotRegistered receipt
     * deactivates that token, and a route that writes should not hide behind a
     * viewer's permissions. Returns the whole readiness block so the caller
     * re-renders from one response.
     */
    public static adminCustomersCheckPushReceipts<ThrowOnError extends boolean = false>(options: Options<AdminCustomersCheckPushReceiptsData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCustomersCheckPushReceiptsResponses, AdminCustomersCheckPushReceiptsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/push-receipts',
            ...options
        });
    }
    
    /**
     * Send Test Push
     * Send ONE real push to ONE user and report exactly what Expo said.
     *
     * Strictly one recipient. There is no list form of this endpoint and there
     * should not be one: it is a diagnostic, and a diagnostic that can address
     * many people is a broadcast channel that skipped the review a broadcast
     * channel gets. Campaigns go through the bulk sender.
     *
     * Drives the real `PushNotificationSender.send()` path, not a shortcut, so
     * that this doubles as the smoke test for the sender itself -- a mock in
     * front of our own send method would hide exactly the bugs an operator is
     * here to find.
     *
     * Returns 200 with `status="no_recipient"` when there is no live device.
     * That is an answer, not an error: "this user has no active token" is
     * frequently the very thing being asked, and a 4xx would make the caller
     * treat the successful diagnosis as a failure.
     */
    public static adminCustomersSendTestPush<ThrowOnError extends boolean = false>(options: Options<AdminCustomersSendTestPushData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCustomersSendTestPushResponses, AdminCustomersSendTestPushErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/customers/{user_id}/test-push',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AdminFunnelLeads {
    /**
     * List Funnel Leads
     * Funnel contacts with no subscription, newest first.
     */
    public static adminFunnelLeadsListFunnelLeads<ThrowOnError extends boolean = false>(options?: Options<AdminFunnelLeadsListFunnelLeadsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminFunnelLeadsListFunnelLeadsResponses, AdminFunnelLeadsListFunnelLeadsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/funnel-leads',
            ...options
        });
    }
    
    /**
     * Export Funnel Leads Csv
     * Every lead matching the filters, as a CSV file.
     */
    public static adminFunnelLeadsExportFunnelLeadsCsv<ThrowOnError extends boolean = false>(options?: Options<AdminFunnelLeadsExportFunnelLeadsCsvData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminFunnelLeadsExportFunnelLeadsCsvResponses, AdminFunnelLeadsExportFunnelLeadsCsvErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/funnel-leads/export.csv',
            ...options
        });
    }
}

export class AdminHardshipOffer {
    /**
     * Get Hardship Offer
     */
    public static adminHardshipOfferGetHardshipOffer<ThrowOnError extends boolean = false>(options?: Options<AdminHardshipOfferGetHardshipOfferData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminHardshipOfferGetHardshipOfferResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/hardship-offer',
            ...options
        });
    }
    
    /**
     * Remove Hardship Email
     * Take one address off. Its next checkout prices normally.
     */
    public static adminHardshipOfferRemoveHardshipEmail<ThrowOnError extends boolean = false>(options: Options<AdminHardshipOfferRemoveHardshipEmailData, ThrowOnError>) {
        return (options.client ?? client).delete<AdminHardshipOfferRemoveHardshipEmailResponses, AdminHardshipOfferRemoveHardshipEmailErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/hardship-offer/emails',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Add Hardship Emails
     * Add every address in the pasted text. Duplicates and ones already on
     * the list are reported, not errors; invalid entries are echoed back.
     */
    public static adminHardshipOfferAddHardshipEmails<ThrowOnError extends boolean = false>(options: Options<AdminHardshipOfferAddHardshipEmailsData, ThrowOnError>) {
        return (options.client ?? client).post<AdminHardshipOfferAddHardshipEmailsResponses, AdminHardshipOfferAddHardshipEmailsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/hardship-offer/emails',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Send Hardship Offer Email
     * The offer email to everyone on the list who has not had it in the
     * last 30 days. A service notice: they are told about a price we set aside
     * for them, so marketing opt-outs do not stop it; the do-not-email list
     * does. `dry_run` (the default) counts and sends nothing. A real send goes
     * after the one-minute undo window, like every one-off.
     */
    public static adminHardshipOfferSendHardshipOfferEmail<ThrowOnError extends boolean = false>(options: Options<AdminHardshipOfferSendHardshipOfferEmailData, ThrowOnError>) {
        return (options.client ?? client).post<AdminHardshipOfferSendHardshipOfferEmailResponses, AdminHardshipOfferSendHardshipOfferEmailErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/hardship-offer/send',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Test Send Hardship Offer Email
     * The offer email to your own address, marked [TEST].
     */
    public static adminHardshipOfferTestSendHardshipOfferEmail<ThrowOnError extends boolean = false>(options?: Options<AdminHardshipOfferTestSendHardshipOfferEmailData, ThrowOnError>) {
        return (options?.client ?? client).post<AdminHardshipOfferTestSendHardshipOfferEmailResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/hardship-offer/test-send',
            ...options
        });
    }
}

export class AdminConsent {
    /**
     * Consent Dashboard
     * Per-purpose states, cohorts of what we may send, statement versions,
     * and the invariants that say whether the counts add up.
     */
    public static adminConsentConsentDashboard<ThrowOnError extends boolean = false>(options?: Options<AdminConsentConsentDashboardData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminConsentConsentDashboardResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/consent/dashboard',
            ...options
        });
    }
}

export class AdminPushLists {
    /**
     * Preview Push List
     * Who this would reach right now. Sends nothing.
     */
    public static adminPushListsPreviewPushList<ThrowOnError extends boolean = false>(options: Options<AdminPushListsPreviewPushListData, ThrowOnError>) {
        return (options.client ?? client).post<AdminPushListsPreviewPushListResponses, AdminPushListsPreviewPushListErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/push-lists/preview',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Send Push List
     */
    public static adminPushListsSendPushList<ThrowOnError extends boolean = false>(options: Options<AdminPushListsSendPushListData, ThrowOnError>) {
        return (options.client ?? client).post<AdminPushListsSendPushListResponses, AdminPushListsSendPushListErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/push-lists/send',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Preview Schedule
     * When each person would get it, and where that estimate came from.
     */
    public static adminPushListsPreviewSchedule<ThrowOnError extends boolean = false>(options: Options<AdminPushListsPreviewScheduleData, ThrowOnError>) {
        return (options.client ?? client).post<AdminPushListsPreviewScheduleResponses, AdminPushListsPreviewScheduleErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/push-lists/schedule/preview',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create Schedule
     * Freeze the list and each person's send time. The scheduler does the rest.
     */
    public static adminPushListsCreateSchedule<ThrowOnError extends boolean = false>(options: Options<AdminPushListsCreateScheduleData, ThrowOnError>) {
        return (options.client ?? client).post<AdminPushListsCreateScheduleResponses, AdminPushListsCreateScheduleErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/push-lists/schedule',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Scheduled
     * The 30 most recent scheduled pushes, with how far each has got.
     */
    public static adminPushListsListScheduled<ThrowOnError extends boolean = false>(options?: Options<AdminPushListsListScheduledData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminPushListsListScheduledResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/push-lists/scheduled',
            ...options
        });
    }
    
    /**
     * Cancel Scheduled
     * Stop it for everyone not yet sent. Already-sent pushes stay sent.
     */
    public static adminPushListsCancelScheduled<ThrowOnError extends boolean = false>(options: Options<AdminPushListsCancelScheduledData, ThrowOnError>) {
        return (options.client ?? client).post<AdminPushListsCancelScheduledResponses, AdminPushListsCancelScheduledErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/push-lists/scheduled/{schedule_id}/cancel',
            ...options
        });
    }
}

export class AdminStoreReview {
    /**
     * Get Store Review Overview
     * Every account with a live permanent code, plus the address to prefill.
     *
     * The list is the answer to "what doors are currently open", which is the
     * question nobody could ask before this page existed -- the codes were only
     * visible one customer record at a time.
     */
    public static adminStoreReviewGetStoreReviewOverview<ThrowOnError extends boolean = false>(options?: Options<AdminStoreReviewGetStoreReviewOverviewData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminStoreReviewGetStoreReviewOverviewResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/store-review',
            ...options
        });
    }
    
    /**
     * Lookup Store Review Email
     * Resolve an address to the account a code would be issued against.
     *
     * Answers 200 with `found: false` rather than 404 for an address nobody owns.
     * That is not an error here: typing an address that has no account yet is the
     * normal first step of setting one up, and the page needs to say "create the
     * account first" rather than show a failure.
     */
    public static adminStoreReviewLookupStoreReviewEmail<ThrowOnError extends boolean = false>(options: Options<AdminStoreReviewLookupStoreReviewEmailData, ThrowOnError>) {
        return (options.client ?? client).get<AdminStoreReviewLookupStoreReviewEmailResponses, AdminStoreReviewLookupStoreReviewEmailErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/store-review/lookup',
            ...options
        });
    }
    
    /**
     * Provision Store Review Account
     * Make this address ready to hand to a store reviewer, in one action.
     *
     * Three things have to be true before review notes can be filled in, and
     * doing them separately is how one gets forgotten: the account must exist,
     * something must pay for it, and it must hold a permanent code. This does all
     * three and reports which ones it had to do.
     *
     * Idempotent by design -- each step is skipped if it is already true -- so it
     * is safe to press again on a half-set-up account, and pressing it twice never
     * rotates a code somebody has already pasted into App Store Connect.
     *
     * Deliberately a button rather than a migration. A migration that mints a live
     * credential bakes it into schema history, runs where nobody is watching, and
     * silently does nothing when the account is absent. This runs on demand in any
     * environment, is attributed to the admin who pressed it, and is revocable
     * from the same page.
     */
    public static adminStoreReviewProvisionStoreReviewAccount<ThrowOnError extends boolean = false>(options: Options<AdminStoreReviewProvisionStoreReviewAccountData, ThrowOnError>) {
        return (options.client ?? client).post<AdminStoreReviewProvisionStoreReviewAccountResponses, AdminStoreReviewProvisionStoreReviewAccountErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/store-review/provision',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AdminCommunity {
    /**
     * List Community Posts
     * Newest-first page of posts, with optional author-email, single-day, and
     * status filters. With no `status`, archived posts are hidden (the active
     * view); pass `status=archived` for the archive. Offset pagination.
     */
    public static adminCommunityListCommunityPosts<ThrowOnError extends boolean = false>(options?: Options<AdminCommunityListCommunityPostsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminCommunityListCommunityPostsResponses, AdminCommunityListCommunityPostsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts',
            ...options
        });
    }
    
    /**
     * Create Community Post
     * Post to the community as the signed-in moderator's own profile: now, or
     * at `publish_at`, when the scheduler publishes it as a new post.
     */
    public static adminCommunityCreateCommunityPost<ThrowOnError extends boolean = false>(options: Options<AdminCommunityCreateCommunityPostData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCommunityCreateCommunityPostResponses, AdminCommunityCreateCommunityPostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Cancel Scheduled Community Post
     * Cancel a scheduled post. Only one that hasn't gone live: a live post is
     * archived instead, which can be undone.
     */
    public static adminCommunityCancelScheduledCommunityPost<ThrowOnError extends boolean = false>(options: Options<AdminCommunityCancelScheduledCommunityPostData, ThrowOnError>) {
        return (options.client ?? client).delete<AdminCommunityCancelScheduledCommunityPostResponses, AdminCommunityCancelScheduledCommunityPostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts/{post_id}',
            ...options
        });
    }
    
    /**
     * Get Community Post
     */
    public static adminCommunityGetCommunityPost<ThrowOnError extends boolean = false>(options: Options<AdminCommunityGetCommunityPostData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCommunityGetCommunityPostResponses, AdminCommunityGetCommunityPostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts/{post_id}',
            ...options
        });
    }
    
    /**
     * Update Scheduled Community Post
     * Rewrite a scheduled post before it goes live: text, category, media
     * (null removes it) and time.
     */
    public static adminCommunityUpdateScheduledCommunityPost<ThrowOnError extends boolean = false>(options: Options<AdminCommunityUpdateScheduledCommunityPostData, ThrowOnError>) {
        return (options.client ?? client).put<AdminCommunityUpdateScheduledCommunityPostResponses, AdminCommunityUpdateScheduledCommunityPostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts/{post_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Archive Community Post
     * Reversible soft-delete: hide from the feed but keep the row.
     */
    public static adminCommunityArchiveCommunityPost<ThrowOnError extends boolean = false>(options: Options<AdminCommunityArchiveCommunityPostData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCommunityArchiveCommunityPostResponses, AdminCommunityArchiveCommunityPostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts/{post_id}/archive',
            ...options
        });
    }
    
    /**
     * Restore Community Post
     */
    public static adminCommunityRestoreCommunityPost<ThrowOnError extends boolean = false>(options: Options<AdminCommunityRestoreCommunityPostData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCommunityRestoreCommunityPostResponses, AdminCommunityRestoreCommunityPostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts/{post_id}/restore',
            ...options
        });
    }
    
    /**
     * Set Community Post Topic
     * Move a post to another category. The target must be an active category;
     * posts in a private room (feedback) stay where they are.
     */
    public static adminCommunitySetCommunityPostTopic<ThrowOnError extends boolean = false>(options: Options<AdminCommunitySetCommunityPostTopicData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCommunitySetCommunityPostTopicResponses, AdminCommunitySetCommunityPostTopicErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts/{post_id}/topic',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Boost Community Post
     * Pin to the top of the feed. Stacks with other boosts (newest boost on
     * top). `hours` needs a positive `hours`; `until_next_post` ignores it.
     */
    public static adminCommunityBoostCommunityPost<ThrowOnError extends boolean = false>(options: Options<AdminCommunityBoostCommunityPostData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCommunityBoostCommunityPostResponses, AdminCommunityBoostCommunityPostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts/{post_id}/boost',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Unboost Community Post
     */
    public static adminCommunityUnboostCommunityPost<ThrowOnError extends boolean = false>(options: Options<AdminCommunityUnboostCommunityPostData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCommunityUnboostCommunityPostResponses, AdminCommunityUnboostCommunityPostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts/{post_id}/unboost',
            ...options
        });
    }
    
    /**
     * Highlight Community Post
     * Override the wins/milestone tint. null = auto (client heuristic).
     */
    public static adminCommunityHighlightCommunityPost<ThrowOnError extends boolean = false>(options: Options<AdminCommunityHighlightCommunityPostData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCommunityHighlightCommunityPostResponses, AdminCommunityHighlightCommunityPostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts/{post_id}/highlight',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Hero Community Post
     * Override the short-win pull-quote. null = auto (client heuristic).
     */
    public static adminCommunityHeroCommunityPost<ThrowOnError extends boolean = false>(options: Options<AdminCommunityHeroCommunityPostData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCommunityHeroCommunityPostResponses, AdminCommunityHeroCommunityPostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts/{post_id}/hero',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Community Identity
     */
    public static adminCommunityGetCommunityIdentity<ThrowOnError extends boolean = false>(options?: Options<AdminCommunityGetCommunityIdentityData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminCommunityGetCommunityIdentityResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/me',
            ...options
        });
    }
    
    /**
     * Set Community Name
     * Set the moderator's own community name, the one members see on what
     * they post from here, exactly as typed. Only the name: bio and avatar are
     * left as they are.
     */
    public static adminCommunitySetCommunityName<ThrowOnError extends boolean = false>(options: Options<AdminCommunitySetCommunityNameData, ThrowOnError>) {
        return (options.client ?? client).put<AdminCommunitySetCommunityNameResponses, AdminCommunitySetCommunityNameErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/me',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Community Post Comments
     * Every comment on the post, hidden ones included, as a thread: top-level
     * comments oldest first, each with its replies.
     */
    public static adminCommunityListCommunityPostComments<ThrowOnError extends boolean = false>(options: Options<AdminCommunityListCommunityPostCommentsData, ThrowOnError>) {
        return (options.client ?? client).get<AdminCommunityListCommunityPostCommentsResponses, AdminCommunityListCommunityPostCommentsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts/{post_id}/comments',
            ...options
        });
    }
    
    /**
     * Create Community Post Comment
     * Respond to the post, or reply to one of its top-level comments, as the
     * signed-in moderator's own community profile. The same path a member's
     * comment takes, so whoever is answered gets the same push.
     */
    public static adminCommunityCreateCommunityPostComment<ThrowOnError extends boolean = false>(options: Options<AdminCommunityCreateCommunityPostCommentData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCommunityCreateCommunityPostCommentResponses, AdminCommunityCreateCommunityPostCommentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts/{post_id}/comments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Archive Community Comment
     * Hide a comment from members. Reversible; its replies go out of sight
     * with it and come back with it.
     */
    public static adminCommunityArchiveCommunityComment<ThrowOnError extends boolean = false>(options: Options<AdminCommunityArchiveCommunityCommentData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCommunityArchiveCommunityCommentResponses, AdminCommunityArchiveCommunityCommentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/comments/{comment_id}/archive',
            ...options
        });
    }
    
    /**
     * Restore Community Comment
     */
    public static adminCommunityRestoreCommunityComment<ThrowOnError extends boolean = false>(options: Options<AdminCommunityRestoreCommunityCommentData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCommunityRestoreCommunityCommentResponses, AdminCommunityRestoreCommunityCommentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/comments/{comment_id}/restore',
            ...options
        });
    }
    
    /**
     * Set Community Comment Reaction
     * React to a comment as the signed-in moderator, the same toggle a
     * member's tap is: same kind clears, a different kind switches, none adds.
     * Only a comment members can see: a hidden one, or a reply under one, is a
     * 404, as it is in the app.
     */
    public static adminCommunitySetCommunityCommentReaction<ThrowOnError extends boolean = false>(options: Options<AdminCommunitySetCommunityCommentReactionData, ThrowOnError>) {
        return (options.client ?? client).put<AdminCommunitySetCommunityCommentReactionResponses, AdminCommunitySetCommunityCommentReactionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/comments/{comment_id}/reaction',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Set Community Post Reaction
     * React to a post as the signed-in moderator, the same toggle a member's
     * tap is: same kind clears, a different kind switches, none adds. Only a
     * post members can see; an archived, hidden or scheduled one is a 404.
     */
    public static adminCommunitySetCommunityPostReaction<ThrowOnError extends boolean = false>(options: Options<AdminCommunitySetCommunityPostReactionData, ThrowOnError>) {
        return (options.client ?? client).put<AdminCommunitySetCommunityPostReactionResponses, AdminCommunitySetCommunityPostReactionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts/{post_id}/reaction',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Publish Scheduled Community Post
     * Put a scheduled post live now instead of at its time.
     */
    public static adminCommunityPublishScheduledCommunityPost<ThrowOnError extends boolean = false>(options: Options<AdminCommunityPublishScheduledCommunityPostData, ThrowOnError>) {
        return (options.client ?? client).post<AdminCommunityPublishScheduledCommunityPostResponses, AdminCommunityPublishScheduledCommunityPostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/posts/{post_id}/publish',
            ...options
        });
    }
    
    /**
     * Community Stats
     * Everything on the community dashboard, from our own tables (UTC days).
     * Default window is the last 30 days; the previous window is the same
     * length ending the day before `start`.
     */
    public static adminCommunityCommunityStats<ThrowOnError extends boolean = false>(options?: Options<AdminCommunityCommunityStatsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminCommunityCommunityStatsResponses, AdminCommunityCommunityStatsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/community/stats',
            ...options
        });
    }
}

export class AdminBeehiiv {
    /**
     * Get Subscription By Email
     * Get Beehiiv subscription information by email.
     *
     * Args:
     * email: Subscriber email address
     * expand: Optional comma-separated list: custom_fields,stats,tags,referrals,subscription_premium_tiers
     */
    public static adminBeehiivGetSubscriptionByEmail<ThrowOnError extends boolean = false>(options: Options<AdminBeehiivGetSubscriptionByEmailData, ThrowOnError>) {
        return (options.client ?? client).get<AdminBeehiivGetSubscriptionByEmailResponses, AdminBeehiivGetSubscriptionByEmailErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/beehiiv/subscription/{email}',
            ...options
        });
    }
    
    /**
     * List Custom Fields
     * List all custom fields for the publication.
     */
    public static adminBeehiivListCustomFields<ThrowOnError extends boolean = false>(options?: Options<AdminBeehiivListCustomFieldsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminBeehiivListCustomFieldsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/beehiiv/custom-fields',
            ...options
        });
    }
    
    /**
     * Get Publication
     * Get publication information (cached for 1 hour).
     */
    public static adminBeehiivGetPublication<ThrowOnError extends boolean = false>(options?: Options<AdminBeehiivGetPublicationData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminBeehiivGetPublicationResponses, AdminBeehiivGetPublicationErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/beehiiv/publication',
            ...options
        });
    }
    
    /**
     * List Posts
     * List all posts for the publication with optional filtering and pagination.
     */
    public static adminBeehiivListPosts<ThrowOnError extends boolean = false>(options?: Options<AdminBeehiivListPostsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminBeehiivListPostsResponses, AdminBeehiivListPostsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/beehiiv/posts',
            ...options
        });
    }
    
    /**
     * Get Posts Aggregate Stats
     * Get aggregate statistics for all posts (cached for 5 minutes).
     */
    public static adminBeehiivGetPostsAggregateStats<ThrowOnError extends boolean = false>(options?: Options<AdminBeehiivGetPostsAggregateStatsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminBeehiivGetPostsAggregateStatsResponses, AdminBeehiivGetPostsAggregateStatsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/beehiiv/posts/aggregate-stats',
            ...options
        });
    }
    
    /**
     * List Subscriptions
     * List all subscriptions for the publication with optional filtering.
     *
     * Note: To get unsubscribed users, use status=inactive.
     * Spam reports and delivery failures are only available in aggregate stats, not per-subscriber.
     * If segment_id is provided, returns members of that segment instead of all subscriptions.
     */
    public static adminBeehiivListSubscriptions<ThrowOnError extends boolean = false>(options?: Options<AdminBeehiivListSubscriptionsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminBeehiivListSubscriptionsResponses, AdminBeehiivListSubscriptionsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/beehiiv/subscriptions',
            ...options
        });
    }
    
    /**
     * List Segments
     * List all segments for the publication.
     */
    public static adminBeehiivListSegments<ThrowOnError extends boolean = false>(options?: Options<AdminBeehiivListSegmentsData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminBeehiivListSegmentsResponses, AdminBeehiivListSegmentsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/beehiiv/segments',
            ...options
        });
    }
    
    /**
     * Recalculate Segment
     * Recalculate a specific segment.
     */
    public static adminBeehiivRecalculateSegment<ThrowOnError extends boolean = false>(options: Options<AdminBeehiivRecalculateSegmentData, ThrowOnError>) {
        return (options.client ?? client).put<AdminBeehiivRecalculateSegmentResponses, AdminBeehiivRecalculateSegmentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/beehiiv/segments/{segment_id}/recalculate',
            ...options
        });
    }
}

export class UsersV2 {
    /**
     * List Users V2
     * List users with subscription state (admin only).
     */
    public static usersV2ListUsersV2<ThrowOnError extends boolean = false>(options?: Options<UsersV2ListUsersV2Data, ThrowOnError>) {
        return (options?.client ?? client).get<UsersV2ListUsersV2Responses, UsersV2ListUsersV2Errors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/v2/users',
            ...options
        });
    }
    
    /**
     * Get User V2
     * Get a user with subscription state.
     */
    public static usersV2GetUserV2<ThrowOnError extends boolean = false>(options: Options<UsersV2GetUserV2Data, ThrowOnError>) {
        return (options.client ?? client).get<UsersV2GetUserV2Responses, UsersV2GetUserV2Errors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/v2/users/{user_id}',
            ...options
        });
    }
    
    /**
     * Get User Events V2
     * Get lifecycle events for a user.
     */
    public static usersV2GetUserEventsV2<ThrowOnError extends boolean = false>(options: Options<UsersV2GetUserEventsV2Data, ThrowOnError>) {
        return (options.client ?? client).get<UsersV2GetUserEventsV2Responses, UsersV2GetUserEventsV2Errors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/v2/users/{user_id}/events',
            ...options
        });
    }
    
    /**
     * Get User Stats V2
     * Get aggregated user stats (admin only).
     */
    public static usersV2GetUserStatsV2<ThrowOnError extends boolean = false>(options?: Options<UsersV2GetUserStatsV2Data, ThrowOnError>) {
        return (options?.client ?? client).get<UsersV2GetUserStatsV2Responses, UsersV2GetUserStatsV2Errors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/v2/users/stats/summary',
            ...options
        });
    }
}

export class Metrics {
    /**
     * Get User Counts
     * How many accounts, and how many of them are paying now.
     *
     * The Users overview reads this instead of the people list's `total`, so the
     * overview needs only the aggregate `metrics:read` scope and never fetches a
     * row that names anybody. Same Account/Environment predicates as the list.
     */
    public static metricsGetUserCounts<ThrowOnError extends boolean = false>(options?: Options<MetricsGetUserCountsData, ThrowOnError>) {
        return (options?.client ?? client).get<MetricsGetUserCountsResponses, MetricsGetUserCountsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/metrics/user-counts',
            ...options
        });
    }
    
    /**
     * Get New Users Chart
     * New accounts per UTC period, for the Users page's New users chart.
     *
     * The payments charts' response shape and filter grammar
     * (``filter.country=GB,US``, ``filter.platform=iOS``), scoped by the same
     * Account and Environment filters as the Users headline, so the two agree.
     * ``summary.countries`` lists the window's countries for the filter picker.
     */
    public static metricsGetNewUsersChart<ThrowOnError extends boolean = false>(options?: Options<MetricsGetNewUsersChartData, ThrowOnError>) {
        return (options?.client ?? client).get<MetricsGetNewUsersChartResponses, MetricsGetNewUsersChartErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/metrics/new-users',
            ...options
        });
    }
    
    /**
     * Get User Count Over Time
     * Get user count over time for charting (admin only).
     *
     * Returns daily user counts for the specified number of days.
     * Can optionally split counts by promo_code, store (iOS/Android/Test), or product_identifier.
     */
    public static metricsGetUserCountOverTime<ThrowOnError extends boolean = false>(options?: Options<MetricsGetUserCountOverTimeData, ThrowOnError>) {
        return (options?.client ?? client).get<MetricsGetUserCountOverTimeResponses, MetricsGetUserCountOverTimeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/metrics/user-count-over-time',
            ...options
        });
    }
    
    /**
     * List User Growth Events
     * Annotations staff put on the growth charts (launches, campaigns,
     * outages): date, label and description, newest first. Use them to explain
     * a step change in a metric.
     */
    public static metricsListUserGrowthEvents<ThrowOnError extends boolean = false>(options?: Options<MetricsListUserGrowthEventsData, ThrowOnError>) {
        return (options?.client ?? client).get<MetricsListUserGrowthEventsResponses, MetricsListUserGrowthEventsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/metrics/events',
            ...options
        });
    }
    
    /**
     * Create User Growth Event
     * Create a user growth event (admin only).
     *
     * Events are displayed on the user growth chart to track marketing campaigns,
     * launches, etc.
     */
    public static metricsCreateUserGrowthEvent<ThrowOnError extends boolean = false>(options: Options<MetricsCreateUserGrowthEventData, ThrowOnError>) {
        return (options.client ?? client).post<MetricsCreateUserGrowthEventResponses, MetricsCreateUserGrowthEventErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/metrics/events',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete User Growth Event
     * Delete a user growth event (admin only).
     */
    public static metricsDeleteUserGrowthEvent<ThrowOnError extends boolean = false>(options: Options<MetricsDeleteUserGrowthEventData, ThrowOnError>) {
        return (options.client ?? client).delete<MetricsDeleteUserGrowthEventResponses, MetricsDeleteUserGrowthEventErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/metrics/events/{event_id}',
            ...options
        });
    }
    
    /**
     * Get Distinct Product Identifiers
     * Distinct product identifiers for the Users admin filter (cached 24h).
     *
     * Reads a.entitlement.product_id — the owned projection, not the RC webhook
     * table — so it survives the RevenueCat retirement. The one live caller is the
     * Users page subscription-product filter, which is why this endpoint stays
     * while the dashboard metrics around it were removed.
     */
    public static metricsGetDistinctProductIdentifiers<ThrowOnError extends boolean = false>(options?: Options<MetricsGetDistinctProductIdentifiersData, ThrowOnError>) {
        return (options?.client ?? client).get<MetricsGetDistinctProductIdentifiersResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/metrics/product-identifiers',
            ...options
        });
    }
    
    /**
     * Get User Retention
     * Bracket retention of daily signup cohorts (``crud.a.retention``).
     *
     * A cohort is the real users (``a.is_real_user``) who signed up on one UTC
     * day; that day is day 0. A person is retained at a point if they made a
     * health entry on any day of its bracket. Sign-ins and token refreshes do
     * not count: a background launch makes those with nobody in the app.
     *
     * - d1: day 1
     * - d7: days 7-13
     * - d30: days 30-59
     * - d30_plus: any day after day 30, so far
     *
     * Each point is independent, so one user can count for all of them. Day 0
     * (onboarding) never counts. A point whose bracket has not ended yet (UTC)
     * has ``active`` and ``retention_rate`` null rather than 0, so a young cohort
     * does not read as churn; d30_plus is measured once day 31 has ended and keeps
     * growing. ``retention_rate`` is a percentage.
     */
    public static metricsGetUserRetention<ThrowOnError extends boolean = false>(options?: Options<MetricsGetUserRetentionData, ThrowOnError>) {
        return (options?.client ?? client).get<MetricsGetUserRetentionResponses, MetricsGetUserRetentionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/metrics/retention',
            ...options
        });
    }
    
    /**
     * Get Cohort Retention
     * Get cohort retention metrics (admin only).
     *
     * Returns retention rates for week-joined cohorts at specified retention days.
     */
    public static metricsGetCohortRetention<ThrowOnError extends boolean = false>(options?: Options<MetricsGetCohortRetentionData, ThrowOnError>) {
        return (options?.client ?? client).get<MetricsGetCohortRetentionResponses, MetricsGetCohortRetentionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/metrics/cohort-retention',
            ...options
        });
    }
}

export class Utils {
    /**
     * Health Check
     * Liveness for Railway's deploy gate and synthetic probes.
     *
     * Polled every second or so during a deploy, so it does exactly one thing: a
     * round trip to the database. A build with a bad DATABASE_URL, a broken pool
     * or a migration that left the schema unusable answers 503 here and never
     * receives traffic. Nothing about the failure is echoed to the caller.
     */
    public static utilsHealthCheck<ThrowOnError extends boolean = false>(options?: Options<UtilsHealthCheckData, ThrowOnError>) {
        return (options?.client ?? client).get<UtilsHealthCheckResponses, UtilsHealthCheckErrors, ThrowOnError>({
            url: '/api/v1/utils/health-check/',
            ...options
        });
    }
}

export class Notifications {
    /**
     * Delete All Notification Preferences
     * Delete all notification preferences for the current user.
     */
    public static notificationsDeleteAllNotificationPreferences<ThrowOnError extends boolean = false>(options?: Options<NotificationsDeleteAllNotificationPreferencesData, ThrowOnError>) {
        return (options?.client ?? client).delete<NotificationsDeleteAllNotificationPreferencesResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/notifications/preferences',
            ...options
        });
    }
    
    /**
     * Get Notification Preferences
     * Get all notification preferences for the current user.
     */
    public static notificationsGetNotificationPreferences<ThrowOnError extends boolean = false>(options?: Options<NotificationsGetNotificationPreferencesData, ThrowOnError>) {
        return (options?.client ?? client).get<NotificationsGetNotificationPreferencesResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/notifications/preferences',
            ...options
        });
    }
    
    /**
     * Create Notification Preference
     * Create a new notification preference for the current user.
     */
    public static notificationsCreateNotificationPreference<ThrowOnError extends boolean = false>(options: Options<NotificationsCreateNotificationPreferenceData, ThrowOnError>) {
        return (options.client ?? client).post<NotificationsCreateNotificationPreferenceResponses, NotificationsCreateNotificationPreferenceErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/notifications/preferences',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Notification Preference
     * Delete a notification preference by ID.
     */
    public static notificationsDeleteNotificationPreference<ThrowOnError extends boolean = false>(options: Options<NotificationsDeleteNotificationPreferenceData, ThrowOnError>) {
        return (options.client ?? client).delete<NotificationsDeleteNotificationPreferenceResponses, NotificationsDeleteNotificationPreferenceErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/notifications/preferences/{preference_id}',
            ...options
        });
    }
    
    /**
     * Update Notification Preference
     * Update a specific notification preference by ID.
     */
    public static notificationsUpdateNotificationPreference<ThrowOnError extends boolean = false>(options: Options<NotificationsUpdateNotificationPreferenceData, ThrowOnError>) {
        return (options.client ?? client).put<NotificationsUpdateNotificationPreferenceResponses, NotificationsUpdateNotificationPreferenceErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/notifications/preferences/{preference_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Read All Notification Preferences
     * Get all notification preferences with pagination. Only accessible to admins.
     */
    public static notificationsReadAllNotificationPreferences<ThrowOnError extends boolean = false>(options?: Options<NotificationsReadAllNotificationPreferencesData, ThrowOnError>) {
        return (options?.client ?? client).get<NotificationsReadAllNotificationPreferencesResponses, NotificationsReadAllNotificationPreferencesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/notifications/preferences/all',
            ...options
        });
    }
    
    /**
     * Read Notification History
     * Get all notification history with pagination. Only accessible to admins.
     */
    public static notificationsReadNotificationHistory<ThrowOnError extends boolean = false>(options?: Options<NotificationsReadNotificationHistoryData, ThrowOnError>) {
        return (options?.client ?? client).get<NotificationsReadNotificationHistoryResponses, NotificationsReadNotificationHistoryErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/notifications/history',
            ...options
        });
    }
    
    /**
     * Read User Notification History
     * Get notification history for a specific user with pagination. Only accessible to admins.
     */
    public static notificationsReadUserNotificationHistory<ThrowOnError extends boolean = false>(options: Options<NotificationsReadUserNotificationHistoryData, ThrowOnError>) {
        return (options.client ?? client).get<NotificationsReadUserNotificationHistoryResponses, NotificationsReadUserNotificationHistoryErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/notifications/history/user/{user_id}',
            ...options
        });
    }
    
    /**
     * Read Notification History By Id
     * Get notification history by ID. Only accessible to admins.
     */
    public static notificationsReadNotificationHistoryById<ThrowOnError extends boolean = false>(options: Options<NotificationsReadNotificationHistoryByIdData, ThrowOnError>) {
        return (options.client ?? client).get<NotificationsReadNotificationHistoryByIdResponses, NotificationsReadNotificationHistoryByIdErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/notifications/history/{history_id}',
            ...options
        });
    }
    
    /**
     * Record Notification Opened
     * Stamp when the user tapped a push open. Idempotent: the first stamp wins.
     *
     * The push payload carries the history row's id as ``notification_id``. A row
     * that is not this user's is a 404, the same answer as one that does not
     * exist, so the endpoint cannot be used to probe other people's ids.
     */
    public static notificationsRecordNotificationOpened<ThrowOnError extends boolean = false>(options: Options<NotificationsRecordNotificationOpenedData, ThrowOnError>) {
        return (options.client ?? client).post<NotificationsRecordNotificationOpenedResponses, NotificationsRecordNotificationOpenedErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/notifications/history/{history_id}/opened',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Public {
    /**
     * Get Community Stats
     * Get community stats for public board.
     * Cached for 1 hour to reduce database load.
     *
     * If selected_date is provided, returns stats for that specific date.
     * Otherwise, returns stats for today (UTC).
     */
    public static publicGetCommunityStats<ThrowOnError extends boolean = false>(options?: Options<PublicGetCommunityStatsData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicGetCommunityStatsResponses, PublicGetCommunityStatsErrors, ThrowOnError>({
            url: '/api/v1/a/public/community-stats',
            ...options
        });
    }
    
    /**
     * Get Cohort Mood Progression
     * Get mood progression data for week-joined cohorts.
     * Cached for 1 hour to reduce database load.
     *
     * Groups users by the week they signed up and tracks their mood progression
     * over the specified number of days. Returns the most recent cohorts (up to max_cohorts).
     *
     * Cohorts are labeled as "1st week of Jan 2024", "2nd week of Jan 2024", etc.
     */
    public static publicGetCohortMoodProgression<ThrowOnError extends boolean = false>(options?: Options<PublicGetCohortMoodProgressionData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicGetCohortMoodProgressionResponses, PublicGetCohortMoodProgressionErrors, ThrowOnError>({
            url: '/api/v1/a/public/community-stats/cohort-mood-progression',
            ...options
        });
    }
    
    /**
     * Get Email Preferences
     * Which email purposes this address currently receives.
     *
     * Read-only on purpose: mail scanners prefetch GET links, so a GET that
     * changed anything would unsubscribe people nobody asked about.
     */
    public static publicGetEmailPreferences<ThrowOnError extends boolean = false>(options: Options<PublicGetEmailPreferencesData, ThrowOnError>) {
        return (options.client ?? client).get<PublicGetEmailPreferencesResponses, PublicGetEmailPreferencesErrors, ThrowOnError>({
            url: '/api/v1/a/public/email-preferences',
            ...options
        });
    }
    
    /**
     * Update Email Preference
     * Turn one purpose on or off from the preferences page.
     *
     * The token came out of the inbox, so the mailbox is proven: turning a
     * purpose back on here is an explicit opt-in in its own right.
     */
    public static publicUpdateEmailPreference<ThrowOnError extends boolean = false>(options: Options<PublicUpdateEmailPreferenceData, ThrowOnError>) {
        return (options.client ?? client).post<PublicUpdateEmailPreferenceResponses, PublicUpdateEmailPreferenceErrors, ThrowOnError>({
            url: '/api/v1/a/public/email-preferences',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * One Click Unsubscribe
     * RFC 8058 one-click: the mail client POSTs here from List-Unsubscribe.
     *
     * Scoped to the purpose of the email it came from, so leaving the welcome
     * emails does not also cancel the newsletter. A purpose that is not live is
     * left alone: a withdrawal of something never given is a decision nobody
     * made.
     */
    public static publicOneClickUnsubscribe<ThrowOnError extends boolean = false>(options: Options<PublicOneClickUnsubscribeData, ThrowOnError>) {
        return (options.client ?? client).post<PublicOneClickUnsubscribeResponses, PublicOneClickUnsubscribeErrors, ThrowOnError>({
            url: '/api/v1/a/public/unsubscribe/one-click',
            ...options
        });
    }
    
    /**
     * Unsubscribe From Emails
     * Unsubscribe a user from all marketing emails using a token from an email link.
     *
     * This is a public endpoint that doesn't require authentication. The token
     * is provided in unsubscribe links in emails and contains the user's email
     * and user_id in a secure, signed JWT.
     */
    public static publicUnsubscribeFromEmails<ThrowOnError extends boolean = false>(options: Options<PublicUnsubscribeFromEmailsData, ThrowOnError>) {
        return (options.client ?? client).post<PublicUnsubscribeFromEmailsResponses, PublicUnsubscribeFromEmailsErrors, ThrowOnError>({
            url: '/api/v1/a/public/unsubscribe',
            ...options
        });
    }
}

export class Stripe {
    /**
     * Refund Eligibility
     * Whether the authenticated user's web Stripe sub is refundable (<=35 days).
     */
    public static stripeRefundEligibility<ThrowOnError extends boolean = false>(options?: Options<StripeRefundEligibilityData, ThrowOnError>) {
        return (options?.client ?? client).get<StripeRefundEligibilityResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/a/stripe/refund-eligibility',
            ...options
        });
    }
    
    /**
     * Refund
     * Refund + cancel the authenticated user's eligible web Stripe subscription.
     *
     * Eligibility is re-checked server-side; the client identity is established by the
     * magic-link JWT, so only the account owner can refund their own subscription.
     */
    public static stripeRefund<ThrowOnError extends boolean = false>(options?: Options<StripeRefundData, ThrowOnError>) {
        return (options?.client ?? client).post<StripeRefundResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/a/stripe/refund',
            ...options
        });
    }
    
    /**
     * Get Stripe Prices
     * Get available Stripe prices for subscription plans.
     *
     * The prices returned depend on the caller's onboarding `age_range` bucket: the
     * youth band gets the lower-priced variants (see app.core.payment.pricing). The
     * band is resolved server-side; checkout re-resolves it from the stored answers,
     * so the displayed price always matches the charged price.
     *
     * Amounts are in the visitor's currency where the price carries it (GBP in the
     * UK, EUR in the EU), as the offer endpoint does; `currency` forces one for QA
     * outside production. See core.payment.local_currency.
     */
    public static stripeGetStripePrices<ThrowOnError extends boolean = false>(options?: Options<StripeGetStripePricesData, ThrowOnError>) {
        return (options?.client ?? client).get<StripeGetStripePricesResponses, StripeGetStripePricesErrors, ThrowOnError>({
            url: '/api/v1/a/stripe/prices',
            ...options
        });
    }
    
    /**
     * Create Billing Portal Session
     * Create a Stripe billing-portal session for the signed-in user.
     *
     * Web (Stripe-store) buyers need this for self-service manage/cancel: RevenueCat's
     * managementURL is null for Stripe subscriptions, so the app's in-app
     * manage-subscription link would otherwise dead-end for them.
     */
    public static stripeCreateBillingPortalSession<ThrowOnError extends boolean = false>(options?: Options<StripeCreateBillingPortalSessionData, ThrowOnError>) {
        return (options?.client ?? client).post<StripeCreateBillingPortalSessionResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/a/stripe/billing-portal',
            ...options
        });
    }
}

export class WebOnboarding {
    /**
     * Ingest Web Onboarding
     * Persist onboarding answers for the authenticated user (marker contract).
     */
    public static webOnboardingIngestWebOnboarding<ThrowOnError extends boolean = false>(options: Options<WebOnboardingIngestWebOnboardingData, ThrowOnError>) {
        return (options.client ?? client).post<WebOnboardingIngestWebOnboardingResponses, WebOnboardingIngestWebOnboardingErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/a/web-onboarding/ingest',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Funnel Touch
     * Record a landing on the site: one ``web_landing`` touch.
     *
     * Called by the site on every landing (a new tab session, or a new ad click
     * in an open one), not only when the paywall renders, so a visitor who
     * leaves at the first question is still in the touch log. Mints the funnel
     * session cookie when there is none, the same one the quiz gate, offer and
     * checkout reuse; that is what stitches this landing to whatever the
     * session later becomes.
     *
     * Always answers 200 with the ref once the cookie is set. A failure to
     * write the touch is logged, never surfaced: the site is not waiting on it.
     */
    public static webOnboardingFunnelTouch<ThrowOnError extends boolean = false>(options: Options<WebOnboardingFunnelTouchData, ThrowOnError>) {
        return (options.client ?? client).post<WebOnboardingFunnelTouchResponses, WebOnboardingFunnelTouchErrors, ThrowOnError>({
            url: '/api/v1/a/web-onboarding/touch',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Funnel Offer
     * The offer to show, recorded so it cannot change under the person shown it.
     *
     * Call this when the PAYWALL renders, not on funnel entry: someone still
     * answering questions has been told no number, so there is nothing to promise
     * and stamping them would pin a price for every abandoned quiz.
     *
     * **The funnel must call this with `credentials: 'include'`**, or the session
     * cookie is neither stored nor sent back, every render looks like a new person,
     * and the promise this endpoint exists to keep is silently not kept.
     */
    public static webOnboardingFunnelOffer<ThrowOnError extends boolean = false>(options: Options<WebOnboardingFunnelOfferData, ThrowOnError>) {
        return (options.client ?? client).post<WebOnboardingFunnelOfferResponses, WebOnboardingFunnelOfferErrors, ThrowOnError>({
            url: '/api/v1/a/web-onboarding/offer',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Web Onboarding Config
     * Legacy funnel config: trial + which plans to show.
     *
     * Superseded by /web-onboarding/offer, which resolves prices at the same time
     * and RECORDS what it showed. Kept for funnel builds that predate it, and it
     * now reads plan visibility from the same single source — a.funnel_plan_display
     * — so the two endpoints cannot disagree about what the paywall contains.
     *
     * The trial stays a PostHog flag: it is a genuine per-visitor experiment, and
     * unlike plan visibility it was never configured in four places at once.
     */
    public static webOnboardingWebOnboardingConfig<ThrowOnError extends boolean = false>(options?: Options<WebOnboardingWebOnboardingConfigData, ThrowOnError>) {
        return (options?.client ?? client).get<WebOnboardingWebOnboardingConfigResponses, WebOnboardingWebOnboardingConfigErrors, ThrowOnError>({
            url: '/api/v1/a/web-onboarding/config',
            ...options
        });
    }
    
    /**
     * Web Onboarding Checkout
     * Email-keyed checkout: get-or-create the account by email, attach the
     * onboarding answers, and open a Stripe embedded checkout for it.
     */
    public static webOnboardingWebOnboardingCheckout<ThrowOnError extends boolean = false>(options: Options<WebOnboardingWebOnboardingCheckoutData, ThrowOnError>) {
        return (options.client ?? client).post<WebOnboardingWebOnboardingCheckoutResponses, WebOnboardingWebOnboardingCheckoutErrors, ThrowOnError>({
            url: '/api/v1/a/web-onboarding/checkout',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Web Onboarding Complete
     * After embedded checkout completes: save the sub (fires the Stripe→RC
     * bridge) and send the long-lived magic link to the account's email.
     */
    public static webOnboardingWebOnboardingComplete<ThrowOnError extends boolean = false>(options: Options<WebOnboardingWebOnboardingCompleteData, ThrowOnError>) {
        return (options.client ?? client).post<WebOnboardingWebOnboardingCompleteResponses, WebOnboardingWebOnboardingCompleteErrors, ThrowOnError>({
            url: '/api/v1/a/web-onboarding/complete',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Web Onboarding Resend
     * Resend the handoff link to an email — works on any device since the account
     * is email-keyed. Silently succeeds if no account exists (no enumeration).
     */
    public static webOnboardingWebOnboardingResend<ThrowOnError extends boolean = false>(options: Options<WebOnboardingWebOnboardingResendData, ThrowOnError>) {
        return (options.client ?? client).post<WebOnboardingWebOnboardingResendResponses, WebOnboardingWebOnboardingResendErrors, ThrowOnError>({
            url: '/api/v1/a/web-onboarding/resend',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Payments {
    /**
     * Payment Webhook
     */
    public static paymentsPaymentWebhook<ThrowOnError extends boolean = false>(options: Options<PaymentsPaymentWebhookData, ThrowOnError>) {
        return (options.client ?? client).post<PaymentsPaymentWebhookResponses, PaymentsPaymentWebhookErrors, ThrowOnError>({
            url: '/api/v1/a/payments/{provider_name}/webhook',
            ...options
        });
    }
}

export class StripeWebhook {
    /**
     * Stripe Webhook
     * Handle Stripe webhook events.
     *
     * Processes subscription-related events:
     * - checkout.session.completed: Initial subscription creation
     * - charge.refunded: Withdraw access a refunded purchase paid for
     * - charge.dispute.created: Withdraw access a charged-back purchase paid for
     * - customer.subscription.created: Subscription created
     * - customer.subscription.updated: Subscription updated
     * - customer.subscription.deleted: Subscription canceled
     * - invoice.payment_succeeded: Payment succeeded
     * - invoice.payment_failed: Payment failed
     */
    public static stripeWebhookStripeWebhook<ThrowOnError extends boolean = false>(options?: Options<StripeWebhookStripeWebhookData, ThrowOnError>) {
        return (options?.client ?? client).post<StripeWebhookStripeWebhookResponses, unknown, ThrowOnError>({
            url: '/api/v1/a/stripe-webhook',
            ...options
        });
    }
}

export class Revenuecat {
    /**
     * Sync Revenuecat Subscription
     * Answer what the backend knows about this account's subscription.
     *
     * The name is a fossil. Nothing is synced upward any more: current builds
     * stopped posting here when the RevenueCat SDK went away (expo
     * ``SubscriptionBackendSync.tsx``), and the store's answer reaches us through
     * the provider webhook. The route stays because installed older builds still
     * call it on purchase and on customer-info refresh, and a 404 in that path
     * would surface as a purchase-time error on a purchase that succeeded.
     *
     * It used to rebuild ``a.rc_subscription_state`` from webhook events on the
     * request path. That projection is retired — nothing read it, and the
     * read-then-insert rebuild raced itself. ``subscription_status`` now comes
     * from ``a.entitlement``, the replayable projection of ``a.payment_event``
     * that every other reader already uses.
     *
     * ``customer_info`` is still only echoed back for the display fields; it is
     * not trusted for status and is not stored.
     */
    public static revenuecatSyncRevenuecatSubscription<ThrowOnError extends boolean = false>(options: Options<RevenuecatSyncRevenuecatSubscriptionData, ThrowOnError>) {
        return (options.client ?? client).post<RevenuecatSyncRevenuecatSubscriptionResponses, RevenuecatSyncRevenuecatSubscriptionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/a/revenuecat/sync',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class RevenuecatWebhook {
    /**
     * Revenuecat Webhook
     * Handle RevenueCat webhook events.
     *
     * Simply stores webhook events in the database for later processing.
     */
    public static revenuecatWebhookRevenuecatWebhook<ThrowOnError extends boolean = false>(options?: Options<RevenuecatWebhookRevenuecatWebhookData, ThrowOnError>) {
        return (options?.client ?? client).post<RevenuecatWebhookRevenuecatWebhookResponses, unknown, ThrowOnError>({
            url: '/api/v1/a/revenuecat-webhook',
            ...options
        });
    }
}

export class PromoCodes {
    /**
     * Validate Promo Code
     * Validate a promo code and apply it to the user.
     *
     * - Validates code exists, is active, not expired, and hasn't exceeded max uses
     * - Increments usage count
     * - Stores code on user record
     * - Returns RevenueCat product IDs for promotion products
     */
    public static promoCodesValidatePromoCode<ThrowOnError extends boolean = false>(options: Options<PromoCodesValidatePromoCodeData, ThrowOnError>) {
        return (options.client ?? client).post<PromoCodesValidatePromoCodeResponses, PromoCodesValidatePromoCodeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/a/promo-codes/validate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Feedback {
    /**
     * Read Feedback List
     * Retrieve feedback with pagination. Only accessible to admins.
     *
     * Parameters:
     * - skip: Number of records to skip
     * - limit: Maximum number of records to return
     * - category: Filter by category
     * - status: Filter by status
     * - priority: Filter by priority
     * - sort_by: Field to sort by (dt_created, dt_updated, category, status, priority, title)
     * - sort_direction: Sort direction (asc or desc)
     */
    public static feedbackReadFeedbackList<ThrowOnError extends boolean = false>(options?: Options<FeedbackReadFeedbackListData, ThrowOnError>) {
        return (options?.client ?? client).get<FeedbackReadFeedbackListResponses, FeedbackReadFeedbackListErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/feedback',
            ...options
        });
    }
    
    /**
     * Create Feedback
     * Create new feedback.
     */
    public static feedbackCreateFeedback<ThrowOnError extends boolean = false>(options: Options<FeedbackCreateFeedbackData, ThrowOnError>) {
        return (options.client ?? client).post<FeedbackCreateFeedbackResponses, FeedbackCreateFeedbackErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/feedback',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Feedback
     * Delete feedback. Only accessible to admins.
     */
    public static feedbackDeleteFeedback<ThrowOnError extends boolean = false>(options: Options<FeedbackDeleteFeedbackData, ThrowOnError>) {
        return (options.client ?? client).delete<FeedbackDeleteFeedbackResponses, FeedbackDeleteFeedbackErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/feedback/{feedback_id}',
            ...options
        });
    }
    
    /**
     * Read Feedback
     * Get feedback by ID. Only accessible to admins.
     */
    public static feedbackReadFeedback<ThrowOnError extends boolean = false>(options: Options<FeedbackReadFeedbackData, ThrowOnError>) {
        return (options.client ?? client).get<FeedbackReadFeedbackResponses, FeedbackReadFeedbackErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/feedback/{feedback_id}',
            ...options
        });
    }
    
    /**
     * Update Feedback
     * Update feedback. Only accessible to admins.
     */
    public static feedbackUpdateFeedback<ThrowOnError extends boolean = false>(options: Options<FeedbackUpdateFeedbackData, ThrowOnError>) {
        return (options.client ?? client).patch<FeedbackUpdateFeedbackResponses, FeedbackUpdateFeedbackErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/feedback/{feedback_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AgentConfigs {
    /**
     * Get Agent Config By Slug
     * Get an agent config by slug (authenticated users only).
     * Returns config without secrets.
     */
    public static agentConfigsGetAgentConfigBySlug<ThrowOnError extends boolean = false>(options: Options<AgentConfigsGetAgentConfigBySlugData, ThrowOnError>) {
        return (options.client ?? client).get<AgentConfigsGetAgentConfigBySlugResponses, AgentConfigsGetAgentConfigBySlugErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/agent-configs/{slug}',
            ...options
        });
    }
    
    /**
     * Create Elevenlabs Signed Url
     * Create ElevenLabs signed URL for starting a conversation.
     * Uses caching to avoid unnecessary API calls to ElevenLabs.
     */
    public static agentConfigsCreateElevenlabsSignedUrl<ThrowOnError extends boolean = false>(options: Options<AgentConfigsCreateElevenlabsSignedUrlData, ThrowOnError>) {
        return (options.client ?? client).post<AgentConfigsCreateElevenlabsSignedUrlResponses, AgentConfigsCreateElevenlabsSignedUrlErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/agent-configs/{slug}/elevenlabs-signed-url',
            ...options
        });
    }
    
    /**
     * List Agent Configs
     * List all agent configs with pagination (admin only).
     */
    public static agentConfigsListAgentConfigs<ThrowOnError extends boolean = false>(options?: Options<AgentConfigsListAgentConfigsData, ThrowOnError>) {
        return (options?.client ?? client).get<AgentConfigsListAgentConfigsResponses, AgentConfigsListAgentConfigsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/agent-configs',
            ...options
        });
    }
    
    /**
     * Create Agent Config
     * Create a new agent config (admin only).
     */
    public static agentConfigsCreateAgentConfig<ThrowOnError extends boolean = false>(options: Options<AgentConfigsCreateAgentConfigData, ThrowOnError>) {
        return (options.client ?? client).post<AgentConfigsCreateAgentConfigResponses, AgentConfigsCreateAgentConfigErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/agent-configs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Agent Config
     * Delete an agent config (admin only).
     */
    public static agentConfigsDeleteAgentConfig<ThrowOnError extends boolean = false>(options: Options<AgentConfigsDeleteAgentConfigData, ThrowOnError>) {
        return (options.client ?? client).delete<AgentConfigsDeleteAgentConfigResponses, AgentConfigsDeleteAgentConfigErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/agent-configs/admin/{config_id}',
            ...options
        });
    }
    
    /**
     * Get Agent Config By Id
     * Get an agent config by ID (admin only).
     */
    public static agentConfigsGetAgentConfigById<ThrowOnError extends boolean = false>(options: Options<AgentConfigsGetAgentConfigByIdData, ThrowOnError>) {
        return (options.client ?? client).get<AgentConfigsGetAgentConfigByIdResponses, AgentConfigsGetAgentConfigByIdErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/agent-configs/admin/{config_id}',
            ...options
        });
    }
    
    /**
     * Update Agent Config
     * Update an agent config (admin only).
     */
    public static agentConfigsUpdateAgentConfig<ThrowOnError extends boolean = false>(options: Options<AgentConfigsUpdateAgentConfigData, ThrowOnError>) {
        return (options.client ?? client).patch<AgentConfigsUpdateAgentConfigResponses, AgentConfigsUpdateAgentConfigErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/agent-configs/admin/{config_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Invalidate Agent Cache
     * Invalidate cached signed URLs for an agent config (admin only).
     */
    public static agentConfigsInvalidateAgentCache<ThrowOnError extends boolean = false>(options: Options<AgentConfigsInvalidateAgentCacheData, ThrowOnError>) {
        return (options.client ?? client).post<AgentConfigsInvalidateAgentCacheResponses, AgentConfigsInvalidateAgentCacheErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/agent-configs/admin/{config_id}/invalidate-cache',
            ...options
        });
    }
}

export class Exercises {
    /**
     * Get Daily Flow Behaviors
     * Get the available daily flow behavior options for the multi-select.
     *
     * This endpoint provides the behavior options that users can select from
     * during their daily check-in flow. These behaviors are then used to
     * recommend appropriate exercises.
     */
    public static exercisesGetDailyFlowBehaviors<ThrowOnError extends boolean = false>(options?: Options<ExercisesGetDailyFlowBehaviorsData, ThrowOnError>) {
        return (options?.client ?? client).get<ExercisesGetDailyFlowBehaviorsResponses, unknown, ThrowOnError>({
            url: '/api/v1/c/exercises/daily-flow-behaviors',
            ...options
        });
    }
    
    /**
     * Get Daily Flow Recommendation
     * Get a recommended exercise based on daily flow tags (authenticated users only).
     *
     * This endpoint implements the daily flow recommendation feature:
     * - Takes daily flow tags as input
     * - Finds exercises that match those tags
     * - Returns a recommended exercise based on historic weighting
     * - Returns None if no matching exercises found
     */
    public static exercisesGetDailyFlowRecommendation<ThrowOnError extends boolean = false>(options: Options<ExercisesGetDailyFlowRecommendationData, ThrowOnError>) {
        return (options.client ?? client).get<ExercisesGetDailyFlowRecommendationResponses, ExercisesGetDailyFlowRecommendationErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/exercises/recommendations/daily-flow',
            ...options
        });
    }
    
    /**
     * List Exercises
     * List exercises with pagination (authenticated users only).
     */
    public static exercisesListExercises<ThrowOnError extends boolean = false>(options?: Options<ExercisesListExercisesData, ThrowOnError>) {
        return (options?.client ?? client).get<ExercisesListExercisesResponses, ExercisesListExercisesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/exercises',
            ...options
        });
    }
    
    /**
     * Create Exercise
     * Create a new exercise (admin only).
     */
    public static exercisesCreateExercise<ThrowOnError extends boolean = false>(options: Options<ExercisesCreateExerciseData, ThrowOnError>) {
        return (options.client ?? client).post<ExercisesCreateExerciseResponses, ExercisesCreateExerciseErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/exercises/admin/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Exercise
     * Delete an exercise by ID (admin only).
     */
    public static exercisesDeleteExercise<ThrowOnError extends boolean = false>(options: Options<ExercisesDeleteExerciseData, ThrowOnError>) {
        return (options.client ?? client).delete<ExercisesDeleteExerciseResponses, ExercisesDeleteExerciseErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/exercises/admin/{exercise_id}',
            ...options
        });
    }
    
    /**
     * Get Exercise By Id Admin
     * Get an exercise by ID (admin only).
     */
    public static exercisesGetExerciseByIdAdmin<ThrowOnError extends boolean = false>(options: Options<ExercisesGetExerciseByIdAdminData, ThrowOnError>) {
        return (options.client ?? client).get<ExercisesGetExerciseByIdAdminResponses, ExercisesGetExerciseByIdAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/exercises/admin/{exercise_id}',
            ...options
        });
    }
    
    /**
     * Update Exercise
     * Update an exercise by ID (admin only).
     */
    public static exercisesUpdateExercise<ThrowOnError extends boolean = false>(options: Options<ExercisesUpdateExerciseData, ThrowOnError>) {
        return (options.client ?? client).patch<ExercisesUpdateExerciseResponses, ExercisesUpdateExerciseErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/exercises/admin/{exercise_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Promote Exercise From Staging
     * Promote a draft exercise from staging to production.
     * Called from staging backend - creates draft on production.
     */
    public static exercisesPromoteExerciseFromStaging<ThrowOnError extends boolean = false>(options: Options<ExercisesPromoteExerciseFromStagingData, ThrowOnError>) {
        return (options.client ?? client).post<ExercisesPromoteExerciseFromStagingResponses, ExercisesPromoteExerciseFromStagingErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/exercises/admin/{exercise_id}/promote',
            ...options
        });
    }
    
    /**
     * Publish Exercise
     * Publish a draft exercise (set is_draft=False, dt_published=now).
     * Only available in production environment.
     */
    public static exercisesPublishExercise<ThrowOnError extends boolean = false>(options: Options<ExercisesPublishExerciseData, ThrowOnError>) {
        return (options.client ?? client).post<ExercisesPublishExerciseResponses, ExercisesPublishExerciseErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/exercises/admin/publish/{exercise_id}',
            ...options
        });
    }
    
    /**
     * Unpublish Exercise
     * Unpublish an exercise (set is_draft=True, dt_published=None).
     * Only available in production environment.
     */
    public static exercisesUnpublishExercise<ThrowOnError extends boolean = false>(options: Options<ExercisesUnpublishExerciseData, ThrowOnError>) {
        return (options.client ?? client).post<ExercisesUnpublishExerciseResponses, ExercisesUnpublishExerciseErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/exercises/admin/unpublish/{exercise_id}',
            ...options
        });
    }
    
    /**
     * Sync Exercises From Production
     * Sync published exercises from production to staging.
     * Only available in staging environment.
     */
    public static exercisesSyncExercisesFromProduction<ThrowOnError extends boolean = false>(options?: Options<ExercisesSyncExercisesFromProductionData, ThrowOnError>) {
        return (options?.client ?? client).post<ExercisesSyncExercisesFromProductionResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/exercises/admin/sync-from-production',
            ...options
        });
    }
    
    /**
     * List Exercise Categories
     * List all exercise categories (authenticated users only).
     */
    public static exercisesListExerciseCategories<ThrowOnError extends boolean = false>(options?: Options<ExercisesListExerciseCategoriesData, ThrowOnError>) {
        return (options?.client ?? client).get<ExercisesListExerciseCategoriesResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/exercises/categories',
            ...options
        });
    }
    
    /**
     * Get Exercises By Category
     * Get exercises by category (authenticated users only).
     */
    public static exercisesGetExercisesByCategory<ThrowOnError extends boolean = false>(options: Options<ExercisesGetExercisesByCategoryData, ThrowOnError>) {
        return (options.client ?? client).get<ExercisesGetExercisesByCategoryResponses, ExercisesGetExercisesByCategoryErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/exercises/categories/{slug}',
            ...options
        });
    }
    
    /**
     * Get Exercise By Slug
     * Get the latest version of an exercise by slug (authenticated users only).
     * Only returns published (non-draft) exercises.
     */
    public static exercisesGetExerciseBySlug<ThrowOnError extends boolean = false>(options: Options<ExercisesGetExerciseBySlugData, ThrowOnError>) {
        return (options.client ?? client).get<ExercisesGetExerciseBySlugResponses, ExercisesGetExerciseBySlugErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/exercises/{slug}',
            ...options
        });
    }
    
    /**
     * Get Exercise By Slug And Version
     * Get a specific version of an exercise by slug and version (authenticated users only).
     * Only returns published (non-draft) exercises.
     */
    public static exercisesGetExerciseBySlugAndVersion<ThrowOnError extends boolean = false>(options: Options<ExercisesGetExerciseBySlugAndVersionData, ThrowOnError>) {
        return (options.client ?? client).get<ExercisesGetExerciseBySlugAndVersionResponses, ExercisesGetExerciseBySlugAndVersionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/exercises/{slug}/versions/{version}',
            ...options
        });
    }
}

export class AmisExercises {
    /**
     * List Amis Exercises
     * List Amis exercises with pagination (authenticated users only).
     */
    public static amisExercisesListAmisExercises<ThrowOnError extends boolean = false>(options?: Options<AmisExercisesListAmisExercisesData, ThrowOnError>) {
        return (options?.client ?? client).get<AmisExercisesListAmisExercisesResponses, AmisExercisesListAmisExercisesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/amis/exercises',
            ...options
        });
    }
    
    /**
     * Create Amis Exercise
     * Create a new Amis exercise (admin only).
     * Creates exercise with initial draft version D1.
     */
    public static amisExercisesCreateAmisExercise<ThrowOnError extends boolean = false>(options: Options<AmisExercisesCreateAmisExerciseData, ThrowOnError>) {
        return (options.client ?? client).post<AmisExercisesCreateAmisExerciseResponses, AmisExercisesCreateAmisExerciseErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/amis/exercises',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Daily Flow Recommendation
     * Get a recommended Amis exercise based on daily flow tags (authenticated users only).
     *
     * This endpoint implements the daily flow recommendation feature:
     * - Takes daily flow tags as input
     * - Finds Amis exercises that match those tags
     * - Returns a recommended exercise based on historic weighting
     * - Returns None if no matching exercises found
     */
    public static amisExercisesGetDailyFlowRecommendation<ThrowOnError extends boolean = false>(options: Options<AmisExercisesGetDailyFlowRecommendationData, ThrowOnError>) {
        return (options.client ?? client).get<AmisExercisesGetDailyFlowRecommendationResponses, AmisExercisesGetDailyFlowRecommendationErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/amis/exercises/recommendations/daily-flow',
            ...options
        });
    }
    
    /**
     * Delete Amis Exercise
     * Delete an Amis exercise by ID (admin only).
     * Cascades to version history.
     */
    public static amisExercisesDeleteAmisExercise<ThrowOnError extends boolean = false>(options: Options<AmisExercisesDeleteAmisExerciseData, ThrowOnError>) {
        return (options.client ?? client).delete<AmisExercisesDeleteAmisExerciseResponses, AmisExercisesDeleteAmisExerciseErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/amis/exercises/{exercise_id}',
            ...options
        });
    }
    
    /**
     * Get Amis Exercise By Id
     * Get an Amis exercise by ID (authenticated users only).
     *
     * If prefer_draft=True:
     * - Returns the latest draft version if one exists
     * - Otherwise returns the latest published version
     *
     * If prefer_draft=False (default):
     * - Returns the latest published version
     * - If no published version exists, returns the current version (which may be a draft)
     */
    public static amisExercisesGetAmisExerciseById<ThrowOnError extends boolean = false>(options: Options<AmisExercisesGetAmisExerciseByIdData, ThrowOnError>) {
        return (options.client ?? client).get<AmisExercisesGetAmisExerciseByIdResponses, AmisExercisesGetAmisExerciseByIdErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/amis/exercises/{exercise_id}',
            ...options
        });
    }
    
    /**
     * Update Amis Exercise
     * Update an Amis exercise by ID (admin only).
     * Creates a new version (D2, D3, etc. or D1 if coming from published).
     */
    public static amisExercisesUpdateAmisExercise<ThrowOnError extends boolean = false>(options: Options<AmisExercisesUpdateAmisExerciseData, ThrowOnError>) {
        return (options.client ?? client).patch<AmisExercisesUpdateAmisExerciseResponses, AmisExercisesUpdateAmisExerciseErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/amis/exercises/{exercise_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Publish Amis Exercise
     * Publish a draft Amis exercise (admin only).
     * Creates a published version (P1, P2, etc.) and deletes all draft versions.
     */
    public static amisExercisesPublishAmisExercise<ThrowOnError extends boolean = false>(options: Options<AmisExercisesPublishAmisExerciseData, ThrowOnError>) {
        return (options.client ?? client).post<AmisExercisesPublishAmisExerciseResponses, AmisExercisesPublishAmisExerciseErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/amis/exercises/{exercise_id}/publish',
            ...options
        });
    }
    
    /**
     * Get Amis Exercise History
     * Get version history for an Amis exercise (admin only).
     * Returns all versions (drafts and published) ordered by creation date (newest first).
     */
    public static amisExercisesGetAmisExerciseHistory<ThrowOnError extends boolean = false>(options: Options<AmisExercisesGetAmisExerciseHistoryData, ThrowOnError>) {
        return (options.client ?? client).get<AmisExercisesGetAmisExerciseHistoryResponses, AmisExercisesGetAmisExerciseHistoryErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/amis/exercises/{exercise_id}/history',
            ...options
        });
    }
    
    /**
     * Delete Amis Exercise Version
     * Delete a specific version (admin only).
     * Cannot delete current version or published versions.
     */
    public static amisExercisesDeleteAmisExerciseVersion<ThrowOnError extends boolean = false>(options: Options<AmisExercisesDeleteAmisExerciseVersionData, ThrowOnError>) {
        return (options.client ?? client).delete<AmisExercisesDeleteAmisExerciseVersionResponses, AmisExercisesDeleteAmisExerciseVersionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/amis/exercises/{exercise_id}/history/{version_id}',
            ...options
        });
    }
    
    /**
     * Get Amis Exercise Version By Id
     * Get a specific version history entry by ID (admin only).
     * Used for diff comparison.
     */
    public static amisExercisesGetAmisExerciseVersionById<ThrowOnError extends boolean = false>(options: Options<AmisExercisesGetAmisExerciseVersionByIdData, ThrowOnError>) {
        return (options.client ?? client).get<AmisExercisesGetAmisExerciseVersionByIdResponses, AmisExercisesGetAmisExerciseVersionByIdErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/amis/exercises/{exercise_id}/history/{version_id}',
            ...options
        });
    }
    
    /**
     * Delete Old Draft Versions
     * Delete all draft versions older than the latest published version (admin only).
     * Returns the number of versions deleted.
     */
    public static amisExercisesDeleteOldDraftVersions<ThrowOnError extends boolean = false>(options: Options<AmisExercisesDeleteOldDraftVersionsData, ThrowOnError>) {
        return (options.client ?? client).delete<AmisExercisesDeleteOldDraftVersionsResponses, AmisExercisesDeleteOldDraftVersionsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/amis/exercises/{exercise_id}/history/old-drafts',
            ...options
        });
    }
}

export class DailyLessons {
    /**
     * Get Available Lessons
     * Get available daily lessons for the current user.
     *
     * Returns lessons based on:
     * - User's current sequence day (based on unique days using app)
     * - Excludes lessons user has already dismissed
     * - Only shows lessons up to today's sequence day (previous days' lessons show if not dismissed)
     *
     * If test_sequence_day is provided, it overrides the calculated sequence day.
     * This is useful for testing different lesson sequences.
     *
     * If include_drafts is True, shows draft lessons (for dev mode testing).
     * Otherwise, only shows published (is_draft=False) and active lessons.
     */
    public static dailyLessonsGetAvailableLessons<ThrowOnError extends boolean = false>(options?: Options<DailyLessonsGetAvailableLessonsData, ThrowOnError>) {
        return (options?.client ?? client).get<DailyLessonsGetAvailableLessonsResponses, DailyLessonsGetAvailableLessonsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/daily-lessons/available',
            ...options
        });
    }
    
    /**
     * Get Saved Lessons
     * Get all saved (liked) daily lessons for the current user.
     * Returns lessons where the user has liked=1 (saved).
     */
    public static dailyLessonsGetSavedLessons<ThrowOnError extends boolean = false>(options?: Options<DailyLessonsGetSavedLessonsData, ThrowOnError>) {
        return (options?.client ?? client).get<DailyLessonsGetSavedLessonsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/daily-lessons/saved',
            ...options
        });
    }
    
    /**
     * Get Daily Lesson
     * Get a single daily lesson by ID. Only returns published (non-draft) lessons.
     */
    public static dailyLessonsGetDailyLesson<ThrowOnError extends boolean = false>(options: Options<DailyLessonsGetDailyLessonData, ThrowOnError>) {
        return (options.client ?? client).get<DailyLessonsGetDailyLessonResponses, DailyLessonsGetDailyLessonErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/daily-lessons/{lesson_id}',
            ...options
        });
    }
    
    /**
     * Dismiss Lesson
     * Mark a lesson as dismissed for the current user.
     */
    public static dailyLessonsDismissLesson<ThrowOnError extends boolean = false>(options: Options<DailyLessonsDismissLessonData, ThrowOnError>) {
        return (options.client ?? client).post<DailyLessonsDismissLessonResponses, DailyLessonsDismissLessonErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/daily-lessons/{lesson_id}/dismiss',
            ...options
        });
    }
    
    /**
     * Like Lesson
     * Like a lesson for the current user.
     */
    public static dailyLessonsLikeLesson<ThrowOnError extends boolean = false>(options: Options<DailyLessonsLikeLessonData, ThrowOnError>) {
        return (options.client ?? client).post<DailyLessonsLikeLessonResponses, DailyLessonsLikeLessonErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/daily-lessons/{lesson_id}/like',
            ...options
        });
    }
    
    /**
     * List Daily Lessons Admin
     * List all daily lessons with pagination (admin only).
     */
    public static dailyLessonsListDailyLessonsAdmin<ThrowOnError extends boolean = false>(options?: Options<DailyLessonsListDailyLessonsAdminData, ThrowOnError>) {
        return (options?.client ?? client).get<DailyLessonsListDailyLessonsAdminResponses, DailyLessonsListDailyLessonsAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/daily-lessons/admin/all',
            ...options
        });
    }
    
    /**
     * Create Daily Lesson Admin
     * Create a new daily lesson (admin only).
     */
    public static dailyLessonsCreateDailyLessonAdmin<ThrowOnError extends boolean = false>(options: Options<DailyLessonsCreateDailyLessonAdminData, ThrowOnError>) {
        return (options.client ?? client).post<DailyLessonsCreateDailyLessonAdminResponses, DailyLessonsCreateDailyLessonAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/daily-lessons/admin',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Bulk Upsert Daily Lessons Admin
     * Bulk upsert daily lessons by slug (admin only).
     * If a lesson with the slug exists, it will be updated. Otherwise, it will be created.
     */
    public static dailyLessonsBulkUpsertDailyLessonsAdmin<ThrowOnError extends boolean = false>(options: Options<DailyLessonsBulkUpsertDailyLessonsAdminData, ThrowOnError>) {
        return (options.client ?? client).post<DailyLessonsBulkUpsertDailyLessonsAdminResponses, DailyLessonsBulkUpsertDailyLessonsAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/daily-lessons/admin/bulk-upsert',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Daily Lesson Admin
     * Soft delete a daily lesson by setting is_active=False (admin only).
     */
    public static dailyLessonsDeleteDailyLessonAdmin<ThrowOnError extends boolean = false>(options: Options<DailyLessonsDeleteDailyLessonAdminData, ThrowOnError>) {
        return (options.client ?? client).delete<DailyLessonsDeleteDailyLessonAdminResponses, DailyLessonsDeleteDailyLessonAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/daily-lessons/admin/{lesson_id}',
            ...options
        });
    }
    
    /**
     * Get Daily Lesson Admin
     * Get a daily lesson by ID (admin only).
     */
    public static dailyLessonsGetDailyLessonAdmin<ThrowOnError extends boolean = false>(options: Options<DailyLessonsGetDailyLessonAdminData, ThrowOnError>) {
        return (options.client ?? client).get<DailyLessonsGetDailyLessonAdminResponses, DailyLessonsGetDailyLessonAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/daily-lessons/admin/{lesson_id}',
            ...options
        });
    }
    
    /**
     * Update Daily Lesson Admin
     * Update a daily lesson (admin only).
     */
    public static dailyLessonsUpdateDailyLessonAdmin<ThrowOnError extends boolean = false>(options: Options<DailyLessonsUpdateDailyLessonAdminData, ThrowOnError>) {
        return (options.client ?? client).patch<DailyLessonsUpdateDailyLessonAdminResponses, DailyLessonsUpdateDailyLessonAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/daily-lessons/admin/{lesson_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Promote Daily Lesson From Staging
     * Promote a draft daily lesson from staging to production.
     * Called from staging backend - creates draft on production.
     */
    public static dailyLessonsPromoteDailyLessonFromStaging<ThrowOnError extends boolean = false>(options: Options<DailyLessonsPromoteDailyLessonFromStagingData, ThrowOnError>) {
        return (options.client ?? client).post<DailyLessonsPromoteDailyLessonFromStagingResponses, DailyLessonsPromoteDailyLessonFromStagingErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/daily-lessons/admin/{lesson_id}/promote',
            ...options
        });
    }
    
    /**
     * Publish Daily Lesson
     * Publish a draft daily lesson (set is_draft=False, dt_published=now).
     * Only available in production environment.
     */
    public static dailyLessonsPublishDailyLesson<ThrowOnError extends boolean = false>(options: Options<DailyLessonsPublishDailyLessonData, ThrowOnError>) {
        return (options.client ?? client).post<DailyLessonsPublishDailyLessonResponses, DailyLessonsPublishDailyLessonErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/daily-lessons/admin/publish/{lesson_id}',
            ...options
        });
    }
    
    /**
     * Unpublish Daily Lesson
     * Unpublish a daily lesson (set is_draft=True, dt_published=None).
     * Only available in production environment.
     */
    public static dailyLessonsUnpublishDailyLesson<ThrowOnError extends boolean = false>(options: Options<DailyLessonsUnpublishDailyLessonData, ThrowOnError>) {
        return (options.client ?? client).post<DailyLessonsUnpublishDailyLessonResponses, DailyLessonsUnpublishDailyLessonErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/daily-lessons/admin/unpublish/{lesson_id}',
            ...options
        });
    }
    
    /**
     * Sync Daily Lessons From Production
     * Sync published daily lessons from production to staging.
     * Only available in staging environment.
     */
    public static dailyLessonsSyncDailyLessonsFromProduction<ThrowOnError extends boolean = false>(options?: Options<DailyLessonsSyncDailyLessonsFromProductionData, ThrowOnError>) {
        return (options?.client ?? client).post<DailyLessonsSyncDailyLessonsFromProductionResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/daily-lessons/admin/sync-from-production',
            ...options
        });
    }
}

export class Banners {
    /**
     * Get Eligible Banners
     * Resolve the user's portal shelf. **Fail-soft:** if the DB can't serve the
     * portal — e.g. a migration hasn't been applied yet, so a column/table the
     * resolver reads doesn't exist — degrade to an EMPTY shelf instead of 500. The
     * app renders "no shelf" for an empty list, so Home stays healthy and the
     * portal is simply, silently unavailable until the schema catches up. This lets
     * the app ship ahead of the backend migration.
     * ponytail: broad SQLAlchemyError catch is deliberate — a portal that can't
     * read its own tables should disappear, not take Home down.
     *
     * It logs at ERROR and emits ``portal_shelf_degraded``, because the failure is
     * otherwise INDISTINGUISHABLE from correct behaviour: a broken query and a
     * healthy paced shelf both render as an empty Home. Without a distinct signal
     * the only way to tell them apart is to go reading server logs, which is exactly
     * what nobody does while QA'ing a quiet shelf. WARNING was too quiet for
     * something that silently removes the entire feature.
     */
    public static bannersGetEligibleBanners<ThrowOnError extends boolean = false>(options?: Options<BannersGetEligibleBannersData, ThrowOnError>) {
        return (options?.client ?? client).get<BannersGetEligibleBannersResponses, BannersGetEligibleBannersErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/eligible',
            ...options
        });
    }
    
    /**
     * Get Banner History
     * The user's past letters (mailbox view): every card that was ever
     * delivered to them, newest interaction first, with its content so the
     * client can render the letter face again.
     */
    public static bannersGetBannerHistory<ThrowOnError extends boolean = false>(options?: Options<BannersGetBannerHistoryData, ThrowOnError>) {
        return (options?.client ?? client).get<BannersGetBannerHistoryResponses, BannersGetBannerHistoryErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/history',
            ...options
        });
    }
    
    /**
     * Record Banner Shown
     * Record that a banner was shown to the user (impression).
     *
     * ``channel`` attributes the interaction ('portal' in-app, 'push' when the
     * user arrived via a push notification tap). One state row spans channels;
     * the column records where the most recent interaction happened.
     */
    public static bannersRecordBannerShown<ThrowOnError extends boolean = false>(options: Options<BannersRecordBannerShownData, ThrowOnError>) {
        return (options.client ?? client).post<BannersRecordBannerShownResponses, BannersRecordBannerShownErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/{banner_id}/shown',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Record Banner Click
     * Record that the user clicked the banner's CTA.
     *
     * A push-notification tap counts as the card's click (same engagement
     * cooldowns take it off the pile) with ``channel='push'`` for attribution.
     */
    public static bannersRecordBannerClick<ThrowOnError extends boolean = false>(options: Options<BannersRecordBannerClickData, ThrowOnError>) {
        return (options.client ?? client).post<BannersRecordBannerClickResponses, BannersRecordBannerClickErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/{banner_id}/click',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Record Banner Complete
     * Record that the user COMPLETED the action behind the banner's CTA
     * (SHAI submitted, lesson finished, supporter invited).
     *
     * Distinct from click (CTA tapped): clicked-without-completed = abandoned.
     * Completion also starts the post-completion rest window — a quiet period
     * before the next letter arrives.
     */
    public static bannersRecordBannerComplete<ThrowOnError extends boolean = false>(options: Options<BannersRecordBannerCompleteData, ThrowOnError>) {
        return (options.client ?? client).post<BannersRecordBannerCompleteResponses, BannersRecordBannerCompleteErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/{banner_id}/complete',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Record Banner Delivered
     * Record that the banner was delivered (sets dt_first_shown if unset).
     *
     * The witness is VALIDATED against the resolved shelf: a delivery only
     * counts for the card that actually is today's selection (or a pin). The
     * client re-fires this on day changes, and a jump/midnight race can make it
     * report the still-rendered STALE card before its refetch lands - counting
     * that witness restarted a turn for a letter whose return interval had not
     * passed, resetting its clock and stealing the day from the rightful card.
     *
     * `meta` carries the client build, so the delivered->opened funnel can be
     * segmented by build (i.e. "does this card fail to render on older
     * bundles?"). A rejected witness writes no event at all, so it carries no
     * build either - the build is a property of a recorded delivery, not of the
     * request that claimed one.
     */
    public static bannersRecordBannerDelivered<ThrowOnError extends boolean = false>(options: Options<BannersRecordBannerDeliveredData, ThrowOnError>) {
        return (options.client ?? client).post<BannersRecordBannerDeliveredResponses, BannersRecordBannerDeliveredErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/{banner_id}/delivered',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Dismiss Banner
     * Record that the user dismissed the banner.
     */
    public static bannersDismissBanner<ThrowOnError extends boolean = false>(options: Options<BannersDismissBannerData, ThrowOnError>) {
        return (options.client ?? client).post<BannersDismissBannerResponses, BannersDismissBannerErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/{banner_id}/dismiss',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Banners Admin
     * List Portal banners, paginated. Filter with is_draft=true for unpublished
     * drafts, is_active for the active flag (admin only).
     */
    public static bannersListBannersAdmin<ThrowOnError extends boolean = false>(options?: Options<BannersListBannersAdminData, ThrowOnError>) {
        return (options?.client ?? client).get<BannersListBannersAdminResponses, BannersListBannersAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin/all',
            ...options
        });
    }
    
    /**
     * Get Banner Stats Admin
     * Full letter funnel for a banner: delivered → opened → the opened-outcome
     * split (completed / abandoned / ignored / dismissed) + rates.
     */
    public static bannersGetBannerStatsAdmin<ThrowOnError extends boolean = false>(options: Options<BannersGetBannerStatsAdminData, ThrowOnError>) {
        return (options.client ?? client).get<BannersGetBannerStatsAdminResponses, BannersGetBannerStatsAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin/{banner_id}/stats',
            ...options
        });
    }
    
    /**
     * Create Banner Admin
     * Create a new banner (admin only). Creating it live needs the publish
     * scope. The publish checks run on the content, which the panel adds after
     * creating, so they are /publish's and PATCH's job, not this one's.
     */
    public static bannersCreateBannerAdmin<ThrowOnError extends boolean = false>(options: Options<BannersCreateBannerAdminData, ThrowOnError>) {
        return (options.client ?? client).post<BannersCreateBannerAdminResponses, BannersCreateBannerAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create Draft Banner Admin
     * Create a NEW banner as an unpublished draft, optionally with content.
     *
     * The draft cannot reach anyone: publishing is a separate, deliberate step in
     * the admin panel. Returns the draft and its panel_url for review.
     */
    public static bannersCreateDraftBannerAdmin<ThrowOnError extends boolean = false>(options: Options<BannersCreateDraftBannerAdminData, ThrowOnError>) {
        return (options.client ?? client).post<BannersCreateDraftBannerAdminResponses, BannersCreateDraftBannerAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin/drafts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Banner Admin
     * Soft delete a banner (admin only).
     */
    public static bannersDeleteBannerAdmin<ThrowOnError extends boolean = false>(options: Options<BannersDeleteBannerAdminData, ThrowOnError>) {
        return (options.client ?? client).delete<BannersDeleteBannerAdminResponses, BannersDeleteBannerAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin/{banner_id}',
            ...options
        });
    }
    
    /**
     * Get Banner Admin
     * Get a banner's full config, its content DSL in every locale, and its
     * panel_url (admin only).
     */
    public static bannersGetBannerAdmin<ThrowOnError extends boolean = false>(options: Options<BannersGetBannerAdminData, ThrowOnError>) {
        return (options.client ?? client).get<BannersGetBannerAdminResponses, BannersGetBannerAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin/{banner_id}',
            ...options
        });
    }
    
    /**
     * Update Banner Admin
     * Update a banner (admin only). Taking a draft live here is publishing:
     * it needs the publish scope and passes the same checks as /publish. So does
     * reactivating a published card, which is what /unarchive does.
     *
     * The slug can change only on a draft that no member has stats against:
     * analytics,
     * contextual pins (/contextual/{slug}) and push lists refer to it by slug
     * from then on. Member state itself is keyed by id.
     */
    public static bannersUpdateBannerAdmin<ThrowOnError extends boolean = false>(options: Options<BannersUpdateBannerAdminData, ThrowOnError>) {
        return (options.client ?? client).patch<BannersUpdateBannerAdminResponses, BannersUpdateBannerAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin/{banner_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Banner Distribution Admin
     * Estimate who would see a banner and when in their journey.
     *
     * Samples real users, evaluates the banner's targeting (conditions, segment,
     * sequence day, active window) against each, and extrapolates how many are
     * eligible NOW, how many will EVENTUALLY be, what blocks the rest, the
     * journey start day and the cadence. Approximate: ignores pacing, cooldowns,
     * impression history and competition from higher-priority banners.
     */
    public static bannersGetBannerDistributionAdmin<ThrowOnError extends boolean = false>(options: Options<BannersGetBannerDistributionAdminData, ThrowOnError>) {
        return (options.client ?? client).get<BannersGetBannerDistributionAdminResponses, BannersGetBannerDistributionAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin/{banner_id}/distribution',
            ...options
        });
    }
    
    /**
     * Archive Banner Admin
     * Archive a banner (admin only): set is_active=false, which takes it off
     * every member's shelf and push at once. Undo with /unarchive.
     */
    public static bannersArchiveBannerAdmin<ThrowOnError extends boolean = false>(options: Options<BannersArchiveBannerAdminData, ThrowOnError>) {
        return (options.client ?? client).post<BannersArchiveBannerAdminResponses, BannersArchiveBannerAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin/{banner_id}/archive',
            ...options
        });
    }
    
    /**
     * Unarchive Banner Admin
     * Bring a banner back from the archive (admin only): set is_active=true. A
     * published card goes straight back to members, so that needs the publish
     * scope; a draft does not.
     */
    public static bannersUnarchiveBannerAdmin<ThrowOnError extends boolean = false>(options: Options<BannersUnarchiveBannerAdminData, ThrowOnError>) {
        return (options.client ?? client).post<BannersUnarchiveBannerAdminResponses, BannersUnarchiveBannerAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin/{banner_id}/unarchive',
            ...options
        });
    }
    
    /**
     * Duplicate Banner Admin
     * Copy a banner, its settings and its content in every locale, as a new
     * unpublished draft with slug ``<slug>-copy`` (``-copy-2``, ... if taken).
     * Dates are kept: an expired window keeps the copy from reaching anyone by
     * accident if it is published before they are changed.
     */
    public static bannersDuplicateBannerAdmin<ThrowOnError extends boolean = false>(options: Options<BannersDuplicateBannerAdminData, ThrowOnError>) {
        return (options.client ?? client).post<BannersDuplicateBannerAdminResponses, BannersDuplicateBannerAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin/{banner_id}/duplicate',
            ...options
        });
    }
    
    /**
     * Publish Banner Admin
     * Publish a draft banner (admin only).
     *
     * Publishing is the irreversible-ish step: the card becomes eligible for real
     * people's phones and, on a push channel, can wake them up. The admin panel
     * lints before it lets anyone press the button, but the panel is not a trust
     * boundary — the API, the Admin MCP and curl all reach this endpoint. So the
     * error-level rules are re-checked here and a failing card is refused with the
     * full list, not the first problem.
     *
     * Only the rules that are unambiguously WRONG live here. The panel's softer
     * warnings (missing translations, no CTA, a long title) stay client-side: they
     * need a human's judgement, not a 400.
     */
    public static bannersPublishBannerAdmin<ThrowOnError extends boolean = false>(options: Options<BannersPublishBannerAdminData, ThrowOnError>) {
        return (options.client ?? client).post<BannersPublishBannerAdminResponses, BannersPublishBannerAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin/{banner_id}/publish',
            ...options
        });
    }
    
    /**
     * Force Deliver Banner Admin
     * Force-deliver a banner NOW to a segment's members and/or explicit users,
     * ignoring cadence, cooldowns, caps, pacing and the segment gate (admin only).
     *
     * The banner pins to the top of each target's portal shelf until they open it.
     * With ``push=True`` a push notification is also sent immediately — even for a
     * portal-only banner — so push vs no-push can be tested per delivery. The
     * banner must be published (draft cards have nothing to show).
     */
    public static bannersForceDeliverBannerAdmin<ThrowOnError extends boolean = false>(options: Options<BannersForceDeliverBannerAdminData, ThrowOnError>) {
        return (options.client ?? client).post<BannersForceDeliverBannerAdminResponses, BannersForceDeliverBannerAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin/{banner_id}/force-deliver',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Banner Content Admin
     * Get banner content for a locale (admin only).
     */
    public static bannersGetBannerContentAdmin<ThrowOnError extends boolean = false>(options: Options<BannersGetBannerContentAdminData, ThrowOnError>) {
        return (options.client ?? client).get<BannersGetBannerContentAdminResponses, BannersGetBannerContentAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin/{banner_id}/content',
            ...options
        });
    }
    
    /**
     * Upsert Banner Content Admin
     * Create or update banner content for a locale (admin only). On a live
     * card this changes what members see at once, so it needs the publish scope.
     */
    public static bannersUpsertBannerContentAdmin<ThrowOnError extends boolean = false>(options: Options<BannersUpsertBannerContentAdminData, ThrowOnError>) {
        return (options.client ?? client).post<BannersUpsertBannerContentAdminResponses, BannersUpsertBannerContentAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin/{banner_id}/content',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Upsert Draft Content Admin
     * Set or replace one locale's content DSL on an UNPUBLISHED draft banner.
     *
     * Refuses a published banner (409): content written there is live at once,
     * so edit those in the admin panel.
     */
    public static bannersUpsertDraftContentAdmin<ThrowOnError extends boolean = false>(options: Options<BannersUpsertDraftContentAdminData, ThrowOnError>) {
        return (options.client ?? client).put<BannersUpsertDraftContentAdminResponses, BannersUpsertDraftContentAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/admin/{banner_id}/draft-content',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Pin Contextual Banner
     * Pin a contextual card above the caller's daily card.
     *
     * This is the trigger path the app needs: a panic session that classifies a
     * heart-anxiety loop can surface the matching lesson as a letter, on top of
     * today's card, without waiting for tomorrow's rotation.
     *
     * A client-callable "put a card on my shelf" is a spam vector, so it is fenced:
     *
     * - the banner must be marked ``contextual``; ordinary sequence cards can never
     * be self-pinned, which keeps the daily rotation out of the client's reach
     * - it pins for the CALLING user only. No user_ids, no segment. Blasting other
     * people stays behind the admin force-deliver route and its mega-confirm
     * - it is idempotent per (user, banner): re-triggering an unconsumed pin is a
     * no-op, so a retry loop or a double-tap cannot stack duplicates
     * - it respects ``PORTAL_MAX_CONTEXTUAL_PER_DAY``. Overflow is SCHEDULED
     * FORWARD, not dropped and not stacked: a heavy panic day yields one extra
     * letter today and the rest on following days, which is the whole point of
     * treating these as a pool rather than an interrupt.
     */
    public static bannersPinContextualBanner<ThrowOnError extends boolean = false>(options: Options<BannersPinContextualBannerData, ThrowOnError>) {
        return (options.client ?? client).post<BannersPinContextualBannerResponses, BannersPinContextualBannerErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/contextual/{slug}',
            ...options
        });
    }
    
    /**
     * Reset Personal Clock
     * Back to real time, optionally nuking the future the trip left behind.
     *
     * ``purge_future=true`` deletes THIS user's journey data stamped later than
     * real now: banner events and state fields, health entries (which otherwise
     * haunt charts and streaks as records from days that have not happened), and
     * pending campaign-email executions that were scheduled during the trip.
     * Future-dated rows are by definition not real history - the same reasoning
     * as the Sim Lab's reset scrub. Emails that already SENT stay sent; there is
     * no unsending. Scoped to the caller alone, like everything else here.
     */
    public static bannersResetPersonalClock<ThrowOnError extends boolean = false>(options?: Options<BannersResetPersonalClockData, ThrowOnError>) {
        return (options?.client ?? client).delete<BannersResetPersonalClockResponses, BannersResetPersonalClockErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/dev/clock',
            ...options
        });
    }
    
    /**
     * Get Personal Clock
     * Discovery: may this user travel, and where do they currently live?
     *
     * Always 200 - the app uses this to decide whether to SHOW the time-travel
     * Pip at all. An ineligible account (or an environment with the feature off)
     * gets ``eligible: false`` and no floater, rather than a button that fails.
     */
    public static bannersGetPersonalClock<ThrowOnError extends boolean = false>(options?: Options<BannersGetPersonalClockData, ThrowOnError>) {
        return (options?.client ?? client).get<BannersGetPersonalClockResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/dev/clock',
            ...options
        });
    }
    
    /**
     * Advance Personal Clock
     * Jump the CALLING user's portal clock forward (the app's "+24h" button).
     *
     * Cumulative, and NEGATIVE hours travel back toward the present (floored at
     * zero - the past is not on offer). ``clean`` (default on) is clean travel:
     * whenever the jump moves toward the present, journey data stamped beyond
     * the NEW now is purged, so stepping back from +7d to +2d does not leave
     * days 3..7 haunting charts and streaks. Affects only this user.
     */
    public static bannersAdvancePersonalClock<ThrowOnError extends boolean = false>(options?: Options<BannersAdvancePersonalClockData, ThrowOnError>) {
        return (options?.client ?? client).post<BannersAdvancePersonalClockResponses, BannersAdvancePersonalClockErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/banners/dev/clock',
            ...options
        });
    }
}

export class Walk {
    /**
     * Start Walk
     * Build (or resume) the caller's walk account for this spec and return a
     * session for it.
     */
    public static walkStartWalk<ThrowOnError extends boolean = false>(options: Options<WalkStartWalkData, ThrowOnError>) {
        return (options.client ?? client).post<WalkStartWalkResponses, WalkStartWalkErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/walk',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class LiveActivity {
    /**
     * Get Live Activity
     * Ambient community counts for the home screen, under the panic button.
     *
     * Cheap and short-cached: every app open hits this, and the numbers only need
     * to be roughly current. On error we return zeroes rather than a 500. This is
     * decoration, and a failure here must never break the home screen; zeroes fall
     * below the client's floor, so the line simply does not render.
     */
    public static liveActivityGetLiveActivity<ThrowOnError extends boolean = false>(options?: Options<LiveActivityGetLiveActivityData, ThrowOnError>) {
        return (options?.client ?? client).get<LiveActivityGetLiveActivityResponses, unknown, ThrowOnError>({
            url: '/api/v1/c/live-activity',
            ...options
        });
    }
}

export class Sim {
    /**
     * Sim Reset
     * Wipe + rebuild the synthetic cohort and reset the sim clock to real time.
     *
     * Also scrubs any future-dated banner state left behind by a previous
     * time-travel session — see ``_scrub_future_state``. Reset is the "put
     * everything back" button, so it repairs real accounts caught by the shared
     * clock, not just the cohort.
     */
    public static simSimReset<ThrowOnError extends boolean = false>(options: Options<SimSimResetData, ThrowOnError>) {
        return (options.client ?? client).post<SimSimResetResponses, SimSimResetErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/sim/reset',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Sim Tick
     * Advance the sim clock by hours and/or days (no data mutation).
     */
    public static simSimTick<ThrowOnError extends boolean = false>(options: Options<SimSimTickData, ThrowOnError>) {
        return (options.client ?? client).post<SimSimTickResponses, SimSimTickErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/sim/tick',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Sim Step
     * Run N interaction rounds for every cohort user at the current sim clock.
     */
    public static simSimStep<ThrowOnError extends boolean = false>(options: Options<SimSimStepData, ThrowOnError>) {
        return (options.client ?? client).post<SimSimStepResponses, SimSimStepErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/sim/step',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Sim Publish
     * Create + activate a banner mid-run (reuses the real banner CRUD).
     */
    public static simSimPublish<ThrowOnError extends boolean = false>(options: Options<SimSimPublishData, ThrowOnError>) {
        return (options.client ?? client).post<SimSimPublishResponses, SimSimPublishErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/sim/publish',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Sim State
     * Snapshot: sim clock, each user's current card, per-banner funnel + reach.
     */
    public static simSimState<ThrowOnError extends boolean = false>(options?: Options<SimSimStateData, ThrowOnError>) {
        return (options?.client ?? client).get<SimSimStateResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/sim/state',
            ...options
        });
    }
    
    /**
     * Sim User Detail
     * One user's resolved queue + full state history + WHY each banner is/ isn't shown.
     */
    public static simSimUserDetail<ThrowOnError extends boolean = false>(options: Options<SimSimUserDetailData, ThrowOnError>) {
        return (options.client ?? client).get<SimSimUserDetailResponses, SimSimUserDetailErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/sim/users/{user_id}',
            ...options
        });
    }
}

export class JourneyDev {
    /**
     * Reset Own Journey
     * Wipe the CALLING user's Journey progress and put their clock back to now.
     *
     * Scoped to the caller alone — there is deliberately no ``user_id`` parameter,
     * so no amount of token confusion can reset somebody else's Journey. Use
     * ``scripts/reset_journey.py`` for the operator-driven, reset-someone-else
     * case, where the target is named explicitly and previewed first.
     *
     * The account, auth, billing and the onboarding SHAI baseline all survive; see
     * ``app/services/journey_reset.py`` for the full kept/wiped contract.
     */
    public static journeyDevResetOwnJourney<ThrowOnError extends boolean = false>(options?: Options<JourneyDevResetOwnJourneyData, ThrowOnError>) {
        return (options?.client ?? client).post<JourneyDevResetOwnJourneyResponses, JourneyDevResetOwnJourneyErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/sim/journey/reset',
            ...options
        });
    }
    
    /**
     * Seed Own Journey
     * Give the CALLING user the work that stands them on a later Arrival day.
     *
     * Idempotent: only the shortfall is written, so calling it twice is the same
     * as calling it once, and calling it over real usage tops up rather than
     * duplicating.
     *
     * ``apply_personal_clock`` is attached deliberately — unlike the reset, which
     * is putting the member back to real now, seeding wants the member's PRODUCT
     * time so day 1's work backdates to their real day 1 rather than to a week in
     * the future. Same gate as the reset.
     */
    public static journeyDevSeedOwnJourney<ThrowOnError extends boolean = false>(options: Options<JourneyDevSeedOwnJourneyData, ThrowOnError>) {
        return (options.client ?? client).post<JourneyDevSeedOwnJourneyResponses, JourneyDevSeedOwnJourneyErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/sim/journey/seed',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class BookInterest {
    /**
     * Capture Book Interest
     * Capture interest in the health anxiety book concept.
     *
     * Public and unauthenticated, so the email address is a claim and not a
     * credential. Two rules follow, and both are load-bearing:
     *
     * - The response is contentless. It carries nothing about the stored record,
     * and does not vary on whether the address is already known.
     * - An existing lead is gap-filled, never overwritten. From here, "the same
     * person re-submitting" and "a stranger rewriting their record" are the
     * identical request.
     */
    public static bookInterestCaptureBookInterest<ThrowOnError extends boolean = false>(options: Options<BookInterestCaptureBookInterestData, ThrowOnError>) {
        return (options.client ?? client).post<BookInterestCaptureBookInterestResponses, BookInterestCaptureBookInterestErrors, ThrowOnError>({
            url: '/api/v1/c/book-interest',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class QuizResult {
    /**
     * Capture Quiz Result
     * Record the contact, their consents, and the answers behind their result.
     *
     * Public and unauthenticated, like the book-interest route it sits beside.
     * The response is deliberately contentless: it must not confirm whether an
     * address is known to us, belongs to a customer, or has a score on file.
     */
    public static quizResultCaptureQuizResult<ThrowOnError extends boolean = false>(options: Options<QuizResultCaptureQuizResultData, ThrowOnError>) {
        return (options.client ?? client).post<QuizResultCaptureQuizResultResponses, QuizResultCaptureQuizResultErrors, ThrowOnError>({
            url: '/api/v1/a/quiz-result',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Download Quiz Result
     */
    public static quizResultDownloadQuizResult<ThrowOnError extends boolean = false>(options?: Options<QuizResultDownloadQuizResultData, ThrowOnError>) {
        return (options?.client ?? client).get<QuizResultDownloadQuizResultResponses, QuizResultDownloadQuizResultErrors, ThrowOnError>({
            url: '/api/v1/a/quiz-result/download',
            ...options
        });
    }
}

export class CoachingWaitlist {
    /**
     * Capture Coaching Waitlist
     * Record the contact and the consent they gave to be contacted.
     *
     * Public and unauthenticated, like the two capture routes it sits beside. No
     * quiz result is written: nothing here is health data, and an empty row in
     * `a.quiz_results` would put a health record on file for someone who never
     * answered a health question.
     *
     * The response is contentless on purpose. It must not confirm whether the
     * address is already known to us, already on the list, or belongs to a
     * customer.
     *
     * Joining sends mail to a typed address (a "please confirm" email; the
     * double opt-in, N2), so it has contact-capture's guards: the honeypot and
     * the bot check, with the same answer whatever they decide. A "yes" counts
     * once the inbox confirms or the account at the address signs in.
     */
    public static coachingWaitlistCaptureCoachingWaitlist<ThrowOnError extends boolean = false>(options: Options<CoachingWaitlistCaptureCoachingWaitlistData, ThrowOnError>) {
        return (options.client ?? client).post<CoachingWaitlistCaptureCoachingWaitlistResponses, CoachingWaitlistCaptureCoachingWaitlistErrors, ThrowOnError>({
            url: '/api/v1/a/coaching-waitlist',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class ContactCapture {
    /**
     * Capture Contact
     * Record a contact and the email choices they made on a site form.
     *
     * Public and unauthenticated, so the address is a claim and not a
     * credential. The response is contentless for the same reason as its
     * siblings: it must not confirm whether the address is already known.
     *
     * A "yes" to an email list is confirmed from the inbox before anything is
     * sent (the double opt-in, N2): the grant is recorded, then one "please
     * confirm" email goes, within its limits. Because that sends mail to a
     * typed address, a "yes" needs the site's bot check (Turnstile) and an
     * empty honeypot. A bot or a refused check gets the same answer as
     * everyone else, with nothing recorded or sent; past the confirmation
     * limit the sign-up is recorded and no email goes, with the same answer.
     */
    public static contactCaptureCaptureContact<ThrowOnError extends boolean = false>(options: Options<ContactCaptureCaptureContactData, ThrowOnError>) {
        return (options.client ?? client).post<ContactCaptureCaptureContactResponses, ContactCaptureCaptureContactErrors, ThrowOnError>({
            url: '/api/v1/a/contact-capture',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class FeatureFlags {
    /**
     * Get Feature Flags
     * Every flag for the current user, resolved per flag: override, global
     * switch, the first matching rule (platform and version read from this
     * request, see ``app.services.flag_context``), then the flag's percentage.
     *
     * Siblings of ``flags``: A/B configs for flags this user has on, the OTA
     * cohort, and the Journey hold config when ``journey_hold`` is on.
     *
     * One write hides in this read: the first time ``journey`` resolves on for a
     * member with no ``journey_epoch``, the epoch is stamped. That is the moment
     * their day 1 should start, and it is idempotent, so it happens once.
     */
    public static featureFlagsGetFeatureFlags<ThrowOnError extends boolean = false>(options?: Options<FeatureFlagsGetFeatureFlagsData, ThrowOnError>) {
        return (options?.client ?? client).get<FeatureFlagsGetFeatureFlagsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/feature-flags',
            ...options
        });
    }
    
    /**
     * List Feature Flags Admin
     * Every flag with its rules, segment health and override count.
     */
    public static featureFlagsListFeatureFlagsAdmin<ThrowOnError extends boolean = false>(options?: Options<FeatureFlagsListFeatureFlagsAdminData, ThrowOnError>) {
        return (options?.client ?? client).get<FeatureFlagsListFeatureFlagsAdminResponses, FeatureFlagsListFeatureFlagsAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags',
            ...options
        });
    }
    
    /**
     * Create Feature Flag
     * Create a new feature flag (admin only).
     */
    public static featureFlagsCreateFeatureFlag<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsCreateFeatureFlagData, ThrowOnError>) {
        return (options.client ?? client).post<FeatureFlagsCreateFeatureFlagResponses, FeatureFlagsCreateFeatureFlagErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Store Versions
     * What each store serves everyone now, as the force-update guard sees it.
     */
    public static featureFlagsGetStoreVersions<ThrowOnError extends boolean = false>(options?: Options<FeatureFlagsGetStoreVersionsData, ThrowOnError>) {
        return (options?.client ?? client).get<FeatureFlagsGetStoreVersionsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags/store-versions',
            ...options
        });
    }
    
    /**
     * Delete Feature Flag
     * Delete a feature flag (admin only).
     */
    public static featureFlagsDeleteFeatureFlag<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsDeleteFeatureFlagData, ThrowOnError>) {
        return (options.client ?? client).delete<FeatureFlagsDeleteFeatureFlagResponses, FeatureFlagsDeleteFeatureFlagErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags/{flag_id}',
            ...options
        });
    }
    
    /**
     * Get Feature Flag Admin
     * One flag with its rules and an estimated reach.
     */
    public static featureFlagsGetFeatureFlagAdmin<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsGetFeatureFlagAdminData, ThrowOnError>) {
        return (options.client ?? client).get<FeatureFlagsGetFeatureFlagAdminResponses, FeatureFlagsGetFeatureFlagAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags/{flag_id}',
            ...options
        });
    }
    
    /**
     * Update Feature Flag
     * One validated change. Returns the flag and, as `previous`, what it replaced.
     *
     * With `expected_dt_updated`, a flag changed since the caller read it is a
     * 409 whose detail carries the current state, never a silent overwrite.
     */
    public static featureFlagsUpdateFeatureFlag<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsUpdateFeatureFlagData, ThrowOnError>) {
        return (options.client ?? client).patch<FeatureFlagsUpdateFeatureFlagResponses, FeatureFlagsUpdateFeatureFlagErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags/{flag_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Estimate Feature Flag Reach
     * Estimated reach of draft rules, before saving. Writes nothing.
     */
    public static featureFlagsEstimateFeatureFlagReach<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsEstimateFeatureFlagReachData, ThrowOnError>) {
        return (options.client ?? client).post<FeatureFlagsEstimateFeatureFlagReachResponses, FeatureFlagsEstimateFeatureFlagReachErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags/reach-estimate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Explain Feature Flag
     * Which rule decides this user's value, against their stored platform and
     * version. Their app sends its own, which can be newer.
     *
     * Shows a person's platform, version and segments, so it also needs one of
     * the scopes that already read those on the customer page.
     */
    public static featureFlagsExplainFeatureFlag<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsExplainFeatureFlagData, ThrowOnError>) {
        return (options.client ?? client).get<FeatureFlagsExplainFeatureFlagResponses, FeatureFlagsExplainFeatureFlagErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags/{flag_id}/explain',
            ...options
        });
    }
    
    /**
     * List Feature Flag Revisions
     * Newest first. Each carries the whole state before and after, so undo is
     * a PATCH with `before`.
     */
    public static featureFlagsListFeatureFlagRevisions<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsListFeatureFlagRevisionsData, ThrowOnError>) {
        return (options.client ?? client).get<FeatureFlagsListFeatureFlagRevisionsResponses, FeatureFlagsListFeatureFlagRevisionsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags/{flag_id}/revisions',
            ...options
        });
    }
    
    /**
     * List Feature Flag Revisions By Key
     * History by key, including a flag that has since been deleted.
     */
    public static featureFlagsListFeatureFlagRevisionsByKey<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsListFeatureFlagRevisionsByKeyData, ThrowOnError>) {
        return (options.client ?? client).get<FeatureFlagsListFeatureFlagRevisionsByKeyResponses, FeatureFlagsListFeatureFlagRevisionsByKeyErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flag-revisions',
            ...options
        });
    }
    
    /**
     * List User Feature Flag Overrides
     * List user overrides for a feature flag with pagination (admin only).
     */
    public static featureFlagsListUserFeatureFlagOverrides<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsListUserFeatureFlagOverridesData, ThrowOnError>) {
        return (options.client ?? client).get<FeatureFlagsListUserFeatureFlagOverridesResponses, FeatureFlagsListUserFeatureFlagOverridesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags/{flag_id}/user-overrides',
            ...options
        });
    }
    
    /**
     * Create User Feature Flag Override
     * Create or update user-specific override for a feature flag (admin only).
     */
    public static featureFlagsCreateUserFeatureFlagOverride<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsCreateUserFeatureFlagOverrideData, ThrowOnError>) {
        return (options.client ?? client).post<FeatureFlagsCreateUserFeatureFlagOverrideResponses, FeatureFlagsCreateUserFeatureFlagOverrideErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags/{flag_id}/user-overrides',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete User Feature Flag Override
     * Remove user-specific override (admin only).
     */
    public static featureFlagsDeleteUserFeatureFlagOverride<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsDeleteUserFeatureFlagOverrideData, ThrowOnError>) {
        return (options.client ?? client).delete<FeatureFlagsDeleteUserFeatureFlagOverrideResponses, FeatureFlagsDeleteUserFeatureFlagOverrideErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags/{flag_id}/user-overrides/{user_id}',
            ...options
        });
    }
    
    /**
     * List Segment Feature Flag Overrides
     * Which segments this flag is overridden for, and how those rows split.
     */
    public static featureFlagsListSegmentFeatureFlagOverrides<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsListSegmentFeatureFlagOverridesData, ThrowOnError>) {
        return (options.client ?? client).get<FeatureFlagsListSegmentFeatureFlagOverridesResponses, FeatureFlagsListSegmentFeatureFlagOverridesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags/{flag_id}/segment-overrides',
            ...options
        });
    }
    
    /**
     * Set Segment Feature Flag Override
     * Set a flag for everybody currently in a segment.
     *
     * Idempotent: re-running it updates the same rows rather than making more.
     *
     * A member who already has an override this segment does not own — one set
     * by hand, or one another segment wrote — keeps it, and comes back in
     * `kept_user_ids`. Nobody's individual decision is overwritten by a list.
     */
    public static featureFlagsSetSegmentFeatureFlagOverride<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsSetSegmentFeatureFlagOverrideData, ThrowOnError>) {
        return (options.client ?? client).post<FeatureFlagsSetSegmentFeatureFlagOverrideResponses, FeatureFlagsSetSegmentFeatureFlagOverrideErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags/{flag_id}/segment-overrides',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Clear Segment Feature Flag Override
     * Remove the overrides this segment wrote, and only those.
     *
     * Matched on the segment recorded in each row's `data`, so an override
     * somebody set by hand for the same person on the same flag survives, and so
     * does one another segment wrote. The write never takes those rows over, so
     * this never has one to remove.
     */
    public static featureFlagsClearSegmentFeatureFlagOverride<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsClearSegmentFeatureFlagOverrideData, ThrowOnError>) {
        return (options.client ?? client).delete<FeatureFlagsClearSegmentFeatureFlagOverrideResponses, FeatureFlagsClearSegmentFeatureFlagOverrideErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags/{flag_id}/segment-overrides/{segment_id}',
            ...options
        });
    }
    
    /**
     * Propose Feature Flag Change
     * Compute a change without applying it: the diff, reach before and after,
     * and whether it is `auto` (apply it) or needs `approval` (send the link).
     */
    public static featureFlagsProposeFeatureFlagChange<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsProposeFeatureFlagChangeData, ThrowOnError>) {
        return (options.client ?? client).post<FeatureFlagsProposeFeatureFlagChangeResponses, FeatureFlagsProposeFeatureFlagChangeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flags/{flag_id}/changes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Feature Flag Changes
     * Newest first. Requests past their expiry read as `expired`.
     */
    public static featureFlagsListFeatureFlagChanges<ThrowOnError extends boolean = false>(options?: Options<FeatureFlagsListFeatureFlagChangesData, ThrowOnError>) {
        return (options?.client ?? client).get<FeatureFlagsListFeatureFlagChangesResponses, FeatureFlagsListFeatureFlagChangesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flag-changes',
            ...options
        });
    }
    
    /**
     * Get Feature Flag Change
     * One change, with the store checks an approver has to confirm.
     */
    public static featureFlagsGetFeatureFlagChange<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsGetFeatureFlagChangeData, ThrowOnError>) {
        return (options.client ?? client).get<FeatureFlagsGetFeatureFlagChangeResponses, FeatureFlagsGetFeatureFlagChangeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flag-changes/{change_id}',
            ...options
        });
    }
    
    /**
     * Apply Feature Flag Change
     * Apply an `auto` change. Anything else is a 403 carrying the approval
     * link. Applying an applied change returns it unchanged.
     */
    public static featureFlagsApplyFeatureFlagChange<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsApplyFeatureFlagChangeData, ThrowOnError>) {
        return (options.client ?? client).post<FeatureFlagsApplyFeatureFlagChangeResponses, FeatureFlagsApplyFeatureFlagChangeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flag-changes/{change_id}/apply',
            ...options
        });
    }
    
    /**
     * Approve Feature Flag Change
     * A person, not the proposer and not a machine account, applies the change
     * they were shown. Every guard runs again; a flag changed since the proposal
     * makes it `superseded`.
     */
    public static featureFlagsApproveFeatureFlagChange<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsApproveFeatureFlagChangeData, ThrowOnError>) {
        return (options.client ?? client).post<FeatureFlagsApproveFeatureFlagChangeResponses, FeatureFlagsApproveFeatureFlagChangeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flag-changes/{change_id}/approve',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reject Feature Flag Change
     */
    public static featureFlagsRejectFeatureFlagChange<ThrowOnError extends boolean = false>(options: Options<FeatureFlagsRejectFeatureFlagChangeData, ThrowOnError>) {
        return (options.client ?? client).post<FeatureFlagsRejectFeatureFlagChangeResponses, FeatureFlagsRejectFeatureFlagChangeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/c/feature-flag-changes/{change_id}/reject',
            ...options
        });
    }
}

export class Insights {
    /**
     * Get Peer Insights
     * Get peer empathy insights for a specific entry type.
     *
     * Returns anonymized statistics about how many other users have done similar actions.
     */
    public static insightsGetPeerInsights<ThrowOnError extends boolean = false>(options: Options<InsightsGetPeerInsightsData, ThrowOnError>) {
        return (options.client ?? client).get<InsightsGetPeerInsightsResponses, InsightsGetPeerInsightsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/insights/peer/{entry_type}',
            ...options
        });
    }
    
    /**
     * Get Behavior Insights
     * Get peer empathy insights for specific behaviors in daily check-ins.
     *
     * Returns anonymized statistics about how many other users selected each behavior.
     */
    public static insightsGetBehaviorInsights<ThrowOnError extends boolean = false>(options: Options<InsightsGetBehaviorInsightsData, ThrowOnError>) {
        return (options.client ?? client).get<InsightsGetBehaviorInsightsResponses, InsightsGetBehaviorInsightsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/insights/behavior/{entry_type}',
            ...options
        });
    }
}

export class Secrets {
    /**
     * List Secrets
     * List secrets with pagination (admin only).
     * Returns secrets without values for security.
     */
    public static secretsListSecrets<ThrowOnError extends boolean = false>(options?: Options<SecretsListSecretsData, ThrowOnError>) {
        return (options?.client ?? client).get<SecretsListSecretsResponses, SecretsListSecretsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/secrets',
            ...options
        });
    }
    
    /**
     * Create Secret
     * Create a new secret or new version of existing secret (admin only).
     * If secret name already exists, creates a new version.
     */
    public static secretsCreateSecret<ThrowOnError extends boolean = false>(options: Options<SecretsCreateSecretData, ThrowOnError>) {
        return (options.client ?? client).post<SecretsCreateSecretResponses, SecretsCreateSecretErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/secrets',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Latest Secret
     * Get the latest active version of a secret by name (admin only).
     * Returns secret without value for security.
     */
    public static secretsGetLatestSecret<ThrowOnError extends boolean = false>(options: Options<SecretsGetLatestSecretData, ThrowOnError>) {
        return (options.client ?? client).get<SecretsGetLatestSecretResponses, SecretsGetLatestSecretErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/secrets/{name}',
            ...options
        });
    }
    
    /**
     * Get Secret Versions
     * Get all versions of a secret by name (admin only).
     * Returns secrets without values for security.
     */
    public static secretsGetSecretVersions<ThrowOnError extends boolean = false>(options: Options<SecretsGetSecretVersionsData, ThrowOnError>) {
        return (options.client ?? client).get<SecretsGetSecretVersionsResponses, SecretsGetSecretVersionsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/secrets/{name}/versions',
            ...options
        });
    }
    
    /**
     * Delete Secret
     * Delete a specific version of a secret (admin only).
     * WARNING: This is a hard delete and cannot be undone.
     */
    public static secretsDeleteSecret<ThrowOnError extends boolean = false>(options: Options<SecretsDeleteSecretData, ThrowOnError>) {
        return (options.client ?? client).delete<SecretsDeleteSecretResponses, SecretsDeleteSecretErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/secrets/{name}/{version}',
            ...options
        });
    }
    
    /**
     * Update Secret
     * Update a secret (admin only).
     * Typically used to deactivate old versions.
     */
    public static secretsUpdateSecret<ThrowOnError extends boolean = false>(options: Options<SecretsUpdateSecretData, ThrowOnError>) {
        return (options.client ?? client).patch<SecretsUpdateSecretResponses, SecretsUpdateSecretErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/secrets/{name}/{version}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Secret Agent Configs
     * Get all agent configs that use this secret (admin only).
     * Returns list of agent config slugs and names.
     */
    public static secretsGetSecretAgentConfigs<ThrowOnError extends boolean = false>(options: Options<SecretsGetSecretAgentConfigsData, ThrowOnError>) {
        return (options.client ?? client).get<SecretsGetSecretAgentConfigsResponses, SecretsGetSecretAgentConfigsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/secrets/{name}/agent-configs',
            ...options
        });
    }
}

export class Media {
    /**
     * List Media
     * List media with pagination and filters. Admin only.
     */
    public static mediaListMedia<ThrowOnError extends boolean = false>(options?: Options<MediaListMediaData, ThrowOnError>) {
        return (options?.client ?? client).get<MediaListMediaResponses, MediaListMediaErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/media',
            ...options
        });
    }
    
    /**
     * Upload Media
     * Upload a media file to R2 (production) or local storage (development) and create media record.
     * Admin only.
     */
    public static mediaUploadMedia<ThrowOnError extends boolean = false>(options: Options<MediaUploadMediaData, ThrowOnError>) {
        return (options.client ?? client).post<MediaUploadMediaResponses, MediaUploadMediaErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/media',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Check Filename Conflict
     * Check if filename already exists. Admin only.
     */
    public static mediaCheckFilenameConflict<ThrowOnError extends boolean = false>(options: Options<MediaCheckFilenameConflictData, ThrowOnError>) {
        return (options.client ?? client).get<MediaCheckFilenameConflictResponses, MediaCheckFilenameConflictErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/media/check-filename',
            ...options
        });
    }
    
    /**
     * Delete Media
     * Delete media (soft delete by default).
     * If hard_delete=True, also removes file from storage (R2 or local).
     * Admin only.
     */
    public static mediaDeleteMedia<ThrowOnError extends boolean = false>(options: Options<MediaDeleteMediaData, ThrowOnError>) {
        return (options.client ?? client).delete<MediaDeleteMediaResponses, MediaDeleteMediaErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/media/{media_id}',
            ...options
        });
    }
    
    /**
     * Get Media
     * Get media by ID. Admin only.
     */
    public static mediaGetMedia<ThrowOnError extends boolean = false>(options: Options<MediaGetMediaData, ThrowOnError>) {
        return (options.client ?? client).get<MediaGetMediaResponses, MediaGetMediaErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/media/{media_id}',
            ...options
        });
    }
    
    /**
     * Update Media
     * Update media metadata. Admin only.
     */
    public static mediaUpdateMedia<ThrowOnError extends boolean = false>(options: Options<MediaUpdateMediaData, ThrowOnError>) {
        return (options.client ?? client).patch<MediaUpdateMediaResponses, MediaUpdateMediaErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/media/{media_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Upload Media Batch
     * Upload multiple media files at once.
     * Admin only.
     */
    public static mediaUploadMediaBatch<ThrowOnError extends boolean = false>(options: Options<MediaUploadMediaBatchData, ThrowOnError>) {
        return (options.client ?? client).post<MediaUploadMediaBatchResponses, MediaUploadMediaBatchErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/media/batch',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
}

export class Reviews {
    /**
     * List Reviews
     * Get approved reviews (public endpoint).
     * Only returns reviews with status='approved', ordered by priority.
     * Cached for 30 minutes to reduce database load.
     */
    public static reviewsListReviews<ThrowOnError extends boolean = false>(options?: Options<ReviewsListReviewsData, ThrowOnError>) {
        return (options?.client ?? client).get<ReviewsListReviewsResponses, ReviewsListReviewsErrors, ThrowOnError>({
            url: '/api/v1/c/reviews',
            ...options
        });
    }
    
    /**
     * Create Review
     * Submit a new review (public endpoint).
     * Creates review with status='pending' - requires admin approval.
     * Invalidates cache on creation.
     */
    public static reviewsCreateReview<ThrowOnError extends boolean = false>(options: Options<ReviewsCreateReviewData, ThrowOnError>) {
        return (options.client ?? client).post<ReviewsCreateReviewResponses, ReviewsCreateReviewErrors, ThrowOnError>({
            url: '/api/v1/c/reviews',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Reviews Admin
     * List all reviews with filters (admin only).
     */
    public static reviewsListReviewsAdmin<ThrowOnError extends boolean = false>(options?: Options<ReviewsListReviewsAdminData, ThrowOnError>) {
        return (options?.client ?? client).get<ReviewsListReviewsAdminResponses, ReviewsListReviewsAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/reviews/admin',
            ...options
        });
    }
    
    /**
     * Delete Review Admin
     * Delete a review (admin only).
     */
    public static reviewsDeleteReviewAdmin<ThrowOnError extends boolean = false>(options: Options<ReviewsDeleteReviewAdminData, ThrowOnError>) {
        return (options.client ?? client).delete<ReviewsDeleteReviewAdminResponses, ReviewsDeleteReviewAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/reviews/admin/{review_id}',
            ...options
        });
    }
    
    /**
     * Get Review Admin
     * Get any review by ID (admin only).
     */
    public static reviewsGetReviewAdmin<ThrowOnError extends boolean = false>(options: Options<ReviewsGetReviewAdminData, ThrowOnError>) {
        return (options.client ?? client).get<ReviewsGetReviewAdminResponses, ReviewsGetReviewAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/reviews/admin/{review_id}',
            ...options
        });
    }
    
    /**
     * Update Review Admin
     * Update a review (admin only).
     */
    public static reviewsUpdateReviewAdmin<ThrowOnError extends boolean = false>(options: Options<ReviewsUpdateReviewAdminData, ThrowOnError>) {
        return (options.client ?? client).patch<ReviewsUpdateReviewAdminResponses, ReviewsUpdateReviewAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/reviews/admin/{review_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Review
     * Get a single approved review by ID (public endpoint).
     * Only returns reviews with status='approved'.
     */
    public static reviewsGetReview<ThrowOnError extends boolean = false>(options: Options<ReviewsGetReviewData, ThrowOnError>) {
        return (options.client ?? client).get<ReviewsGetReviewResponses, ReviewsGetReviewErrors, ThrowOnError>({
            url: '/api/v1/c/reviews/{review_id}',
            ...options
        });
    }
}

export class PromoCodesAdmin {
    /**
     * List Promo Codes
     * List all promo codes with pagination (admin only).
     */
    public static promoCodesAdminListPromoCodes<ThrowOnError extends boolean = false>(options?: Options<PromoCodesAdminListPromoCodesData, ThrowOnError>) {
        return (options?.client ?? client).get<PromoCodesAdminListPromoCodesResponses, PromoCodesAdminListPromoCodesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/promo-codes/admin',
            ...options
        });
    }
    
    /**
     * Create Promo Code
     * Create a new promo code (admin only).
     */
    public static promoCodesAdminCreatePromoCode<ThrowOnError extends boolean = false>(options: Options<PromoCodesAdminCreatePromoCodeData, ThrowOnError>) {
        return (options.client ?? client).post<PromoCodesAdminCreatePromoCodeResponses, PromoCodesAdminCreatePromoCodeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/promo-codes/admin',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Promo Code
     * Delete a promo code (soft delete by setting is_active=False) (admin only).
     */
    public static promoCodesAdminDeletePromoCode<ThrowOnError extends boolean = false>(options: Options<PromoCodesAdminDeletePromoCodeData, ThrowOnError>) {
        return (options.client ?? client).delete<PromoCodesAdminDeletePromoCodeResponses, PromoCodesAdminDeletePromoCodeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/promo-codes/admin/{promo_code_id}',
            ...options
        });
    }
    
    /**
     * Get Promo Code By Id
     * Get a promo code by ID (admin only).
     */
    public static promoCodesAdminGetPromoCodeById<ThrowOnError extends boolean = false>(options: Options<PromoCodesAdminGetPromoCodeByIdData, ThrowOnError>) {
        return (options.client ?? client).get<PromoCodesAdminGetPromoCodeByIdResponses, PromoCodesAdminGetPromoCodeByIdErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/promo-codes/admin/{promo_code_id}',
            ...options
        });
    }
    
    /**
     * Update Promo Code
     * Update a promo code (admin only).
     */
    public static promoCodesAdminUpdatePromoCode<ThrowOnError extends boolean = false>(options: Options<PromoCodesAdminUpdatePromoCodeData, ThrowOnError>) {
        return (options.client ?? client).patch<PromoCodesAdminUpdatePromoCodeResponses, PromoCodesAdminUpdatePromoCodeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/promo-codes/admin/{promo_code_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Revenuecat Products
     * Get available RevenueCat products (admin only).
     * Results are cached for 1 hour to reduce API calls.
     */
    public static promoCodesAdminGetRevenuecatProducts<ThrowOnError extends boolean = false>(options?: Options<PromoCodesAdminGetRevenuecatProductsData, ThrowOnError>) {
        return (options?.client ?? client).get<PromoCodesAdminGetRevenuecatProductsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/promo-codes/admin/revenuecat/products',
            ...options
        });
    }
    
    /**
     * Get Revenuecat Offerings
     * Get available RevenueCat offerings (admin only).
     * Results are cached for 1 hour to reduce API calls.
     */
    public static promoCodesAdminGetRevenuecatOfferings<ThrowOnError extends boolean = false>(options?: Options<PromoCodesAdminGetRevenuecatOfferingsData, ThrowOnError>) {
        return (options?.client ?? client).get<PromoCodesAdminGetRevenuecatOfferingsResponses, PromoCodesAdminGetRevenuecatOfferingsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/promo-codes/admin/revenuecat/offerings',
            ...options
        });
    }
    
    /**
     * Get Revenuecat App
     * Get RevenueCat app details by app_id (admin only).
     * Results are cached for 1 hour to reduce API calls.
     */
    public static promoCodesAdminGetRevenuecatApp<ThrowOnError extends boolean = false>(options: Options<PromoCodesAdminGetRevenuecatAppData, ThrowOnError>) {
        return (options.client ?? client).get<PromoCodesAdminGetRevenuecatAppResponses, PromoCodesAdminGetRevenuecatAppErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/promo-codes/admin/revenuecat/apps/{app_id}',
            ...options
        });
    }
    
    /**
     * Clear Revenuecat Cache
     * Clear RevenueCat cache (admin only).
     * Useful for refreshing product/app data after changes in RevenueCat dashboard.
     */
    public static promoCodesAdminClearRevenuecatCache<ThrowOnError extends boolean = false>(options?: Options<PromoCodesAdminClearRevenuecatCacheData, ThrowOnError>) {
        return (options?.client ?? client).delete<PromoCodesAdminClearRevenuecatCacheResponses, PromoCodesAdminClearRevenuecatCacheErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/promo-codes/admin/revenuecat/cache',
            ...options
        });
    }
}

export class EmailTemplates {
    /**
     * List Email Templates
     * List email templates (admin only).
     */
    public static emailTemplatesListEmailTemplates<ThrowOnError extends boolean = false>(options?: Options<EmailTemplatesListEmailTemplatesData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailTemplatesListEmailTemplatesResponses, EmailTemplatesListEmailTemplatesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates',
            ...options
        });
    }
    
    /**
     * Create Email Template
     * Create a new email template whose content is an unpublished draft.
     *
     * Nothing is sent and nothing goes live: no campaign can use a template
     * until a person reviews and publishes a version in the admin panel
     * (/admin/email-templates/{id}, the `id` in the response). Names starting
     * `system-` are refused.
     *
     * Content format: `subject`, `body_html` and `body_text` are Jinja
     * templates, rendered per member at send. Variables include
     * `{{ first_name }}`, `{{ unsub_link }}`, `{{ app_link }}`,
     * `{{ support_email }}`; marketing mail must link `{{ unsub_link }}`.
     * `{% if may_promote %}...{% endif %}` wraps anything promotional. To write
     * in the editor's block format instead, create the template and then save a
     * draft with `format: "blocks"` (see the draft tool).
     */
    public static emailTemplatesCreateEmailTemplate<ThrowOnError extends boolean = false>(options: Options<EmailTemplatesCreateEmailTemplateData, ThrowOnError>) {
        return (options.client ?? client).post<EmailTemplatesCreateEmailTemplateResponses, EmailTemplatesCreateEmailTemplateErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List System Emails
     * The emails auth and accounts send from built-in files, and whether
     * each has been customised in the studio.
     */
    public static emailTemplatesListSystemEmails<ThrowOnError extends boolean = false>(options?: Options<EmailTemplatesListSystemEmailsData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailTemplatesListSystemEmailsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates/system',
            ...options
        });
    }
    
    /**
     * System Email Built In
     * The built-in email as an editor document: what "Open in the editor"
     * loads into a draft. Reading it changes nothing.
     */
    public static emailTemplatesSystemEmailBuiltIn<ThrowOnError extends boolean = false>(options: Options<EmailTemplatesSystemEmailBuiltInData, ThrowOnError>) {
        return (options.client ?? client).get<EmailTemplatesSystemEmailBuiltInResponses, EmailTemplatesSystemEmailBuiltInErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates/system/{slug}/built-in',
            ...options
        });
    }
    
    /**
     * Customize System Email
     * Copy a built-in email into the studio. Its words don't change until a
     * new version is published; the built-in file stays the fallback.
     */
    public static emailTemplatesCustomizeSystemEmail<ThrowOnError extends boolean = false>(options: Options<EmailTemplatesCustomizeSystemEmailData, ThrowOnError>) {
        return (options.client ?? client).post<EmailTemplatesCustomizeSystemEmailResponses, EmailTemplatesCustomizeSystemEmailErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates/system/{slug}/customize',
            ...options
        });
    }
    
    /**
     * Use Built In System Email
     * Send the built-in version again. The customised one is kept, switched
     * off, so it can be switched back on with its history intact.
     */
    public static emailTemplatesUseBuiltInSystemEmail<ThrowOnError extends boolean = false>(options: Options<EmailTemplatesUseBuiltInSystemEmailData, ThrowOnError>) {
        return (options.client ?? client).post<EmailTemplatesUseBuiltInSystemEmailResponses, EmailTemplatesUseBuiltInSystemEmailErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates/system/{slug}/use-built-in',
            ...options
        });
    }
    
    /**
     * Delete Email Template
     * Delete email template (admin only).
     */
    public static emailTemplatesDeleteEmailTemplate<ThrowOnError extends boolean = false>(options: Options<EmailTemplatesDeleteEmailTemplateData, ThrowOnError>) {
        return (options.client ?? client).delete<EmailTemplatesDeleteEmailTemplateResponses, EmailTemplatesDeleteEmailTemplateErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates/{template_id}',
            ...options
        });
    }
    
    /**
     * Get Email Template
     * Get email template by ID (admin only).
     */
    public static emailTemplatesGetEmailTemplate<ThrowOnError extends boolean = false>(options: Options<EmailTemplatesGetEmailTemplateData, ThrowOnError>) {
        return (options.client ?? client).get<EmailTemplatesGetEmailTemplateResponses, EmailTemplatesGetEmailTemplateErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates/{template_id}',
            ...options
        });
    }
    
    /**
     * Update Email Template
     * Update a template's settings: name, slug, active, variables notes.
     *
     * Not its content: that is a draft, reviewed and published.
     */
    public static emailTemplatesUpdateEmailTemplate<ThrowOnError extends boolean = false>(options: Options<EmailTemplatesUpdateEmailTemplateData, ThrowOnError>) {
        return (options.client ?? client).patch<EmailTemplatesUpdateEmailTemplateResponses, EmailTemplatesUpdateEmailTemplateErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates/{template_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Preview Email Template
     * Render a template, or an unsaved draft of it, as a real send would.
     * Sends nothing and saves nothing. Leave out `user_id` to render it for
     * yourself.
     *
     * Rendered for someone else, for staff without personal details (the
     * Send review's sample recipients), their name and address read as
     * stand-ins (`_masked`): the email still shows, whether it greets by name
     * still shows, who it is doesn't.
     *
     * With a campaign step: that campaign's variables and link stamping, and
     * whether the member would get it at all. With `branches`: every
     * combination of the template's conditions, rendered strictly so an
     * undefined variable shows up as an error.
     */
    public static emailTemplatesPreviewEmailTemplate<ThrowOnError extends boolean = false>(options: Options<EmailTemplatesPreviewEmailTemplateData, ThrowOnError>) {
        return (options.client ?? client).post<EmailTemplatesPreviewEmailTemplateResponses, EmailTemplatesPreviewEmailTemplateErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates/{template_id}/preview',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Test Send Email Template
     * Send this template, or an unsaved draft, to yourself as a real email.
     *
     * A preview proves the template renders. This proves it survives the trip:
     * Postmark accepts it, the HTML holds up in a real mail client, the links
     * resolve. Only to the caller's own address: that is what the scope grants.
     * Not recorded as a campaign execution, so tests never move the stats.
     */
    public static emailTemplatesTestSendEmailTemplate<ThrowOnError extends boolean = false>(options: Options<EmailTemplatesTestSendEmailTemplateData, ThrowOnError>) {
        return (options.client ?? client).post<EmailTemplatesTestSendEmailTemplateResponses, EmailTemplatesTestSendEmailTemplateErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates/{template_id}/test-send',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Template Versions
     * Every version, newest first: the draft (if any) and all published ones.
     */
    public static emailTemplatesListTemplateVersions<ThrowOnError extends boolean = false>(options: Options<EmailTemplatesListTemplateVersionsData, ThrowOnError>) {
        return (options.client ?? client).get<EmailTemplatesListTemplateVersionsResponses, EmailTemplatesListTemplateVersionsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates/{template_id}/versions',
            ...options
        });
    }
    
    /**
     * Discard Template Draft
     */
    public static emailTemplatesDiscardTemplateDraft<ThrowOnError extends boolean = false>(options: Options<EmailTemplatesDiscardTemplateDraftData, ThrowOnError>) {
        return (options.client ?? client).delete<EmailTemplatesDiscardTemplateDraftResponses, EmailTemplatesDiscardTemplateDraftErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates/{template_id}/draft',
            ...options
        });
    }
    
    /**
     * Save Template Draft
     * Save (create or overwrite) the template's one draft version.
     *
     * Nothing is sent and nothing a member receives changes: what sends is the
     * published version, and only a person publishes, in the admin panel at
     * /admin/email-templates/{template_id}. Use the preview and review tools to
     * check the draft first.
     *
     * Formats: `"html"` takes `body_html` and `body_text` as Jinja (variables
     * like `{{ first_name }}`, `{{ unsub_link }}`). `"blocks"` takes `document`,
     * the editor's ProseMirror JSON: `{"type": "doc", "content": [...]}` with
     * blocks `paragraph`, `heading` (attrs.level 2 or 3), `bulletList` /
     * `orderedList` of `listItem`, `blockquote`, `horizontalRule`, `button`
     * (attrs.href, attrs.label), `image`, `logo`, `feedback`, `conditional`;
     * inline `text` (marks bold, italic, underline, link) and `variable`
     * (attrs.name, attrs.fallback), e.g.
     * `{"type": "variable", "attrs": {"name": "first_name", "fallback": "there"}}`.
     * Unknown nodes are refused. A blocks draft goes into `layout_id` (default
     * layout when unset), which adds the footer and unsubscribe link. Pass
     * `base_dt_updated` from the draft you read to avoid overwriting someone
     * else's edit.
     */
    public static emailTemplatesSaveTemplateDraft<ThrowOnError extends boolean = false>(options: Options<EmailTemplatesSaveTemplateDraftData, ThrowOnError>) {
        return (options.client ?? client).put<EmailTemplatesSaveTemplateDraftResponses, EmailTemplatesSaveTemplateDraftErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates/{template_id}/draft',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Review Template Version
     * Every check the version must pass to go live, rendered as you.
     */
    public static emailTemplatesReviewTemplateVersion<ThrowOnError extends boolean = false>(options: Options<EmailTemplatesReviewTemplateVersionData, ThrowOnError>) {
        return (options.client ?? client).get<EmailTemplatesReviewTemplateVersionResponses, EmailTemplatesReviewTemplateVersionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates/{template_id}/review',
            ...options
        });
    }
    
    /**
     * Publish Template Version
     * Make a version what this template sends, from the next send on.
     *
     * The draft goes live, or an older version is restored (as a new version,
     * so history only grows). Refused with the review while any blocking check
     * fails: the guard lives here, not in the client.
     */
    public static emailTemplatesPublishTemplateVersion<ThrowOnError extends boolean = false>(options: Options<EmailTemplatesPublishTemplateVersionData, ThrowOnError>) {
        return (options.client ?? client).post<EmailTemplatesPublishTemplateVersionResponses, EmailTemplatesPublishTemplateVersionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates/{template_id}/publish',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Template Stats
     * How this email is doing, version by version, against its campaigns.
     */
    public static emailTemplatesTemplateStats<ThrowOnError extends boolean = false>(options: Options<EmailTemplatesTemplateStatsData, ThrowOnError>) {
        return (options.client ?? client).get<EmailTemplatesTemplateStatsResponses, EmailTemplatesTemplateStatsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-templates/{template_id}/stats',
            ...options
        });
    }
}

export class EmailLayouts {
    /**
     * List Layouts
     * Every email layout (the wrapper a blocks email is poured into: header,
     * footer, unsubscribe line), by name.
     */
    public static emailLayoutsListLayouts<ThrowOnError extends boolean = false>(options?: Options<EmailLayoutsListLayoutsData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailLayoutsListLayoutsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-layouts',
            ...options
        });
    }
    
    /**
     * Get Sender Identity
     * Who marketing email says it is from, as every footer shows it.
     */
    public static emailLayoutsGetSenderIdentity<ThrowOnError extends boolean = false>(options?: Options<EmailLayoutsGetSenderIdentityData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailLayoutsGetSenderIdentityResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-layouts/sender-identity',
            ...options
        });
    }
    
    /**
     * Update Sender Identity
     * Change the legal name, postal address or contact every marketing
     * footer shows. Live from the next send: the footer reads it as it goes.
     */
    public static emailLayoutsUpdateSenderIdentity<ThrowOnError extends boolean = false>(options: Options<EmailLayoutsUpdateSenderIdentityData, ThrowOnError>) {
        return (options.client ?? client).put<EmailLayoutsUpdateSenderIdentityResponses, EmailLayoutsUpdateSenderIdentityErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-layouts/sender-identity',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Layout Usage
     * How many templates' published version is built on this layout.
     */
    public static emailLayoutsLayoutUsage<ThrowOnError extends boolean = false>(options: Options<EmailLayoutsLayoutUsageData, ThrowOnError>) {
        return (options.client ?? client).get<EmailLayoutsLayoutUsageResponses, EmailLayoutsLayoutUsageErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-layouts/{layout_id}/usage',
            ...options
        });
    }
    
    /**
     * Duplicate Layout
     * A copy of a layout, used by no email, to change without touching the
     * original. It is also how a new layout starts: a blank one would have no
     * slots or unsubscribe link, so it starts from one that does.
     */
    public static emailLayoutsDuplicateLayout<ThrowOnError extends boolean = false>(options: Options<EmailLayoutsDuplicateLayoutData, ThrowOnError>) {
        return (options.client ?? client).post<EmailLayoutsDuplicateLayoutResponses, EmailLayoutsDuplicateLayoutErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-layouts/{layout_id}/duplicate',
            ...options
        });
    }
    
    /**
     * Delete Layout
     * Delete a layout nothing is built on: not the default, and no version
     * of any email (live, draft or past) uses it, so no record loses its shell.
     */
    public static emailLayoutsDeleteLayout<ThrowOnError extends boolean = false>(options: Options<EmailLayoutsDeleteLayoutData, ThrowOnError>) {
        return (options.client ?? client).delete<EmailLayoutsDeleteLayoutResponses, EmailLayoutsDeleteLayoutErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-layouts/{layout_id}',
            ...options
        });
    }
    
    /**
     * Update Layout
     */
    public static emailLayoutsUpdateLayout<ThrowOnError extends boolean = false>(options: Options<EmailLayoutsUpdateLayoutData, ThrowOnError>) {
        return (options.client ?? client).patch<EmailLayoutsUpdateLayoutResponses, EmailLayoutsUpdateLayoutErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-layouts/{layout_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Preview Layout
     * A sample email in this (possibly unsaved) layout, rendered for you.
     * Sends nothing and saves nothing.
     */
    public static emailLayoutsPreviewLayout<ThrowOnError extends boolean = false>(options: Options<EmailLayoutsPreviewLayoutData, ThrowOnError>) {
        return (options.client ?? client).post<EmailLayoutsPreviewLayoutResponses, EmailLayoutsPreviewLayoutErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-layouts/{layout_id}/preview',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Compile Body
     * The editor's block document (ProseMirror JSON) as the Jinja HTML and
     * text it compiles to, for reading. Saves nothing; refuses unknown blocks,
     * so it checks a document before drafting it.
     */
    public static emailLayoutsCompileBody<ThrowOnError extends boolean = false>(options: Options<EmailLayoutsCompileBodyData, ThrowOnError>) {
        return (options.client ?? client).post<EmailLayoutsCompileBodyResponses, EmailLayoutsCompileBodyErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-layouts/compile',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class EmailDeliverability {
    /**
     * Deliverability
     * SPF, DMARC, Return-Path, MX and (via Postmark) DKIM, each with advice.
     */
    public static emailDeliverabilityDeliverability<ThrowOnError extends boolean = false>(options?: Options<EmailDeliverabilityDeliverabilityData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailDeliverabilityDeliverabilityResponses, EmailDeliverabilityDeliverabilityErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-deliverability',
            ...options
        });
    }
    
    /**
     * Rates
     * Hard-bounce and complaint rates per stream, last 24 hours and 7 days,
     * and per mailbox provider over 7 days.
     */
    public static emailDeliverabilityRates<ThrowOnError extends boolean = false>(options?: Options<EmailDeliverabilityRatesData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailDeliverabilityRatesResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-deliverability/rates',
            ...options
        });
    }
    
    /**
     * List Health
     * Is the marketing list still reading us: open rate per stream and per
     * campaign over 7, 30 and 90 days, Apple's machine opens apart, and the
     * share of people mailed with a sign of life. Aggregates only.
     */
    public static emailDeliverabilityListHealth<ThrowOnError extends boolean = false>(options?: Options<EmailDeliverabilityListHealthData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailDeliverabilityListHealthResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-deliverability/list-health',
            ...options
        });
    }
    
    /**
     * Delivery Methods Compared
     * Which way of sending works best: marketing one-offs over 90 days by
     * when they landed and staged or not. Aggregates only.
     */
    public static emailDeliverabilityDeliveryMethodsCompared<ThrowOnError extends boolean = false>(options?: Options<EmailDeliverabilityDeliveryMethodsComparedData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailDeliverabilityDeliveryMethodsComparedResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-deliverability/delivery-methods',
            ...options
        });
    }
    
    /**
     * Pipeline
     * Queued, the oldest send waiting, sent and failed in the last 24 hours,
     * when we last sent and when Postmark last reported, and what is wrong.
     */
    public static emailDeliverabilityPipeline<ThrowOnError extends boolean = false>(options?: Options<EmailDeliverabilityPipelineData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailDeliverabilityPipelineResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-deliverability/pipeline',
            ...options
        });
    }
}

export class EmailSuppressions {
    /**
     * List Suppressions
     */
    public static emailSuppressionsListSuppressions<ThrowOnError extends boolean = false>(options?: Options<EmailSuppressionsListSuppressionsData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailSuppressionsListSuppressionsResponses, EmailSuppressionsListSuppressionsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-suppressions',
            ...options
        });
    }
    
    /**
     * Add Suppression
     * Somebody asked by phone, chat or letter. Already on the list for a
     * stronger reason, it stays as it is.
     */
    public static emailSuppressionsAddSuppression<ThrowOnError extends boolean = false>(options: Options<EmailSuppressionsAddSuppressionData, ThrowOnError>) {
        return (options.client ?? client).post<EmailSuppressionsAddSuppressionResponses, EmailSuppressionsAddSuppressionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-suppressions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Lift Suppression
     */
    public static emailSuppressionsLiftSuppression<ThrowOnError extends boolean = false>(options: Options<EmailSuppressionsLiftSuppressionData, ThrowOnError>) {
        return (options.client ?? client).post<EmailSuppressionsLiftSuppressionResponses, EmailSuppressionsLiftSuppressionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-suppressions/{suppression_id}/lift',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Request Postmark Lift
     * A spam complaint can't be removed here: Condri asks Postmark support
     * (the runbook is in docs/features/mail-studio/README.md). This records
     * that we asked; Postmark's reactivation then lifts it.
     */
    public static emailSuppressionsRequestPostmarkLift<ThrowOnError extends boolean = false>(options: Options<EmailSuppressionsRequestPostmarkLiftData, ThrowOnError>) {
        return (options.client ?? client).post<EmailSuppressionsRequestPostmarkLiftResponses, EmailSuppressionsRequestPostmarkLiftErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-suppressions/{suppression_id}/request-lift',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class EmailCampaigns {
    /**
     * Get Trigger Events
     * The events a campaign can start on, with the kind of mail each sends.
     */
    public static emailCampaignsGetTriggerEvents<ThrowOnError extends boolean = false>(options?: Options<EmailCampaignsGetTriggerEventsData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailCampaignsGetTriggerEventsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/trigger-events',
            ...options
        });
    }
    
    /**
     * Get Flow Conditions
     * What a flow's step ("only if") or goal can check, from the fixed list
     * in code (application/conditions.py).
     */
    public static emailCampaignsGetFlowConditions<ThrowOnError extends boolean = false>(options?: Options<EmailCampaignsGetFlowConditionsData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailCampaignsGetFlowConditionsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/flow-conditions',
            ...options
        });
    }
    
    /**
     * Get Enrollment Counts
     * How many people each campaign holds, by status. Counts only, no ids.
     */
    public static emailCampaignsGetEnrollmentCounts<ThrowOnError extends boolean = false>(options?: Options<EmailCampaignsGetEnrollmentCountsData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailCampaignsGetEnrollmentCountsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/enrollment-counts',
            ...options
        });
    }
    
    /**
     * List Email Campaigns
     * List email campaigns with pagination.
     */
    public static emailCampaignsListEmailCampaigns<ThrowOnError extends boolean = false>(options?: Options<EmailCampaignsListEmailCampaignsData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailCampaignsListEmailCampaignsResponses, EmailCampaignsListEmailCampaignsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns',
            ...options
        });
    }
    
    /**
     * Create Email Campaign
     * Create a new email campaign.
     */
    public static emailCampaignsCreateEmailCampaign<ThrowOnError extends boolean = false>(options: Options<EmailCampaignsCreateEmailCampaignData, ThrowOnError>) {
        return (options.client ?? client).post<EmailCampaignsCreateEmailCampaignResponses, EmailCampaignsCreateEmailCampaignErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Email Campaign
     * Delete a campaign that never planned a send. One that has is
     * archived instead, which keeps the record of what it sent (SEND-24).
     */
    public static emailCampaignsDeleteEmailCampaign<ThrowOnError extends boolean = false>(options: Options<EmailCampaignsDeleteEmailCampaignData, ThrowOnError>) {
        return (options.client ?? client).delete<EmailCampaignsDeleteEmailCampaignResponses, EmailCampaignsDeleteEmailCampaignErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}',
            ...options
        });
    }
    
    /**
     * Get Email Campaign
     * Get email campaign by ID.
     */
    public static emailCampaignsGetEmailCampaign<ThrowOnError extends boolean = false>(options: Options<EmailCampaignsGetEmailCampaignData, ThrowOnError>) {
        return (options.client ?? client).get<EmailCampaignsGetEmailCampaignResponses, EmailCampaignsGetEmailCampaignErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}',
            ...options
        });
    }
    
    /**
     * Update Email Campaign
     * Update email campaign.
     */
    public static emailCampaignsUpdateEmailCampaign<ThrowOnError extends boolean = false>(options: Options<EmailCampaignsUpdateEmailCampaignData, ThrowOnError>) {
        return (options.client ?? client).patch<EmailCampaignsUpdateEmailCampaignResponses, EmailCampaignsUpdateEmailCampaignErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Move Campaign
     * Move a broadcast to another state: schedule or reschedule it
     * (`send_at`), unschedule it (draft), pause, resume (sending) or cancel it.
     * Asking for the state it is already in changes nothing. A refused move is
     * a 409 that says why.
     */
    public static emailCampaignsMoveCampaign<ThrowOnError extends boolean = false>(options: Options<EmailCampaignsMoveCampaignData, ThrowOnError>) {
        return (options.client ?? client).post<EmailCampaignsMoveCampaignResponses, EmailCampaignsMoveCampaignErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}/status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Cancel Rest
     * A send in stages: cancel the stages not yet sent. The ones already
     * let go carry on (or have gone). A 409 says why when there's nothing to
     * cancel.
     */
    public static emailCampaignsCancelRest<ThrowOnError extends boolean = false>(options: Options<EmailCampaignsCancelRestData, ThrowOnError>) {
        return (options.client ?? client).post<EmailCampaignsCancelRestResponses, EmailCampaignsCancelRestErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}/cancel-rest',
            ...options
        });
    }
    
    /**
     * Enroll Segment In Campaign
     * Enroll all users from a segment into a campaign.
     */
    public static emailCampaignsEnrollSegmentInCampaign<ThrowOnError extends boolean = false>(options: Options<EmailCampaignsEnrollSegmentInCampaignData, ThrowOnError>) {
        return (options.client ?? client).post<EmailCampaignsEnrollSegmentInCampaignResponses, EmailCampaignsEnrollSegmentInCampaignErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}/enroll-segment',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Campaign Engagement
     * Open, click, bounce and unsubscribe rates for a campaign, per step.
     */
    public static emailCampaignsGetCampaignEngagement<ThrowOnError extends boolean = false>(options: Options<EmailCampaignsGetCampaignEngagementData, ThrowOnError>) {
        return (options.client ?? client).get<EmailCampaignsGetCampaignEngagementResponses, EmailCampaignsGetCampaignEngagementErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}/engagement',
            ...options
        });
    }
    
    /**
     * Campaign Overview
     * Everything the campaign page shows: who it may reach and under what
     * consent, and each step with its email, timing, results and the people
     * already enrolled who have no send planned for it.
     */
    public static emailCampaignsCampaignOverview<ThrowOnError extends boolean = false>(options: Options<EmailCampaignsCampaignOverviewData, ThrowOnError>) {
        return (options.client ?? client).get<EmailCampaignsCampaignOverviewResponses, EmailCampaignsCampaignOverviewErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}/overview',
            ...options
        });
    }
}

export class EmailFlows {
    /**
     * Discard Flow Draft
     * Throw the draft away; the live flow is untouched.
     */
    public static emailFlowsDiscardFlowDraft<ThrowOnError extends boolean = false>(options: Options<EmailFlowsDiscardFlowDraftData, ThrowOnError>) {
        return (options.client ?? client).delete<EmailFlowsDiscardFlowDraftResponses, EmailFlowsDiscardFlowDraftErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}/draft',
            ...options
        });
    }
    
    /**
     * Get Flow Draft
     * The flow's draft, or the live flow when nobody has started one.
     */
    public static emailFlowsGetFlowDraft<ThrowOnError extends boolean = false>(options: Options<EmailFlowsGetFlowDraftData, ThrowOnError>) {
        return (options.client ?? client).get<EmailFlowsGetFlowDraftResponses, EmailFlowsGetFlowDraftErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}/draft',
            ...options
        });
    }
    
    /**
     * Save Flow Draft
     * Save the flow's draft: its steps, timing and conditions.
     *
     * Nothing is sent and nobody's enrollment or schedule changes: the live
     * flow keeps running as it is until a person publishes the draft in the
     * admin panel (/admin/email-campaigns/{campaign_id}). Read the current
     * draft first (it has the shape to send back) and check it with the review
     * and preview tools. Steps may only use templates that are published.
     */
    public static emailFlowsSaveFlowDraft<ThrowOnError extends boolean = false>(options: Options<EmailFlowsSaveFlowDraftData, ThrowOnError>) {
        return (options.client ?? client).put<EmailFlowsSaveFlowDraftResponses, EmailFlowsSaveFlowDraftErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}/draft',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Review Flow Draft
     * What stops the draft going live, each with a fix, and what publishing
     * it would do to the people already in the flow.
     */
    public static emailFlowsReviewFlowDraft<ThrowOnError extends boolean = false>(options: Options<EmailFlowsReviewFlowDraftData, ThrowOnError>) {
        return (options.client ?? client).get<EmailFlowsReviewFlowDraftResponses, EmailFlowsReviewFlowDraftErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}/draft/review',
            ...options
        });
    }
    
    /**
     * Publish Flow Draft
     * Apply the draft. Sends to real people, so it takes the impact the
     * person was shown and refuses (409) if it has changed or the review
     * blocks.
     */
    public static emailFlowsPublishFlowDraft<ThrowOnError extends boolean = false>(options: Options<EmailFlowsPublishFlowDraftData, ThrowOnError>) {
        return (options.client ?? client).post<EmailFlowsPublishFlowDraftResponses, EmailFlowsPublishFlowDraftErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}/draft/publish',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Preview Flow Draft
     * When each email in the draft would reach this member, in their time,
     * and which would be skipped and why, as of now. Sends and saves nothing;
     * `user_id` defaults to you.
     */
    public static emailFlowsPreviewFlowDraft<ThrowOnError extends boolean = false>(options: Options<EmailFlowsPreviewFlowDraftData, ThrowOnError>) {
        return (options.client ?? client).post<EmailFlowsPreviewFlowDraftResponses, EmailFlowsPreviewFlowDraftErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}/draft/preview',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Test Flow Draft
     * Send every email in the draft to yourself, "[TEST]" first, rendered as
     * the member you pick. Only to your own address; never counted as a send.
     */
    public static emailFlowsTestFlowDraft<ThrowOnError extends boolean = false>(options: Options<EmailFlowsTestFlowDraftData, ThrowOnError>) {
        return (options.client ?? client).post<EmailFlowsTestFlowDraftResponses, EmailFlowsTestFlowDraftErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}/draft/test',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Archive Flow
     * Switch the flow off for good: its planned sends are cancelled and
     * everyone in it leaves; what it sent stays. Can't be undone.
     */
    public static emailFlowsArchiveFlow<ThrowOnError extends boolean = false>(options: Options<EmailFlowsArchiveFlowData, ThrowOnError>) {
        return (options.client ?? client).post<EmailFlowsArchiveFlowResponses, EmailFlowsArchiveFlowErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}/archive',
            ...options
        });
    }
    
    /**
     * Flow Preview People
     * Members to preview the flow as, picked by the state its conditions
     * read (days since joining, opening the app, a subscription). Nothing
     * personal: an ID, when they joined, and that state.
     */
    public static emailFlowsFlowPreviewPeople<ThrowOnError extends boolean = false>(options: Options<EmailFlowsFlowPreviewPeopleData, ThrowOnError>) {
        return (options.client ?? client).get<EmailFlowsFlowPreviewPeopleResponses, EmailFlowsFlowPreviewPeopleErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}/draft/people',
            ...options
        });
    }
    
    /**
     * Duplicate Flow
     * A copy of the flow, off, with nobody in it and its emails as a draft
     * to review and publish; named "… (copy)", with a new slug.
     */
    public static emailFlowsDuplicateFlow<ThrowOnError extends boolean = false>(options: Options<EmailFlowsDuplicateFlowData, ThrowOnError>) {
        return (options.client ?? client).post<EmailFlowsDuplicateFlowResponses, EmailFlowsDuplicateFlowErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-campaigns/{campaign_id}/duplicate',
            ...options
        });
    }
}

export class EmailCampaignSteps {
    /**
     * List Campaign Steps
     * List all steps for a campaign (admin only).
     */
    public static emailCampaignStepsListCampaignSteps<ThrowOnError extends boolean = false>(options: Options<EmailCampaignStepsListCampaignStepsData, ThrowOnError>) {
        return (options.client ?? client).get<EmailCampaignStepsListCampaignStepsResponses, EmailCampaignStepsListCampaignStepsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/campaigns/{campaign_id}/steps',
            ...options
        });
    }
    
    /**
     * Create Campaign Step
     * Create a new campaign step (admin only).
     */
    public static emailCampaignStepsCreateCampaignStep<ThrowOnError extends boolean = false>(options: Options<EmailCampaignStepsCreateCampaignStepData, ThrowOnError>) {
        return (options.client ?? client).post<EmailCampaignStepsCreateCampaignStepResponses, EmailCampaignStepsCreateCampaignStepErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/campaigns/{campaign_id}/steps',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Campaign Step
     * Delete a campaign step (admin only).
     */
    public static emailCampaignStepsDeleteCampaignStep<ThrowOnError extends boolean = false>(options: Options<EmailCampaignStepsDeleteCampaignStepData, ThrowOnError>) {
        return (options.client ?? client).delete<EmailCampaignStepsDeleteCampaignStepResponses, EmailCampaignStepsDeleteCampaignStepErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/campaigns/{campaign_id}/steps/{step_id}',
            ...options
        });
    }
    
    /**
     * Get Campaign Step
     * Get a campaign step by ID (admin only).
     */
    public static emailCampaignStepsGetCampaignStep<ThrowOnError extends boolean = false>(options: Options<EmailCampaignStepsGetCampaignStepData, ThrowOnError>) {
        return (options.client ?? client).get<EmailCampaignStepsGetCampaignStepResponses, EmailCampaignStepsGetCampaignStepErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/campaigns/{campaign_id}/steps/{step_id}',
            ...options
        });
    }
    
    /**
     * Update Campaign Step
     * Update a campaign step (admin only).
     */
    public static emailCampaignStepsUpdateCampaignStep<ThrowOnError extends boolean = false>(options: Options<EmailCampaignStepsUpdateCampaignStepData, ThrowOnError>) {
        return (options.client ?? client).patch<EmailCampaignStepsUpdateCampaignStepResponses, EmailCampaignStepsUpdateCampaignStepErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/campaigns/{campaign_id}/steps/{step_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reorder Campaign Steps
     * Reorder campaign steps (admin only).
     */
    public static emailCampaignStepsReorderCampaignSteps<ThrowOnError extends boolean = false>(options: Options<EmailCampaignStepsReorderCampaignStepsData, ThrowOnError>) {
        return (options.client ?? client).post<EmailCampaignStepsReorderCampaignStepsResponses, EmailCampaignStepsReorderCampaignStepsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/campaigns/{campaign_id}/steps/reorder',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Plan Step Backfill
     * How many people already enrolled have no send planned for this step:
     * still due (on time) and overdue (would go from now).
     */
    public static emailCampaignStepsPlanStepBackfill<ThrowOnError extends boolean = false>(options: Options<EmailCampaignStepsPlanStepBackfillData, ThrowOnError>) {
        return (options.client ?? client).get<EmailCampaignStepsPlanStepBackfillResponses, EmailCampaignStepsPlanStepBackfillErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/campaigns/{campaign_id}/steps/{step_id}/backfill',
            ...options
        });
    }
    
    /**
     * Apply Step Backfill
     * Schedule this step for people already enrolled. Sends to real members,
     * so it takes the count the plan showed and refuses if it has changed.
     */
    public static emailCampaignStepsApplyStepBackfill<ThrowOnError extends boolean = false>(options: Options<EmailCampaignStepsApplyStepBackfillData, ThrowOnError>) {
        return (options.client ?? client).post<EmailCampaignStepsApplyStepBackfillResponses, EmailCampaignStepsApplyStepBackfillErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/campaigns/{campaign_id}/steps/{step_id}/backfill',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class EmailSends {
    /**
     * Preview Email
     * Preview rendered email for a user (admin only).
     */
    public static emailSendsPreviewEmail<ThrowOnError extends boolean = false>(options: Options<EmailSendsPreviewEmailData, ThrowOnError>) {
        return (options.client ?? client).post<EmailSendsPreviewEmailResponses, EmailSendsPreviewEmailErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-sends/preview',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Enqueue Email Send
     * Enqueue one-off email send (admin only). Who is left out is named
     * only for staff who may see personal details.
     */
    public static emailSendsEnqueueEmailSend<ThrowOnError extends boolean = false>(options: Options<EmailSendsEnqueueEmailSendData, ThrowOnError>) {
        return (options.client ?? client).post<EmailSendsEnqueueEmailSendResponses, EmailSendsEnqueueEmailSendErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-sends/enqueue',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Enqueue Email Send From Csv
     * Enqueue one-off email send from CSV upload (admin only).
     */
    public static emailSendsEnqueueEmailSendFromCsv<ThrowOnError extends boolean = false>(options: Options<EmailSendsEnqueueEmailSendFromCsvData, ThrowOnError>) {
        return (options.client ?? client).post<EmailSendsEnqueueEmailSendFromCsvResponses, EmailSendsEnqueueEmailSendFromCsvErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-sends/enqueue-from-csv',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
}

export class EmailControls {
    /**
     * Get Mail Controls
     * Whether marketing is paused, and by whom, when and why.
     */
    public static emailControlsGetMailControls<ThrowOnError extends boolean = false>(options?: Options<EmailControlsGetMailControlsData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailControlsGetMailControlsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-controls',
            ...options
        });
    }
    
    /**
     * Pause Marketing
     * Hold every marketing send now. The brake is easy to pull: anyone who
     * can edit email can pause it.
     */
    public static emailControlsPauseMarketing<ThrowOnError extends boolean = false>(options: Options<EmailControlsPauseMarketingData, ThrowOnError>) {
        return (options.client ?? client).post<EmailControlsPauseMarketingResponses, EmailControlsPauseMarketingErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-controls/pause-marketing',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Resume Marketing
     * Let marketing go again: held sends go on the next tick. Releasing it
     * sends mail, so it needs the send permission. Refused (409, with the
     * reason) while a stream's rate is over the block level (SEND-21).
     */
    public static emailControlsResumeMarketing<ThrowOnError extends boolean = false>(options?: Options<EmailControlsResumeMarketingData, ThrowOnError>) {
        return (options?.client ?? client).post<EmailControlsResumeMarketingResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-controls/resume-marketing',
            ...options
        });
    }
}

export class EmailExecutions {
    /**
     * List Email Executions
     * List email executions with filtering and pagination (admin only).
     */
    public static emailExecutionsListEmailExecutions<ThrowOnError extends boolean = false>(options?: Options<EmailExecutionsListEmailExecutionsData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailExecutionsListEmailExecutionsResponses, EmailExecutionsListEmailExecutionsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-executions',
            ...options
        });
    }
    
    /**
     * Get Email Execution
     * Get email execution by ID (admin only).
     */
    public static emailExecutionsGetEmailExecution<ThrowOnError extends boolean = false>(options: Options<EmailExecutionsGetEmailExecutionData, ThrowOnError>) {
        return (options.client ?? client).get<EmailExecutionsGetEmailExecutionResponses, EmailExecutionsGetEmailExecutionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-executions/{execution_id}',
            ...options
        });
    }
    
    /**
     * Get Execution Stats
     * Get execution statistics (admin only).
     */
    public static emailExecutionsGetExecutionStats<ThrowOnError extends boolean = false>(options?: Options<EmailExecutionsGetExecutionStatsData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailExecutionsGetExecutionStatsResponses, EmailExecutionsGetExecutionStatsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-executions/stats/summary',
            ...options
        });
    }
    
    /**
     * Retry Email Execution
     * Retry a failed email execution (admin only). An uncertain one (it may
     * have gone out) only with `confirm_may_duplicate`.
     */
    public static emailExecutionsRetryEmailExecution<ThrowOnError extends boolean = false>(options: Options<EmailExecutionsRetryEmailExecutionData, ThrowOnError>) {
        return (options.client ?? client).post<EmailExecutionsRetryEmailExecutionResponses, EmailExecutionsRetryEmailExecutionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-executions/{execution_id}/retry',
            ...options
        });
    }
    
    /**
     * Cancel Email Execution
     * Cancel a pending email execution (admin only).
     */
    public static emailExecutionsCancelEmailExecution<ThrowOnError extends boolean = false>(options: Options<EmailExecutionsCancelEmailExecutionData, ThrowOnError>) {
        return (options.client ?? client).post<EmailExecutionsCancelEmailExecutionResponses, EmailExecutionsCancelEmailExecutionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-executions/{execution_id}/cancel',
            ...options
        });
    }
    
    /**
     * Bulk Retry Email Executions
     * Bulk retry failed email executions (admin only). Only `failed`: an
     * uncertain send may have gone out, so it is retried one at a time, by a
     * person who has been told so.
     */
    public static emailExecutionsBulkRetryEmailExecutions<ThrowOnError extends boolean = false>(options: Options<EmailExecutionsBulkRetryEmailExecutionsData, ThrowOnError>) {
        return (options.client ?? client).post<EmailExecutionsBulkRetryEmailExecutionsResponses, EmailExecutionsBulkRetryEmailExecutionsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-executions/bulk-retry',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Bulk Cancel Email Executions
     * Bulk cancel pending email executions (admin only).
     */
    public static emailExecutionsBulkCancelEmailExecutions<ThrowOnError extends boolean = false>(options: Options<EmailExecutionsBulkCancelEmailExecutionsData, ThrowOnError>) {
        return (options.client ?? client).post<EmailExecutionsBulkCancelEmailExecutionsResponses, EmailExecutionsBulkCancelEmailExecutionsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-executions/bulk-cancel',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Send Run Engagement
     * Open/click/bounce rates for one broadcast (a single send run), and
     * what its readers said would have helped.
     */
    public static emailExecutionsGetSendRunEngagement<ThrowOnError extends boolean = false>(options: Options<EmailExecutionsGetSendRunEngagementData, ThrowOnError>) {
        return (options.client ?? client).get<EmailExecutionsGetSendRunEngagementResponses, EmailExecutionsGetSendRunEngagementErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-executions/send-run/{send_run_id}/engagement',
            ...options
        });
    }
}

export class EmailComeback {
    /**
     * Campaigns Came Back
     * Every campaign with sends in the range, one row each.
     */
    public static emailComebackCampaignsCameBack<ThrowOnError extends boolean = false>(options?: Options<EmailComebackCampaignsCameBackData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailComebackCampaignsCameBackResponses, EmailComebackCampaignsCameBackErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-comeback/campaigns',
            ...options
        });
    }
    
    /**
     * Campaign Came Back
     * One campaign, per step.
     */
    public static emailComebackCampaignCameBack<ThrowOnError extends boolean = false>(options: Options<EmailComebackCampaignCameBackData, ThrowOnError>) {
        return (options.client ?? client).get<EmailComebackCampaignCameBackResponses, EmailComebackCampaignCameBackErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-comeback/campaigns/{campaign_id}',
            ...options
        });
    }
    
    /**
     * Send Run Came Back
     * One one-off send.
     */
    public static emailComebackSendRunCameBack<ThrowOnError extends boolean = false>(options: Options<EmailComebackSendRunCameBackData, ThrowOnError>) {
        return (options.client ?? client).get<EmailComebackSendRunCameBackResponses, EmailComebackSendRunCameBackErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-comeback/send-runs/{send_run_id}',
            ...options
        });
    }
    
    /**
     * Template Came Back
     * Each version of a template, newest first.
     */
    public static emailComebackTemplateCameBack<ThrowOnError extends boolean = false>(options: Options<EmailComebackTemplateCameBackData, ThrowOnError>) {
        return (options.client ?? client).get<EmailComebackTemplateCameBackResponses, EmailComebackTemplateCameBackErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-comeback/templates/{template_id}',
            ...options
        });
    }
}

export class Newsletter {
    /**
     * List Issues
     * Every newsletter issue, drafted, sent and imported, with how each did.
     */
    public static newsletterListIssues<ThrowOnError extends boolean = false>(options?: Options<NewsletterListIssuesData, ThrowOnError>) {
        return (options?.client ?? client).get<NewsletterListIssuesResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/newsletter/issues',
            ...options
        });
    }
    
    /**
     * Create Issue
     * A new issue, as a draft from the starter (or from the words of issue
     * `copy_of`), for the studio to open.
     */
    public static newsletterCreateIssue<ThrowOnError extends boolean = false>(options?: Options<NewsletterCreateIssueData, ThrowOnError>) {
        return (options?.client ?? client).post<NewsletterCreateIssueResponses, NewsletterCreateIssueErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/newsletter/issues',
            ...options
        });
    }
    
    /**
     * Delete Drafts
     * Bulk-delete drafts that were never published and never sent. Refuses
     * the whole request if any one was published or is a step in any campaign,
     * so a sent edition (and its results) can't go by accident.
     */
    public static newsletterDeleteDrafts<ThrowOnError extends boolean = false>(options: Options<NewsletterDeleteDraftsData, ThrowOnError>) {
        return (options.client ?? client).post<NewsletterDeleteDraftsResponses, NewsletterDeleteDraftsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/newsletter/issues/delete-drafts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Health
     * The newsletter lists: size and growth week by week. Counts only.
     */
    public static newsletterListHealth<ThrowOnError extends boolean = false>(options?: Options<NewsletterListHealthData, ThrowOnError>) {
        return (options?.client ?? client).get<NewsletterListHealthResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/newsletter/lists',
            ...options
        });
    }
}

export class EmailPeople {
    /**
     * List People
     * Everyone we hold an address for, newest first. Each filter is a
     * comma-separated list of values to keep. Searching by address, and the
     * address itself, need personal details on. `list_name` or `segment_id`:
     * only who a one-off send to it would target, as the send resolves them,
     * with whether each would get it (`will_get`).
     */
    public static emailPeopleListPeople<ThrowOnError extends boolean = false>(options?: Options<EmailPeopleListPeopleData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailPeopleListPeopleResponses, EmailPeopleListPeopleErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-people',
            ...options
        });
    }
    
    /**
     * Find Person
     * A member when an account holds the address, else the inbox.
     */
    public static emailPeopleFindPerson<ThrowOnError extends boolean = false>(options: Options<EmailPeopleFindPersonData, ThrowOnError>) {
        return (options.client ?? client).get<EmailPeopleFindPersonResponses, EmailPeopleFindPersonErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-people/find',
            ...options
        });
    }
    
    /**
     * Get Person
     */
    public static emailPeopleGetPerson<ThrowOnError extends boolean = false>(options: Options<EmailPeopleGetPersonData, ThrowOnError>) {
        return (options.client ?? client).get<EmailPeopleGetPersonResponses, EmailPeopleGetPersonErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-people/{kind}/{person_id}',
            ...options
        });
    }
    
    /**
     * Withdraw Person
     * They asked support to stop one list: a `withdrawn` event through
     * support, the way the preferences page records one. A list that isn't
     * live is left alone.
     */
    public static emailPeopleWithdrawPerson<ThrowOnError extends boolean = false>(options: Options<EmailPeopleWithdrawPersonData, ThrowOnError>) {
        return (options.client ?? client).post<EmailPeopleWithdrawPersonResponses, EmailPeopleWithdrawPersonErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-people/{kind}/{person_id}/withdraw',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Erase Person
     * Erase an inbox with no account (DATA-02, `contact.erase_contact`):
     * dry by default. The address stays, every list withdrawn, as the record
     * of their objection. Needs PII access: it acts on a person's data.
     */
    public static emailPeopleErasePerson<ThrowOnError extends boolean = false>(options: Options<EmailPeopleErasePersonData, ThrowOnError>) {
        return (options.client ?? client).post<EmailPeopleErasePersonResponses, EmailPeopleErasePersonErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-people/contact/{person_id}/erase',
            ...options
        });
    }
}

export class EmailEnrollments {
    /**
     * List Email Enrollments
     * List email enrollments with filtering and pagination (admin only).
     */
    public static emailEnrollmentsListEmailEnrollments<ThrowOnError extends boolean = false>(options?: Options<EmailEnrollmentsListEmailEnrollmentsData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailEnrollmentsListEmailEnrollmentsResponses, EmailEnrollmentsListEmailEnrollmentsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-enrollments',
            ...options
        });
    }
    
    /**
     * Get Email Enrollment
     * Get email enrollment by ID (admin only).
     */
    public static emailEnrollmentsGetEmailEnrollment<ThrowOnError extends boolean = false>(options: Options<EmailEnrollmentsGetEmailEnrollmentData, ThrowOnError>) {
        return (options.client ?? client).get<EmailEnrollmentsGetEmailEnrollmentResponses, EmailEnrollmentsGetEmailEnrollmentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-enrollments/{enrollment_id}',
            ...options
        });
    }
    
    /**
     * Pause Email Enrollment
     * Pause an email enrollment (admin only).
     */
    public static emailEnrollmentsPauseEmailEnrollment<ThrowOnError extends boolean = false>(options: Options<EmailEnrollmentsPauseEmailEnrollmentData, ThrowOnError>) {
        return (options.client ?? client).post<EmailEnrollmentsPauseEmailEnrollmentResponses, EmailEnrollmentsPauseEmailEnrollmentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-enrollments/{enrollment_id}/pause',
            ...options
        });
    }
    
    /**
     * Resume Email Enrollment
     * Resume a paused email enrollment (admin only).
     */
    public static emailEnrollmentsResumeEmailEnrollment<ThrowOnError extends boolean = false>(options: Options<EmailEnrollmentsResumeEmailEnrollmentData, ThrowOnError>) {
        return (options.client ?? client).post<EmailEnrollmentsResumeEmailEnrollmentResponses, EmailEnrollmentsResumeEmailEnrollmentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-enrollments/{enrollment_id}/resume',
            ...options
        });
    }
    
    /**
     * Cancel Email Enrollment
     * Cancel an email enrollment (admin only).
     */
    public static emailEnrollmentsCancelEmailEnrollment<ThrowOnError extends boolean = false>(options: Options<EmailEnrollmentsCancelEmailEnrollmentData, ThrowOnError>) {
        return (options.client ?? client).post<EmailEnrollmentsCancelEmailEnrollmentResponses, EmailEnrollmentsCancelEmailEnrollmentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/email-enrollments/{enrollment_id}/cancel',
            ...options
        });
    }
}

export class MailMedia {
    /**
     * List Mail Images
     * The most recent images, newest first, to reuse in another email.
     */
    public static mailMediaListMailImages<ThrowOnError extends boolean = false>(options?: Options<MailMediaListMailImagesData, ThrowOnError>) {
        return (options?.client ?? client).get<MailMediaListMailImagesResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/mail/media',
            ...options
        });
    }
    
    /**
     * Upload Mail Image
     */
    public static mailMediaUploadMailImage<ThrowOnError extends boolean = false>(options: Options<MailMediaUploadMailImageData, ThrowOnError>) {
        return (options.client ?? client).post<MailMediaUploadMailImageResponses, MailMediaUploadMailImageErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/mail/media',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Update Mail Image
     * The words for an image, kept with it so its next use starts with them.
     */
    public static mailMediaUpdateMailImage<ThrowOnError extends boolean = false>(options: Options<MailMediaUpdateMailImageData, ThrowOnError>) {
        return (options.client ?? client).patch<MailMediaUpdateMailImageResponses, MailMediaUpdateMailImageErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/mail/media/{media_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Campaigns {
    /**
     * Enroll In Campaign
     * Enroll the current user in a campaign.
     *
     * This endpoint is idempotent - if the user is already enrolled,
     * it will return the existing enrollment without creating a duplicate.
     *
     * Args:
     * campaign_id: UUID of the campaign to enroll in
     * session: Database session
     * current_user: Current authenticated user
     *
     * Returns:
     * Enrollment details including enrollment_id, campaign_id, user_id,
     * status, already_enrolled flag, and dt_enrolled timestamp
     *
     * Raises:
     * 404: Campaign not found, inactive, or not one a member may join
     * 400: User has no email
     */
    public static campaignsEnrollInCampaign<ThrowOnError extends boolean = false>(options: Options<CampaignsEnrollInCampaignData, ThrowOnError>) {
        return (options.client ?? client).post<CampaignsEnrollInCampaignResponses, CampaignsEnrollInCampaignErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/a/campaigns/{campaign_id}/enroll',
            ...options
        });
    }
}

export class PostmarkWebhook {
    /**
     * Handle Postmark Webhook
     * Record a Postmark engagement event.
     *
     * Postmark treats any non-2xx as a failure and retries, so anything we
     * simply don't care about (unhandled record types, unparseable bodies,
     * duplicates) returns 200 with an explanatory status. A real failure to
     * store answers 500, so Postmark retries it: a lost bounce or complaint is
     * somebody we keep emailing who asked us to stop.
     */
    public static postmarkWebhookHandlePostmarkWebhook<ThrowOnError extends boolean = false>(options?: Options<PostmarkWebhookHandlePostmarkWebhookData, ThrowOnError>) {
        return (options?.client ?? client).post<PostmarkWebhookHandlePostmarkWebhookResponses, unknown, ThrowOnError>({
            url: '/api/v1/a/postmark-webhook/',
            ...options
        });
    }
    
    /**
     * Handle Postmark Webhook
     * Record a Postmark engagement event.
     *
     * Postmark treats any non-2xx as a failure and retries, so anything we
     * simply don't care about (unhandled record types, unparseable bodies,
     * duplicates) returns 200 with an explanatory status. A real failure to
     * store answers 500, so Postmark retries it: a lost bounce or complaint is
     * somebody we keep emailing who asked us to stop.
     */
    public static postmarkWebhookHandlePostmarkWebhook2<ThrowOnError extends boolean = false>(options?: Options<PostmarkWebhookHandlePostmarkWebhook2Data, ThrowOnError>) {
        return (options?.client ?? client).post<PostmarkWebhookHandlePostmarkWebhook2Responses, unknown, ThrowOnError>({
            url: '/api/v1/a/postmark-webhook',
            ...options
        });
    }
    
    /**
     * Handle Postmark Inbound
     * An email to the List-Unsubscribe mailto, from Postmark's inbound
     * webhook (UNSUB-11). The subject carries the purpose and the signed
     * unsubscribe token from the email it came from, so it withdraws exactly
     * what the one-click link would; who it is from proves nothing and is not
     * read. Anything else (a reply, a bad token) is acknowledged and ignored,
     * so Postmark doesn't retry it; a failure to record answers 500, so it
     * does.
     */
    public static postmarkWebhookHandlePostmarkInbound<ThrowOnError extends boolean = false>(options?: Options<PostmarkWebhookHandlePostmarkInboundData, ThrowOnError>) {
        return (options?.client ?? client).post<PostmarkWebhookHandlePostmarkInboundResponses, unknown, ThrowOnError>({
            url: '/api/v1/a/postmark-webhook/inbound',
            ...options
        });
    }
}

export class UserSegments {
    /**
     * List User Segments
     * List user segments (admin only).
     *
     * Narrowed for a dogfood-only caller, because a row is not the harmless
     * summary it looks like: `UserSegmentPublic` carries `segment_config`, which
     * for a sql segment is the stored query, and `member_count`. Without this,
     * `panel:segments:dogfood:read` reads every segment's definition and how many
     * people each reaches, and the narrowing on `/count` and `/sample` is a gate
     * beside an open door.
     *
     * The filter goes into the query, not over the page, so `total` and `pages`
     * count the rows this caller may see. A holder of `panel:segments:read` takes
     * no filter at all and gets exactly what it always got.
     */
    public static userSegmentsListUserSegments<ThrowOnError extends boolean = false>(options?: Options<UserSegmentsListUserSegmentsData, ThrowOnError>) {
        return (options?.client ?? client).get<UserSegmentsListUserSegmentsResponses, UserSegmentsListUserSegmentsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/user-segments',
            ...options
        });
    }
    
    /**
     * Create User Segment
     * Create user segment (admin only).
     */
    public static userSegmentsCreateUserSegment<ThrowOnError extends boolean = false>(options: Options<UserSegmentsCreateUserSegmentData, ThrowOnError>) {
        return (options.client ?? client).post<UserSegmentsCreateUserSegmentResponses, UserSegmentsCreateUserSegmentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/user-segments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete User Segment
     * Delete user segment (admin only).
     */
    public static userSegmentsDeleteUserSegment<ThrowOnError extends boolean = false>(options: Options<UserSegmentsDeleteUserSegmentData, ThrowOnError>) {
        return (options.client ?? client).delete<UserSegmentsDeleteUserSegmentResponses, UserSegmentsDeleteUserSegmentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/user-segments/{segment_id}',
            ...options
        });
    }
    
    /**
     * Get User Segment
     * Get user segment by ID (admin only).
     *
     * Behind the same dependency as `/count` and `/sample`, for the same reason:
     * this route hands back `segment_config` (a sql segment's stored query) and
     * the live `member_count`. A dogfood-only caller gets 403 for a segment
     * nobody marked, and the 404 for a segment that does not exist still comes
     * first, so this tells nobody which ids are real.
     */
    public static userSegmentsGetUserSegment<ThrowOnError extends boolean = false>(options: Options<UserSegmentsGetUserSegmentData, ThrowOnError>) {
        return (options.client ?? client).get<UserSegmentsGetUserSegmentResponses, UserSegmentsGetUserSegmentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/user-segments/{segment_id}',
            ...options
        });
    }
    
    /**
     * Update User Segment
     * Update user segment (admin only).
     *
     * Two callers, one route. A person with `panel:segments:write` edits any
     * segment as they always could. The agent principal holds
     * `panel:segments:dogfood:write` and may send `is_ota_active` on a segment
     * somebody marked `is_dogfood` -- which is `bun ota dogfood` starting and
     * stopping its own cohort, and nothing else.
     */
    public static userSegmentsUpdateUserSegment<ThrowOnError extends boolean = false>(options: Options<UserSegmentsUpdateUserSegmentData, ThrowOnError>) {
        return (options.client ?? client).patch<UserSegmentsUpdateUserSegmentResponses, UserSegmentsUpdateUserSegmentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/user-segments/{segment_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Segment Count
     * How many people the segment reaches: what the send resolves, counted
     * (SEG-03), so the number and the send can't disagree.
     */
    public static userSegmentsGetSegmentCount<ThrowOnError extends boolean = false>(options: Options<UserSegmentsGetSegmentCountData, ThrowOnError>) {
        return (options.client ?? client).post<UserSegmentsGetSegmentCountResponses, UserSegmentsGetSegmentCountErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/user-segments/{segment_id}/count',
            ...options
        });
    }
    
    /**
     * Get Segment Sample
     * Get sample user IDs from segment (admin only).
     *
     * This is the route that turns a segment into people, emails included, so it
     * is the one the dogfood scope narrows: a caller holding only
     * `panel:segments:dogfood:read` gets 403 for any segment nobody has marked.
     *
     * Both the 404 and that 403 come from `DogfoodReadableSegment`, so they are
     * answered before the body is validated; the body is optional besides, since
     * the path already names the segment.
     */
    public static userSegmentsGetSegmentSample<ThrowOnError extends boolean = false>(options: Options<UserSegmentsGetSegmentSampleData, ThrowOnError>) {
        return (options.client ?? client).post<UserSegmentsGetSegmentSampleResponses, UserSegmentsGetSegmentSampleErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/user-segments/{segment_id}/sample',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Upload Csv To Segment
     * Upload CSV file to populate CSV static segment (admin only).
     */
    public static userSegmentsUploadCsvToSegment<ThrowOnError extends boolean = false>(options: Options<UserSegmentsUploadCsvToSegmentData, ThrowOnError>) {
        return (options.client ?? client).post<UserSegmentsUploadCsvToSegmentResponses, UserSegmentsUploadCsvToSegmentErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/user-segments/{segment_id}/upload-csv',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Clear Segment Members
     * Clear all members from CSV static segment (admin only).
     */
    public static userSegmentsClearSegmentMembers<ThrowOnError extends boolean = false>(options: Options<UserSegmentsClearSegmentMembersData, ThrowOnError>) {
        return (options.client ?? client).post<UserSegmentsClearSegmentMembersResponses, UserSegmentsClearSegmentMembersErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/user-segments/{segment_id}/clear-members',
            ...options
        });
    }
}

export class Ota {
    /**
     * Ota Bundle Adoption
     * Distinct devices running each OTA bundle, and each app version.
     *
     * ``items`` is per bundle, over all time. ``versions`` is per platform and
     * app version within ``days``, split by what each group is running, so a
     * fleet that cannot take a bundle is visible rather than inferred.
     *
     * ``lag_note`` travels with the payload rather than living only in the CLI:
     * a number that is up to 24 hours stale and does not say so is worse than no
     * number. Any future reader of this endpoint gets the caveat attached to the
     * data instead of having to know it.
     */
    public static otaOtaBundleAdoption<ThrowOnError extends boolean = false>(options?: Options<OtaOtaBundleAdoptionData, ThrowOnError>) {
        return (options?.client ?? client).get<OtaOtaBundleAdoptionResponses, OtaOtaBundleAdoptionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ota/adoption',
            ...options
        });
    }
}

export class DbSchema {
    /**
     * Get Database Schema
     * Get database schema for SQL autocomplete (admin only, cached).
     */
    public static dbSchemaGetDatabaseSchema<ThrowOnError extends boolean = false>(options?: Options<DbSchemaGetDatabaseSchemaData, ThrowOnError>) {
        return (options?.client ?? client).get<DbSchemaGetDatabaseSchemaResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/db-schema/schema',
            ...options
        });
    }
}

export class Ops {
    /**
     * Get Ops Status
     * This env, and the other env's answer beside it. The panel asks with peer=false and
     * fetches /status/peer on its own, so this env renders without waiting on the network.
     */
    public static opsGetOpsStatus<ThrowOnError extends boolean = false>(options?: Options<OpsGetOpsStatusData, ThrowOnError>) {
        return (options?.client ?? client).get<OpsGetOpsStatusResponses, OpsGetOpsStatusErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/status',
            ...options
        });
    }
    
    /**
     * Get Ops Peer Status
     * The other env's status, fetched over HTTPS and cached for PEER_TTL_S.
     */
    public static opsGetOpsPeerStatus<ThrowOnError extends boolean = false>(options?: Options<OpsGetOpsPeerStatusData, ThrowOnError>) {
        return (options?.client ?? client).get<OpsGetOpsPeerStatusResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/status/peer',
            ...options
        });
    }
    
    /**
     * Get Peer Status
     * This env's status, for the other env's backend.
     */
    public static opsGetPeerStatus<ThrowOnError extends boolean = false>(options?: Options<OpsGetPeerStatusData, ThrowOnError>) {
        return (options?.client ?? client).get<OpsGetPeerStatusResponses, OpsGetPeerStatusErrors, ThrowOnError>({
            url: '/api/v1/c/ops/peer-status',
            ...options
        });
    }
    
    /**
     * Mark Backfill Run Manually
     * A person attests this backfill already ran in this env, by hand, before the runner.
     */
    public static opsMarkBackfillRunManually<ThrowOnError extends boolean = false>(options: Options<OpsMarkBackfillRunManuallyData, ThrowOnError>) {
        return (options.client ?? client).post<OpsMarkBackfillRunManuallyResponses, OpsMarkBackfillRunManuallyErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/backfills/{name}/manual-run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Retire Backfill
     * A person retires a once-backfill in this env: applied in both envs, nothing left.
     * It folds into "Retired"; the name stays reserved (app/backfills/NAMES).
     */
    public static opsRetireBackfill<ThrowOnError extends boolean = false>(options: Options<OpsRetireBackfillData, ThrowOnError>) {
        return (options.client ?? client).post<OpsRetireBackfillResponses, OpsRetireBackfillErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/backfills/{name}/retire',
            ...options
        });
    }
    
    /**
     * Preview Migration
     * What a migrate job from `ref` would apply to this env's database, read-only: no job is
     * created and none of the ref's code runs. Planning re-checks all of it.
     */
    public static opsPreviewMigration<ThrowOnError extends boolean = false>(options: Options<OpsPreviewMigrationData, ThrowOnError>) {
        return (options.client ?? client).get<OpsPreviewMigrationResponses, OpsPreviewMigrationErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/migrations/preview',
            ...options
        });
    }
    
    /**
     * Locate Migration
     * Which open PR branches (or main) applied `rev` here: read-only, cached five minutes.
     */
    public static opsLocateMigration<ThrowOnError extends boolean = false>(options: Options<OpsLocateMigrationData, ThrowOnError>) {
        return (options.client ?? client).get<OpsLocateMigrationResponses, OpsLocateMigrationErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/migrations/locate',
            ...options
        });
    }
    
    /**
     * Migration Refs
     * Suggestions for the ref field: staging, main, and open PR branches when GitHub answers.
     */
    public static opsMigrationRefs<ThrowOnError extends boolean = false>(options?: Options<OpsMigrationRefsData, ThrowOnError>) {
        return (options?.client ?? client).get<OpsMigrationRefsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/migrations/refs',
            ...options
        });
    }
    
    /**
     * List Ops Jobs
     */
    public static opsListOpsJobs<ThrowOnError extends boolean = false>(options?: Options<OpsListOpsJobsData, ThrowOnError>) {
        return (options?.client ?? client).get<OpsListOpsJobsResponses, OpsListOpsJobsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/jobs',
            ...options
        });
    }
    
    /**
     * Request Ops Job
     */
    public static opsRequestOpsJob<ThrowOnError extends boolean = false>(options: Options<OpsRequestOpsJobData, ThrowOnError>) {
        return (options.client ?? client).post<OpsRequestOpsJobResponses, OpsRequestOpsJobErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/jobs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Ops Runner
     */
    public static opsGetOpsRunner<ThrowOnError extends boolean = false>(options?: Options<OpsGetOpsRunnerData, ThrowOnError>) {
        return (options?.client ?? client).get<OpsGetOpsRunnerResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/jobs/runner',
            ...options
        });
    }
    
    /**
     * Get Ops Job
     * Status, plan, progress and first error. Following a job polls this, and a
     * poll of a job still waiting on the runner wakes it.
     */
    public static opsGetOpsJob<ThrowOnError extends boolean = false>(options: Options<OpsGetOpsJobData, ThrowOnError>) {
        return (options.client ?? client).get<OpsGetOpsJobResponses, OpsGetOpsJobErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/jobs/{job_id}',
            ...options
        });
    }
    
    /**
     * Get Ops Job Log
     * Log lines after `after` (a line_no), oldest first: the live tail.
     */
    public static opsGetOpsJobLog<ThrowOnError extends boolean = false>(options: Options<OpsGetOpsJobLogData, ThrowOnError>) {
        return (options.client ?? client).get<OpsGetOpsJobLogResponses, OpsGetOpsJobLogErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/jobs/{job_id}/log',
            ...options
        });
    }
    
    /**
     * Cancel Ops Job
     * Soft (between batches) or hard (fence now; needs confirm). Your own job with
     * panel:ops:jobs:request; anyone's with panel:ops:jobs:approve, as a person.
     */
    public static opsCancelOpsJob<ThrowOnError extends boolean = false>(options: Options<OpsCancelOpsJobData, ThrowOnError>) {
        return (options.client ?? client).post<OpsCancelOpsJobResponses, OpsCancelOpsJobErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/jobs/{job_id}/cancel',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Approve Ops Job
     */
    public static opsApproveOpsJob<ThrowOnError extends boolean = false>(options: Options<OpsApproveOpsJobData, ThrowOnError>) {
        return (options.client ?? client).post<OpsApproveOpsJobResponses, OpsApproveOpsJobErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/jobs/{job_id}/approve',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reject Ops Job
     */
    public static opsRejectOpsJob<ThrowOnError extends boolean = false>(options: Options<OpsRejectOpsJobData, ThrowOnError>) {
        return (options.client ?? client).post<OpsRejectOpsJobResponses, OpsRejectOpsJobErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/jobs/{job_id}/reject',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Resume Ops Job
     */
    public static opsResumeOpsJob<ThrowOnError extends boolean = false>(options: Options<OpsResumeOpsJobData, ThrowOnError>) {
        return (options.client ?? client).post<OpsResumeOpsJobResponses, OpsResumeOpsJobErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/jobs/{job_id}/resume',
            ...options
        });
    }
    
    /**
     * Pause Ops Runner
     * Stop everything in this env: the runner claims nothing; hard also hard-cancels live jobs.
     */
    public static opsPauseOpsRunner<ThrowOnError extends boolean = false>(options: Options<OpsPauseOpsRunnerData, ThrowOnError>) {
        return (options.client ?? client).post<OpsPauseOpsRunnerResponses, OpsPauseOpsRunnerErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/jobs/runner/pause',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Unpause Ops Runner
     */
    public static opsUnpauseOpsRunner<ThrowOnError extends boolean = false>(options?: Options<OpsUnpauseOpsRunnerData, ThrowOnError>) {
        return (options?.client ?? client).post<OpsUnpauseOpsRunnerResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/ops/jobs/runner/unpause',
            ...options
        });
    }
}

export class DbMigrations {
    /**
     * Get Current Revision
     * The revision this backend's database is at.
     */
    public static dbMigrationsGetCurrentRevision<ThrowOnError extends boolean = false>(options?: Options<DbMigrationsGetCurrentRevisionData, ThrowOnError>) {
        return (options?.client ?? client).get<DbMigrationsGetCurrentRevisionResponses, DbMigrationsGetCurrentRevisionErrors, ThrowOnError>({
            url: '/api/v1/c/db-migrations/current',
            ...options
        });
    }
    
    /**
     * Create Approval Request
     * The workflow's plan job asks for a person's approval.
     */
    public static dbMigrationsCreateApprovalRequest<ThrowOnError extends boolean = false>(options: Options<DbMigrationsCreateApprovalRequestData, ThrowOnError>) {
        return (options.client ?? client).post<DbMigrationsCreateApprovalRequestResponses, DbMigrationsCreateApprovalRequestErrors, ThrowOnError>({
            url: '/api/v1/c/db-migrations/approval-requests',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Approval Status
     * The workflow's wait job polls this until a person decides.
     */
    public static dbMigrationsGetApprovalStatus<ThrowOnError extends boolean = false>(options: Options<DbMigrationsGetApprovalStatusData, ThrowOnError>) {
        return (options.client ?? client).get<DbMigrationsGetApprovalStatusResponses, DbMigrationsGetApprovalStatusErrors, ThrowOnError>({
            url: '/api/v1/c/db-migrations/approval-requests/{request_id}/status',
            ...options
        });
    }
    
    /**
     * Get Approval Request
     * The approval page: the whole plan, for a person to read.
     */
    public static dbMigrationsGetApprovalRequest<ThrowOnError extends boolean = false>(options: Options<DbMigrationsGetApprovalRequestData, ThrowOnError>) {
        return (options.client ?? client).get<DbMigrationsGetApprovalRequestResponses, DbMigrationsGetApprovalRequestErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/db-migrations/approval-requests/{request_id}',
            ...options
        });
    }
    
    /**
     * Approve Approval Request
     * A person approves exactly this plan.
     */
    public static dbMigrationsApproveApprovalRequest<ThrowOnError extends boolean = false>(options: Options<DbMigrationsApproveApprovalRequestData, ThrowOnError>) {
        return (options.client ?? client).post<DbMigrationsApproveApprovalRequestResponses, DbMigrationsApproveApprovalRequestErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/db-migrations/approval-requests/{request_id}/approve',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reject Approval Request
     * A person rejects it; the apply job stops without touching the database.
     */
    public static dbMigrationsRejectApprovalRequest<ThrowOnError extends boolean = false>(options: Options<DbMigrationsRejectApprovalRequestData, ThrowOnError>) {
        return (options.client ?? client).post<DbMigrationsRejectApprovalRequestResponses, DbMigrationsRejectApprovalRequestErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/db-migrations/approval-requests/{request_id}/reject',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TherapistWaitlist {
    /**
     * Get Rates
     * Get all active session rates, optionally for a single kind.
     * Returns rates with Cache-Control header for aggressive client caching.
     */
    public static therapistWaitlistGetRates<ThrowOnError extends boolean = false>(options?: Options<TherapistWaitlistGetRatesData, ThrowOnError>) {
        return (options?.client ?? client).get<TherapistWaitlistGetRatesResponses, TherapistWaitlistGetRatesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/therapist-waitlist/rates',
            ...options
        });
    }
    
    /**
     * Record Group Coaching Consents
     * Record the group coaching contact step's decisions in the consent log.
     *
     * Same rules as every other in-app email choice (``record_app_consents``):
     * channel ``app``, stamped with this account, and effective only once the
     * account proves the mailbox. If the address is the caller's own verified
     * one, that has already happened, so the grants are confirmed on the spot;
     * a typed address is confirmed when the same account later redeems a link
     * or code sent to it.
     *
     * The purpose is ``web_group_coaching_waitlist`` even though this is the app.
     * It is one consent (being contacted about the programme), and the channel
     * says where it was given.
     *
     * No email is sent and the response says nothing about the address, so this
     * cannot be used to learn whether an address has an account.
     */
    public static therapistWaitlistRecordGroupCoachingConsents<ThrowOnError extends boolean = false>(options: Options<TherapistWaitlistRecordGroupCoachingConsentsData, ThrowOnError>) {
        return (options.client ?? client).post<TherapistWaitlistRecordGroupCoachingConsentsResponses, TherapistWaitlistRecordGroupCoachingConsentsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/therapist-waitlist/group-coaching/consents',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Rates Admin
     * List all rates including inactive (admin only).
     */
    public static therapistWaitlistListRatesAdmin<ThrowOnError extends boolean = false>(options?: Options<TherapistWaitlistListRatesAdminData, ThrowOnError>) {
        return (options?.client ?? client).get<TherapistWaitlistListRatesAdminResponses, TherapistWaitlistListRatesAdminErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/therapist-waitlist/admin/rates',
            ...options
        });
    }
    
    /**
     * Create Rate
     * Create a new rate (admin only).
     */
    public static therapistWaitlistCreateRate<ThrowOnError extends boolean = false>(options: Options<TherapistWaitlistCreateRateData, ThrowOnError>) {
        return (options.client ?? client).post<TherapistWaitlistCreateRateResponses, TherapistWaitlistCreateRateErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/therapist-waitlist/admin/rates',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Rate
     * Delete a rate (admin only).
     */
    public static therapistWaitlistDeleteRate<ThrowOnError extends boolean = false>(options: Options<TherapistWaitlistDeleteRateData, ThrowOnError>) {
        return (options.client ?? client).delete<TherapistWaitlistDeleteRateResponses, TherapistWaitlistDeleteRateErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/therapist-waitlist/admin/rates/{rate_id}',
            ...options
        });
    }
    
    /**
     * Update Rate
     * Update an existing rate (admin only).
     */
    public static therapistWaitlistUpdateRate<ThrowOnError extends boolean = false>(options: Options<TherapistWaitlistUpdateRateData, ThrowOnError>) {
        return (options.client ?? client).put<TherapistWaitlistUpdateRateResponses, TherapistWaitlistUpdateRateErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/therapist-waitlist/admin/rates/{rate_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Bulk Upsert Rates
     * Bulk create or update rates by country code (admin only).
     */
    public static therapistWaitlistBulkUpsertRates<ThrowOnError extends boolean = false>(options: Options<TherapistWaitlistBulkUpsertRatesData, ThrowOnError>) {
        return (options.client ?? client).post<TherapistWaitlistBulkUpsertRatesResponses, TherapistWaitlistBulkUpsertRatesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/therapist-waitlist/admin/rates/bulk',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Waitlist Users
     * List users who joined a waitlist (admin only).
     */
    public static therapistWaitlistListWaitlistUsers<ThrowOnError extends boolean = false>(options?: Options<TherapistWaitlistListWaitlistUsersData, ThrowOnError>) {
        return (options?.client ?? client).get<TherapistWaitlistListWaitlistUsersResponses, TherapistWaitlistListWaitlistUsersErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/therapist-waitlist/admin/users',
            ...options
        });
    }
    
    /**
     * Export Waitlist Users Csv
     * Export all matching waitlist users as a CSV file (admin only).
     */
    public static therapistWaitlistExportWaitlistUsersCsv<ThrowOnError extends boolean = false>(options?: Options<TherapistWaitlistExportWaitlistUsersCsvData, ThrowOnError>) {
        return (options?.client ?? client).get<TherapistWaitlistExportWaitlistUsersCsvResponses, TherapistWaitlistExportWaitlistUsersCsvErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/therapist-waitlist/admin/users/export.csv',
            ...options
        });
    }
    
    /**
     * Get Waitlist Stats
     * Get aggregate stats about a waitlist (admin only).
     */
    public static therapistWaitlistGetWaitlistStats<ThrowOnError extends boolean = false>(options?: Options<TherapistWaitlistGetWaitlistStatsData, ThrowOnError>) {
        return (options?.client ?? client).get<TherapistWaitlistGetWaitlistStatsResponses, TherapistWaitlistGetWaitlistStatsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/c/therapist-waitlist/admin/stats',
            ...options
        });
    }
}

export class Conversations {
    /**
     * List Conversation Sessions
     * List conversation sessions for the current user with pagination.
     */
    public static conversationsListConversationSessions<ThrowOnError extends boolean = false>(options?: Options<ConversationsListConversationSessionsData, ThrowOnError>) {
        return (options?.client ?? client).get<ConversationsListConversationSessionsResponses, ConversationsListConversationSessionsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/conversations/sessions',
            ...options
        });
    }
    
    /**
     * Create Conversation Session
     * POST creates a new conversation session.
     */
    public static conversationsCreateConversationSession<ThrowOnError extends boolean = false>(options: Options<ConversationsCreateConversationSessionData, ThrowOnError>) {
        return (options.client ?? client).post<ConversationsCreateConversationSessionResponses, ConversationsCreateConversationSessionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/conversations/sessions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create Or Resume Conversation Session
     * PUT does a create or resume conversation session.
     */
    public static conversationsCreateOrResumeConversationSession<ThrowOnError extends boolean = false>(options: Options<ConversationsCreateOrResumeConversationSessionData, ThrowOnError>) {
        return (options.client ?? client).put<ConversationsCreateOrResumeConversationSessionResponses, ConversationsCreateOrResumeConversationSessionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/conversations/sessions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Conversation Session
     * Get a specific conversation session by ID.
     */
    public static conversationsGetConversationSession<ThrowOnError extends boolean = false>(options: Options<ConversationsGetConversationSessionData, ThrowOnError>) {
        return (options.client ?? client).get<ConversationsGetConversationSessionResponses, ConversationsGetConversationSessionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/conversations/sessions/{session_id}',
            ...options
        });
    }
    
    /**
     * Update Conversation Session
     * Update a conversation session.
     */
    public static conversationsUpdateConversationSession<ThrowOnError extends boolean = false>(options: Options<ConversationsUpdateConversationSessionData, ThrowOnError>) {
        return (options.client ?? client).patch<ConversationsUpdateConversationSessionResponses, ConversationsUpdateConversationSessionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/conversations/sessions/{session_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Session Messages
     * Get messages for a conversation session.
     */
    public static conversationsGetSessionMessages<ThrowOnError extends boolean = false>(options: Options<ConversationsGetSessionMessagesData, ThrowOnError>) {
        return (options.client ?? client).get<ConversationsGetSessionMessagesResponses, ConversationsGetSessionMessagesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/conversations/sessions/{session_id}/messages',
            ...options
        });
    }
    
    /**
     * Add Message
     * Add a message to a conversation session.
     */
    public static conversationsAddMessage<ThrowOnError extends boolean = false>(options: Options<ConversationsAddMessageData, ThrowOnError>) {
        return (options.client ?? client).post<ConversationsAddMessageResponses, ConversationsAddMessageErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/conversations/sessions/{session_id}/messages',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class HealthEntries {
    /**
     * List Health Entries
     * List all health entries for the current user with pagination.
     *
     * Optionally filter by entry_type and dt_updated_after (for incremental sync).
     *
     * ``entry_types`` and ``exclude_entry_types`` are the two halves of a split
     * restore: the sync client first pulls the types its first screen reads, then
     * sweeps the rest. Both are additive — a caller that sends neither sees
     * exactly what it saw before.
     *
     * ``before_dt_timestamp`` + ``before_id`` page by KEYSET rather than by
     * offset, which is what lets the sync client stop part-way down a large
     * account and resume exactly where it stopped. ``total`` and ``pages``
     * deliberately ignore the keyset, so they stay a fixed denominator for the
     * whole walk instead of shrinking as it progresses.
     */
    public static healthEntriesListHealthEntries<ThrowOnError extends boolean = false>(options?: Options<HealthEntriesListHealthEntriesData, ThrowOnError>) {
        return (options?.client ?? client).get<HealthEntriesListHealthEntriesResponses, HealthEntriesListHealthEntriesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/entries',
            ...options
        });
    }
    
    /**
     * Create Health Entry
     * Create a new health entry for the current user.
     */
    public static healthEntriesCreateHealthEntry<ThrowOnError extends boolean = false>(options: Options<HealthEntriesCreateHealthEntryData, ThrowOnError>) {
        return (options.client ?? client).post<HealthEntriesCreateHealthEntryResponses, HealthEntriesCreateHealthEntryErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/entries',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Upsert Health Entry
     * Create or update a health entry.
     *
     * If entry_in.id is provided and the entry exists, it will be updated.
     * Otherwise, a new entry will be created.
     */
    public static healthEntriesUpsertHealthEntry<ThrowOnError extends boolean = false>(options: Options<HealthEntriesUpsertHealthEntryData, ThrowOnError>) {
        return (options.client ?? client).put<HealthEntriesUpsertHealthEntryResponses, HealthEntriesUpsertHealthEntryErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/entries',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Health Entry
     * Delete a health entry.
     */
    public static healthEntriesDeleteHealthEntry<ThrowOnError extends boolean = false>(options: Options<HealthEntriesDeleteHealthEntryData, ThrowOnError>) {
        return (options.client ?? client).delete<HealthEntriesDeleteHealthEntryResponses, HealthEntriesDeleteHealthEntryErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/entries/{entry_id}',
            ...options
        });
    }
    
    /**
     * Get Health Entry
     * Get a specific health entry by ID.
     */
    public static healthEntriesGetHealthEntry<ThrowOnError extends boolean = false>(options: Options<HealthEntriesGetHealthEntryData, ThrowOnError>) {
        return (options.client ?? client).get<HealthEntriesGetHealthEntryResponses, HealthEntriesGetHealthEntryErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/entries/{entry_id}',
            ...options
        });
    }
    
    /**
     * Update Health Entry
     * Update a health entry.
     */
    public static healthEntriesUpdateHealthEntry<ThrowOnError extends boolean = false>(options: Options<HealthEntriesUpdateHealthEntryData, ThrowOnError>) {
        return (options.client ?? client).patch<HealthEntriesUpdateHealthEntryResponses, HealthEntriesUpdateHealthEntryErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/entries/{entry_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Bulk Delete Health Entries
     * Delete multiple health entries in bulk.
     * More efficient than deleting entries one by one.
     */
    public static healthEntriesBulkDeleteHealthEntries<ThrowOnError extends boolean = false>(options: Options<HealthEntriesBulkDeleteHealthEntriesData, ThrowOnError>) {
        return (options.client ?? client).post<HealthEntriesBulkDeleteHealthEntriesResponses, HealthEntriesBulkDeleteHealthEntriesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/entries/bulk-delete',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Prepare {
    /**
     * List Moments
     * Every moment for the current user, open and closed.
     */
    public static prepareListMoments<ThrowOnError extends boolean = false>(options?: Options<PrepareListMomentsData, ThrowOnError>) {
        return (options?.client ?? client).get<PrepareListMomentsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/prepare/moments',
            ...options
        });
    }
    
    /**
     * Create Moment
     * Create a moment, optionally chained to the moment that spawned it.
     */
    public static prepareCreateMoment<ThrowOnError extends boolean = false>(options: Options<PrepareCreateMomentData, ThrowOnError>) {
        return (options.client ?? client).post<PrepareCreateMomentResponses, PrepareCreateMomentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/prepare/moments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Moment
     * Hard delete. Closing a moment is a PATCH; this is for 'I added it by mistake'.
     */
    public static prepareDeleteMoment<ThrowOnError extends boolean = false>(options: Options<PrepareDeleteMomentData, ThrowOnError>) {
        return (options.client ?? client).delete<PrepareDeleteMomentResponses, PrepareDeleteMomentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/prepare/moments/{moment_id}',
            ...options
        });
    }
    
    /**
     * Get Moment
     */
    public static prepareGetMoment<ThrowOnError extends boolean = false>(options: Options<PrepareGetMomentData, ThrowOnError>) {
        return (options.client ?? client).get<PrepareGetMomentResponses, PrepareGetMomentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/prepare/moments/{moment_id}',
            ...options
        });
    }
    
    /**
     * Update Moment
     * Edit a moment, record its outcome, or close it.
     *
     * `moment_date` is explicitly settable to null so a user can move a moment back to
     * open-ended ("the appointment got cancelled, I don't know when it'll be").
     */
    public static prepareUpdateMoment<ThrowOnError extends boolean = false>(options: Options<PrepareUpdateMomentData, ThrowOnError>) {
        return (options.client ?? client).patch<PrepareUpdateMomentResponses, PrepareUpdateMomentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/prepare/moments/{moment_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SupportRelationships {
    /**
     * Get Support Relationships
     * Get all supporters for the current user.
     */
    public static supportRelationshipsGetSupportRelationships<ThrowOnError extends boolean = false>(options?: Options<SupportRelationshipsGetSupportRelationshipsData, ThrowOnError>) {
        return (options?.client ?? client).get<SupportRelationshipsGetSupportRelationshipsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/support-relationships',
            ...options
        });
    }
    
    /**
     * Create Support Relationship
     * Invite a supporter.
     */
    public static supportRelationshipsCreateSupportRelationship<ThrowOnError extends boolean = false>(options: Options<SupportRelationshipsCreateSupportRelationshipData, ThrowOnError>) {
        return (options.client ?? client).post<SupportRelationshipsCreateSupportRelationshipResponses, SupportRelationshipsCreateSupportRelationshipErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/support-relationships',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Accept Supporter Invitation Page
     * Show the invitation and ask. Does not accept anything — see _confirm_page.
     */
    public static supportRelationshipsAcceptSupporterInvitationPage<ThrowOnError extends boolean = false>(options: Options<SupportRelationshipsAcceptSupporterInvitationPageData, ThrowOnError>) {
        return (options.client ?? client).get<SupportRelationshipsAcceptSupporterInvitationPageResponses, SupportRelationshipsAcceptSupporterInvitationPageErrors, ThrowOnError>({
            url: '/api/v1/d/support-relationships/accept',
            ...options
        });
    }
    
    /**
     * Accept Supporter Invitation
     * Accept a supporter invitation. Public, no auth.
     *
     * The signed token is the authority here — the supporter has no account to
     * sign in with, and an unsigned relationship id would let anyone confirm a
     * relationship by guessing.
     */
    public static supportRelationshipsAcceptSupporterInvitation<ThrowOnError extends boolean = false>(options: Options<SupportRelationshipsAcceptSupporterInvitationData, ThrowOnError>) {
        return (options.client ?? client).post<SupportRelationshipsAcceptSupporterInvitationResponses, SupportRelationshipsAcceptSupporterInvitationErrors, ThrowOnError>({
            url: '/api/v1/d/support-relationships/accept',
            ...options
        });
    }
    
    /**
     * Decline Supporter Invitation Page
     * Ask before declining. Does not decline — see _confirm_page.
     */
    public static supportRelationshipsDeclineSupporterInvitationPage<ThrowOnError extends boolean = false>(options: Options<SupportRelationshipsDeclineSupporterInvitationPageData, ThrowOnError>) {
        return (options.client ?? client).get<SupportRelationshipsDeclineSupporterInvitationPageResponses, SupportRelationshipsDeclineSupporterInvitationPageErrors, ThrowOnError>({
            url: '/api/v1/d/support-relationships/decline',
            ...options
        });
    }
    
    /**
     * Decline Supporter Invitation
     * Decline a supporter invitation. Public, no auth.
     */
    public static supportRelationshipsDeclineSupporterInvitation<ThrowOnError extends boolean = false>(options: Options<SupportRelationshipsDeclineSupporterInvitationData, ThrowOnError>) {
        return (options.client ?? client).post<SupportRelationshipsDeclineSupporterInvitationResponses, SupportRelationshipsDeclineSupporterInvitationErrors, ThrowOnError>({
            url: '/api/v1/d/support-relationships/decline',
            ...options
        });
    }
    
    /**
     * Unsubscribe Supporter Notifications
     * Ask before unsubscribing. Does not unsubscribe — see _confirm_page.
     *
     * The token is still validated here, so a tampered or expired link fails
     * immediately rather than offering a button that cannot work.
     *
     * The RFC 8058 POST below is untouched: that one is a mail client acting on
     * an explicit instruction from its user, which is the whole point of the
     * standard. This GET is the footer link a human clicks, and a scanner might.
     */
    public static supportRelationshipsUnsubscribeSupporterNotifications<ThrowOnError extends boolean = false>(options: Options<SupportRelationshipsUnsubscribeSupporterNotificationsData, ThrowOnError>) {
        return (options.client ?? client).get<SupportRelationshipsUnsubscribeSupporterNotificationsResponses, SupportRelationshipsUnsubscribeSupporterNotificationsErrors, ThrowOnError>({
            url: '/api/v1/d/support-relationships/unsubscribe',
            ...options
        });
    }
    
    /**
     * Unsubscribe Supporter Notifications Post
     * RFC 8058 one-click unsubscribe (mail clients POST to the List-Unsubscribe URL).
     */
    public static supportRelationshipsUnsubscribeSupporterNotificationsPost<ThrowOnError extends boolean = false>(options: Options<SupportRelationshipsUnsubscribeSupporterNotificationsPostData, ThrowOnError>) {
        return (options.client ?? client).post<SupportRelationshipsUnsubscribeSupporterNotificationsPostResponses, SupportRelationshipsUnsubscribeSupporterNotificationsPostErrors, ThrowOnError>({
            url: '/api/v1/d/support-relationships/unsubscribe',
            ...options
        });
    }
    
    /**
     * Get Supporting Relationships
     * Get all users that the current user supports.
     */
    public static supportRelationshipsGetSupportingRelationships<ThrowOnError extends boolean = false>(options?: Options<SupportRelationshipsGetSupportingRelationshipsData, ThrowOnError>) {
        return (options?.client ?? client).get<SupportRelationshipsGetSupportingRelationshipsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/support-relationships/supporting',
            ...options
        });
    }
    
    /**
     * Confirm Support Relationship
     * Confirm/accept a support relationship invitation.
     */
    public static supportRelationshipsConfirmSupportRelationship<ThrowOnError extends boolean = false>(options: Options<SupportRelationshipsConfirmSupportRelationshipData, ThrowOnError>) {
        return (options.client ?? client).put<SupportRelationshipsConfirmSupportRelationshipResponses, SupportRelationshipsConfirmSupportRelationshipErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/support-relationships/{relationship_id}/confirm',
            ...options
        });
    }
    
    /**
     * Delete Support Relationship
     * Delete a support relationship.
     */
    public static supportRelationshipsDeleteSupportRelationship<ThrowOnError extends boolean = false>(options: Options<SupportRelationshipsDeleteSupportRelationshipData, ThrowOnError>) {
        return (options.client ?? client).delete<SupportRelationshipsDeleteSupportRelationshipResponses, SupportRelationshipsDeleteSupportRelationshipErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/support-relationships/{relationship_id}',
            ...options
        });
    }
    
    /**
     * Update Support Relationship
     * Update a support relationship.
     */
    public static supportRelationshipsUpdateSupportRelationship<ThrowOnError extends boolean = false>(options: Options<SupportRelationshipsUpdateSupportRelationshipData, ThrowOnError>) {
        return (options.client ?? client).put<SupportRelationshipsUpdateSupportRelationshipResponses, SupportRelationshipsUpdateSupportRelationshipErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/support-relationships/{relationship_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Supporter {
    /**
     * Get Supporter Dashboard
     * Get supporter dashboard showing all users they support.
     */
    public static supporterGetSupporterDashboard<ThrowOnError extends boolean = false>(options?: Options<SupporterGetSupporterDashboardData, ThrowOnError>) {
        return (options?.client ?? client).get<SupporterGetSupporterDashboardResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/supporter/dashboard',
            ...options
        });
    }
    
    /**
     * Get User Insights
     * Get insights for a specific user that the supporter supports.
     */
    public static supporterGetUserInsights<ThrowOnError extends boolean = false>(options: Options<SupporterGetUserInsightsData, ThrowOnError>) {
        return (options.client ?? client).get<SupporterGetUserInsightsResponses, SupporterGetUserInsightsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/supporter/{user_id}/insights',
            ...options
        });
    }
    
    /**
     * Delete Supporter Account
     * Remove the supporter from everyone they support, and stop all email.
     *
     * The user row itself only goes when it exists purely because somebody
     * invited them. A supporter who also uses the Condri app keeps their account:
     * they asked to stop supporting people, not to erase their own health record.
     * They can delete the app account from the app, where that intent is clear.
     */
    public static supporterDeleteSupporterAccount<ThrowOnError extends boolean = false>(options?: Options<SupporterDeleteSupporterAccountData, ThrowOnError>) {
        return (options?.client ?? client).delete<SupporterDeleteSupporterAccountResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/supporter/me',
            ...options
        });
    }
    
    /**
     * Get Supporter Account
     * The supporter's own account, as shown in the supporter portal.
     */
    public static supporterGetSupporterAccount<ThrowOnError extends boolean = false>(options?: Options<SupporterGetSupporterAccountData, ThrowOnError>) {
        return (options?.client ?? client).get<SupporterGetSupporterAccountResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/supporter/me',
            ...options
        });
    }
    
    /**
     * Update Supporter Preferences
     * Let a supporter set how often their own inbox is touched.
     *
     * Scoped to relationships where the caller IS the supporter. The existing
     * PUT /support-relationships/{id} is the supported person's door and stays
     * that way; this one cannot reach anyone else's settings.
     */
    public static supporterUpdateSupporterPreferences<ThrowOnError extends boolean = false>(options: Options<SupporterUpdateSupporterPreferencesData, ThrowOnError>) {
        return (options.client ?? client).put<SupporterUpdateSupporterPreferencesResponses, SupporterUpdateSupporterPreferencesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/supporter/relationships/{relationship_id}/preferences',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Community {
    /**
     * Get Feed
     * Newest-first page of the posts the caller sees, optionally filtered by
     * category. An admin also sees archived posts, marked; an author also sees
     * their own archived posts, unmarked. `archived=true` is an admin's Archived
     * tab: only archived posts, and a 403 for anyone else.
     */
    public static communityGetFeed<ThrowOnError extends boolean = false>(options?: Options<CommunityGetFeedData, ThrowOnError>) {
        return (options?.client ?? client).get<CommunityGetFeedResponses, CommunityGetFeedErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/feed',
            ...options
        });
    }
    
    /**
     * Delete Post
     * Delete your own post (comments/reactions/views go with it).
     */
    public static communityDeletePost<ThrowOnError extends boolean = false>(options: Options<CommunityDeletePostData, ThrowOnError>) {
        return (options.client ?? client).delete<CommunityDeletePostResponses, CommunityDeletePostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/posts/{post_id}',
            ...options
        });
    }
    
    /**
     * Get Post
     * Get a single post. Records the caller's view (idempotent per user).
     */
    public static communityGetPost<ThrowOnError extends boolean = false>(options: Options<CommunityGetPostData, ThrowOnError>) {
        return (options.client ?? client).get<CommunityGetPostResponses, CommunityGetPostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/posts/{post_id}',
            ...options
        });
    }
    
    /**
     * Update Post
     * Edit your own post, within 24h of posting.
     */
    public static communityUpdatePost<ThrowOnError extends boolean = false>(options: Options<CommunityUpdatePostData, ThrowOnError>) {
        return (options.client ?? client).patch<CommunityUpdatePostResponses, CommunityUpdatePostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/posts/{post_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Post Comments
     * Oldest-first page of top-level comments, each with its replies.
     */
    public static communityGetPostComments<ThrowOnError extends boolean = false>(options: Options<CommunityGetPostCommentsData, ThrowOnError>) {
        return (options.client ?? client).get<CommunityGetPostCommentsResponses, CommunityGetPostCommentsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/posts/{post_id}/comments',
            ...options
        });
    }
    
    /**
     * Create Post
     */
    public static communityCreatePost<ThrowOnError extends boolean = false>(options: Options<CommunityCreatePostData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityCreatePostResponses, CommunityCreatePostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/posts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Upload Media
     * Upload an image to the private community bucket. Validated by magic bytes
     * (the client content-type is not trusted); returns the media id + a signed
     * preview URL. Attach it to a post via createPost's mediaId.
     */
    public static communityUploadMedia<ThrowOnError extends boolean = false>(options: Options<CommunityUploadMediaData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityUploadMediaResponses, CommunityUploadMediaErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/media',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Attach Youtube Media
     * Attach a YouTube video by URL. Parses the video id, validates it via
     * oembed (built from the parsed id, not the raw URL — SSRF-safe), and stores a
     * kind='youtube' media row. Attach it to a post via createPost's mediaId.
     */
    public static communityAttachYoutubeMedia<ThrowOnError extends boolean = false>(options: Options<CommunityAttachYoutubeMediaData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityAttachYoutubeMediaResponses, CommunityAttachYoutubeMediaErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/media/youtube',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create Video Upload
     * Signed URLs to upload a video from the device straight to the private
     * bucket, plus its poster frame. Community admins only. Finalize with
     * POST /media/video once both PUTs succeed.
     */
    public static communityCreateVideoUpload<ThrowOnError extends boolean = false>(options: Options<CommunityCreateVideoUploadData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityCreateVideoUploadResponses, CommunityCreateVideoUploadErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/media/video/upload',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Finalize Video Media
     * Verify an uploaded video (size + sniffed type, for both the video and its
     * poster) and store a kind='video' media row. Attach it to a post via
     * createPost's mediaId.
     */
    public static communityFinalizeVideoMedia<ThrowOnError extends boolean = false>(options: Options<CommunityFinalizeVideoMediaData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityFinalizeVideoMediaResponses, CommunityFinalizeVideoMediaErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/media/video',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create Comment
     */
    public static communityCreateComment<ThrowOnError extends boolean = false>(options: Options<CommunityCreateCommentData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityCreateCommentResponses, CommunityCreateCommentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/comments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Boost Post
     * Pin a post to the top of the feed (`hours` or `until_next_post`).
     */
    public static communityBoostPost<ThrowOnError extends boolean = false>(options: Options<CommunityBoostPostData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityBoostPostResponses, CommunityBoostPostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/posts/{post_id}/boost',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Unboost Post
     */
    public static communityUnboostPost<ThrowOnError extends boolean = false>(options: Options<CommunityUnboostPostData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityUnboostPostResponses, CommunityUnboostPostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/posts/{post_id}/unboost',
            ...options
        });
    }
    
    /**
     * Archive Post
     * Reversible soft-delete: drop from the feed but keep the row.
     */
    public static communityArchivePost<ThrowOnError extends boolean = false>(options: Options<CommunityArchivePostData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityArchivePostResponses, CommunityArchivePostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/posts/{post_id}/archive',
            ...options
        });
    }
    
    /**
     * Restore Post
     * Reverse an archive. Dashboard-symmetric; no in-app caller today.
     */
    public static communityRestorePost<ThrowOnError extends boolean = false>(options: Options<CommunityRestorePostData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityRestorePostResponses, CommunityRestorePostErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/posts/{post_id}/restore',
            ...options
        });
    }
    
    /**
     * Set Post Topic
     * Move a post to another active category. Not an edit by the author, so
     * no "edited" mark. Posts in a private room (feedback) stay where they are.
     */
    public static communitySetPostTopic<ThrowOnError extends boolean = false>(options: Options<CommunitySetPostTopicData, ThrowOnError>) {
        return (options.client ?? client).post<CommunitySetPostTopicResponses, CommunitySetPostTopicErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/posts/{post_id}/topic',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Archive Comment
     * Hide a comment from members. Reversible from the dashboard; its replies
     * go out of sight with it.
     */
    public static communityArchiveComment<ThrowOnError extends boolean = false>(options: Options<CommunityArchiveCommentData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityArchiveCommentResponses, CommunityArchiveCommentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/comments/{comment_id}/archive',
            ...options
        });
    }
    
    /**
     * Update Comment
     * Edit your own comment, within 24h of posting. A community admin may
     * also edit any admin's comment, with no time limit.
     */
    public static communityUpdateComment<ThrowOnError extends boolean = false>(options: Options<CommunityUpdateCommentData, ThrowOnError>) {
        return (options.client ?? client).patch<CommunityUpdateCommentResponses, CommunityUpdateCommentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/comments/{comment_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Set Post Reaction
     * Toggle the caller's reaction on a post: same kind clears, a different
     * kind switches, none adds.
     */
    public static communitySetPostReaction<ThrowOnError extends boolean = false>(options: Options<CommunitySetPostReactionData, ThrowOnError>) {
        return (options.client ?? client).put<CommunitySetPostReactionResponses, CommunitySetPostReactionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/posts/{post_id}/reaction',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Set Comment Reaction
     * Toggle the caller's reaction on a comment or reply, the same way as on
     * a post: same kind clears, a different kind switches, none adds.
     */
    public static communitySetCommentReaction<ThrowOnError extends boolean = false>(options: Options<CommunitySetCommentReactionData, ThrowOnError>) {
        return (options.client ?? client).put<CommunitySetCommentReactionResponses, CommunitySetCommentReactionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/comments/{comment_id}/reaction',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Set Post Saved
     * Bookmark (save) or un-bookmark a post for the caller.
     */
    public static communitySetPostSaved<ThrowOnError extends boolean = false>(options: Options<CommunitySetPostSavedData, ThrowOnError>) {
        return (options.client ?? client).put<CommunitySetPostSavedResponses, CommunitySetPostSavedErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/posts/{post_id}/save',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Saved
     * The caller's saved posts, newest-saved first.
     */
    public static communityGetSaved<ThrowOnError extends boolean = false>(options?: Options<CommunityGetSavedData, ThrowOnError>) {
        return (options?.client ?? client).get<CommunityGetSavedResponses, CommunityGetSavedErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/saved',
            ...options
        });
    }
    
    /**
     * Report Content
     */
    public static communityReportContent<ThrowOnError extends boolean = false>(options: Options<CommunityReportContentData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityReportContentResponses, CommunityReportContentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/report',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get User Profile
     * A user's community profile: author, bio, and computed stats.
     */
    public static communityGetUserProfile<ThrowOnError extends boolean = false>(options: Options<CommunityGetUserProfileData, ThrowOnError>) {
        return (options.client ?? client).get<CommunityGetUserProfileResponses, CommunityGetUserProfileErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/users/{user_id}',
            ...options
        });
    }
    
    /**
     * Get User Posts
     * That user's posts the caller sees, newest-first (the profile trail).
     */
    public static communityGetUserPosts<ThrowOnError extends boolean = false>(options: Options<CommunityGetUserPostsData, ThrowOnError>) {
        return (options.client ?? client).get<CommunityGetUserPostsResponses, CommunityGetUserPostsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/users/{user_id}/posts',
            ...options
        });
    }
    
    /**
     * Update My Profile
     * Edit your own community profile: bio, avatar, and the name the community
     * shows. Bio always replaces; avatar and name change only when sent.
     */
    public static communityUpdateMyProfile<ThrowOnError extends boolean = false>(options: Options<CommunityUpdateMyProfileData, ThrowOnError>) {
        return (options.client ?? client).patch<CommunityUpdateMyProfileResponses, CommunityUpdateMyProfileErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/profile',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Pledge Room
     * Who is on a pledge right now, each with their pledge day, and the
     * caller's own entry. Members-only, like the room's feed.
     */
    public static communityGetPledgeRoom<ThrowOnError extends boolean = false>(options?: Options<CommunityGetPledgeRoomData, ThrowOnError>) {
        return (options?.client ?? client).get<CommunityGetPledgeRoomResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/rooms/pledge',
            ...options
        });
    }
    
    /**
     * List Topics
     */
    public static communityListTopics<ThrowOnError extends boolean = false>(options?: Options<CommunityListTopicsData, ThrowOnError>) {
        return (options?.client ?? client).get<CommunityListTopicsResponses, CommunityListTopicsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/topics',
            ...options
        });
    }
    
    /**
     * Create Topic
     */
    public static communityCreateTopic<ThrowOnError extends boolean = false>(options: Options<CommunityCreateTopicData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityCreateTopicResponses, CommunityCreateTopicErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/topics',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Topic
     */
    public static communityDeleteTopic<ThrowOnError extends boolean = false>(options: Options<CommunityDeleteTopicData, ThrowOnError>) {
        return (options.client ?? client).delete<CommunityDeleteTopicResponses, CommunityDeleteTopicErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/topics/{slug}',
            ...options
        });
    }
    
    /**
     * Update Topic
     */
    public static communityUpdateTopic<ThrowOnError extends boolean = false>(options: Options<CommunityUpdateTopicData, ThrowOnError>) {
        return (options.client ?? client).patch<CommunityUpdateTopicResponses, CommunityUpdateTopicErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/topics/{slug}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reorder Topics
     */
    public static communityReorderTopics<ThrowOnError extends boolean = false>(options: Options<CommunityReorderTopicsData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityReorderTopicsResponses, CommunityReorderTopicsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/topics/reorder',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Channel Videos
     */
    public static communityListChannelVideos<ThrowOnError extends boolean = false>(options?: Options<CommunityListChannelVideosData, ThrowOnError>) {
        return (options?.client ?? client).get<CommunityListChannelVideosResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/videos',
            ...options
        });
    }
    
    /**
     * Set Channel Videos
     */
    public static communitySetChannelVideos<ThrowOnError extends boolean = false>(options: Options<CommunitySetChannelVideosData, ThrowOnError>) {
        return (options.client ?? client).put<CommunitySetChannelVideosResponses, CommunitySetChannelVideosErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/videos',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Activity
     * Outstanding comments on your posts and replies to your comments.
     *
     * Everything here is undismissed, so the hub's red dot is just "this list is
     * not empty" — one request serves both the badge and the screen.
     */
    public static communityGetActivity<ThrowOnError extends boolean = false>(options?: Options<CommunityGetActivityData, ThrowOnError>) {
        return (options?.client ?? client).get<CommunityGetActivityResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/activity',
            ...options
        });
    }
    
    /**
     * Dismiss Activity Row
     * Clear one row up to now. Later activity brings it back, counting only
     * what is new. Idempotent.
     */
    public static communityDismissActivityRow<ThrowOnError extends boolean = false>(options: Options<CommunityDismissActivityRowData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityDismissActivityRowResponses, CommunityDismissActivityRowErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/activity/dismiss',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Dismiss All Activity
     * Clear every outstanding row, including any beyond the page.
     */
    public static communityDismissAllActivity<ThrowOnError extends boolean = false>(options?: Options<CommunityDismissAllActivityData, ThrowOnError>) {
        return (options?.client ?? client).post<CommunityDismissAllActivityResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/activity/dismiss-all',
            ...options
        });
    }
    
    /**
     * Get Push Preference
     * Whether community reply pushes are on for the caller. Default is on.
     */
    public static communityGetPushPreference<ThrowOnError extends boolean = false>(options?: Options<CommunityGetPushPreferenceData, ThrowOnError>) {
        return (options?.client ?? client).get<CommunityGetPushPreferenceResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/push-preference',
            ...options
        });
    }
    
    /**
     * Set Push Preference
     * Turn community reply pushes on or off. Gates PUSH only — the in-app
     * activity list is never hidden by this.
     */
    public static communitySetPushPreference<ThrowOnError extends boolean = false>(options: Options<CommunitySetPushPreferenceData, ThrowOnError>) {
        return (options.client ?? client).put<CommunitySetPushPreferenceResponses, CommunitySetPushPreferenceErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/push-preference',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get My Flairs
     * The caller's earned flairs; records any newly earned on the way.
     */
    public static communityGetMyFlairs<ThrowOnError extends boolean = false>(options?: Options<CommunityGetMyFlairsData, ThrowOnError>) {
        return (options?.client ?? client).get<CommunityGetMyFlairsResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/flairs/me',
            ...options
        });
    }
    
    /**
     * Set My Shown Flairs
     * Which earned flairs the caller wears on their posts.
     */
    public static communitySetMyShownFlairs<ThrowOnError extends boolean = false>(options: Options<CommunitySetMyShownFlairsData, ThrowOnError>) {
        return (options.client ?? client).patch<CommunitySetMyShownFlairsResponses, CommunitySetMyShownFlairsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/flairs/me',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Mark My Flairs Seen
     * The earned moment for these flairs has been shown.
     */
    public static communityMarkMyFlairsSeen<ThrowOnError extends boolean = false>(options: Options<CommunityMarkMyFlairsSeenData, ThrowOnError>) {
        return (options.client ?? client).post<CommunityMarkMyFlairsSeenResponses, CommunityMarkMyFlairsSeenErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/community/flairs/me/seen',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class UserState {
    /**
     * Read My State
     * Every state key for the calling member, in one call.
     *
     * Unpaginated on purpose: a partial map is worse than none, because the client
     * cannot tell a key that is absent from a key that is on page two, and would
     * restore a member's device to a half-remembered state.
     */
    public static userStateReadMyState<ThrowOnError extends boolean = false>(options?: Options<UserStateReadMyStateData, ThrowOnError>) {
        return (options?.client ?? client).get<UserStateReadMyStateResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/state',
            ...options
        });
    }
    
    /**
     * Write My State
     * Set one or many keys for the calling member. Last write wins.
     *
     * All-or-nothing: if any item in the batch is refused, none are written. A
     * partially applied batch would leave the member in a state no device ever
     * held, which is harder to reason about than a rejection.
     */
    public static userStateWriteMyState<ThrowOnError extends boolean = false>(options: Options<UserStateWriteMyStateData, ThrowOnError>) {
        return (options.client ?? client).put<UserStateWriteMyStateResponses, UserStateWriteMyStateErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/d/state',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class PaywallEvents {
    /**
     * Record My Paywall Events
     */
    public static paywallEventsRecordMyPaywallEvents<ThrowOnError extends boolean = false>(options: Options<PaywallEventsRecordMyPaywallEventsData, ThrowOnError>) {
        return (options.client ?? client).post<PaywallEventsRecordMyPaywallEventsResponses, PaywallEventsRecordMyPaywallEventsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/a/paywall-events',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class ActiveDays {
    /**
     * Record My Active Days
     */
    public static activeDaysRecordMyActiveDays<ThrowOnError extends boolean = false>(options: Options<ActiveDaysRecordMyActiveDaysData, ThrowOnError>) {
        return (options.client ?? client).post<ActiveDaysRecordMyActiveDaysResponses, ActiveDaysRecordMyActiveDaysErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/a/active-days',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Private {
    /**
     * Send Custom Notification
     * Send a custom push notification to a specific user.
     *
     * This endpoint allows administrators to send custom push notifications to any user.
     */
    public static privateSendCustomNotification<ThrowOnError extends boolean = false>(options: Options<PrivateSendCustomNotificationData, ThrowOnError>) {
        return (options.client ?? client).post<PrivateSendCustomNotificationResponses, PrivateSendCustomNotificationErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/v1/private/send-notification/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
